var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp(a, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp(a, prop, b2[prop]);
    }
  return a;
};
var __spreadProps = (a, b2) => __defProps(a, __getOwnPropDescs(b2));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import * as React from "react";
import React__default, { createContext, forwardRef, useContext, createElement, Fragment, Component, useState, useCallback, useMemo, useRef, useEffect, PureComponent } from "react";
import LitJsSdk from "lit-js-sdk";
import { createPortal } from "react-dom";
const ShareModalContext = createContext({});
const TOP_LIST = [
  {
    label: "Lit Genesis Gate",
    logo: "https://litgateway.com/favicon.png",
    value: "0xA3D109E28589D2AbC15991B57Ce5ca461Ad8e026",
    symbol: "LITGATE",
    standard: "ERC721"
  }
];
const checkAndCleanNested = (entry) => {
  if (entry.length === 1) {
    return entry[0];
  } else {
    return entry;
  }
};
const cleanUnifiedAccessControlConditions = (acc) => {
  const cleanedAcc = [];
  for (let i = 0; i < acc.length; i++) {
    if (!acc[i]["operator"] && !!acc[i][0]) {
      cleanedAcc.push(checkAndCleanNested(acc[i]));
    } else if (!acc[i]["operator"]) {
      cleanedAcc.push(acc[i]);
    } else {
      cleanedAcc.push(acc[i]);
    }
  }
  return cleanedAcc;
};
const humanizeUnifiedAccessControlConditions = async (unifiedAccessControlConditions) => {
  return LitJsSdk.humanizeAccessControlConditions({
    unifiedAccessControlConditions
  });
};
const humanizeNestedConditions = async (acc) => {
  const newHumanizedAcc = [];
  for (let i = 0; i < acc.length; i++) {
    if (Array.isArray(acc[i])) {
      const humanizedNest = await humanizeNestedConditions(acc[i]);
      newHumanizedAcc.push(humanizedNest);
    } else if (!!acc[i] && !!acc[i]["operator"]) {
      newHumanizedAcc.push({
        operator: acc[i]["operator"],
        index: i
      });
    } else {
      const humanizedAcc = await humanizeUnifiedAccessControlConditions([acc[i]]);
      newHumanizedAcc.push({
        humanizedAcc,
        conditionType: acc[i].conditionType,
        chain: acc[i].chain,
        index: i
      });
    }
  }
  return newHumanizedAcc;
};
const getAllNeededAuthSigs = (uacc) => {
  let allAuthSigs = [];
  for (let i = 0; i < uacc.length; i++) {
    if (Array.isArray(uacc[i])) {
      const authSigs = getAllNeededAuthSigs(uacc[i]);
      allAuthSigs.push(...authSigs);
    } else {
      if (uacc[i]["conditionType"] && uacc[i]["conditionType"] === "solRpc") {
        allAuthSigs.push("solana");
      } else if (uacc[i]["conditionType"] && uacc[i]["conditionType"] === "evmBasic") {
        allAuthSigs.push("ethereum");
      }
    }
  }
  return allAuthSigs;
};
const getAllChains = (uacc) => {
  let allChains = [];
  for (let i = 0; i < uacc.length; i++) {
    if (Array.isArray(uacc[i])) {
      const chains = getAllChains(uacc[i]);
      allChains.push(...chains);
    } else {
      if (uacc[i]["chain"]) {
        allChains.push(uacc[i]["chain"]);
      }
    }
  }
  return allChains;
};
var LitHeader$1 = "";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof {} !== "undefined" ? {} : typeof self !== "undefined" ? self : {};
function getAugmentedNamespace(n2) {
  if (n2.__esModule)
    return n2;
  var a = Object.defineProperty({}, "__esModule", { value: true });
  Object.keys(n2).forEach(function(k2) {
    var d2 = Object.getOwnPropertyDescriptor(n2, k2);
    Object.defineProperty(a, k2, d2.get ? d2 : {
      enumerable: true,
      get: function() {
        return n2[k2];
      }
    });
  });
  return a;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f$1 = React__default, k$1 = Symbol.for("react.element"), l$1 = Symbol.for("react.fragment"), m$1 = Object.prototype.hasOwnProperty, n$1 = f$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p$1 = { key: true, ref: true, __self: true, __source: true };
function q$1(c2, a, g2) {
  var b2, d2 = {}, e2 = null, h2 = null;
  g2 !== void 0 && (e2 = "" + g2);
  a.key !== void 0 && (e2 = "" + a.key);
  a.ref !== void 0 && (h2 = a.ref);
  for (b2 in a)
    m$1.call(a, b2) && !p$1.hasOwnProperty(b2) && (d2[b2] = a[b2]);
  if (c2 && c2.defaultProps)
    for (b2 in a = c2.defaultProps, a)
      d2[b2] === void 0 && (d2[b2] = a[b2]);
  return { $$typeof: k$1, type: c2, key: e2, ref: h2, props: d2, _owner: n$1.current };
}
reactJsxRuntime_production_min.Fragment = l$1;
reactJsxRuntime_production_min.jsx = q$1;
reactJsxRuntime_production_min.jsxs = q$1;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx$1 = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const LitHeader = ({
  handleClose,
  isModal
}) => {
  return /* @__PURE__ */ jsxs("header", {
    className: "lsm-header-container",
    children: [/* @__PURE__ */ jsx$1("h3", {
      className: "lsm-header-text",
      children: "Access Control"
    }), isModal && /* @__PURE__ */ jsx$1("button", {
      className: "lsm-header-close-button",
      onClick: handleClose,
      children: /* @__PURE__ */ jsx$1("svg", {
        className: "lsm-header-close-button-icon",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ jsx$1("path", {
          d: "M10 11.4142L17.7782 19.1924L19.1924 17.7782L11.4142 10L19.1924 2.22183L17.7782 0.807617L10 8.58579L2.22183 0.807617L0.807617 2.22183L8.58579 10L0.807619 17.7782L2.22183 19.1924L10 11.4142Z",
          fill: "rgba(0, 5, 51, 0.6)"
        })
      })
    })]
  });
};
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
}
function createStyleElement(options2) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options2.key);
  if (options2.nonce !== void 0) {
    tag.setAttribute("nonce", options2.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(options2) {
    var _this = this;
    this._insertTag = function(tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options2.speedy === void 0 ? true : options2.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options2.nonce;
    this.key = options2.key;
    this.container = options2.container;
    this.prepend = options2.prepend;
    this.insertionPoint = options2.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e2) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function(tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet2;
}();
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var abs = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;
function hash(value, length2) {
  return (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3);
}
function trim(value) {
  return value.trim();
}
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}
function indexof(value, search) {
  return value.indexOf(search);
}
function charat(value, index) {
  return value.charCodeAt(index) | 0;
}
function substr(value, begin, end) {
  return value.slice(begin, end);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append(value, array) {
  return array.push(value), value;
}
function combine(array, callback) {
  return array.map(callback).join("");
}
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value, root, parent, type, props, children, length2) {
  return { value, root, parent, type, props, children, line, column, length: length2, return: "" };
}
function copy(root, props) {
  return assign(node("", null, null, "", null, null, 0), root, { length: -root.length }, props);
}
function char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10)
    column = 1, line--;
  return character;
}
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10)
    column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(begin, end) {
  return substr(characters, begin, end);
}
function token(type) {
  switch (type) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type) {
  return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function whitespace(type) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index, count) {
  while (--count && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32));
}
function delimiter(type) {
  while (next())
    switch (character) {
      case type:
        return position;
      case 34:
      case 39:
        if (type !== 34 && type !== 39)
          delimiter(character);
        break;
      case 40:
        if (type === 41)
          delimiter(type);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(type, index) {
  while (next())
    if (type + character === 47 + 10)
      break;
    else if (type + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(index, position - 1) + "*" + from(type === 47 ? type : next());
}
function identifier(index) {
  while (!token(peek()))
    next();
  return slice(index, position);
}
function compile(value) {
  return dealloc(parse("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index = 0;
  var offset = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type = "";
  var props = rules;
  var children = rulesets;
  var reference = rule;
  var characters2 = type;
  while (scanning)
    switch (previous = character2, character2 = next()) {
      case 40:
        if (previous != 108 && characters2.charCodeAt(length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1)
            ampersand = -1;
          break;
        }
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), root, parent), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      case 123 * variable:
        points[index++] = strlen(characters2) * ampersand;
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          case 0:
          case 125:
            scanning = 0;
          case 59 + offset:
            if (property > 0 && strlen(characters2) - length2)
              append(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
            break;
          case 59:
            characters2 += ";";
          default:
            append(reference = ruleset(characters2, root, parent, index, offset, rules, points, type, props = [], children = [], length2), rulesets);
            if (character2 === 123)
              if (offset === 0)
                parse(characters2, root, reference, reference, props, rulesets, length2, points, children);
              else
                switch (atrule) {
                  case 100:
                  case 109:
                  case 115:
                    parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length2), children), rules, children, length2, points, rule ? props : children);
                    break;
                  default:
                    parse(characters2, reference, reference, reference, [""], children, 0, points, children);
                }
        }
        index = offset = property = 0, variable = ampersand = 1, type = characters2 = "", length2 = pseudo;
        break;
      case 58:
        length2 = 1 + strlen(characters2), property = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          case 38:
            ampersand = offset > 0 ? 1 : (characters2 += "\f", -1);
            break;
          case 44:
            points[index++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset = length2 = strlen(type = characters2 += identifier(caret())), character2++;
            break;
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root, parent, index, offset, rules, points, type, props, children, length2) {
  var post = offset - 1;
  var rule = offset === 0 ? rules : [""];
  var size2 = sizeof(rule);
  for (var i = 0, j = 0, k2 = 0; i < index; ++i)
    for (var x2 = 0, y2 = substr(value, post + 1, post = abs(j = points[i])), z2 = value; x2 < size2; ++x2)
      if (z2 = trim(j > 0 ? rule[x2] + " " + y2 : replace(y2, /&\f/g, rule[x2])))
        props[k2++] = z2;
  return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length2);
}
function comment(value, root, parent) {
  return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0);
}
function declaration(value, root, parent, length2) {
  return node(value, root, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}
function prefix(value, length2) {
  switch (hash(value, length2)) {
    case 5103:
      return WEBKIT + "print-" + value + value;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;
    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace(value, /flex-|-self/, "") + value;
    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace(value, /align-content|flex-|-self/, "") + value;
    case 5548:
      return WEBKIT + value + MS + replace(value, "shrink", "negative") + value;
    case 5292:
      return WEBKIT + value + MS + replace(value, "basis", "preferred-size") + value;
    case 6060:
      return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS + replace(value, "grow", "positive") + value;
    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6)
        switch (charat(value, length2 + 1)) {
          case 109:
            if (charat(value, length2 + 4) !== 45)
              break;
          case 102:
            return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
          case 115:
            return ~indexof(value, "stretch") ? prefix(replace(value, "stretch", "fill-available"), length2) + value : value;
        }
      break;
    case 4949:
      if (charat(value, length2 + 1) !== 115)
        break;
    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
        case 107:
          return replace(value, ":", ":" + WEBKIT) + value;
        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
      }
      break;
    case 5936:
      switch (charat(value, length2 + 11)) {
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
function serialize(children, callback) {
  var output = "";
  var length2 = sizeof(children);
  for (var i = 0; i < length2; i++)
    output += callback(children[i], i, children, callback) || "";
  return output;
}
function stringify(element, index, children, callback) {
  switch (element.type) {
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize(element.children, callback) + "}";
    case RULESET:
      element.value = element.props.join(",");
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof(collection);
  return function(element, index, children, callback) {
    var output = "";
    for (var i = 0; i < length2; i++)
      output += collection[i](element, index, children, callback) || "";
    return output;
  };
}
function rulesheet(callback) {
  return function(element) {
    if (!element.root) {
      if (element = element.return)
        callback(element);
    }
  };
}
function prefixer(element, index, children, callback) {
  if (element.length > -1) {
    if (!element.return)
      switch (element.type) {
        case DECLARATION:
          element.return = prefix(element.value, element.length);
          break;
        case KEYFRAMES:
          return serialize([copy(element, { value: replace(element.value, "@", "@" + WEBKIT) })], callback);
        case RULESET:
          if (element.length)
            return combine(element.props, function(value) {
              switch (match(value, /(::plac\w+|:read-\w+)/)) {
                case ":read-only":
                case ":read-write":
                  return serialize([copy(element, { props: [replace(value, /:(read-\w+)/, ":" + MOZ + "$1")] })], callback);
                case "::placeholder":
                  return serialize([
                    copy(element, { props: [replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")] }),
                    copy(element, { props: [replace(value, /:(plac\w+)/, ":" + MOZ + "$1")] }),
                    copy(element, { props: [replace(value, /:(plac\w+)/, MS + "input-$1")] })
                  ], callback);
              }
              return "";
            });
      }
  }
}
function memoize(fn) {
  var cache = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache[arg] === void 0)
      cache[arg] = fn(arg);
    return cache[arg];
  };
}
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index) {
  var previous = 0;
  var character2 = 0;
  while (true) {
    previous = character2;
    character2 = peek();
    if (previous === 38 && character2 === 12) {
      points[index] = 1;
    }
    if (token(character2)) {
      break;
    }
    next();
  }
  return slice(begin, position);
};
var toRules = function toRules2(parsed, points) {
  var index = -1;
  var character2 = 44;
  do {
    switch (token(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index] = 1;
        }
        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;
      case 2:
        parsed[index] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index] = peek() === 58 ? "&\f" : "";
          points[index] = parsed[index].length;
          break;
        }
      default:
        parsed[index] += from(character2);
    }
  } while (character2 = next());
  return parsed;
};
var getRules = function getRules2(value, points) {
  return dealloc(toRules(alloc(value), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element) {
  if (element.type !== "rule" || !element.parent || element.length < 1) {
    return;
  }
  var value = element.value, parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== "rule") {
    parent = parent.parent;
    if (!parent)
      return;
  }
  if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i = 0, k2 = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k2++) {
      element.props[k2] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel2(element) {
  if (element.type === "decl") {
    var value = element.value;
    if (value.charCodeAt(0) === 108 && value.charCodeAt(2) === 98) {
      element["return"] = "";
      element.value = "";
    }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache = function createCache2(options2) {
  var key = options2.key;
  if (key === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options2.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options2.container || document.head;
    Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node2) {
      var attrib = node2.getAttribute("data-emotion").split(" ");
      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }
      nodesToHydrate.push(node2);
    });
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles) {
      return serialize(compile(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }
  var cache = {
    key,
    sheet: new StyleSheet({
      key,
      container,
      nonce: options2.nonce,
      speedy: options2.speedy,
      prepend: options2.prepend,
      insertionPoint: options2.insertionPoint
    }),
    nonce: options2.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};
var reactIs$1 = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = typeof Symbol === "function" && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w$1 = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
  if (typeof a === "object" && a !== null) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m;
}
reactIs_production_min.AsyncMode = l;
reactIs_production_min.ConcurrentMode = m;
reactIs_production_min.ContextConsumer = k;
reactIs_production_min.ContextProvider = h;
reactIs_production_min.Element = c;
reactIs_production_min.ForwardRef = n;
reactIs_production_min.Fragment = e;
reactIs_production_min.Lazy = t;
reactIs_production_min.Memo = r;
reactIs_production_min.Portal = d;
reactIs_production_min.Profiler = g;
reactIs_production_min.StrictMode = f;
reactIs_production_min.Suspense = p;
reactIs_production_min.isAsyncMode = function(a) {
  return A(a) || z(a) === l;
};
reactIs_production_min.isConcurrentMode = A;
reactIs_production_min.isContextConsumer = function(a) {
  return z(a) === k;
};
reactIs_production_min.isContextProvider = function(a) {
  return z(a) === h;
};
reactIs_production_min.isElement = function(a) {
  return typeof a === "object" && a !== null && a.$$typeof === c;
};
reactIs_production_min.isForwardRef = function(a) {
  return z(a) === n;
};
reactIs_production_min.isFragment = function(a) {
  return z(a) === e;
};
reactIs_production_min.isLazy = function(a) {
  return z(a) === t;
};
reactIs_production_min.isMemo = function(a) {
  return z(a) === r;
};
reactIs_production_min.isPortal = function(a) {
  return z(a) === d;
};
reactIs_production_min.isProfiler = function(a) {
  return z(a) === g;
};
reactIs_production_min.isStrictMode = function(a) {
  return z(a) === f;
};
reactIs_production_min.isSuspense = function(a) {
  return z(a) === p;
};
reactIs_production_min.isValidElementType = function(a) {
  return typeof a === "string" || typeof a === "function" || a === e || a === m || a === g || a === f || a === p || a === q || typeof a === "object" && a !== null && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w$1 || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
reactIs_production_min.typeOf = z;
{
  reactIs$1.exports = reactIs_production_min;
}
var reactIs = reactIs$1.exports;
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames2) {
  var rawClassName = "";
  classNames2.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if ((isStringTag === false || isBrowser === false) && cache.registered[className] === void 0) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;
  if (cache.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function murmur2(str) {
  var h2 = 0;
  var k2, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k2 = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k2 = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16);
    k2 ^= k2 >>> 24;
    h2 = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16) ^ (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h2 ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h2 ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h2 ^= str.charCodeAt(i) & 255;
      h2 = (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  h2 ^= h2 >>> 13;
  h2 = (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  return ((h2 ^ h2 >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = /* @__PURE__ */ memoize(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key, value) {
  switch (key) {
    case "animation":
    case "animationName": {
      if (typeof value === "string") {
        return value.replace(animationRegex, function(match2, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  if (interpolation.__emotion_styles !== void 0) {
    return interpolation;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      if (interpolation.anim === 1) {
        cursor = {
          name: interpolation.name,
          styles: interpolation.styles,
          next: cursor
        };
        return interpolation.name;
      }
      if (interpolation.styles !== void 0) {
        var next2 = interpolation.next;
        if (next2 !== void 0) {
          while (next2 !== void 0) {
            cursor = {
              name: next2.name,
              styles: next2.styles,
              next: cursor
            };
            next2 = next2.next;
          }
        }
        var styles = interpolation.styles + ";";
        return styles;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result);
      }
      break;
    }
  }
  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== void 0 ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = "";
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== "object") {
        if (registered != null && registered[value] !== void 0) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === "NO_COMPONENT_SELECTOR" && false) {
          throw new Error("Component selectors can only be used in conjunction with @emotion/babel-plugin.");
        }
        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (_key) {
            case "animation":
            case "animationName": {
              string += processStyleName(_key) + ":" + interpolated + ";";
              break;
            }
            default: {
              string += _key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var cursor;
var serializeStyles = function serializeStyles2(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    styles += strings[0];
  }
  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      styles += strings[i];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match2;
  while ((match2 = labelPattern.exec(styles)) !== null) {
    identifierName += "-" + match2[1];
  }
  var name = murmur2(styles) + identifierName;
  return {
    name,
    styles,
    next: cursor
  };
};
var hasOwnProperty = {}.hasOwnProperty;
var EmotionCacheContext = /* @__PURE__ */ createContext(typeof HTMLElement !== "undefined" ? /* @__PURE__ */ createCache({
  key: "css"
}) : null);
var CacheProvider = EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */ forwardRef(function(props, ref) {
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};
var ThemeContext = /* @__PURE__ */ createContext({});
var useInsertionEffect = React["useInsertionEffect"] ? React["useInsertionEffect"] : function useInsertionEffect2(create) {
  create();
};
function useInsertionEffectMaybe(create) {
  useInsertionEffect(create);
}
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps2(type, props) {
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }
  newProps[typePropName] = type;
  return newProps;
};
var Insertion$1 = function Insertion(_ref3) {
  var cache = _ref3.cache, serialized = _ref3.serialized, isStringTag = _ref3.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  useInsertionEffectMaybe(function() {
    return insertStyles(cache, serialized, isStringTag);
  });
  return null;
};
var Emotion = /* @__PURE__ */ withEmotionCache(function(props, cache, ref) {
  var cssProp = props.css;
  if (typeof cssProp === "string" && cache.registered[cssProp] !== void 0) {
    cssProp = cache.registered[cssProp];
  }
  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = "";
  if (typeof props.className === "string") {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, void 0, useContext(ThemeContext));
  className += cache.key + "-" + serialized.name;
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== "css" && key !== typePropName && true) {
      newProps[key] = props[key];
    }
  }
  newProps.ref = ref;
  newProps.className = className;
  return /* @__PURE__ */ createElement(Fragment, null, /* @__PURE__ */ createElement(Insertion$1, {
    cache,
    serialized,
    isStringTag: typeof WrappedComponent === "string"
  }), /* @__PURE__ */ createElement(WrappedComponent, newProps));
});
var jsx = function jsx2(type, props) {
  var args = arguments;
  if (props == null || !hasOwnProperty.call(props, "css")) {
    return createElement.apply(void 0, args);
  }
  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);
  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }
  return createElement.apply(null, createElementArgArray);
};
function css$2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
var keyframes = function keyframes2() {
  var insertable = css$2.apply(void 0, arguments);
  var name = "animation-" + insertable.name;
  return {
    name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
var classnames = function classnames2(args) {
  var len = args.length;
  var i = 0;
  var cls = "";
  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null)
      continue;
    var toAdd = void 0;
    switch (typeof arg) {
      case "boolean":
        break;
      case "object": {
        if (Array.isArray(arg)) {
          toAdd = classnames2(arg);
        } else {
          toAdd = "";
          for (var k2 in arg) {
            if (arg[k2] && k2) {
              toAdd && (toAdd += " ");
              toAdd += k2;
            }
          }
        }
        break;
      }
      default: {
        toAdd = arg;
      }
    }
    if (toAdd) {
      cls && (cls += " ");
      cls += toAdd;
    }
  }
  return cls;
};
function merge(registered, css4, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
  if (registeredStyles.length < 2) {
    return className;
  }
  return rawClassName + css4(registeredStyles);
}
var Insertion2 = function Insertion3(_ref3) {
  var cache = _ref3.cache, serializedArr = _ref3.serializedArr;
  useInsertionEffectMaybe(function() {
    for (var i = 0; i < serializedArr.length; i++) {
      insertStyles(cache, serializedArr[i], false);
    }
  });
  return null;
};
var ClassNames = /* @__PURE__ */ withEmotionCache(function(props, cache) {
  var hasRendered = false;
  var serializedArr = [];
  var css4 = function css5() {
    if (hasRendered && false) {
      throw new Error("css can only be used during render");
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized);
    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };
  var cx = function cx2() {
    if (hasRendered && false) {
      throw new Error("cx can only be used during render");
    }
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return merge(cache.registered, css4, classnames(args));
  };
  var content = {
    css: css4,
    cx,
    theme: useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /* @__PURE__ */ createElement(Fragment, null, /* @__PURE__ */ createElement(Insertion2, {
    cache,
    serializedArr
  }), ele);
});
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor)
    n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray(o, minLen);
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _setPrototypeOf(o, p2) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf(o, p2);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
function _assertThisInitialized$1(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _possibleConstructorReturn(self2, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized$1(self2);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
var _excluded$3$1 = ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
var noop = function noop2() {
};
function applyPrefixToName(prefix2, name) {
  if (!name) {
    return prefix2;
  } else if (name[0] === "-") {
    return prefix2 + name;
  } else {
    return prefix2 + "__" + name;
  }
}
function classNames(prefix2, state, className) {
  var arr = [className];
  if (state && prefix2) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix2, key)));
      }
    }
  }
  return arr.filter(function(i) {
    return i;
  }).map(function(i) {
    return String(i).trim();
  }).join(" ");
}
var cleanValue = function cleanValue2(value) {
  if (isArray(value))
    return value.filter(Boolean);
  if (_typeof(value) === "object" && value !== null)
    return [value];
  return [];
};
var cleanCommonProps = function cleanCommonProps2(props) {
  props.className;
  props.clearValue;
  props.cx;
  props.getStyles;
  props.getValue;
  props.hasValue;
  props.isMulti;
  props.isRtl;
  props.options;
  props.selectOption;
  props.selectProps;
  props.setValue;
  props.theme;
  var innerProps = _objectWithoutProperties(props, _excluded$3$1);
  return _objectSpread2({}, innerProps);
};
function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}
function normalizedHeight(el) {
  if (isDocumentElement(el)) {
    return window.innerHeight;
  }
  return el.clientHeight;
}
function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}
function scrollTo(el, top) {
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }
  el.scrollTop = top;
}
function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === "absolute";
  var overflowRx = /(auto|scroll)/;
  if (style.position === "fixed")
    return document.documentElement;
  for (var parent = element; parent = parent.parentElement; ) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === "static") {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }
  return document.documentElement;
}
function easeOutCubic(t2, b2, c2, d2) {
  return c2 * ((t2 = t2 / d2 - 1) * t2 * t2 + 1) + b2;
}
function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;
  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}
function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;
  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
function isTouchCapable() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e2) {
    return false;
  }
}
function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e2) {
    return false;
  }
}
var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }
};
var w = typeof window !== "undefined" ? window : {};
if (w.addEventListener && w.removeEventListener) {
  w.addEventListener("p", noop, options);
  w.removeEventListener("p", noop, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
  return item != null;
}
function isArray(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}
var removeProps = function removeProps2(propsObj) {
  for (var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    properties[_key - 1] = arguments[_key];
  }
  var propsMap = Object.entries(propsObj).filter(function(_ref3) {
    var _ref22 = _slicedToArray(_ref3, 1), key = _ref22[0];
    return !properties.includes(key);
  });
  return propsMap.reduce(function(newProps, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2), key = _ref4[0], val = _ref4[1];
    newProps[key] = val;
    return newProps;
  }, {});
};
function getMenuPlacement(_ref3) {
  var maxHeight = _ref3.maxHeight, menuEl = _ref3.menuEl, minHeight = _ref3.minHeight, placement = _ref3.placement, shouldScroll = _ref3.shouldScroll, isFixedPosition = _ref3.isFixedPosition, theme = _ref3.theme;
  var spacing2 = theme.spacing;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: "bottom",
    maxHeight
  };
  if (!menuEl || !menuEl.offsetParent)
    return defaultState;
  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
  var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;
  switch (placement) {
    case "auto":
    case "bottom":
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: "bottom",
          maxHeight
        };
      }
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        return {
          placement: "bottom",
          maxHeight
        };
      }
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: "bottom",
          maxHeight: constrainedHeight
        };
      }
      if (placement === "auto" || isFixedPosition) {
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing2.controlHeight, maxHeight);
        }
        return {
          placement: "top",
          maxHeight: _constrainedHeight
        };
      }
      if (placement === "bottom") {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }
        return {
          placement: "bottom",
          maxHeight
        };
      }
      break;
    case "top":
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: "top",
          maxHeight
        };
      }
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: "top",
          maxHeight
        };
      }
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight;
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: "top",
          maxHeight: _constrainedHeight2
        };
      }
      return {
        placement: "bottom",
        maxHeight
      };
    default:
      throw new Error('Invalid placement provided "'.concat(placement, '".'));
  }
  return defaultState;
}
function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: "top",
    top: "bottom"
  };
  return placement ? placementToCSSProp[placement] : "bottom";
}
var coercePlacement = function coercePlacement2(p2) {
  return p2 === "auto" ? "bottom" : p2;
};
var menuCSS = function menuCSS2(_ref22) {
  var _ref3;
  var placement = _ref22.placement, _ref2$theme = _ref22.theme, borderRadius2 = _ref2$theme.borderRadius, spacing2 = _ref2$theme.spacing, colors2 = _ref2$theme.colors;
  return _ref3 = {
    label: "menu"
  }, _defineProperty$1(_ref3, alignToControl(placement), "100%"), _defineProperty$1(_ref3, "backgroundColor", colors2.neutral0), _defineProperty$1(_ref3, "borderRadius", borderRadius2), _defineProperty$1(_ref3, "boxShadow", "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)"), _defineProperty$1(_ref3, "marginBottom", spacing2.menuGutter), _defineProperty$1(_ref3, "marginTop", spacing2.menuGutter), _defineProperty$1(_ref3, "position", "absolute"), _defineProperty$1(_ref3, "width", "100%"), _defineProperty$1(_ref3, "zIndex", 1), _ref3;
};
var PortalPlacementContext = /* @__PURE__ */ createContext({
  getPortalPlacement: null
});
var MenuPlacer = /* @__PURE__ */ function(_Component) {
  _inherits(MenuPlacer2, _Component);
  var _super = _createSuper(MenuPlacer2);
  function MenuPlacer2() {
    var _this;
    _classCallCheck(this, MenuPlacer2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    };
    _this.context = void 0;
    _this.getPlacement = function(ref) {
      var _this$props = _this.props, minMenuHeight = _this$props.minMenuHeight, maxMenuHeight = _this$props.maxMenuHeight, menuPlacement = _this$props.menuPlacement, menuPosition = _this$props.menuPosition, menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView, theme = _this$props.theme;
      if (!ref)
        return;
      var isFixedPosition = menuPosition === "fixed";
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll,
        isFixedPosition,
        theme
      });
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (getPortalPlacement)
        getPortalPlacement(state);
      _this.setState(state);
    };
    _this.getUpdatedProps = function() {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return _objectSpread2(_objectSpread2({}, _this.props), {}, {
        placement,
        maxHeight: _this.state.maxHeight
      });
    };
    return _this;
  }
  _createClass(MenuPlacer2, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);
  return MenuPlacer2;
}(Component);
MenuPlacer.contextType = PortalPlacementContext;
var Menu = function Menu2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerRef = props.innerRef, innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles("menu", props),
    className: cx({
      menu: true
    }, className),
    ref: innerRef
  }, innerProps), children);
};
var menuListCSS = function menuListCSS2(_ref4) {
  var maxHeight = _ref4.maxHeight, baseUnit2 = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight,
    overflowY: "auto",
    paddingBottom: baseUnit2,
    paddingTop: baseUnit2,
    position: "relative",
    WebkitOverflowScrolling: "touch"
  };
};
var MenuList = function MenuList2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
  return jsx("div", _extends({
    css: getStyles("menuList", props),
    className: cx({
      "menu-list": true,
      "menu-list--is-multi": isMulti
    }, className),
    ref: innerRef
  }, innerProps), children);
};
var noticeCSS = function noticeCSS2(_ref5) {
  var _ref5$theme = _ref5.theme, baseUnit2 = _ref5$theme.spacing.baseUnit, colors2 = _ref5$theme.colors;
  return {
    color: colors2.neutral40,
    padding: "".concat(baseUnit2 * 2, "px ").concat(baseUnit2 * 3, "px"),
    textAlign: "center"
  };
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles("noOptionsMessage", props),
    className: cx({
      "menu-notice": true,
      "menu-notice--no-options": true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: "No options"
};
var LoadingMessage = function LoadingMessage2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles("loadingMessage", props),
    className: cx({
      "menu-notice": true,
      "menu-notice--loading": true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: "Loading..."
};
var menuPortalCSS = function menuPortalCSS2(_ref6) {
  var rect = _ref6.rect, offset = _ref6.offset, position2 = _ref6.position;
  return {
    left: rect.left,
    position: position2,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = /* @__PURE__ */ function(_Component2) {
  _inherits(MenuPortal2, _Component2);
  var _super2 = _createSuper(MenuPortal2);
  function MenuPortal2() {
    var _this2;
    _classCallCheck(this, MenuPortal2);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.state = {
      placement: null
    };
    _this2.getPortalPlacement = function(_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement);
      if (placement !== initialPlacement) {
        _this2.setState({
          placement
        });
      }
    };
    return _this2;
  }
  _createClass(MenuPortal2, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props, appendTo = _this$props2.appendTo, children = _this$props2.children, className = _this$props2.className, controlElement = _this$props2.controlElement, cx = _this$props2.cx, innerProps = _this$props2.innerProps, menuPlacement = _this$props2.menuPlacement, position2 = _this$props2.menuPosition, getStyles = _this$props2.getStyles;
      var isFixed = position2 === "fixed";
      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }
      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset,
        position: position2,
        rect
      };
      var menuWrapper = jsx("div", _extends({
        css: getStyles("menuPortal", state),
        className: cx({
          "menu-portal": true
        }, className)
      }, innerProps), children);
      return jsx(PortalPlacementContext.Provider, {
        value: {
          getPortalPlacement: this.getPortalPlacement
        }
      }, appendTo ? /* @__PURE__ */ createPortal(menuWrapper, appendTo) : menuWrapper);
    }
  }]);
  return MenuPortal2;
}(Component);
var containerCSS = function containerCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled, isRtl = _ref3.isRtl;
  return {
    label: "container",
    direction: isRtl ? "rtl" : void 0,
    pointerEvents: isDisabled ? "none" : void 0,
    position: "relative"
  };
};
var SelectContainer = function SelectContainer2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
  return jsx("div", _extends({
    css: getStyles("container", props),
    className: cx({
      "--is-disabled": isDisabled,
      "--is-rtl": isRtl
    }, className)
  }, innerProps), children);
};
var valueContainerCSS = function valueContainerCSS2(_ref22) {
  var spacing2 = _ref22.theme.spacing, isMulti = _ref22.isMulti, hasValue = _ref22.hasValue, controlShouldRenderValue = _ref22.selectProps.controlShouldRenderValue;
  return {
    alignItems: "center",
    display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    padding: "".concat(spacing2.baseUnit / 2, "px ").concat(spacing2.baseUnit * 2, "px"),
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  };
};
var ValueContainer = function ValueContainer2(props) {
  var children = props.children, className = props.className, cx = props.cx, innerProps = props.innerProps, isMulti = props.isMulti, getStyles = props.getStyles, hasValue = props.hasValue;
  return jsx("div", _extends({
    css: getStyles("valueContainer", props),
    className: cx({
      "value-container": true,
      "value-container--is-multi": isMulti,
      "value-container--has-value": hasValue
    }, className)
  }, innerProps), children);
};
var indicatorsContainerCSS = function indicatorsContainerCSS2() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer2(props) {
  var children = props.children, className = props.className, cx = props.cx, innerProps = props.innerProps, getStyles = props.getStyles;
  return jsx("div", _extends({
    css: getStyles("indicatorsContainer", props),
    className: cx({
      indicators: true
    }, className)
  }, innerProps), children);
};
var _templateObject;
var _excluded$2$1 = ["size"];
var _ref2$1 = {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var Svg = function Svg2(_ref3) {
  var size2 = _ref3.size, props = _objectWithoutProperties(_ref3, _excluded$2$1);
  return jsx("svg", _extends({
    height: size2,
    width: size2,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2$1
  }, props));
};
var CrossIcon = function CrossIcon2(props) {
  return jsx(Svg, _extends({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron2(props) {
  return jsx(Svg, _extends({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
};
var baseCSS = function baseCSS2(_ref3) {
  var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit2 = _ref3$theme.spacing.baseUnit, colors2 = _ref3$theme.colors;
  return {
    label: "indicatorContainer",
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    display: "flex",
    padding: baseUnit2 * 2,
    transition: "color 150ms",
    ":hover": {
      color: isFocused ? colors2.neutral80 : colors2.neutral40
    }
  };
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles("dropdownIndicator", props),
    className: cx({
      indicator: true,
      "dropdown-indicator": true
    }, className)
  }, innerProps), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles("clearIndicator", props),
    className: cx({
      indicator: true,
      "clear-indicator": true
    }, className)
  }, innerProps), children || jsx(CrossIcon, null));
};
var indicatorSeparatorCSS = function indicatorSeparatorCSS2(_ref4) {
  var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit2 = _ref4$theme.spacing.baseUnit, colors2 = _ref4$theme.colors;
  return {
    label: "indicatorSeparator",
    alignSelf: "stretch",
    backgroundColor: isDisabled ? colors2.neutral10 : colors2.neutral20,
    marginBottom: baseUnit2 * 2,
    marginTop: baseUnit2 * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator2(props) {
  var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("span", _extends({}, innerProps, {
    css: getStyles("indicatorSeparator", props),
    className: cx({
      "indicator-separator": true
    }, className)
  }));
};
var loadingDotAnimations = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS2(_ref5) {
  var isFocused = _ref5.isFocused, size2 = _ref5.size, _ref5$theme = _ref5.theme, colors2 = _ref5$theme.colors, baseUnit2 = _ref5$theme.spacing.baseUnit;
  return {
    label: "loadingIndicator",
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    display: "flex",
    padding: baseUnit2 * 2,
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: size2,
    lineHeight: 1,
    marginRight: size2,
    textAlign: "center",
    verticalAlign: "middle"
  };
};
var LoadingDot = function LoadingDot2(_ref6) {
  var delay = _ref6.delay, offset = _ref6.offset;
  return jsx("span", {
    css: /* @__PURE__ */ css$2({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: offset ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, "", "")
  });
};
var LoadingIndicator = function LoadingIndicator2(props) {
  var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isRtl = props.isRtl;
  return jsx("div", _extends({
    css: getStyles("loadingIndicator", props),
    className: cx({
      indicator: true,
      "loading-indicator": true
    }, className)
  }, innerProps), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};
var css$1 = function css(_ref3) {
  var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, _ref$theme = _ref3.theme, colors2 = _ref$theme.colors, borderRadius2 = _ref$theme.borderRadius, spacing2 = _ref$theme.spacing;
  return {
    label: "control",
    alignItems: "center",
    backgroundColor: isDisabled ? colors2.neutral5 : colors2.neutral0,
    borderColor: isDisabled ? colors2.neutral10 : isFocused ? colors2.primary : colors2.neutral20,
    borderRadius: borderRadius2,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors2.primary) : void 0,
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: spacing2.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms",
    "&:hover": {
      borderColor: isFocused ? colors2.primary : colors2.neutral30
    }
  };
};
var Control = function Control2(props) {
  var children = props.children, cx = props.cx, getStyles = props.getStyles, className = props.className, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
  return jsx("div", _extends({
    ref: innerRef,
    css: getStyles("control", props),
    className: cx({
      control: true,
      "control--is-disabled": isDisabled,
      "control--is-focused": isFocused,
      "control--menu-is-open": menuIsOpen
    }, className)
  }, innerProps), children);
};
var _excluded$1$1 = ["data"];
var groupCSS = function groupCSS2(_ref3) {
  var spacing2 = _ref3.theme.spacing;
  return {
    paddingBottom: spacing2.baseUnit * 2,
    paddingTop: spacing2.baseUnit * 2
  };
};
var Group = function Group2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
  return jsx("div", _extends({
    css: getStyles("group", props),
    className: cx({
      group: true
    }, className)
  }, innerProps), jsx(Heading, _extends({}, headingProps, {
    selectProps,
    theme,
    getStyles,
    cx
  }), label), jsx("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS2(_ref22) {
  var spacing2 = _ref22.theme.spacing;
  return {
    label: "group",
    color: "#999",
    cursor: "default",
    display: "block",
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: spacing2.baseUnit * 3,
    paddingRight: spacing2.baseUnit * 3,
    textTransform: "uppercase"
  };
};
var GroupHeading = function GroupHeading2(props) {
  var getStyles = props.getStyles, cx = props.cx, className = props.className;
  var _cleanCommonProps = cleanCommonProps(props);
  _cleanCommonProps.data;
  var innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$1$1);
  return jsx("div", _extends({
    css: getStyles("groupHeading", props),
    className: cx({
      "group-heading": true
    }, className)
  }, innerProps));
};
var _excluded$4 = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled, value = _ref3.value, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return _objectSpread2({
    margin: spacing2.baseUnit / 2,
    paddingBottom: spacing2.baseUnit / 2,
    paddingTop: spacing2.baseUnit / 2,
    visibility: isDisabled ? "hidden" : "visible",
    color: colors2.neutral80,
    transform: value ? "translateZ(0)" : ""
  }, containerStyle);
};
var spacingStyle = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": _objectSpread2({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, spacingStyle)
};
var inputStyle = function inputStyle2(isHidden) {
  return _objectSpread2({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: "100%"
  }, spacingStyle);
};
var Input = function Input2(props) {
  var className = props.className, cx = props.cx, getStyles = props.getStyles, value = props.value;
  var _cleanCommonProps = cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$4);
  return jsx("div", {
    className: cx({
      "input-container": true
    }, className),
    css: getStyles("input", props),
    "data-value": value || ""
  }, jsx("input", _extends({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};
var multiValueCSS = function multiValueCSS2(_ref3) {
  var _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, borderRadius2 = _ref$theme.borderRadius, colors2 = _ref$theme.colors;
  return {
    label: "multiValue",
    backgroundColor: colors2.neutral10,
    borderRadius: borderRadius2 / 2,
    display: "flex",
    margin: spacing2.baseUnit / 2,
    minWidth: 0
  };
};
var multiValueLabelCSS = function multiValueLabelCSS2(_ref22) {
  var _ref2$theme = _ref22.theme, borderRadius2 = _ref2$theme.borderRadius, colors2 = _ref2$theme.colors, cropWithEllipsis = _ref22.cropWithEllipsis;
  return {
    borderRadius: borderRadius2 / 2,
    color: colors2.neutral80,
    fontSize: "85%",
    overflow: "hidden",
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis || cropWithEllipsis === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS2(_ref3) {
  var _ref3$theme = _ref3.theme, spacing2 = _ref3$theme.spacing, borderRadius2 = _ref3$theme.borderRadius, colors2 = _ref3$theme.colors, isFocused = _ref3.isFocused;
  return {
    alignItems: "center",
    borderRadius: borderRadius2 / 2,
    backgroundColor: isFocused ? colors2.dangerLight : void 0,
    display: "flex",
    paddingLeft: spacing2.baseUnit,
    paddingRight: spacing2.baseUnit,
    ":hover": {
      backgroundColor: colors2.dangerLight,
      color: colors2.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric2(_ref4) {
  var children = _ref4.children, innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children, innerProps = _ref5.innerProps;
  return jsx("div", _extends({
    role: "button"
  }, innerProps), children || jsx(CrossIcon, {
    size: 14
  }));
}
var MultiValue = function MultiValue2(props) {
  var children = props.children, className = props.className, components2 = props.components, cx = props.cx, data = props.data, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps3 = props.removeProps, selectProps = props.selectProps;
  var Container = components2.Container, Label = components2.Label, Remove = components2.Remove;
  return jsx(ClassNames, null, function(_ref6) {
    var css4 = _ref6.css, emotionCx = _ref6.cx;
    return jsx(Container, {
      data,
      innerProps: _objectSpread2({
        className: emotionCx(css4(getStyles("multiValue", props)), cx({
          "multi-value": true,
          "multi-value--is-disabled": isDisabled
        }, className))
      }, innerProps),
      selectProps
    }, jsx(Label, {
      data,
      innerProps: {
        className: emotionCx(css4(getStyles("multiValueLabel", props)), cx({
          "multi-value__label": true
        }, className))
      },
      selectProps
    }, children), jsx(Remove, {
      data,
      innerProps: _objectSpread2({
        className: emotionCx(css4(getStyles("multiValueRemove", props)), cx({
          "multi-value__remove": true
        }, className)),
        "aria-label": "Remove ".concat(children || "option")
      }, removeProps3),
      selectProps
    }));
  });
};
var optionCSS = function optionCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, isSelected = _ref3.isSelected, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return {
    label: "option",
    backgroundColor: isSelected ? colors2.primary : isFocused ? colors2.primary25 : "transparent",
    color: isDisabled ? colors2.neutral20 : isSelected ? colors2.neutral0 : "inherit",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    padding: "".concat(spacing2.baseUnit * 2, "px ").concat(spacing2.baseUnit * 3, "px"),
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
    ":active": {
      backgroundColor: !isDisabled ? isSelected ? colors2.primary : colors2.primary50 : void 0
    }
  };
};
var Option = function Option2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles("option", props),
    className: cx({
      option: true,
      "option--is-disabled": isDisabled,
      "option--is-focused": isFocused,
      "option--is-selected": isSelected
    }, className),
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};
var placeholderCSS = function placeholderCSS2(_ref3) {
  var _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return {
    label: "placeholder",
    color: colors2.neutral50,
    gridArea: "1 / 1 / 2 / 3",
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2
  };
};
var Placeholder = function Placeholder2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles("placeholder", props),
    className: cx({
      placeholder: true
    }, className)
  }, innerProps), children);
};
var css2 = function css3(_ref3) {
  var isDisabled = _ref3.isDisabled, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return {
    label: "singleValue",
    color: isDisabled ? colors2.neutral40 : colors2.neutral80,
    gridArea: "1 / 1 / 2 / 3",
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  };
};
var SingleValue = function SingleValue2(props) {
  var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles("singleValue", props),
    className: cx({
      "single-value": true,
      "single-value--is-disabled": isDisabled
    }, className)
  }, innerProps), children);
};
var components = {
  ClearIndicator,
  Control,
  DropdownIndicator,
  DownChevron,
  CrossIcon,
  Group,
  GroupHeading,
  IndicatorsContainer,
  IndicatorSeparator,
  Input,
  LoadingIndicator,
  Menu,
  MenuList,
  MenuPortal,
  LoadingMessage,
  NoOptionsMessage,
  MultiValue,
  MultiValueContainer,
  MultiValueLabel,
  MultiValueRemove,
  Option,
  Placeholder,
  SelectContainer,
  SingleValue,
  ValueContainer
};
var defaultComponents = function defaultComponents2(props) {
  return _objectSpread2(_objectSpread2({}, components), props.components);
};
var _excluded$3 = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(_ref3) {
  var _ref$defaultInputValu = _ref3.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref3.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref3.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref3.inputValue, propsMenuIsOpen = _ref3.menuIsOpen, propsOnChange = _ref3.onChange, propsOnInputChange = _ref3.onInputChange, propsOnMenuClose = _ref3.onMenuClose, propsOnMenuOpen = _ref3.onMenuOpen, propsValue = _ref3.value, restSelectProps = _objectWithoutProperties(_ref3, _excluded$3);
  var _useState = useState(propsInputValue !== void 0 ? propsInputValue : defaultInputValue), _useState2 = _slicedToArray(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
  var _useState3 = useState(propsMenuIsOpen !== void 0 ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = _slicedToArray(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
  var _useState5 = useState(propsValue !== void 0 ? propsValue : defaultValue), _useState6 = _slicedToArray(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
  var onChange2 = useCallback(function(value2, actionMeta) {
    if (typeof propsOnChange === "function") {
      propsOnChange(value2, actionMeta);
    }
    setStateValue(value2);
  }, [propsOnChange]);
  var onInputChange = useCallback(function(value2, actionMeta) {
    var newValue;
    if (typeof propsOnInputChange === "function") {
      newValue = propsOnInputChange(value2, actionMeta);
    }
    setStateInputValue(newValue !== void 0 ? newValue : value2);
  }, [propsOnInputChange]);
  var onMenuOpen = useCallback(function() {
    if (typeof propsOnMenuOpen === "function") {
      propsOnMenuOpen();
    }
    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = useCallback(function() {
    if (typeof propsOnMenuClose === "function") {
      propsOnMenuClose();
    }
    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== void 0 ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== void 0 ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== void 0 ? propsValue : stateValue;
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    inputValue,
    menuIsOpen,
    onChange: onChange2,
    onInputChange,
    onMenuClose,
    onMenuOpen,
    value
  });
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === "number" && value !== value;
};
function isEqual(first, second) {
  if (first === second) {
    return true;
  }
  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }
  return false;
}
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i = 0; i < newInputs.length; i++) {
    if (!isEqual(newInputs[i], lastInputs[i])) {
      return false;
    }
  }
  return true;
}
function memoizeOne(resultFn, isEqual2) {
  if (isEqual2 === void 0) {
    isEqual2 = areInputsEqual;
  }
  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;
  function memoized() {
    var newArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }
    if (calledOnce && lastThis === this && isEqual2(newArgs, lastArgs)) {
      return lastResult;
    }
    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  }
  return memoized;
}
var _ref = {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var A11yText = function A11yText2(props) {
  return jsx("span", _extends({
    css: _ref
  }, props));
};
var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
    switch (context) {
      case "menu":
        return "Use Up and Down to choose options".concat(isDisabled ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "");
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function onChange(props) {
    var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
    switch (action) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(label, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
      case "select-option":
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context, focused = props.focused, options2 = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
    var getArrayIndex = function getArrayIndex2(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
    };
    if (context === "value" && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }
    if (context === "menu") {
      var disabled = isDisabled ? " disabled" : "";
      var status = "".concat(isSelected ? "selected" : "focused").concat(disabled);
      return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options2, focused), ".");
    }
    return "";
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
  }
};
var LiveRegion = function LiveRegion2(props) {
  var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
  var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel4 = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled3 = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options2 = selectProps.options, screenReaderStatus2 = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
  var ariaLabel = selectProps["aria-label"];
  var ariaLive = selectProps["aria-live"];
  var messages = useMemo(function() {
    return _objectSpread2(_objectSpread2({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]);
  var ariaSelected = useMemo(function() {
    var message = "";
    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
      var asOption = function asOption2(val) {
        return !Array.isArray(val) ? val : null;
      };
      var selected = removedValue || option || asOption(value);
      var label = selected ? getOptionLabel4(selected) : "";
      var multiSelected = selectedOptions || removedValues || void 0;
      var labels = multiSelected ? multiSelected.map(getOptionLabel4) : [];
      var onChangeProps = _objectSpread2({
        isDisabled: selected && isOptionDisabled3(selected, selectValue),
        label,
        labels
      }, ariaSelection);
      message = messages.onChange(onChangeProps);
    }
    return message;
  }, [ariaSelection, messages, isOptionDisabled3, selectValue, getOptionLabel4]);
  var ariaFocused = useMemo(function() {
    var focusMsg = "";
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused,
        label: getOptionLabel4(focused),
        isDisabled: isOptionDisabled3(focused, selectValue),
        isSelected,
        options: options2,
        context: focused === focusedOption ? "menu" : "value",
        selectValue
      };
      focusMsg = messages.onFocus(onFocusProps);
    }
    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel4, isOptionDisabled3, messages, options2, selectValue]);
  var ariaResults = useMemo(function() {
    var resultsMsg = "";
    if (menuIsOpen && options2.length && messages.onFilter) {
      var resultsMessage = screenReaderStatus2({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue,
        resultsMessage
      });
    }
    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options2, screenReaderStatus2]);
  var ariaGuidance = useMemo(function() {
    var guidanceMsg = "";
    if (messages.guidance) {
      var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
      guidanceMsg = messages.guidance({
        "aria-label": ariaLabel,
        context,
        isDisabled: focusedOption && isOptionDisabled3(focusedOption, selectValue),
        isMulti,
        isSearchable,
        tabSelectsValue
      });
    }
    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled3, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue]);
  var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
  var ScreenReaderText = jsx(Fragment, null, jsx("span", {
    id: "aria-selection"
  }, ariaSelected), jsx("span", {
    id: "aria-context"
  }, ariaContext));
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
  return jsx(Fragment, null, jsx(A11yText, {
    id
  }, isInitialFocus && ScreenReaderText), jsx(A11yText, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};
var diacritics = [{
  base: "A",
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: "AA",
  letters: "\uA732"
}, {
  base: "AE",
  letters: "\xC6\u01FC\u01E2"
}, {
  base: "AO",
  letters: "\uA734"
}, {
  base: "AU",
  letters: "\uA736"
}, {
  base: "AV",
  letters: "\uA738\uA73A"
}, {
  base: "AY",
  letters: "\uA73C"
}, {
  base: "B",
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: "C",
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: "D",
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: "DZ",
  letters: "\u01F1\u01C4"
}, {
  base: "Dz",
  letters: "\u01F2\u01C5"
}, {
  base: "E",
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: "F",
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: "G",
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: "H",
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: "I",
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: "J",
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: "K",
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: "L",
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: "LJ",
  letters: "\u01C7"
}, {
  base: "Lj",
  letters: "\u01C8"
}, {
  base: "M",
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: "N",
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: "NJ",
  letters: "\u01CA"
}, {
  base: "Nj",
  letters: "\u01CB"
}, {
  base: "O",
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: "OI",
  letters: "\u01A2"
}, {
  base: "OO",
  letters: "\uA74E"
}, {
  base: "OU",
  letters: "\u0222"
}, {
  base: "P",
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: "Q",
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: "R",
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: "S",
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: "T",
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: "TZ",
  letters: "\uA728"
}, {
  base: "U",
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: "V",
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: "VY",
  letters: "\uA760"
}, {
  base: "W",
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: "X",
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: "Y",
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: "Z",
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: "a",
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: "aa",
  letters: "\uA733"
}, {
  base: "ae",
  letters: "\xE6\u01FD\u01E3"
}, {
  base: "ao",
  letters: "\uA735"
}, {
  base: "au",
  letters: "\uA737"
}, {
  base: "av",
  letters: "\uA739\uA73B"
}, {
  base: "ay",
  letters: "\uA73D"
}, {
  base: "b",
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: "c",
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: "d",
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: "dz",
  letters: "\u01F3\u01C6"
}, {
  base: "e",
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: "f",
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: "g",
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: "h",
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: "hv",
  letters: "\u0195"
}, {
  base: "i",
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: "j",
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: "k",
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: "l",
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: "lj",
  letters: "\u01C9"
}, {
  base: "m",
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: "n",
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: "nj",
  letters: "\u01CC"
}, {
  base: "o",
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: "oi",
  letters: "\u01A3"
}, {
  base: "ou",
  letters: "\u0223"
}, {
  base: "oo",
  letters: "\uA74F"
}, {
  base: "p",
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: "q",
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: "r",
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: "s",
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: "t",
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: "tz",
  letters: "\uA729"
}, {
  base: "u",
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: "v",
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: "vy",
  letters: "\uA761"
}, {
  base: "w",
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: "x",
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: "y",
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: "z",
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp("[" + diacritics.map(function(d2) {
  return d2.letters;
}).join("") + "]", "g");
var diacriticToBase = {};
for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];
  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}
var stripDiacritics = function stripDiacritics2(str) {
  return str.replace(anyDiacritic, function(match2) {
    return diacriticToBase[match2];
  });
};
var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics);
var trimString = function trimString2(str) {
  return str.replace(/^\s+|\s+$/g, "");
};
var defaultStringify = function defaultStringify2(option) {
  return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter2(config) {
  return function(option, rawInput) {
    if (option.data.__isNew__)
      return true;
    var _ignoreCase$ignoreAcc = _objectSpread2({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: "any"
    }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify2 = _ignoreCase$ignoreAcc.stringify, trim2 = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
    var input = trim2 ? trimString(rawInput) : rawInput;
    var candidate = trim2 ? trimString(stringify2(option)) : stringify2(option);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};
var _excluded$2 = ["innerRef"];
function DummyInput(_ref3) {
  var innerRef = _ref3.innerRef, props = _objectWithoutProperties(_ref3, _excluded$2);
  var filteredProps = removeProps(props, "onExited", "in", "enter", "exit", "appear");
  return jsx("input", _extends({
    ref: innerRef
  }, filteredProps, {
    css: /* @__PURE__ */ css$2({
      label: "dummyInput",
      background: 0,
      border: 0,
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      width: 1,
      color: "transparent",
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, "", "")
  }));
}
var cancelScroll = function cancelScroll2(event) {
  event.preventDefault();
  event.stopPropagation();
};
function useScrollCapture(_ref3) {
  var isEnabled = _ref3.isEnabled, onBottomArrive = _ref3.onBottomArrive, onBottomLeave = _ref3.onBottomLeave, onTopArrive = _ref3.onTopArrive, onTopLeave = _ref3.onTopLeave;
  var isBottom = useRef(false);
  var isTop = useRef(false);
  var touchStart = useRef(0);
  var scrollTarget = useRef(null);
  var handleEventDelta = useCallback(function(event, delta) {
    if (scrollTarget.current === null)
      return;
    var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false;
    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave)
        onBottomLeave(event);
      isBottom.current = false;
    }
    if (isDeltaPositive && isTop.current) {
      if (onTopLeave)
        onTopLeave(event);
      isTop.current = false;
    }
    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }
      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true;
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }
      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    }
    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = useCallback(function(event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = useCallback(function(event) {
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = useCallback(function(event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = useCallback(function(el) {
    if (!el)
      return;
    var notPassive = supportsPassiveEvents ? {
      passive: false
    } : false;
    el.addEventListener("wheel", onWheel, notPassive);
    el.addEventListener("touchstart", onTouchStart, notPassive);
    el.addEventListener("touchmove", onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = useCallback(function(el) {
    if (!el)
      return;
    el.removeEventListener("wheel", onWheel, false);
    el.removeEventListener("touchstart", onTouchStart, false);
    el.removeEventListener("touchmove", onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  useEffect(function() {
    if (!isEnabled)
      return;
    var element = scrollTarget.current;
    startListening(element);
    return function() {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function(element) {
    scrollTarget.current = element;
  };
}
var STYLE_KEYS = ["boxSizing", "height", "overflow", "paddingRight", "position"];
var LOCK_STYLES = {
  boxSizing: "border-box",
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function preventTouchMove(e2) {
  e2.preventDefault();
}
function allowTouchMove(e2) {
  e2.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;
  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}
function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref3) {
  var isEnabled = _ref3.isEnabled, _ref$accountForScroll = _ref3.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = useRef({});
  var scrollTarget = useRef(null);
  var addScrollLock = useCallback(function(touchScrollTarget) {
    if (!canUseDOM)
      return;
    var target = document.body;
    var targetStyle = target && target.style;
    if (accountForScrollbars) {
      STYLE_KEYS.forEach(function(key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    }
    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function(key) {
        var val = LOCK_STYLES[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    }
    if (target && isTouchDevice()) {
      target.addEventListener("touchmove", preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.addEventListener("touchstart", preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener("touchmove", allowTouchMove, listenerOptions);
      }
    }
    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = useCallback(function(touchScrollTarget) {
    if (!canUseDOM)
      return;
    var target = document.body;
    var targetStyle = target && target.style;
    activeScrollLocks = Math.max(activeScrollLocks - 1, 0);
    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function(key) {
        var val = originalStyles.current[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    }
    if (target && isTouchDevice()) {
      target.removeEventListener("touchmove", preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener("touchstart", preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener("touchmove", allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  useEffect(function() {
    if (!isEnabled)
      return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function() {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function(element) {
    scrollTarget.current = element;
  };
}
var blurSelectInput = function blurSelectInput2() {
  return document.activeElement && document.activeElement.blur();
};
var _ref2 = {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function ScrollManager(_ref3) {
  var children = _ref3.children, lockEnabled = _ref3.lockEnabled, _ref$captureEnabled = _ref3.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref3.onBottomArrive, onBottomLeave = _ref3.onBottomLeave, onTopArrive = _ref3.onTopArrive, onTopLeave = _ref3.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive,
    onBottomLeave,
    onTopArrive,
    onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });
  var targetRef = function targetRef2(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };
  return jsx(Fragment, null, lockEnabled && jsx("div", {
    onClick: blurSelectInput,
    css: _ref2
  }), children(targetRef));
}
var formatGroupLabel = function formatGroupLabel2(group) {
  return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled2(option) {
  return !!option.isDisabled;
};
var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css2,
  valueContainer: valueContainerCSS
};
function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var styles = _objectSpread2({}, source);
  Object.keys(target).forEach(function(keyAsString) {
    var key = keyAsString;
    if (source[key]) {
      styles[key] = function(rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });
  return styles;
}
var colors = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
};
var borderRadius = 4;
var baseUnit = 4;
var controlHeight = 38;
var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit,
  controlHeight,
  menuGutter
};
var defaultTheme = {
  borderRadius,
  colors,
  spacing
};
var defaultProps = {
  "aria-live": "polite",
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return "No options";
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function screenReaderStatus(_ref3) {
    var count = _ref3.count;
    return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true
};
function toCategorizedOption(props, option, selectValue, index) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);
  var isSelected = _isOptionSelected(props, option, selectValue);
  var label = getOptionLabel2(props, option);
  var value = getOptionValue2(props, option);
  return {
    type: "option",
    data: option,
    isDisabled,
    isSelected,
    label,
    value,
    index
  };
}
function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function(groupOrOption, groupOrOptionIndex) {
    if ("options" in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function(categorizedOption2) {
        return isFocusable(props, categorizedOption2);
      });
      return categorizedOptions.length > 0 ? {
        type: "group",
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : void 0;
    }
    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable(props, categorizedOption) ? categorizedOption : void 0;
  }).filter(notNullish);
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === "group") {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function(option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
  var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label,
    value,
    data
  }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
    if (nextFocusedIndex > -1) {
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      return nextSelectValue[lastFocusedIndex];
    }
  }
  return null;
}
function getNextFocusedOption(state, options2) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options2.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options2[0];
}
var getOptionLabel2 = function getOptionLabel3(props, data) {
  return props.getOptionLabel(data);
};
var getOptionValue2 = function getOptionValue3(props, data) {
  return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1)
    return true;
  if (typeof props.isOptionSelected === "function") {
    return props.isOptionSelected(option, selectValue);
  }
  var candidate = getOptionValue2(props, option);
  return selectValue.some(function(i) {
    return getOptionValue2(props, i) === candidate;
  });
}
function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions2(props) {
  var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
  if (hideSelectedOptions === void 0)
    return isMulti;
  return hideSelectedOptions;
};
var instanceId = 1;
var Select = /* @__PURE__ */ function(_Component) {
  _inherits(Select2, _Component);
  var _super = _createSuper(Select2);
  function Select2(_props) {
    var _this;
    _classCallCheck(this, Select2);
    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.instancePrefix = "";
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;
    _this.getControlRef = function(ref) {
      _this.controlRef = ref;
    };
    _this.focusedOptionRef = null;
    _this.getFocusedOptionRef = function(ref) {
      _this.focusedOptionRef = ref;
    };
    _this.menuListRef = null;
    _this.getMenuListRef = function(ref) {
      _this.menuListRef = ref;
    };
    _this.inputRef = null;
    _this.getInputRef = function(ref) {
      _this.inputRef = ref;
    };
    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;
    _this.onChange = function(newValue, actionMeta) {
      var _this$props = _this.props, onChange2 = _this$props.onChange, name = _this$props.name;
      actionMeta.name = name;
      _this.ariaOnChange(newValue, actionMeta);
      onChange2(newValue, actionMeta);
    };
    _this.setValue = function(newValue, action, option) {
      var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
      _this.onInputChange("", {
        action: "set-value",
        prevInputValue: inputValue
      });
      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      }
      _this.setState({
        clearFocusValueOnUpdate: true
      });
      _this.onChange(newValue, {
        action,
        option
      });
    };
    _this.selectOption = function(newValue) {
      var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
      var selectValue = _this.state.selectValue;
      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
      var isDisabled = _this.isOptionDisabled(newValue, selectValue);
      if (deselected) {
        var candidate = _this.getOptionValue(newValue);
        _this.setValue(multiValueAsValue(selectValue.filter(function(i) {
          return _this.getOptionValue(i) !== candidate;
        })), "deselect-option", newValue);
      } else if (!isDisabled) {
        if (isMulti) {
          _this.setValue(multiValueAsValue([].concat(_toConsumableArray(selectValue), [newValue])), "select-option", newValue);
        } else {
          _this.setValue(singleValueAsValue(newValue), "select-option");
        }
      } else {
        _this.ariaOnChange(singleValueAsValue(newValue), {
          action: "select-option",
          option: newValue,
          name
        });
        return;
      }
      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };
    _this.removeValue = function(removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var candidate = _this.getOptionValue(removedValue);
      var newValueArray = selectValue.filter(function(i) {
        return _this.getOptionValue(i) !== candidate;
      });
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: "remove-value",
        removedValue
      });
      _this.focusInput();
    };
    _this.clearValue = function() {
      var selectValue = _this.state.selectValue;
      _this.onChange(valueTernary(_this.props.isMulti, [], null), {
        action: "clear",
        removedValues: selectValue
      });
    };
    _this.popValue = function() {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: "pop-value",
        removedValue: lastSelectedValue
      });
    };
    _this.getValue = function() {
      return _this.state.selectValue;
    };
    _this.cx = function() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };
    _this.getOptionLabel = function(data) {
      return getOptionLabel2(_this.props, data);
    };
    _this.getOptionValue = function(data) {
      return getOptionValue2(_this.props, data);
    };
    _this.getStyles = function(key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = "border-box";
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };
    _this.getElementId = function(element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    };
    _this.getComponents = function() {
      return defaultComponents(_this.props);
    };
    _this.buildCategorizedOptions = function() {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };
    _this.getCategorizedOptions = function() {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };
    _this.buildFocusableOptions = function() {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };
    _this.getFocusableOptions = function() {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };
    _this.ariaOnChange = function(value, actionMeta) {
      _this.setState({
        ariaSelection: _objectSpread2({
          value
        }, actionMeta)
      });
    };
    _this.onMenuMouseDown = function(event) {
      if (event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      _this.focusInput();
    };
    _this.onMenuMouseMove = function(event) {
      _this.blockOptionHover = false;
    };
    _this.onControlMouseDown = function(event) {
      if (event.defaultPrevented) {
        return;
      }
      var openMenuOnClick = _this.props.openMenuOnClick;
      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }
        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu("first");
        }
      } else {
        if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
          _this.onMenuClose();
        }
      }
      if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
        event.preventDefault();
      }
    };
    _this.onDropdownIndicatorMouseDown = function(event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }
      if (_this.props.isDisabled)
        return;
      var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
      _this.focusInput();
      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      } else {
        _this.openMenu("first");
      }
      event.preventDefault();
    };
    _this.onClearIndicatorMouseDown = function(event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }
      _this.clearValue();
      event.preventDefault();
      _this.openAfterFocus = false;
      if (event.type === "touchend") {
        _this.focusInput();
      } else {
        setTimeout(function() {
          return _this.focusInput();
        });
      }
    };
    _this.onScroll = function(event) {
      if (typeof _this.props.closeMenuOnScroll === "boolean") {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === "function") {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };
    _this.onCompositionStart = function() {
      _this.isComposing = true;
    };
    _this.onCompositionEnd = function() {
      _this.isComposing = false;
    };
    _this.onTouchStart = function(_ref22) {
      var touches = _ref22.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };
    _this.onTouchMove = function(_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };
    _this.onTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      }
      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };
    _this.onControlTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      _this.onControlMouseDown(event);
    };
    _this.onClearIndicatorTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      _this.onClearIndicatorMouseDown(event);
    };
    _this.onDropdownIndicatorTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      _this.onDropdownIndicatorMouseDown(event);
    };
    _this.handleInputChange = function(event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;
      _this.setState({
        inputIsHiddenAfterUpdate: false
      });
      _this.onInputChange(inputValue, {
        action: "input-change",
        prevInputValue
      });
      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };
    _this.onInputFocus = function(event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });
      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu("first");
      }
      _this.openAfterFocus = false;
    };
    _this.onInputBlur = function(event) {
      var prevInputValue = _this.props.inputValue;
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();
        return;
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      _this.onInputChange("", {
        action: "input-blur",
        prevInputValue
      });
      _this.onMenuClose();
      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };
    _this.onOptionHover = function(focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }
      _this.setState({
        focusedOption
      });
    };
    _this.shouldHideSelectedOptions = function() {
      return shouldHideSelectedOptions(_this.props);
    };
    _this.onKeyDown = function(event) {
      var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
      if (isDisabled)
        return;
      if (typeof onKeyDown === "function") {
        onKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      }
      _this.blockOptionHover = true;
      switch (event.key) {
        case "ArrowLeft":
          if (!isMulti || inputValue)
            return;
          _this.focusValue("previous");
          break;
        case "ArrowRight":
          if (!isMulti || inputValue)
            return;
          _this.focusValue("next");
          break;
        case "Delete":
        case "Backspace":
          if (inputValue)
            return;
          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue)
              return;
            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }
          break;
        case "Tab":
          if (_this.isComposing)
            return;
          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }
          _this.selectOption(focusedOption);
          break;
        case "Enter":
          if (event.keyCode === 229) {
            break;
          }
          if (menuIsOpen) {
            if (!focusedOption)
              return;
            if (_this.isComposing)
              return;
            _this.selectOption(focusedOption);
            break;
          }
          return;
        case "Escape":
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange("", {
              action: "menu-close",
              prevInputValue: inputValue
            });
            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }
          break;
        case " ":
          if (inputValue) {
            return;
          }
          if (!menuIsOpen) {
            _this.openMenu("first");
            break;
          }
          if (!focusedOption)
            return;
          _this.selectOption(focusedOption);
          break;
        case "ArrowUp":
          if (menuIsOpen) {
            _this.focusOption("up");
          } else {
            _this.openMenu("last");
          }
          break;
        case "ArrowDown":
          if (menuIsOpen) {
            _this.focusOption("down");
          } else {
            _this.openMenu("first");
          }
          break;
        case "PageUp":
          if (!menuIsOpen)
            return;
          _this.focusOption("pageup");
          break;
        case "PageDown":
          if (!menuIsOpen)
            return;
          _this.focusOption("pagedown");
          break;
        case "Home":
          if (!menuIsOpen)
            return;
          _this.focusOption("first");
          break;
        case "End":
          if (!menuIsOpen)
            return;
          _this.focusOption("last");
          break;
        default:
          return;
      }
      event.preventDefault();
    };
    _this.instancePrefix = "react-select-" + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = cleanValue(_props.value);
    return _this;
  }
  _createClass(Select2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();
      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        document.addEventListener("scroll", this.onScroll, true);
      }
      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;
      if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }
      if (isFocused && isDisabled && !prevProps.isDisabled) {
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      }
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener("scroll", this.onScroll, true);
    }
  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }
  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef)
        return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef)
        return;
      this.inputRef.blur();
    }
  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;
      var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }
      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex]
      }, function() {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
      if (!this.props.isMulti)
        return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
      }
      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length)
        return;
      switch (direction) {
        case "previous":
          if (focusedIndex === 0) {
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case "next":
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }
      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first";
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options2 = this.getFocusableOptions();
      if (!options2.length)
        return;
      var nextFocus = 0;
      var focusedIndex = options2.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
      }
      if (direction === "up") {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options2.length - 1;
      } else if (direction === "down") {
        nextFocus = (focusedIndex + 1) % options2.length;
      } else if (direction === "pageup") {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0)
          nextFocus = 0;
      } else if (direction === "pagedown") {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options2.length - 1)
          nextFocus = options2.length - 1;
      } else if (direction === "last") {
        nextFocus = options2.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options2[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: "getTheme",
    value: function getTheme() {
      if (!this.props.theme) {
        return defaultTheme;
      }
      if (typeof this.props.theme === "function") {
        return this.props.theme(defaultTheme);
      }
      return _objectSpread2(_objectSpread2({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
      var isMulti = props.isMulti, isRtl = props.isRtl, options2 = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue,
        cx,
        getStyles,
        getValue,
        hasValue,
        isMulti,
        isRtl,
        options: options2,
        selectOption,
        selectProps: props,
        setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props, isClearable2 = _this$props7.isClearable, isMulti = _this$props7.isMulti;
      if (isClearable2 === void 0)
        return isMulti;
      return isClearable2;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled3(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === "function") {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel3(data) {
      return this.props.formatGroupLabel(data);
    }
  }, {
    key: "startListeningComposition",
    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener("compositionstart", this.onCompositionStart, false);
        document.addEventListener("compositionend", this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener("compositionstart", this.onCompositionStart);
        document.removeEventListener("compositionend", this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener("touchstart", this.onTouchStart, false);
        document.addEventListener("touchmove", this.onTouchMove, false);
        document.addEventListener("touchend", this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener("touchstart", this.onTouchStart);
        document.removeEventListener("touchmove", this.onTouchMove);
        document.removeEventListener("touchend", this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen;
      var _this$getComponents = this.getComponents(), Input3 = _this$getComponents.Input;
      var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
      var commonProps = this.commonProps;
      var id = inputId || this.getElementId("input");
      var ariaAttributes = _objectSpread2(_objectSpread2(_objectSpread2({
        "aria-autocomplete": "list",
        "aria-expanded": menuIsOpen,
        "aria-haspopup": true,
        "aria-errormessage": this.props["aria-errormessage"],
        "aria-invalid": this.props["aria-invalid"],
        "aria-label": this.props["aria-label"],
        "aria-labelledby": this.props["aria-labelledby"],
        role: "combobox"
      }, menuIsOpen && {
        "aria-controls": this.getElementId("listbox"),
        "aria-owns": this.getElementId("listbox")
      }), !isSearchable && {
        "aria-readonly": true
      }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
        "aria-describedby": this.getElementId("live-region")
      } : {
        "aria-describedby": this.getElementId("placeholder")
      });
      if (!isSearchable) {
        return /* @__PURE__ */ React.createElement(DummyInput, _extends({
          id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          disabled: isDisabled,
          tabIndex,
          inputMode: "none",
          form,
          value: ""
        }, ariaAttributes));
      }
      return /* @__PURE__ */ React.createElement(Input3, _extends({}, commonProps, {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id,
        innerRef: this.getInputRef,
        isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex,
        form,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;
      var _this$getComponents2 = this.getComponents(), MultiValue3 = _this$getComponents2.MultiValue, MultiValueContainer2 = _this$getComponents2.MultiValueContainer, MultiValueLabel2 = _this$getComponents2.MultiValueLabel, MultiValueRemove2 = _this$getComponents2.MultiValueRemove, SingleValue3 = _this$getComponents2.SingleValue, Placeholder3 = _this$getComponents2.Placeholder;
      var commonProps = this.commonProps;
      var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
      var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /* @__PURE__ */ React.createElement(Placeholder3, _extends({}, commonProps, {
          key: "placeholder",
          isDisabled,
          isFocused,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), placeholder);
      }
      if (isMulti) {
        return selectValue.map(function(opt, index) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /* @__PURE__ */ React.createElement(MultiValue3, _extends({}, commonProps, {
            components: {
              Container: MultiValueContainer2,
              Label: MultiValueLabel2,
              Remove: MultiValueRemove2
            },
            isFocused: isOptionFocused,
            isDisabled,
            key,
            index,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e2) {
                e2.preventDefault();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, "value"));
        });
      }
      if (inputValue) {
        return null;
      }
      var singleValue = selectValue[0];
      return /* @__PURE__ */ React.createElement(SingleValue3, _extends({}, commonProps, {
        data: singleValue,
        isDisabled
      }), this.formatOptionLabel(singleValue, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(), ClearIndicator3 = _this$getComponents3.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;
      if (!this.isClearable() || !ClearIndicator3 || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }
      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ React.createElement(ClearIndicator3, _extends({}, commonProps, {
        innerProps,
        isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(), LoadingIndicator3 = _this$getComponents4.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator3 || !isLoading)
        return null;
      var innerProps = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ React.createElement(LoadingIndicator3, _extends({}, commonProps, {
        innerProps,
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(), DropdownIndicator3 = _this$getComponents5.DropdownIndicator, IndicatorSeparator3 = _this$getComponents5.IndicatorSeparator;
      if (!DropdownIndicator3 || !IndicatorSeparator3)
        return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /* @__PURE__ */ React.createElement(IndicatorSeparator3, _extends({}, commonProps, {
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(), DropdownIndicator3 = _this$getComponents6.DropdownIndicator;
      if (!DropdownIndicator3)
        return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ React.createElement(DropdownIndicator3, _extends({}, commonProps, {
        innerProps,
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;
      var _this$getComponents7 = this.getComponents(), Group3 = _this$getComponents7.Group, GroupHeading3 = _this$getComponents7.GroupHeading, Menu3 = _this$getComponents7.Menu, MenuList3 = _this$getComponents7.MenuList, MenuPortal2 = _this$getComponents7.MenuPortal, LoadingMessage3 = _this$getComponents7.LoadingMessage, NoOptionsMessage3 = _this$getComponents7.NoOptionsMessage, Option3 = _this$getComponents7.Option;
      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage2 = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage2 = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen)
        return null;
      var render = function render2(props, id) {
        var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
        var isFocused = focusedOption === data;
        var onHover = isDisabled ? void 0 : function() {
          return _this4.onOptionHover(data);
        };
        var onSelect = isDisabled ? void 0 : function() {
          return _this4.selectOption(data);
        };
        var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1
        };
        return /* @__PURE__ */ React.createElement(Option3, _extends({}, commonProps, {
          innerProps,
          data,
          isDisabled,
          isSelected,
          key: optionId,
          label,
          type,
          value,
          isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : void 0
        }), _this4.formatOptionLabel(props.data, "menu"));
      };
      var menuUI;
      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function(item) {
          if (item.type === "group") {
            var _data = item.data, options2 = item.options, groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /* @__PURE__ */ React.createElement(Group3, _extends({}, commonProps, {
              key: groupId,
              data: _data,
              options: options2,
              Heading: GroupHeading3,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this4.formatGroupLabel(item.data)
            }), item.options.map(function(option) {
              return render(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item.type === "option") {
            return render(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message = loadingMessage2({
          inputValue
        });
        if (message === null)
          return null;
        menuUI = /* @__PURE__ */ React.createElement(LoadingMessage3, commonProps, message);
      } else {
        var _message = noOptionsMessage2({
          inputValue
        });
        if (_message === null)
          return null;
        menuUI = /* @__PURE__ */ React.createElement(NoOptionsMessage3, commonProps, _message);
      }
      var menuPlacementProps = {
        minMenuHeight,
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView
      };
      var menuElement = /* @__PURE__ */ React.createElement(MenuPlacer, _extends({}, commonProps, menuPlacementProps), function(_ref4) {
        var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
        return /* @__PURE__ */ React.createElement(Menu3, _extends({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove,
            id: _this4.getElementId("listbox")
          },
          isLoading,
          placement
        }), /* @__PURE__ */ React.createElement(ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function(scrollTargetRef) {
          return /* @__PURE__ */ React.createElement(MenuList3, _extends({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);
              scrollTargetRef(instance);
            },
            isLoading,
            maxHeight,
            focusedOption
          }), menuUI);
        }));
      });
      return menuPortalTarget || menuPosition === "fixed" ? /* @__PURE__ */ React.createElement(MenuPortal2, _extends({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement,
        menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;
      var _this$props13 = this.props, delimiter2 = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled)
        return;
      if (isMulti) {
        if (delimiter2) {
          var value = selectValue.map(function(opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter2);
          return /* @__PURE__ */ React.createElement("input", {
            name,
            type: "hidden",
            value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
            return /* @__PURE__ */ React.createElement("input", {
              key: "i-".concat(i),
              name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /* @__PURE__ */ React.createElement("input", {
            name,
            type: "hidden"
          });
          return /* @__PURE__ */ React.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
        return /* @__PURE__ */ React.createElement("input", {
          name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /* @__PURE__ */ React.createElement(LiveRegion, _extends({}, commonProps, {
        id: this.getElementId("live-region"),
        ariaSelection,
        focusedOption,
        focusedValue,
        isFocused,
        selectValue,
        focusableOptions
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(), Control3 = _this$getComponents8.Control, IndicatorsContainer3 = _this$getComponents8.IndicatorsContainer, SelectContainer3 = _this$getComponents8.SelectContainer, ValueContainer3 = _this$getComponents8.ValueContainer;
      var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ React.createElement(SelectContainer3, _extends({}, commonProps, {
        className,
        innerProps: {
          id,
          onKeyDown: this.onKeyDown
        },
        isDisabled,
        isFocused
      }), this.renderLiveRegion(), /* @__PURE__ */ React.createElement(Control3, _extends({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled,
        isFocused,
        menuIsOpen
      }), /* @__PURE__ */ React.createElement(ValueContainer3, _extends({}, commonProps, {
        isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ React.createElement(IndicatorsContainer3, _extends({}, commonProps, {
        isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
      var options2 = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
      var selectValue = cleanValue(value);
      var newMenuOptionsState = {};
      if (prevProps && (value !== prevProps.value || options2 !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        newMenuOptionsState = {
          selectValue,
          focusedOption,
          focusedValue,
          clearFocusValueOnUpdate: false
        };
      }
      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: void 0
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;
      if (isFocused && !hasKeptFocus) {
        newAriaSelection = {
          value: valueTernary(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: "initial-input-focus"
        };
        hasKeptFocus = !prevWasFocused;
      }
      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") {
        newAriaSelection = null;
      }
      return _objectSpread2(_objectSpread2(_objectSpread2({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);
  return Select2;
}(Component);
Select.defaultProps = defaultProps;
var StateManagedSelect = /* @__PURE__ */ forwardRef(function(props, ref) {
  var baseSelectProps = useStateManager(props);
  return /* @__PURE__ */ React.createElement(Select, _extends({
    ref
  }, baseSelectProps));
});
var NonceProvider = /* @__PURE__ */ function(_Component) {
  _inherits(NonceProvider2, _Component);
  var _super = _createSuper(NonceProvider2);
  function NonceProvider2(props) {
    var _this;
    _classCallCheck(this, NonceProvider2);
    _this = _super.call(this, props);
    _this.createEmotionCache = function(nonce, key) {
      return createCache({
        nonce,
        key
      });
    };
    _this.createEmotionCache = memoizeOne(_this.createEmotionCache);
    return _this;
  }
  _createClass(NonceProvider2, [{
    key: "render",
    value: function render() {
      var emotionCache = this.createEmotionCache(this.props.nonce, this.props.cacheKey);
      return /* @__PURE__ */ React.createElement(CacheProvider, {
        value: emotionCache
      }, this.props.children);
    }
  }]);
  return NonceProvider2;
}(Component);
var reactSelect_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": StateManagedSelect,
  NonceProvider,
  useStateManager,
  createFilter,
  defaultTheme,
  mergeStyles,
  components
}, Symbol.toStringTag, { value: "Module" }));
const LitChainSelector = () => {
  const {
    chain,
    setChain,
    chainList,
    allowChainSelector
  } = useContext(ShareModalContext);
  const {
    Option: Option3
  } = components;
  const IconOption = (props) => {
    return /* @__PURE__ */ jsxs(Option3, __spreadProps(__spreadValues({}, props), {
      children: [/* @__PURE__ */ jsx$1("img", {
        src: props.data.logo,
        style: {
          height: "1em",
          marginRight: "0.5em"
        },
        className: "lsm-chain-selector-options-icons",
        alt: props.data.label
      }), props.data.label]
    }));
  };
  return /* @__PURE__ */ jsx$1("div", {
    children: !!chain && !!chainList && /* @__PURE__ */ jsxs("span", {
      className: "lsm-chain-selector-container",
      children: [/* @__PURE__ */ jsx$1("img", {
        src: chain.logo,
        className: "lsm-chain-selector-control-icon"
      }), allowChainSelector ? /* @__PURE__ */ jsx$1(StateManagedSelect, {
        className: "lsm-chain-selector",
        classNamePrefix: "lsm",
        defaultValue: chainList.find((c2) => c2.value === chain.value),
        options: chainList,
        onChange: (c2) => setChain(c2),
        components: {
          Option: IconOption
        }
      }) : /* @__PURE__ */ jsx$1("span", {
        className: "lsm-disabled-selector",
        children: chain.label
      })]
    })
  });
};
const LitChooseAccessButton = (props) => {
  return /* @__PURE__ */ jsxs("button", {
    className: "lsm-choose-access-button",
    onClick: props.onClick,
    children: [!!props["img"] && /* @__PURE__ */ jsx$1("img", {
      className: "lsm-choose-access-button-icon",
      src: props.img
    }), props.label]
  });
};
var venn = "data:image/svg+xml;base64,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";
const LitBackButton = ({
  onClick,
  label,
  backgroundColor = "lsm-bg-white"
}) => {
  return /* @__PURE__ */ jsxs("button", {
    className: `${backgroundColor} lsm-text-brand-4 lsm-back-button`,
    onClick,
    children: [/* @__PURE__ */ jsx$1("span", {
      className: "lsm-back-arrow",
      children: "\u2190"
    }), !label ? "BACK" : label]
  });
};
const LitNextButton = ({
  disabled = false,
  onClick,
  label
}) => {
  return /* @__PURE__ */ jsxs("button", {
    className: "lsm-next-button",
    disabled,
    onClick,
    children: [/* @__PURE__ */ jsx$1("span", {
      className: "lsm-next-label",
      children: !label ? "NEXT" : label
    }), /* @__PURE__ */ jsx$1("span", {
      className: "lsm-next-arrow",
      children: "\u2192"
    })]
  });
};
const LitFooter = ({
  backAction = null,
  nextAction = null,
  disableNextButton = null,
  backgroundColor = "lsm-bg-white",
  nextButtonLabel = null
}) => {
  console.log("disable next button", disableNextButton);
  return /* @__PURE__ */ jsxs("div", {
    className: `${backgroundColor} lsm-lit-footer`,
    children: [!!backAction && /* @__PURE__ */ jsx$1(LitBackButton, {
      onClick: backAction,
      backgroundColor
    }), !!nextAction && /* @__PURE__ */ jsx$1(LitNextButton, {
      disabled: disableNextButton,
      onClick: nextAction,
      label: nextButtonLabel
    })]
  });
};
const SingleConditionSelect = ({
  chain,
  initialState = null,
  initialCondition = null
}) => {
  const {
    handleUpdateUnifiedAccessControlConditions,
    setDisplayedPage,
    setFlow,
    allowMultipleConditions
  } = useContext(ShareModalContext);
  const [selectPage, setSelectPage] = useState("chooseAccess");
  const [unifiedAccessControlConditions, setUnifiedAccessControlConditions] = useState([]);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  useEffect(() => {
    if (initialCondition) {
      setSelectPage(initialCondition);
    }
  }, []);
  const coordinateUpdateAccessControl = () => {
    handleUpdateUnifiedAccessControlConditions(unifiedAccessControlConditions);
    setUnifiedAccessControlConditions([]);
    setSelectPage("chooseAccess");
    setDisplayedPage("review");
  };
  const backButtonAction = () => {
    setSelectPage("chooseAccess");
    setUnifiedAccessControlConditions([]);
  };
  const getRenderedConditionOption = () => {
    const conditionTypeData = chain.types.conditionTypeData;
    if (selectPage === "chooseAccess") {
      return /* @__PURE__ */ jsxs("div", {
        className: "lsm-single-condition-rendering-options-container",
        children: [/* @__PURE__ */ jsx$1("h3", {
          className: "lsm-single-condition-select-prompt",
          children: "Choose who can access this:"
        }), Object.keys(chain.types.conditionTypes).map((c2, i) => {
          if (!conditionTypeData[c2].supportedChains || conditionTypeData[c2].supportedChains.includes(chain.value)) {
            return /* @__PURE__ */ jsx$1(LitChooseAccessButton, {
              onClick: () => setSelectPage(c2),
              label: conditionTypeData[c2].label,
              img: conditionTypeData[c2].img
            }, i);
          } else {
            return null;
          }
        })]
      });
    } else {
      if (chain.types.conditionTypes[selectPage]) {
        const ConditionHolder = chain.types.conditionTypes[selectPage];
        return /* @__PURE__ */ jsx$1(ConditionHolder, {
          updateUnifiedAccessControlConditions: setUnifiedAccessControlConditions,
          chain,
          initialState,
          submitDisabled: setSubmitDisabled
        });
      } else {
        setSelectPage("chooseAccess");
      }
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-single-condition-select-container",
    children: [/* @__PURE__ */ jsx$1(LitChainSelector, {}), !!chain && !!setSelectPage && /* @__PURE__ */ jsx$1("div", {
      className: "lsm-single-select-condition-display",
      children: getRenderedConditionOption()
    }), selectPage === "chooseAccess" && allowMultipleConditions && /* @__PURE__ */ jsxs("button", {
      className: "lsm-single-condition-multiple-button",
      onClick: () => {
        setFlow("multipleConditions");
        setDisplayedPage("multiple");
      },
      children: [/* @__PURE__ */ jsx$1("img", {
        src: venn
      }), /* @__PURE__ */ jsx$1("p", {
        className: "",
        children: "Gate with multiple conditions using AND/OR operators"
      })]
    }), selectPage !== "chooseAccess" && /* @__PURE__ */ jsx$1(LitFooter, {
      className: "lsm-single-condition-footer",
      backAction: backButtonAction,
      nextAction: coordinateUpdateAccessControl,
      disableNextButton: submitDisabled
    })]
  });
};
const colorArray = [
  "rgba(0, 148, 255, .22)",
  "rgba(255,0,0,0.22)",
  "rgba(255, 230, 0, 0.22)",
  "rgba(0,255,87,0.22)",
  "rgba(255,153,0,0.5)",
  "rgba(183,0,255,0.5)",
  "rgba(0,255,187,0.5)",
  "rgba(0, 148, 255, .22)",
  "rgba(255,0,0,0.22)",
  "rgba(0,255,87,0.22)",
  "rgba(255,153,0,0.5)",
  "rgba(183,0,255,0.5)",
  "rgba(0,255,187,0.5)"
];
const LitDeleteModal = ({
  showDeleteModal,
  onClick
}) => {
  return /* @__PURE__ */ jsx$1("div", {
    children: !!showDeleteModal && /* @__PURE__ */ jsx$1("div", {
      className: "lsm-delete-modal-container",
      children: /* @__PURE__ */ jsxs("div", {
        className: "lsm-delete-modal",
        children: [/* @__PURE__ */ jsx$1("h3", {
          className: "lsm-delete-modal-prompt",
          children: "Are you sure you want to delete this access control condition?"
        }), /* @__PURE__ */ jsxs("span", {
          className: "lsm-delete-modal-button-container",
          children: [/* @__PURE__ */ jsx$1("button", {
            className: "lsm-delete-modal-button-no",
            onClick: () => onClick("no"),
            children: "NO"
          }), /* @__PURE__ */ jsx$1("button", {
            className: "lsm-delete-modal-button-yes",
            onClick: () => onClick("yes"),
            children: "YES"
          })]
        })]
      })
    })
  });
};
const MultipleConditionsEditor = ({
  humanizedUnifiedAccessControlConditions,
  createCondition
}) => {
  const {
    handleDeleteAccessControlCondition,
    updateLogicOperator,
    setDisplayedPage
  } = useContext(ShareModalContext);
  const [currentAccIndex, setCurrentAccIndex] = useState(null);
  const [accType, setAccType] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleDelete = (modalResponse) => {
    if (modalResponse === "yes") {
      if (accType === "paop") {
        handleDeleteAccessControlCondition(currentAccIndex[0], null);
        return;
      }
      currentAccIndex.length === 1 ? handleDeleteAccessControlCondition(currentAccIndex[0], null) : handleDeleteAccessControlCondition(currentAccIndex[0], currentAccIndex[1]);
    }
    setCurrentAccIndex(null);
    setAccType(null);
    setShowDeleteModal(false);
  };
  const checkOperator = (operator, value) => {
    if (operator === value) {
      return "lsm-multiple-condition-operator-selected";
    } else {
      return "lsm-multiple-condition-operator-not-selected ";
    }
  };
  const callCreateCondition = (isNested = false, nestedIndex = null) => {
    createCondition(isNested, nestedIndex);
    setDisplayedPage("multiple-add");
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-multiple-condition-editor-container",
    children: [humanizedUnifiedAccessControlConditions.length > 0 && humanizedUnifiedAccessControlConditions.map((a, i) => {
      if (Array.isArray(a) && a.length === 3 && a[0].humanizedAcc.includes("POAP") && a[2].humanizedAcc.includes("POAP")) {
        return /* @__PURE__ */ jsx$1("div", {
          className: "lsm-multiple-condition-group",
          style: {
            "backgroundColor": colorArray[i / 2]
          },
          children: /* @__PURE__ */ jsxs("span", {
            className: "lsm-multiple-condition-humanized-container",
            children: [/* @__PURE__ */ jsxs("span", {
              className: "lsm-multiple-condition-humanized-text",
              children: [/* @__PURE__ */ jsxs("span", {
                children: ["[", a[0].conditionType, "] ", a[0].humanizedAcc]
              }), /* @__PURE__ */ jsx$1("button", {
                className: `lsm-multiple-condition-group-operator-poap lsm-multiple-condition-operator-selected`,
                children: "OR"
              }), /* @__PURE__ */ jsxs("span", {
                children: ["[", a[2].conditionType, "] ", a[2].humanizedAcc]
              })]
            }), /* @__PURE__ */ jsx$1("span", {
              children: /* @__PURE__ */ jsx$1("button", {
                className: "lsm-multiple-condition-humanized-delete",
                onClick: () => {
                  setCurrentAccIndex([i]);
                  setShowDeleteModal(true);
                },
                children: /* @__PURE__ */ jsx$1("svg", {
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: /* @__PURE__ */ jsx$1("path", {
                    d: "M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z",
                    fill: "#888",
                    fillOpacity: "1"
                  })
                })
              })
            })]
          })
        }, i);
      } else if (Array.isArray(a)) {
        return /* @__PURE__ */ jsxs("div", {
          className: "lsm-multiple-condition-group",
          style: {
            "backgroundColor": colorArray[i / 2]
          },
          children: [a.map((n2, ni) => {
            if (!n2["operator"]) {
              return /* @__PURE__ */ jsxs("span", {
                className: "lsm-multiple-condition-humanized-container",
                children: [/* @__PURE__ */ jsxs("div", {
                  className: "lsm-multiple-condition-humanized-text",
                  children: [/* @__PURE__ */ jsx$1("span", {
                    children: n2.humanizedAcc
                  }), /* @__PURE__ */ jsx$1("span", {
                    children: /* @__PURE__ */ jsxs("i", {
                      children: ["chain - ", n2.chain, " | condition type - ", n2.conditionType]
                    })
                  })]
                }), /* @__PURE__ */ jsx$1("span", {
                  children: /* @__PURE__ */ jsx$1("button", {
                    className: "lsm-multiple-condition-humanized-delete",
                    onClick: () => {
                      setCurrentAccIndex([i]);
                      setShowDeleteModal(true);
                    },
                    children: /* @__PURE__ */ jsx$1("svg", {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                      children: /* @__PURE__ */ jsx$1("path", {
                        d: "M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z",
                        fill: "#888",
                        fillOpacity: "1"
                      })
                    })
                  })
                })]
              }, `n-${ni}`);
            } else {
              return /* @__PURE__ */ jsxs("span", {
                className: "lsm-multiple-condition-operator-container",
                children: [/* @__PURE__ */ jsx$1("button", {
                  onClick: () => updateLogicOperator("and", i, ni),
                  className: `lsm-multiple-condition-group-operator ${checkOperator("and", n2["operator"])}`,
                  children: "AND"
                }), /* @__PURE__ */ jsx$1("button", {
                  onClick: () => updateLogicOperator("or", i, ni),
                  className: `lsm-multiple-condition-group-operator ${checkOperator("or", n2["operator"])}`,
                  children: "OR"
                })]
              }, `n-${ni}`);
            }
          }), /* @__PURE__ */ jsx$1("button", {
            className: "lsm-multiple-condition-define-button",
            onClick: () => callCreateCondition(true, i),
            children: "Define Another Nested Condition"
          })]
        }, i);
      } else if (!a["operator"]) {
        return /* @__PURE__ */ jsxs("div", {
          className: "lsm-multiple-condition-group ",
          style: {
            "backgroundColor": colorArray[i / 2]
          },
          children: [/* @__PURE__ */ jsxs("span", {
            className: "lsm-multiple-condition-humanized-container",
            children: [/* @__PURE__ */ jsxs("div", {
              className: "lsm-multiple-condition-humanized-text",
              children: [/* @__PURE__ */ jsx$1("span", {
                children: humanizedUnifiedAccessControlConditions[i].humanizedAcc
              }), /* @__PURE__ */ jsx$1("span", {
                children: /* @__PURE__ */ jsxs("i", {
                  children: ["chain - ", humanizedUnifiedAccessControlConditions[i].chain, " | condition type - ", humanizedUnifiedAccessControlConditions[i].conditionType]
                })
              })]
            }), /* @__PURE__ */ jsx$1("span", {
              children: /* @__PURE__ */ jsx$1("button", {
                className: "lsm-multiple-condition-humanized-delete",
                onClick: () => {
                  setCurrentAccIndex([i]);
                  setShowDeleteModal(true);
                },
                children: /* @__PURE__ */ jsx$1("svg", {
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: /* @__PURE__ */ jsx$1("path", {
                    d: "M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z",
                    fill: "#888",
                    fillOpacity: "1"
                  })
                })
              })
            })]
          }), /* @__PURE__ */ jsx$1("button", {
            className: "lsm-multiple-condition-define-button",
            onClick: () => callCreateCondition(true, i),
            children: "Define Another Nested Condition"
          })]
        }, i);
      } else {
        return /* @__PURE__ */ jsxs("span", {
          className: "lsm-multiple-condition-operator-container",
          children: [/* @__PURE__ */ jsx$1("button", {
            onClick: () => updateLogicOperator("and", i),
            className: `lsm-multiple-condition-group-operator ${checkOperator("and", a["operator"])}`,
            children: "AND"
          }), /* @__PURE__ */ jsx$1("button", {
            onClick: () => updateLogicOperator("or", i),
            className: `lsm-multiple-condition-group-operator ${checkOperator("or", a["operator"])}`,
            children: "OR"
          })]
        }, i);
      }
    }), !humanizedUnifiedAccessControlConditions.length ? /* @__PURE__ */ jsxs("div", {
      className: "lsm-multiple-condition-initial-container",
      children: [/* @__PURE__ */ jsx$1("span", {
        className: "lsm-multiple-condition-define-first-group",
        style: {
          "backgroundColor": colorArray[0]
        },
        children: /* @__PURE__ */ jsx$1("button", {
          className: "lsm-multiple-condition-define-first-button",
          onClick: () => callCreateCondition(),
          children: "Define First Condition"
        })
      }), /* @__PURE__ */ jsx$1("svg", {
        className: "lsm-multiple-condition-define-first-arrow",
        width: "23",
        height: "109",
        viewBox: "0 0 23 109",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ jsx$1("path", {
          d: "M22.5107 108.5C14.5107 96 5.4 68.1 5 54.5C4.6 40.9 8.51071 13 14.0107 1M14.0107 1L0.5 10M14.0107 1L20 15",
          stroke: "#888",
          strokeOpacity: "1"
        })
      }), /* @__PURE__ */ jsx$1("h3", {
        className: "lsm-multiple-condition-define-first-text",
        children: "Once you've added your first condition, you can add AND/OR operators and groups"
      })]
    }) : /* @__PURE__ */ jsx$1(Fragment, {
      children: /* @__PURE__ */ jsx$1("span", {
        className: "lsm-multiple-condition-group",
        children: /* @__PURE__ */ jsx$1("button", {
          className: "lsm-multiple-condition-define-first-button",
          onClick: () => callCreateCondition(),
          children: "Define Another Condition"
        })
      })
    }), /* @__PURE__ */ jsx$1(LitDeleteModal, {
      showDeleteModal,
      onClick: handleDelete
    })]
  });
};
const MultipleAddCondition = ({
  selectPage,
  setSelectPage,
  chain,
  isNested = false,
  endOfCreateCondition,
  initialState = null
}) => {
  const {
    setDisplayedPage
  } = useContext(ShareModalContext);
  const [unifiedAccessControlConditions, setUnifiedAccessControlConditions] = useState([]);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const backButtonAction = () => {
    setSelectPage("chooseAccess");
    setUnifiedAccessControlConditions([]);
  };
  const toggleCoordinateUpdateAccessControl = () => {
    endOfCreateCondition(unifiedAccessControlConditions);
    setUnifiedAccessControlConditions([]);
  };
  const getRenderedConditionOption = () => {
    const conditionTypeData = chain.types.conditionTypeData;
    if (selectPage === "chooseAccess") {
      let allowedNestedConditions = [];
      if (isNested === true) {
        Object.keys(chain.types.conditionTypes).forEach((c2, i) => {
          if ((!conditionTypeData[c2].supportedChains || conditionTypeData[c2].supportedChains.includes(chain.value)) && (!chain["disallowNesting"] || !chain["disallowNesting"].find((n2) => n2 === c2))) {
            allowedNestedConditions.push(/* @__PURE__ */ jsx$1(LitChooseAccessButton, {
              onClick: () => setSelectPage(c2),
              label: conditionTypeData[c2].label,
              img: conditionTypeData[c2].img
            }, i));
          }
        });
      } else {
        Object.keys(chain.types.conditionTypes).forEach((c2, i) => {
          if (!conditionTypeData[c2].supportedChains || conditionTypeData[c2].supportedChains.includes(chain.value)) {
            allowedNestedConditions.push(/* @__PURE__ */ jsx$1(LitChooseAccessButton, {
              onClick: () => setSelectPage(c2),
              label: conditionTypeData[c2].label,
              img: conditionTypeData[c2].img
            }, i));
          }
        });
      }
      return /* @__PURE__ */ jsxs("div", {
        className: "lsm-multiple-condition-rendering-options-container",
        children: [/* @__PURE__ */ jsx$1("h3", {
          className: "lsm-multiple-condition-select-prompt",
          children: "Choose who can access this:"
        }), allowedNestedConditions.map((c2, i) => {
          return c2;
        })]
      });
    } else {
      if (chain.types.conditionTypes[selectPage]) {
        const ConditionHolder = chain.types.conditionTypes[selectPage];
        return /* @__PURE__ */ jsx$1(ConditionHolder, {
          updateUnifiedAccessControlConditions: setUnifiedAccessControlConditions,
          chain,
          initialState,
          submitDisabled: setSubmitDisabled
        });
      } else {
        setSelectPage("chooseAccess");
      }
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-multiple-condition-add-container",
    children: [/* @__PURE__ */ jsx$1(LitChainSelector, {}), !!chain && !!setSelectPage && /* @__PURE__ */ jsx$1("div", {
      className: "lsm-multiple-select-condition-display",
      children: getRenderedConditionOption()
    }), selectPage === "chooseAccess" && /* @__PURE__ */ jsx$1(LitFooter, {
      backAction: () => {
        setDisplayedPage("multiple");
      }
    }), selectPage !== "chooseAccess" && /* @__PURE__ */ jsx$1(LitFooter, {
      className: "lsm-single-condition-footer",
      backAction: backButtonAction,
      nextAction: toggleCoordinateUpdateAccessControl,
      disableNextButton: submitDisabled
    })]
  });
};
const LitConfirmationModal = ({
  showConfirmationModal,
  onClick,
  message = null
}) => {
  return /* @__PURE__ */ jsx$1("div", {
    children: !!showConfirmationModal && /* @__PURE__ */ jsx$1("div", {
      className: "lsm-confirmation-modal-container",
      children: /* @__PURE__ */ jsxs("div", {
        className: "lsm-confirmation-modal",
        children: [/* @__PURE__ */ jsx$1("h3", {
          className: "lsm-confirmation-modal-prompt",
          children: !message ? "Are you sure you want to go back? Current conditions will be lost." : message
        }), /* @__PURE__ */ jsxs("span", {
          className: "lsm-confirmation-modal-button-container",
          children: [/* @__PURE__ */ jsx$1("button", {
            className: "lsm-confirmation-modal-button-no",
            onClick: () => onClick("no"),
            children: "NO"
          }), /* @__PURE__ */ jsx$1("button", {
            className: "lsm-confirmation-modal-button-yes",
            onClick: () => onClick("yes"),
            children: "YES"
          })]
        })]
      })
    })
  });
};
const MultipleConditionSelect = ({
  humanizedUnifiedAccessControlConditions,
  chain,
  initialState = null,
  initialCondition = null
}) => {
  const {
    setDisplayedPage,
    setFlow,
    displayedPage,
    resetModal,
    handleUpdateUnifiedAccessControlConditions
  } = useContext(ShareModalContext);
  useEffect(() => {
    if (initialCondition) {
      setSelectPage(initialCondition);
    }
  }, []);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isNested, setIsNested] = useState(false);
  const [nestedIndex, setNestedIndex] = useState(null);
  const [selectPage, setSelectPage] = useState("chooseAccess");
  const handleConfirmGoBack = (modalResponse) => {
    if (modalResponse === "yes") {
      resetModal();
    }
    setShowConfirmationModal(false);
  };
  const coordinateUpdateAccessControl = (unifiedAccessControlConditions) => {
    handleUpdateUnifiedAccessControlConditions(unifiedAccessControlConditions, isNested, nestedIndex);
    setSelectPage("chooseAccess");
    setDisplayedPage("multiple");
  };
  const createCondition = (isNested2 = false, nestedIndex2 = null) => {
    setIsNested(isNested2);
    setNestedIndex(nestedIndex2);
  };
  const endOfCreateCondition = (unifiedAccessControlConditions) => {
    coordinateUpdateAccessControl(unifiedAccessControlConditions);
    setIsNested(false);
    setNestedIndex(null);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-multiple-conditions-container",
    children: [displayedPage === "multiple" && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx$1(MultipleConditionsEditor, {
        humanizedUnifiedAccessControlConditions,
        createCondition
      }), /* @__PURE__ */ jsx$1(LitFooter, {
        backAction: () => {
          if (humanizedUnifiedAccessControlConditions.length < 1) {
            setFlow("singleCondition");
            setDisplayedPage("single");
          } else {
            setShowConfirmationModal(true);
          }
        },
        nextAction: () => setDisplayedPage("review"),
        disableNextButton: !humanizedUnifiedAccessControlConditions || !humanizedUnifiedAccessControlConditions.length
      })]
    }), displayedPage === "multiple-add" && /* @__PURE__ */ jsx$1(MultipleAddCondition, {
      selectPage,
      setSelectPage,
      chain,
      initialCondition,
      initialState,
      isNested,
      endOfCreateCondition
    }), /* @__PURE__ */ jsx$1(LitConfirmationModal, {
      showConfirmationModal,
      onClick: handleConfirmGoBack
    })]
  });
};
var ethLogo = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPCEtLSBDcmVhdG9yOiBDb3JlbERSQVcgMjAxOSAoNjQtQml0KSAtLT4KPHN2ZyB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sbnM6eG9kbT0iaHR0cDovL3d3dy5jb3JlbC5jb20vY29yZWxkcmF3L29kbS8yMDAzIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSIxMDAlIgogICAgIGhlaWdodD0iMTAwJSIgdmVyc2lvbj0iMS4xIiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiIKICAgICB0ZXh0LXJlbmRlcmluZz0iZ2VvbWV0cmljUHJlY2lzaW9uIiBpbWFnZS1yZW5kZXJpbmc9Im9wdGltaXplUXVhbGl0eSIKICAgICBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICAgY2xpcC1ydWxlPSJldmVub2RkIgogICAgIHZpZXdCb3g9IjAgMCA3ODQuMzcgMTI3Ny4zOSI+CiA8ZyBpZD0iTGF5ZXJfeDAwMjBfMSI+CiAgPG1ldGFkYXRhIGlkPSJDb3JlbENvcnBJRF8wQ29yZWwtTGF5ZXIiLz4KICAgICA8ZyBpZD0iXzE0MjEzOTQzNDI0MDAiPgogICA8Zz4KICAgIDxwb2x5Z29uIGZpbGw9IiMzNDM0MzQiIGZpbGwtcnVsZT0ibm9uemVybyIKICAgICAgICAgICAgIHBvaW50cz0iMzkyLjA3LDAgMzgzLjUsMjkuMTEgMzgzLjUsODczLjc0IDM5Mi4wNyw4ODIuMjkgNzg0LjEzLDY1MC41NCAiLz4KICAgICAgIDxwb2x5Z29uIGZpbGw9IiM4QzhDOEMiIGZpbGwtcnVsZT0ibm9uemVybyIgcG9pbnRzPSIzOTIuMDcsMCAtMCw2NTAuNTQgMzkyLjA3LDg4Mi4yOSAzOTIuMDcsNDcyLjMzICIvPgogICAgICAgPHBvbHlnb24gZmlsbD0iIzNDM0MzQiIgZmlsbC1ydWxlPSJub256ZXJvIgogICAgICAgICAgICAgICAgcG9pbnRzPSIzOTIuMDcsOTU2LjUyIDM4Ny4yNCw5NjIuNDEgMzg3LjI0LDEyNjMuMjggMzkyLjA3LDEyNzcuMzggNzg0LjM3LDcyNC44OSAiLz4KICAgICAgIDxwb2x5Z29uIGZpbGw9IiM4QzhDOEMiIGZpbGwtcnVsZT0ibm9uemVybyIgcG9pbnRzPSIzOTIuMDcsMTI3Ny4zOCAzOTIuMDcsOTU2LjUyIC0wLDcyNC44OSAiLz4KICAgICAgIDxwb2x5Z29uIGZpbGw9IiMxNDE0MTQiIGZpbGwtcnVsZT0ibm9uemVybyIgcG9pbnRzPSIzOTIuMDcsODgyLjI5IDc4NC4xMyw2NTAuNTQgMzkyLjA3LDQ3Mi4zMyAiLz4KICAgICAgIDxwb2x5Z29uIGZpbGw9IiMzOTM5MzkiIGZpbGwtcnVsZT0ibm9uemVybyIgcG9pbnRzPSIwLDY1MC41NCAzOTIuMDcsODgyLjI5IDM5Mi4wNyw0NzIuMzMgIi8+CiAgIDwvZz4KICA8L2c+CiA8L2c+Cjwvc3ZnPgo=";
var ftmLogo = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMzIgMzIiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmO2ZpbGwtcnVsZTpldmVub2RkO30uY2xzLTJ7ZmlsbDojMTNiNWVjO30uY2xzLTN7bWFzazp1cmwoI21hc2spO308L3N0eWxlPjxtYXNrIGlkPSJtYXNrIiB4PSIxMCIgeT0iNiIgd2lkdGg9IjkzLjEiIGhlaWdodD0iMjAiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiPjxnIGlkPSJhIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xMCw2aDkzLjFWMjZIMTBaIi8+PC9nPjwvbWFzaz48L2RlZnM+PHRpdGxlPmZhPC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxjaXJjbGUgY2xhc3M9ImNscy0yIiBjeD0iMTYiIGN5PSIxNiIgcj0iMTYiLz48ZyBjbGFzcz0iY2xzLTMiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE3LjIsMTIuOWwzLjYtMi4xVjE1Wm0zLjYsOUwxNiwyNC43bC00LjgtMi44VjE3TDE2LDE5LjgsMjAuOCwxN1pNMTEuMiwxMC44bDMuNiwyLjFMMTEuMiwxNVptNS40LDMuMUwyMC4yLDE2bC0zLjYsMi4xWm0tMS4yLDQuMkwxMS44LDE2bDMuNi0yLjFabTQuOC04LjNMMTYsMTIuMiwxMS44LDkuOCwxNiw3LjNaTTEwLDkuNFYyMi41bDYsMy40LDYtMy40VjkuNEwxNiw2WiIvPjwvZz48L2c+PC9nPjwvc3ZnPg==";
var polygonLogo = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzOC40IDMzLjUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDM4LjQgMzMuNTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiM4MjQ3RTU7fQo8L3N0eWxlPgo8Zz4KCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0yOSwxMC4yYy0wLjctMC40LTEuNi0wLjQtMi40LDBMMjEsMTMuNWwtMy44LDIuMWwtNS41LDMuM2MtMC43LDAuNC0xLjYsMC40LTIuNCwwTDUsMTYuMwoJCWMtMC43LTAuNC0xLjItMS4yLTEuMi0yLjF2LTVjMC0wLjgsMC40LTEuNiwxLjItMi4xbDQuMy0yLjVjMC43LTAuNCwxLjYtMC40LDIuNCwwTDE2LDcuMmMwLjcsMC40LDEuMiwxLjIsMS4yLDIuMXYzLjNsMy44LTIuMlY3CgkJYzAtMC44LTAuNC0xLjYtMS4yLTIuMWwtOC00LjdjLTAuNy0wLjQtMS42LTAuNC0yLjQsMEwxLjIsNUMwLjQsNS40LDAsNi4yLDAsN3Y5LjRjMCwwLjgsMC40LDEuNiwxLjIsMi4xbDguMSw0LjcKCQljMC43LDAuNCwxLjYsMC40LDIuNCwwbDUuNS0zLjJsMy44LTIuMmw1LjUtMy4yYzAuNy0wLjQsMS42LTAuNCwyLjQsMGw0LjMsMi41YzAuNywwLjQsMS4yLDEuMiwxLjIsMi4xdjVjMCwwLjgtMC40LDEuNi0xLjIsMi4xCgkJTDI5LDI4LjhjLTAuNywwLjQtMS42LDAuNC0yLjQsMGwtNC4zLTIuNWMtMC43LTAuNC0xLjItMS4yLTEuMi0yLjFWMjFsLTMuOCwyLjJ2My4zYzAsMC44LDAuNCwxLjYsMS4yLDIuMWw4LjEsNC43CgkJYzAuNywwLjQsMS42LDAuNCwyLjQsMGw4LjEtNC43YzAuNy0wLjQsMS4yLTEuMiwxLjItMi4xVjE3YzAtMC44LTAuNC0xLjYtMS4yLTIuMUwyOSwxMC4yeiIvPgo8L2c+Cjwvc3ZnPgo=";
var xdaiLogo = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNTYgMjU1LjgiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI1NiAyNTUuODsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtmaWxsOiM0OEE5QTY7fQoJLnN0MXtmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtmaWxsOiNGRkZGRkY7fQo8L3N0eWxlPgo8dGl0bGU+R3JvdXAgNjwvdGl0bGU+CjxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgo8ZyBpZD0iUGFnZS0xIj4KCTxnIGlkPSJBcnRib2FyZCI+CgkJPGcgaWQ9Ikdyb3VwLTYiPgoJCQk8cGF0aCBpZD0iRmlsbC0xIiBjbGFzcz0ic3QwIiBkPSJNMTI4LDBjNzAuNiwwLDEyOCw1Ny4zLDEyOCwxMjcuOXMtNTcuNCwxMjcuOS0xMjgsMTI3LjlTMCwxOTguNSwwLDEyNy45UzU3LjQsMCwxMjgsMHoiLz4KCQkJPHBvbHlnb24gaWQ9IkZpbGwtMiIgY2xhc3M9InN0MSIgcG9pbnRzPSI2Mi4zLDg4LjYgMTE0LjksODguNiAxMTQuOSw2Mi4zIDYyLjMsNjIuMyAJCQkiLz4KCQkJPHBvbHlnb24gaWQ9IkZpbGwtMyIgY2xhc3M9InN0MSIgcG9pbnRzPSIxNDEuMSw4OC42IDE5My43LDg4LjYgMTkzLjcsNjIuMyAxNDEuMSw2Mi4zIAkJCSIvPgoJCQk8cG9seWdvbiBpZD0iRmlsbC00IiBjbGFzcz0ic3QxIiBwb2ludHM9IjE5My43LDE0MS4xIDE2Ny40LDE0MS4xIDE2Ny40LDE2Ny40IDE0MS4xLDE2Ny40IDE0MS4xLDE5My43IDE5My43LDE5My43IAkJCSIvPgoJCQk8cG9seWdvbiBpZD0iRmlsbC01IiBjbGFzcz0ic3QxIiBwb2ludHM9IjExNC45LDE5My43IDExNC45LDE2Ny40IDg4LjYsMTY3LjQgODguNiwxNDEuMSA2Mi4zLDE0MS4xIDYyLjMsMTkzLjcgCQkJIi8+CgkJPC9nPgoJPC9nPgo8L2c+Cjwvc3ZnPgo=";
var bnbLogo = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNDk2IDI0OTYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI0OTYgMjQ5NjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxwYXRoIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtmaWxsOiNGMEI5MEI7IiBkPSJNMTI0OCwwYzY4OS4zLDAsMTI0OCw1NTguNywxMjQ4LDEyNDhzLTU1OC43LDEyNDgtMTI0OCwxMjQ4CgkJUzAsMTkzNy4zLDAsMTI0OFM1NTguNywwLDEyNDgsMEwxMjQ4LDB6Ii8+Cgk8cGF0aCBzdHlsZT0iZmlsbDojRkZGRkZGOyIgZD0iTTY4NS45LDEyNDhsMC45LDMzMGwyODAuNCwxNjV2MTkzLjJsLTQ0NC41LTI2MC43di01MjRMNjg1LjksMTI0OEw2ODUuOSwxMjQ4eiBNNjg1LjksOTE4djE5Mi4zCgkJbC0xNjMuMy05Ni42VjgyMS40bDE2My4zLTk2LjZsMTY0LjEsOTYuNkw2ODUuOSw5MThMNjg1LjksOTE4eiBNMTA4NC4zLDgyMS40bDE2My4zLTk2LjZsMTY0LjEsOTYuNkwxMjQ3LjYsOTE4TDEwODQuMyw4MjEuNAoJCUwxMDg0LjMsODIxLjR6Ii8+Cgk8cGF0aCBzdHlsZT0iZmlsbDojRkZGRkZGOyIgZD0iTTgwMy45LDE1MDkuNnYtMTkzLjJsMTYzLjMsOTYuNnYxOTIuM0w4MDMuOSwxNTA5LjZMODAzLjksMTUwOS42eiBNMTA4NC4zLDE4MTIuMmwxNjMuMyw5Ni42CgkJbDE2NC4xLTk2LjZ2MTkyLjNsLTE2NC4xLDk2LjZsLTE2My4zLTk2LjZWMTgxMi4yTDEwODQuMywxODEyLjJ6IE0xNjQ1LjksODIxLjRsMTYzLjMtOTYuNmwxNjQuMSw5Ni42djE5Mi4zbC0xNjQuMSw5Ni42VjkxOAoJCUwxNjQ1LjksODIxLjRMMTY0NS45LDgyMS40TDE2NDUuOSw4MjEuNHogTTE4MDkuMiwxNTc4bDAuOS0zMzBsMTYzLjMtOTYuNnY1MjRsLTQ0NC41LDI2MC43di0xOTMuMkwxODA5LjIsMTU3OEwxODA5LjIsMTU3OAoJCUwxODA5LjIsMTU3OHoiLz4KCTxwb2x5Z29uIHN0eWxlPSJmaWxsOiNGRkZGRkY7IiBwb2ludHM9IjE2OTIuMSwxNTA5LjYgMTUyOC44LDE2MDUuMyAxNTI4LjgsMTQxMyAxNjkyLjEsMTMxNi40IDE2OTIuMSwxNTA5LjYgCSIvPgoJPHBhdGggc3R5bGU9ImZpbGw6I0ZGRkZGRjsiIGQ9Ik0xNjkyLjEsOTg2LjRsMC45LDE5My4ybC0yODEuMiwxNjV2MzMwLjhsLTE2My4zLDk1LjdsLTE2My4zLTk1Ljd2LTMzMC44bC0yODEuMi0xNjVWOTg2LjQKCQlMOTY4LDg4OS44bDI3OS41LDE2NS44bDI4MS4yLTE2NS44bDE2NC4xLDk2LjZIMTY5Mi4xTDE2OTIuMSw5ODYuNHogTTgwMy45LDY1Ni41bDQ0My43LTI2MS42bDQ0NC41LDI2MS42bC0xNjMuMyw5Ni42CgkJbC0yODEuMi0xNjUuOEw5NjcuMiw3NTMuMUw4MDMuOSw2NTYuNUw4MDMuOSw2NTYuNXoiLz4KPC9nPgo8L3N2Zz4K";
var arbitrumLogo = "data:image/svg+xml;base64,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";
var avalancheLogo = "data:image/svg+xml;base64,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";
var harmonyLogo = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMTgwIDE3OS41MSI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJsaW5lYXItZ3JhZGllbnQiIHgxPSIyMDIuOTMiIHkxPSI1NDQuNyIgeDI9IjIwMy44IiB5Mj0iNTQ1LjU3IiBncmFkaWVudFRyYW5zZm9ybT0ibWF0cml4KDE4MCwgMCwgMCwgLTE3OS41MSwgLTM2NDU2LCA5ODAwNS4yMykiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMwMGFlZTkiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM2OWZhYmQiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48dGl0bGU+aGFybW9ueS1vbmUtbG9nbzwvdGl0bGU+PHBhdGggaWQ9IlNoYXBlIiBkPSJNMjAxLjE3LDYwYTM4LjgxLDM4LjgxLDAsMCwwLTM4Ljg0LDM4LjcxdjQyLjkyYy00LC4yNy04LjA5LjQ0LTEyLjMzLDAuNDRzLTguMzEuMTctMTIuMzMsMC40MVY5OC43MWEzOC44NCwzOC44NCwwLDAsMC03Ny42NywwVjIwMS4yOWEzOC44NCwzOC44NCwwLDAsMCw3Ny42NywwVjE1OC4zN2M0LS4yNyw4LjA5LTAuNDQsMTIuMzMtMC40NHM4LjMxLS4xNywxMi4zMy0wLjQxdjQzLjc3YTM4Ljg0LDM4Ljg0LDAsMCwwLDc3LjY3LDBWOTguNzFBMzguODEsMzguODEsMCwwLDAsMjAxLjE3LDYwWk05OC44Myw3NS44NmEyMi45MSwyMi45MSwwLDAsMSwyMi45MiwyMi44NXY0NS40NWExMzAuNjQsMTMwLjY0LDAsMCwwLTMzLDkuMzMsNjAsNjAsMCwwLDAtMTIuOCw3LjY0Vjk4LjcxQTIyLjkxLDIyLjkxLDAsMCwxLDk4LjgzLDc1Ljg2Wm0yMi45MiwxMjUuNDNhMjIuOTIsMjIuOTIsMCwxLDEtNDUuODQsMFYxOTFjMC05LjA5LDcuMi0xNy43LDE5LjI3LTIzLjA2YTExMywxMTMsMCwwLDEsMjYuNTctNy43N3Y0MS4xMlptNzkuNDIsMjIuODVhMjIuOTEsMjIuOTEsMCwwLDEtMjIuOTItMjIuODVWMTU1Ljg0YTEzMC42NCwxMzAuNjQsMCwwLDAsMzMtOS4zMyw2MCw2MCwwLDAsMCwxMi44LTcuNjR2NjIuNDJBMjIuOTEsMjIuOTEsMCwwLDEsMjAxLjE3LDIyNC4xNFpNMjA0LjgyLDEzMmExMTMsMTEzLDAsMCwxLTI2LjU3LDcuNzdWOTguNzFhMjIuOTIsMjIuOTIsMCwxLDEsNDUuODQsMFYxMDlDMjI0LjA5LDExOC4wNSwyMTYuODksMTI2LjY2LDIwNC44MiwxMzJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjAgLTYwKSIgc3R5bGU9ImZpbGw6dXJsKCNsaW5lYXItZ3JhZGllbnQpIi8+PC9zdmc+";
var cronosLogo = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIxIiBoZWlnaHQ9IjEzOSIgdmlld0JveD0iMCAwIDEyMSAxMzkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik02MC4wOTMgMEwtMS41MjU4OGUtMDUgMzQuNzEyM1YxMDQuMTE0TDYwLjA5MyAxMzguODAzTDEyMC4xNCAxMDQuMTE0VjM0LjcxMjNMNjAuMDkzIDBaTTEwMi4zNDkgOTMuODMwNEw2MC4wOTMgMTE4LjIzNkwxNy44MTQgOTMuODMwNFY0NC45NzI1TDYwLjA5MyAyMC41NjY4TDEwMi4zNDkgNDQuOTcyNVY5My44MzA0WiIgZmlsbD0iIzAwMkQ3NCIvPgo8cGF0aCBzdHlsZT0ibWl4LWJsZW5kLW1vZGU6bXVsdGlwbHkiIGQ9Ik02MC4wOTMyIDEzOC44MDNMMTIwLjE0IDEwNC4xMTRWMzQuNzEyM0w2MC4wOTMyIDBWMjAuNTkwMUwxMDIuMzQ5IDQ0Ljk5NThWOTMuODUzNkw2MC4wOTMyIDExOC4yMzZWMTM4LjgwM1oiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8zMDRfMzEpIi8+CjxwYXRoIHN0eWxlPSJtaXgtYmxlbmQtbW9kZTptdWx0aXBseSIgZD0iTTYwLjA0NjUgMEwwIDM0LjY4OTFWMTA0LjA5MUw2MC4wNDY1IDEzOC44MDNWMTE4LjIxM0wxNy43OTA3IDkzLjgwNzFWNDQuOTQ5Mkw2MC4wNDY1IDIwLjU2NjhWMFoiIGZpbGw9InVybCgjcGFpbnQxX2xpbmVhcl8zMDRfMzEpIi8+CjxwYXRoIGQ9Ik04OC4xMTYzIDg1LjYxNzZMNjAuMDY5OCAxMDEuODExTDMyIDg1LjYxNzZWNTMuMjA4Nkw2MC4wNjk4IDM2Ljk5MjRMODguMTE2MyA1My4yMDg2TDc2LjQ0MTkgNTkuOTU1Nkw2MC4wNjk4IDUwLjQ4NjVMNDMuNjk3NyA1OS45NTU2Vjc4Ljg0NzNMNjAuMDY5OCA4OC4zMTY1TDc2LjQ0MTkgNzguODQ3M0w4OC4xMTYzIDg1LjYxNzZaIiBmaWxsPSIjMDAyRDc0Ii8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMzA0XzMxIiB4MT0iOTAuMTE2NCIgeTE9IjEzOC44MDMiIHgyPSI5MC4xMTY0IiB5Mj0iNjkuNDAxNCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMDAyRDc0Ii8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzAwMkQ3NCIgc3RvcC1vcGFjaXR5PSIwIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQxX2xpbmVhcl8zMDRfMzEiIHgxPSIzMC4wMjMzIiB5MT0iMCIgeDI9IjMwLjAyMzMiIHkyPSI2OS40MDE0IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiMwMDJENzQiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMDAyRDc0IiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
var celoLogo = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNlbG9fUmluZ3MiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA5NTAgOTUwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA5NTAgOTUwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0ZCQ0M1Qzt9Cgkuc3Qxe2ZpbGw6IzM1RDA3Rjt9Cgkuc3Qye2ZpbGw6IzVFQTMzQjt9Cjwvc3R5bGU+Cjx0aXRsZT5BcnRib2FyZCAxPC90aXRsZT4KPHBhdGggaWQ9IkJvdHRvbV9SaW5nIiBjbGFzcz0ic3QwIiBkPSJNMzc1LDg1MGMxNTEuOSwwLDI3NS0xMjMuMSwyNzUtMjc1UzUyNi45LDMwMCwzNzUsMzAwUzEwMCw0MjMuMSwxMDAsNTc1UzIyMy4xLDg1MCwzNzUsODUwegoJIE0zNzUsOTUwQzE2Ny45LDk1MCwwLDc4Mi4xLDAsNTc1czE2Ny45LTM3NSwzNzUtMzc1czM3NSwxNjcuOSwzNzUsMzc1UzU4Mi4xLDk1MCwzNzUsOTUweiIvPgo8cGF0aCBpZD0iVG9wX1JpbmciIGNsYXNzPSJzdDEiIGQ9Ik01NzUsNjUwYzE1MS45LDAsMjc1LTEyMy4xLDI3NS0yNzVTNzI2LjksMTAwLDU3NSwxMDBTMzAwLDIyMy4xLDMwMCwzNzVTNDIzLjEsNjUwLDU3NSw2NTB6CgkgTTU3NSw3NTBjLTIwNy4xLDAtMzc1LTE2Ny45LTM3NS0zNzVTMzY3LjksMCw1NzUsMHMzNzUsMTY3LjksMzc1LDM3NVM3ODIuMSw3NTAsNTc1LDc1MHoiLz4KPHBhdGggaWQ9IlJpbmdzX092ZXJsYXAiIGNsYXNzPSJzdDIiIGQ9Ik01ODcuNCw3NTBjMjYtMzEuNSw0NC42LTY4LjQsNTQuNS0xMDguMWMzOS42LTkuOSw3Ni41LTI4LjUsMTA4LjEtNTQuNQoJYy0xLjQsNDUuOS0xMS4zLDkxLjEtMjkuMiwxMzMuNUM2NzguNSw3MzguNyw2MzMuMyw3NDguNiw1ODcuNCw3NTB6IE0zMDguMSwzMDguMWMtMzkuNiw5LjktNzYuNSwyOC41LTEwOC4xLDU0LjUKCWMxLjQtNDUuOSwxMS4zLTkxLjEsMjkuMi0xMzMuNGM0Mi4zLTE3LjgsODcuNi0yNy43LDEzMy40LTI5LjJDMzM2LjYsMjMxLjUsMzE4LDI2OC40LDMwOC4xLDMwOC4xeiIvPgo8L3N2Zz4K";
var eluvioLogo = "data:image/png;base64,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";
var auroraLogo = "data:image/svg+xml;base64,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";
var kovanLogo = "data:image/png;base64,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";
var goerliLogo = "data:image/png;base64,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";
var optimismLogo = "data:image/jpeg;base64,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";
var solanaLogo = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAxIiBoZWlnaHQ9Ijg4IiB2aWV3Qm94PSIwIDAgMTAxIDg4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTAwLjQ4IDY5LjM4MTdMODMuODA2OCA4Ni44MDE1QzgzLjQ0NDQgODcuMTc5OSA4My4wMDU4IDg3LjQ4MTYgODIuNTE4NSA4Ny42ODc4QzgyLjAzMTIgODcuODk0IDgxLjUwNTUgODguMDAwMyA4MC45NzQzIDg4SDEuOTM1NjNDMS41NTg0OSA4OCAxLjE4OTU3IDg3Ljg5MjYgMC44NzQyMDIgODcuNjkxMkMwLjU1ODgyOSA4Ny40ODk3IDAuMzEwNzQgODcuMjAyOSAwLjE2MDQxNiA4Ni44NjU5QzAuMDEwMDkyMyA4Ni41MjkgLTAuMDM1OTE4MSA4Ni4xNTY2IDAuMDI4MDM4MiA4NS43OTQ1QzAuMDkxOTk0NCA4NS40MzI0IDAuMjYzMTMxIDg1LjA5NjQgMC41MjA0MjIgODQuODI3OEwxNy4yMDYxIDY3LjQwOEMxNy41Njc2IDY3LjAzMDYgMTguMDA0NyA2Ni43Mjk1IDE4LjQ5MDQgNjYuNTIzNEMxOC45NzYyIDY2LjMxNzIgMTkuNTAwMiA2Ni4yMTA0IDIwLjAzMDEgNjYuMjA5NUg5OS4wNjQ0Qzk5LjQ0MTUgNjYuMjA5NSA5OS44MTA0IDY2LjMxNjkgMTAwLjEyNiA2Ni41MTgzQzEwMC40NDEgNjYuNzE5OCAxMDAuNjg5IDY3LjAwNjcgMTAwLjg0IDY3LjM0MzZDMTAwLjk5IDY3LjY4MDYgMTAxLjAzNiA2OC4wNTI5IDEwMC45NzIgNjguNDE1QzEwMC45MDggNjguNzc3MSAxMDAuNzM3IDY5LjExMzEgMTAwLjQ4IDY5LjM4MTdaTTgzLjgwNjggMzQuMzAzMkM4My40NDQ0IDMzLjkyNDggODMuMDA1OCAzMy42MjMxIDgyLjUxODUgMzMuNDE2OUM4Mi4wMzEyIDMzLjIxMDggODEuNTA1NSAzMy4xMDQ1IDgwLjk3NDMgMzMuMTA0OEgxLjkzNTYzQzEuNTU4NDkgMzMuMTA0OCAxLjE4OTU3IDMzLjIxMjEgMC44NzQyMDIgMzMuNDEzNkMwLjU1ODgyOSAzMy42MTUxIDAuMzEwNzQgMzMuOTAxOSAwLjE2MDQxNiAzNC4yMzg4QzAuMDEwMDkyMyAzNC41NzU4IC0wLjAzNTkxODEgMzQuOTQ4MiAwLjAyODAzODIgMzUuMzEwM0MwLjA5MTk5NDQgMzUuNjcyMyAwLjI2MzEzMSAzNi4wMDgzIDAuNTIwNDIyIDM2LjI3N0wxNy4yMDYxIDUzLjY5NjhDMTcuNTY3NiA1NC4wNzQyIDE4LjAwNDcgNTQuMzc1MiAxOC40OTA0IDU0LjU4MTRDMTguOTc2MiA1NC43ODc1IDE5LjUwMDIgNTQuODk0NCAyMC4wMzAxIDU0Ljg5NTJIOTkuMDY0NEM5OS40NDE1IDU0Ljg5NTIgOTkuODEwNCA1NC43ODc5IDEwMC4xMjYgNTQuNTg2NEMxMDAuNDQxIDU0LjM4NDkgMTAwLjY4OSA1NC4wOTgxIDEwMC44NCA1My43NjEyQzEwMC45OSA1My40MjQyIDEwMS4wMzYgNTMuMDUxOCAxMDAuOTcyIDUyLjY4OTdDMTAwLjkwOCA1Mi4zMjc3IDEwMC43MzcgNTEuOTkxNyAxMDAuNDggNTEuNzIzTDgzLjgwNjggMzQuMzAzMlpNMS45MzU2MyAyMS43OTA1SDgwLjk3NDNDODEuNTA1NSAyMS43OTA3IDgyLjAzMTIgMjEuNjg0NSA4Mi41MTg1IDIxLjQ3ODNDODMuMDA1OCAyMS4yNzIxIDgzLjQ0NDQgMjAuOTcwNCA4My44MDY4IDIwLjU5MkwxMDAuNDggMy4xNzIxOUMxMDAuNzM3IDIuOTAzNTcgMTAwLjkwOCAyLjU2NzU4IDEwMC45NzIgMi4yMDU1QzEwMS4wMzYgMS44NDM0MiAxMDAuOTkgMS40NzEwMyAxMDAuODQgMS4xMzQwOEMxMDAuNjg5IDAuNzk3MTMgMTAwLjQ0MSAwLjUxMDI5NiAxMDAuMTI2IDAuMzA4ODIzQzk5LjgxMDQgMC4xMDczNDkgOTkuNDQxNSAxLjI0MDc0ZS0wNSA5OS4wNjQ0IDBMMjAuMDMwMSAwQzE5LjUwMDIgMC4wMDA4NzgzOTcgMTguOTc2MiAwLjEwNzY5OSAxOC40OTA0IDAuMzEzODQ4QzE4LjAwNDcgMC41MTk5OTggMTcuNTY3NiAwLjgyMTA4NyAxNy4yMDYxIDEuMTk4NDhMMC41MjQ3MjMgMTguNjE4M0MwLjI2NzY4MSAxOC44ODY2IDAuMDk2NjE5OCAxOS4yMjIzIDAuMDMyNTE4NSAxOS41ODM5Qy0wLjAzMTU4MjkgMTkuOTQ1NiAwLjAxNDA2MjQgMjAuMzE3NyAwLjE2Mzg1NiAyMC42NTQ1QzAuMzEzNjUgMjAuOTkxMyAwLjU2MTA4MSAyMS4yNzgxIDAuODc1ODA0IDIxLjQ3OTlDMS4xOTA1MyAyMS42ODE3IDEuNTU4ODYgMjEuNzg5NiAxLjkzNTYzIDIxLjc5MDVaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMTc0XzQ0MDMpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMTc0XzQ0MDMiIHgxPSI4LjUyNTU4IiB5MT0iOTAuMDk3MyIgeDI9Ijg4Ljk5MzMiIHkyPSItMy4wMTYyMiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBvZmZzZXQ9IjAuMDgiIHN0b3AtY29sb3I9IiM5OTQ1RkYiLz4KPHN0b3Agb2Zmc2V0PSIwLjMiIHN0b3AtY29sb3I9IiM4NzUyRjMiLz4KPHN0b3Agb2Zmc2V0PSIwLjUiIHN0b3AtY29sb3I9IiM1NDk3RDUiLz4KPHN0b3Agb2Zmc2V0PSIwLjYiIHN0b3AtY29sb3I9IiM0M0I0Q0EiLz4KPHN0b3Agb2Zmc2V0PSIwLjcyIiBzdG9wLWNvbG9yPSIjMjhFMEI5Ii8+CjxzdG9wIG9mZnNldD0iMC45NyIgc3RvcC1jb2xvcj0iIzE5RkI5QiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
const LitInput = ({
  value,
  setValue,
  errorMessage = null,
  placeholder = "",
  type = "text",
  disabled = false,
  loading = false
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: `lsm-input-container`,
    children: [/* @__PURE__ */ jsx$1("input", {
      placeholder,
      value,
      type,
      disabled,
      onChange: (e2) => setValue(e2.target.value),
      className: "lsm-input"
    }), !loading ? /* @__PURE__ */ jsx$1("p", {
      className: "lsm-input-error",
      children: errorMessage && value.length ? errorMessage : ""
    }) : /* @__PURE__ */ jsx$1("p", {
      className: "lsm-loading",
      children: "Loading..."
    })]
  });
};
const EthereumSelectWallet = ({
  updateUnifiedAccessControlConditions,
  submitDisabled,
  chain,
  initialState = null
}) => {
  const [walletAddress, setWalletAddress] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const {
    wipeInitialProps
  } = useContext(ShareModalContext);
  useEffect(() => {
    if (initialState) {
      if (initialState["walletAddress"]) {
        setWalletAddress(initialState["walletAddress"]);
        handleSubmit(initialState["walletAddress"]);
      }
    }
    wipeInitialProps();
  }, []);
  useEffect(() => {
    handleSubmit(walletAddress);
  }, [chain, walletAddress]);
  const handleSubmit = async (address) => {
    let resolvedAddress = address;
    if (address.toLowerCase().includes(".eth")) {
      setLoading(true);
      try {
        resolvedAddress = await LitJsSdk.lookupNameServiceAddress({
          chain: chain["value"],
          name: address
        });
      } catch (err) {
        setLoading(false);
        setErrorMessage("Error connecting");
        alert("Error connecting.  If using mobile, use the Metamask Mobile Browser to connect.");
        return;
      }
      if (!resolvedAddress) {
        setErrorMessage("Failed to resolve ENS address");
        setLoading(false);
        return;
      }
    }
    const checkIfAddressIsValid = chain.addressValidator(resolvedAddress);
    if (!checkIfAddressIsValid) {
      setErrorMessage("Address is invalid");
    } else {
      setErrorMessage("");
    }
    submitDisabled(!resolvedAddress.length || !checkIfAddressIsValid);
    setLoading(false);
    const unifiedAccessControlConditions = [{
      conditionType: "evmBasic",
      contractAddress: "",
      standardContractType: "",
      chain: chain["value"],
      method: "",
      parameters: [":userAddress"],
      returnValueTest: {
        comparator: "=",
        value: resolvedAddress
      }
    }];
    updateUnifiedAccessControlConditions(unifiedAccessControlConditions);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-condition-container",
    children: [/* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "Which wallet should be able to access this asset?"
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "Add Wallet Address or Blockchain Domain (e.g. ENS) here:"
    }), /* @__PURE__ */ jsx$1(LitInput, {
      value: walletAddress,
      setValue: setWalletAddress,
      errorMessage,
      loading
    })]
  });
};
var require$$1 = /* @__PURE__ */ getAugmentedNamespace(reactSelect_esm);
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
var hasNativePerformanceNow = typeof performance === "object" && typeof performance.now === "function";
var now = hasNativePerformanceNow ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function cancelTimeout(timeoutID) {
  cancelAnimationFrame(timeoutID.id);
}
function requestTimeout(callback, delay) {
  var start = now();
  function tick() {
    if (now() - start >= delay) {
      callback.call(null);
    } else {
      timeoutID.id = requestAnimationFrame(tick);
    }
  }
  var timeoutID = {
    id: requestAnimationFrame(tick)
  };
  return timeoutID;
}
var size = -1;
function getScrollbarSize(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }
  if (size === -1 || recalculate) {
    var div = document.createElement("div");
    var style = div.style;
    style.width = "50px";
    style.height = "50px";
    style.overflow = "scroll";
    document.body.appendChild(div);
    size = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
  }
  return size;
}
var cachedRTLResult = null;
function getRTLOffsetType(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }
  if (cachedRTLResult === null || recalculate) {
    var outerDiv = document.createElement("div");
    var outerStyle = outerDiv.style;
    outerStyle.width = "50px";
    outerStyle.height = "50px";
    outerStyle.overflow = "scroll";
    outerStyle.direction = "rtl";
    var innerDiv = document.createElement("div");
    var innerStyle = innerDiv.style;
    innerStyle.width = "100px";
    innerStyle.height = "100px";
    outerDiv.appendChild(innerDiv);
    document.body.appendChild(outerDiv);
    if (outerDiv.scrollLeft > 0) {
      cachedRTLResult = "positive-descending";
    } else {
      outerDiv.scrollLeft = 1;
      if (outerDiv.scrollLeft === 0) {
        cachedRTLResult = "negative";
      } else {
        cachedRTLResult = "positive-ascending";
      }
    }
    document.body.removeChild(outerDiv);
    return cachedRTLResult;
  }
  return cachedRTLResult;
}
var IS_SCROLLING_DEBOUNCE_INTERVAL = 150;
var defaultItemKey = function defaultItemKey2(_ref3) {
  var columnIndex = _ref3.columnIndex;
  _ref3.data;
  var rowIndex = _ref3.rowIndex;
  return rowIndex + ":" + columnIndex;
};
function createGridComponent(_ref22) {
  var _class;
  var getColumnOffset3 = _ref22.getColumnOffset, getColumnStartIndexForOffset3 = _ref22.getColumnStartIndexForOffset, getColumnStopIndexForStartIndex3 = _ref22.getColumnStopIndexForStartIndex, getColumnWidth3 = _ref22.getColumnWidth, getEstimatedTotalHeight4 = _ref22.getEstimatedTotalHeight, getEstimatedTotalWidth4 = _ref22.getEstimatedTotalWidth, getOffsetForColumnAndAlignment3 = _ref22.getOffsetForColumnAndAlignment, getOffsetForRowAndAlignment3 = _ref22.getOffsetForRowAndAlignment, getRowHeight3 = _ref22.getRowHeight, getRowOffset3 = _ref22.getRowOffset, getRowStartIndexForOffset3 = _ref22.getRowStartIndexForOffset, getRowStopIndexForStartIndex3 = _ref22.getRowStopIndexForStartIndex, initInstanceProps5 = _ref22.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref22.shouldResetStyleCacheOnItemSizeChange, validateProps5 = _ref22.validateProps;
  return _class = /* @__PURE__ */ function(_PureComponent) {
    _inheritsLoose(Grid, _PureComponent);
    function Grid(props) {
      var _this;
      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps5(_this.props, _assertThisInitialized(_this));
      _this._resetIsScrollingTimeoutId = null;
      _this._outerRef = void 0;
      _this.state = {
        instance: _assertThisInitialized(_this),
        isScrolling: false,
        horizontalScrollDirection: "forward",
        scrollLeft: typeof _this.props.initialScrollLeft === "number" ? _this.props.initialScrollLeft : 0,
        scrollTop: typeof _this.props.initialScrollTop === "number" ? _this.props.initialScrollTop : 0,
        scrollUpdateWasRequested: false,
        verticalScrollDirection: "forward"
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = memoizeOne(function(overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
        return _this.props.onItemsRendered({
          overscanColumnStartIndex,
          overscanColumnStopIndex,
          overscanRowStartIndex,
          overscanRowStopIndex,
          visibleColumnStartIndex,
          visibleColumnStopIndex,
          visibleRowStartIndex,
          visibleRowStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = memoizeOne(function(scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          horizontalScrollDirection,
          scrollLeft,
          scrollTop,
          verticalScrollDirection,
          scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;
      _this._getItemStyle = function(rowIndex, columnIndex) {
        var _this$props = _this.props, columnWidth = _this$props.columnWidth, direction = _this$props.direction, rowHeight = _this$props.rowHeight;
        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);
        var key = rowIndex + ":" + columnIndex;
        var style;
        if (itemStyleCache.hasOwnProperty(key)) {
          style = itemStyleCache[key];
        } else {
          var _offset = getColumnOffset3(_this.props, columnIndex, _this._instanceProps);
          var isRtl = direction === "rtl";
          itemStyleCache[key] = style = {
            position: "absolute",
            left: isRtl ? void 0 : _offset,
            right: isRtl ? _offset : void 0,
            top: getRowOffset3(_this.props, rowIndex, _this._instanceProps),
            height: getRowHeight3(_this.props, rowIndex, _this._instanceProps),
            width: getColumnWidth3(_this.props, columnIndex, _this._instanceProps)
          };
        }
        return style;
      };
      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = memoizeOne(function(_, __, ___) {
        return {};
      });
      _this._onScroll = function(event) {
        var _event$currentTarget = event.currentTarget, clientHeight = _event$currentTarget.clientHeight, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollTop = _event$currentTarget.scrollTop, scrollHeight = _event$currentTarget.scrollHeight, scrollWidth = _event$currentTarget.scrollWidth;
        _this.setState(function(prevState) {
          if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) {
            return null;
          }
          var direction = _this.props.direction;
          var calculatedScrollLeft = scrollLeft;
          if (direction === "rtl") {
            switch (getRTLOffsetType()) {
              case "negative":
                calculatedScrollLeft = -scrollLeft;
                break;
              case "positive-descending":
                calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                break;
            }
          }
          calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
          var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? "forward" : "backward",
            scrollLeft: calculatedScrollLeft,
            scrollTop: calculatedScrollTop,
            verticalScrollDirection: prevState.scrollTop < scrollTop ? "forward" : "backward",
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };
      _this._outerRefSetter = function(ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;
        if (typeof outerRef === "function") {
          outerRef(ref);
        } else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) {
          outerRef.current = ref;
        }
      };
      _this._resetIsScrollingDebounced = function() {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }
        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL);
      };
      _this._resetIsScrolling = function() {
        _this._resetIsScrollingTimeoutId = null;
        _this.setState({
          isScrolling: false
        }, function() {
          _this._getItemStyleCache(-1);
        });
      };
      return _this;
    }
    Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps(nextProps, prevState);
      validateProps5(nextProps);
      return null;
    };
    var _proto = Grid.prototype;
    _proto.scrollTo = function scrollTo2(_ref3) {
      var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
      if (scrollLeft !== void 0) {
        scrollLeft = Math.max(0, scrollLeft);
      }
      if (scrollTop !== void 0) {
        scrollTop = Math.max(0, scrollTop);
      }
      this.setState(function(prevState) {
        if (scrollLeft === void 0) {
          scrollLeft = prevState.scrollLeft;
        }
        if (scrollTop === void 0) {
          scrollTop = prevState.scrollTop;
        }
        if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) {
          return null;
        }
        return {
          horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? "forward" : "backward",
          scrollLeft,
          scrollTop,
          scrollUpdateWasRequested: true,
          verticalScrollDirection: prevState.scrollTop < scrollTop ? "forward" : "backward"
        };
      }, this._resetIsScrollingDebounced);
    };
    _proto.scrollToItem = function scrollToItem(_ref4) {
      var _ref4$align = _ref4.align, align = _ref4$align === void 0 ? "auto" : _ref4$align, columnIndex = _ref4.columnIndex, rowIndex = _ref4.rowIndex;
      var _this$props2 = this.props, columnCount = _this$props2.columnCount, height = _this$props2.height, rowCount = _this$props2.rowCount, width = _this$props2.width;
      var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
      var scrollbarSize = getScrollbarSize();
      if (columnIndex !== void 0) {
        columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
      }
      if (rowIndex !== void 0) {
        rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
      }
      var estimatedTotalHeight = getEstimatedTotalHeight4(this.props, this._instanceProps);
      var estimatedTotalWidth = getEstimatedTotalWidth4(this.props, this._instanceProps);
      var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
      var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
      this.scrollTo({
        scrollLeft: columnIndex !== void 0 ? getOffsetForColumnAndAlignment3(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
        scrollTop: rowIndex !== void 0 ? getOffsetForRowAndAlignment3(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
      });
    };
    _proto.componentDidMount = function componentDidMount() {
      var _this$props3 = this.props, initialScrollLeft = _this$props3.initialScrollLeft, initialScrollTop = _this$props3.initialScrollTop;
      if (this._outerRef != null) {
        var outerRef = this._outerRef;
        if (typeof initialScrollLeft === "number") {
          outerRef.scrollLeft = initialScrollLeft;
        }
        if (typeof initialScrollTop === "number") {
          outerRef.scrollTop = initialScrollTop;
        }
      }
      this._callPropsCallbacks();
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
      var direction = this.props.direction;
      var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollTop = _this$state2.scrollTop, scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
      if (scrollUpdateWasRequested && this._outerRef != null) {
        var outerRef = this._outerRef;
        if (direction === "rtl") {
          switch (getRTLOffsetType()) {
            case "negative":
              outerRef.scrollLeft = -scrollLeft;
              break;
            case "positive-ascending":
              outerRef.scrollLeft = scrollLeft;
              break;
            default:
              var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
              outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
              break;
          }
        } else {
          outerRef.scrollLeft = Math.max(0, scrollLeft);
        }
        outerRef.scrollTop = Math.max(0, scrollTop);
      }
      this._callPropsCallbacks();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };
    _proto.render = function render() {
      var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, columnCount = _this$props4.columnCount, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? defaultItemKey : _this$props4$itemKey, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, rowCount = _this$props4.rowCount, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
      var isScrolling = this.state.isScrolling;
      var _this$_getHorizontalR = this._getHorizontalRangeToRender(), columnStartIndex = _this$_getHorizontalR[0], columnStopIndex = _this$_getHorizontalR[1];
      var _this$_getVerticalRan = this._getVerticalRangeToRender(), rowStartIndex = _this$_getVerticalRan[0], rowStopIndex = _this$_getVerticalRan[1];
      var items = [];
      if (columnCount > 0 && rowCount) {
        for (var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++) {
          for (var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++) {
            items.push(createElement(children, {
              columnIndex: _columnIndex,
              data: itemData,
              isScrolling: useIsScrolling ? isScrolling : void 0,
              key: itemKey({
                columnIndex: _columnIndex,
                data: itemData,
                rowIndex: _rowIndex
              }),
              rowIndex: _rowIndex,
              style: this._getItemStyle(_rowIndex, _columnIndex)
            }));
          }
        }
      }
      var estimatedTotalHeight = getEstimatedTotalHeight4(this.props, this._instanceProps);
      var estimatedTotalWidth = getEstimatedTotalWidth4(this.props, this._instanceProps);
      return createElement(outerElementType || outerTagName || "div", {
        className,
        onScroll: this._onScroll,
        ref: this._outerRefSetter,
        style: _extends({
          position: "relative",
          height,
          width,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction
        }, style)
      }, createElement(innerElementType || innerTagName || "div", {
        children: items,
        ref: innerRef,
        style: {
          height: estimatedTotalHeight,
          pointerEvents: isScrolling ? "none" : void 0,
          width: estimatedTotalWidth
        }
      }));
    };
    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      var _this$props5 = this.props, columnCount = _this$props5.columnCount, onItemsRendered = _this$props5.onItemsRendered, onScroll = _this$props5.onScroll, rowCount = _this$props5.rowCount;
      if (typeof onItemsRendered === "function") {
        if (columnCount > 0 && rowCount > 0) {
          var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(), _overscanColumnStartIndex = _this$_getHorizontalR2[0], _overscanColumnStopIndex = _this$_getHorizontalR2[1], _visibleColumnStartIndex = _this$_getHorizontalR2[2], _visibleColumnStopIndex = _this$_getHorizontalR2[3];
          var _this$_getVerticalRan2 = this._getVerticalRangeToRender(), _overscanRowStartIndex = _this$_getVerticalRan2[0], _overscanRowStopIndex = _this$_getVerticalRan2[1], _visibleRowStartIndex = _this$_getVerticalRan2[2], _visibleRowStopIndex = _this$_getVerticalRan2[3];
          this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
        }
      }
      if (typeof onScroll === "function") {
        var _this$state3 = this.state, _horizontalScrollDirection = _this$state3.horizontalScrollDirection, _scrollLeft = _this$state3.scrollLeft, _scrollTop = _this$state3.scrollTop, _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested, _verticalScrollDirection = _this$state3.verticalScrollDirection;
        this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
      }
    };
    _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
      var _this$props6 = this.props, columnCount = _this$props6.columnCount, overscanColumnCount = _this$props6.overscanColumnCount, overscanColumnsCount = _this$props6.overscanColumnsCount, overscanCount = _this$props6.overscanCount, rowCount = _this$props6.rowCount;
      var _this$state4 = this.state, horizontalScrollDirection = _this$state4.horizontalScrollDirection, isScrolling = _this$state4.isScrolling, scrollLeft = _this$state4.scrollLeft;
      var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;
      if (columnCount === 0 || rowCount === 0) {
        return [0, 0, 0, 0];
      }
      var startIndex = getColumnStartIndexForOffset3(this.props, scrollLeft, this._instanceProps);
      var stopIndex = getColumnStopIndexForStartIndex3(this.props, startIndex, scrollLeft, this._instanceProps);
      var overscanBackward = !isScrolling || horizontalScrollDirection === "backward" ? Math.max(1, overscanCountResolved) : 1;
      var overscanForward = !isScrolling || horizontalScrollDirection === "forward" ? Math.max(1, overscanCountResolved) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };
    _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
      var _this$props7 = this.props, columnCount = _this$props7.columnCount, overscanCount = _this$props7.overscanCount, overscanRowCount = _this$props7.overscanRowCount, overscanRowsCount = _this$props7.overscanRowsCount, rowCount = _this$props7.rowCount;
      var _this$state5 = this.state, isScrolling = _this$state5.isScrolling, verticalScrollDirection = _this$state5.verticalScrollDirection, scrollTop = _this$state5.scrollTop;
      var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;
      if (columnCount === 0 || rowCount === 0) {
        return [0, 0, 0, 0];
      }
      var startIndex = getRowStartIndexForOffset3(this.props, scrollTop, this._instanceProps);
      var stopIndex = getRowStopIndexForStartIndex3(this.props, startIndex, scrollTop, this._instanceProps);
      var overscanBackward = !isScrolling || verticalScrollDirection === "backward" ? Math.max(1, overscanCountResolved) : 1;
      var overscanForward = !isScrolling || verticalScrollDirection === "forward" ? Math.max(1, overscanCountResolved) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };
    return Grid;
  }(PureComponent), _class.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    useIsScrolling: false
  }, _class;
}
var validateSharedProps = function validateSharedProps2(_ref5, _ref6) {
  _ref5.children;
  _ref5.direction;
  _ref5.height;
  _ref5.innerTagName;
  _ref5.outerTagName;
  _ref5.overscanColumnsCount;
  _ref5.overscanCount;
  _ref5.overscanRowsCount;
  _ref5.width;
  _ref6.instance;
};
var DEFAULT_ESTIMATED_ITEM_SIZE = 50;
var getEstimatedTotalHeight = function getEstimatedTotalHeight2(_ref3, _ref22) {
  var rowCount = _ref3.rowCount;
  var rowMetadataMap = _ref22.rowMetadataMap, estimatedRowHeight = _ref22.estimatedRowHeight, lastMeasuredRowIndex = _ref22.lastMeasuredRowIndex;
  var totalSizeOfMeasuredRows = 0;
  if (lastMeasuredRowIndex >= rowCount) {
    lastMeasuredRowIndex = rowCount - 1;
  }
  if (lastMeasuredRowIndex >= 0) {
    var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
    totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
  }
  var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
  return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var getEstimatedTotalWidth = function getEstimatedTotalWidth2(_ref3, _ref4) {
  var columnCount = _ref3.columnCount;
  var columnMetadataMap = _ref4.columnMetadataMap, estimatedColumnWidth = _ref4.estimatedColumnWidth, lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
  var totalSizeOfMeasuredRows = 0;
  if (lastMeasuredColumnIndex >= columnCount) {
    lastMeasuredColumnIndex = columnCount - 1;
  }
  if (lastMeasuredColumnIndex >= 0) {
    var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
    totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
  }
  var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
  return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var getItemMetadata = function getItemMetadata2(itemType, props, index, instanceProps) {
  var itemMetadataMap, itemSize, lastMeasuredIndex;
  if (itemType === "column") {
    itemMetadataMap = instanceProps.columnMetadataMap;
    itemSize = props.columnWidth;
    lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
  } else {
    itemMetadataMap = instanceProps.rowMetadataMap;
    itemSize = props.rowHeight;
    lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
  }
  if (index > lastMeasuredIndex) {
    var offset = 0;
    if (lastMeasuredIndex >= 0) {
      var itemMetadata = itemMetadataMap[lastMeasuredIndex];
      offset = itemMetadata.offset + itemMetadata.size;
    }
    for (var i = lastMeasuredIndex + 1; i <= index; i++) {
      var size2 = itemSize(i);
      itemMetadataMap[i] = {
        offset,
        size: size2
      };
      offset += size2;
    }
    if (itemType === "column") {
      instanceProps.lastMeasuredColumnIndex = index;
    } else {
      instanceProps.lastMeasuredRowIndex = index;
    }
  }
  return itemMetadataMap[index];
};
var findNearestItem = function findNearestItem2(itemType, props, instanceProps, offset) {
  var itemMetadataMap, lastMeasuredIndex;
  if (itemType === "column") {
    itemMetadataMap = instanceProps.columnMetadataMap;
    lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
  } else {
    itemMetadataMap = instanceProps.rowMetadataMap;
    lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
  }
  var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
  if (lastMeasuredItemOffset >= offset) {
    return findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
  } else {
    return findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
  }
};
var findNearestItemBinarySearch = function findNearestItemBinarySearch2(itemType, props, instanceProps, high, low, offset) {
  while (low <= high) {
    var middle = low + Math.floor((high - low) / 2);
    var currentOffset = getItemMetadata(itemType, props, middle, instanceProps).offset;
    if (currentOffset === offset) {
      return middle;
    } else if (currentOffset < offset) {
      low = middle + 1;
    } else if (currentOffset > offset) {
      high = middle - 1;
    }
  }
  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};
var findNearestItemExponentialSearch = function findNearestItemExponentialSearch2(itemType, props, instanceProps, index, offset) {
  var itemCount = itemType === "column" ? props.columnCount : props.rowCount;
  var interval = 1;
  while (index < itemCount && getItemMetadata(itemType, props, index, instanceProps).offset < offset) {
    index += interval;
    interval *= 2;
  }
  return findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment2(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
  var size2 = itemType === "column" ? props.width : props.height;
  var itemMetadata = getItemMetadata(itemType, props, index, instanceProps);
  var estimatedTotalSize = itemType === "column" ? getEstimatedTotalWidth(props, instanceProps) : getEstimatedTotalHeight(props, instanceProps);
  var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size2, itemMetadata.offset));
  var minOffset = Math.max(0, itemMetadata.offset - size2 + scrollbarSize + itemMetadata.size);
  if (align === "smart") {
    if (scrollOffset >= minOffset - size2 && scrollOffset <= maxOffset + size2) {
      align = "auto";
    } else {
      align = "center";
    }
  }
  switch (align) {
    case "start":
      return maxOffset;
    case "end":
      return minOffset;
    case "center":
      return Math.round(minOffset + (maxOffset - minOffset) / 2);
    case "auto":
    default:
      if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
        return scrollOffset;
      } else if (minOffset > maxOffset) {
        return minOffset;
      } else if (scrollOffset < minOffset) {
        return minOffset;
      } else {
        return maxOffset;
      }
  }
};
var VariableSizeGrid = /* @__PURE__ */ createGridComponent({
  getColumnOffset: function getColumnOffset(props, index, instanceProps) {
    return getItemMetadata("column", props, index, instanceProps).offset;
  },
  getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
    return findNearestItem("column", props, instanceProps, scrollLeft);
  },
  getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
    var columnCount = props.columnCount, width = props.width;
    var itemMetadata = getItemMetadata("column", props, startIndex, instanceProps);
    var maxOffset = scrollLeft + width;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;
    while (stopIndex < columnCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata("column", props, stopIndex, instanceProps).size;
    }
    return stopIndex;
  },
  getColumnWidth: function getColumnWidth(props, index, instanceProps) {
    return instanceProps.columnMetadataMap[index].size;
  },
  getEstimatedTotalHeight,
  getEstimatedTotalWidth,
  getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    return getOffsetForIndexAndAlignment("column", props, index, align, scrollOffset, instanceProps, scrollbarSize);
  },
  getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    return getOffsetForIndexAndAlignment("row", props, index, align, scrollOffset, instanceProps, scrollbarSize);
  },
  getRowOffset: function getRowOffset(props, index, instanceProps) {
    return getItemMetadata("row", props, index, instanceProps).offset;
  },
  getRowHeight: function getRowHeight(props, index, instanceProps) {
    return instanceProps.rowMetadataMap[index].size;
  },
  getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
    return findNearestItem("row", props, instanceProps, scrollTop);
  },
  getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
    var rowCount = props.rowCount, height = props.height;
    var itemMetadata = getItemMetadata("row", props, startIndex, instanceProps);
    var maxOffset = scrollTop + height;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;
    while (stopIndex < rowCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata("row", props, stopIndex, instanceProps).size;
    }
    return stopIndex;
  },
  initInstanceProps: function initInstanceProps(props, instance) {
    var _ref5 = props, estimatedColumnWidth = _ref5.estimatedColumnWidth, estimatedRowHeight = _ref5.estimatedRowHeight;
    var instanceProps = {
      columnMetadataMap: {},
      estimatedColumnWidth: estimatedColumnWidth || DEFAULT_ESTIMATED_ITEM_SIZE,
      estimatedRowHeight: estimatedRowHeight || DEFAULT_ESTIMATED_ITEM_SIZE,
      lastMeasuredColumnIndex: -1,
      lastMeasuredRowIndex: -1,
      rowMetadataMap: {}
    };
    instance.resetAfterColumnIndex = function(columnIndex, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }
      instance.resetAfterIndices({
        columnIndex,
        shouldForceUpdate
      });
    };
    instance.resetAfterRowIndex = function(rowIndex, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }
      instance.resetAfterIndices({
        rowIndex,
        shouldForceUpdate
      });
    };
    instance.resetAfterIndices = function(_ref6) {
      var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex, _ref6$shouldForceUpda = _ref6.shouldForceUpdate, shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;
      if (typeof columnIndex === "number") {
        instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
      }
      if (typeof rowIndex === "number") {
        instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
      }
      instance._getItemStyleCache(-1);
      if (shouldForceUpdate) {
        instance.forceUpdate();
      }
    };
    return instanceProps;
  },
  shouldResetStyleCacheOnItemSizeChange: false,
  validateProps: function validateProps(_ref7) {
    _ref7.columnWidth;
    _ref7.rowHeight;
  }
});
var IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var defaultItemKey$1 = function defaultItemKey3(index, data) {
  return index;
};
function createListComponent(_ref3) {
  var _class;
  var getItemOffset3 = _ref3.getItemOffset, getEstimatedTotalSize4 = _ref3.getEstimatedTotalSize, getItemSize3 = _ref3.getItemSize, getOffsetForIndexAndAlignment5 = _ref3.getOffsetForIndexAndAlignment, getStartIndexForOffset3 = _ref3.getStartIndexForOffset, getStopIndexForStartIndex3 = _ref3.getStopIndexForStartIndex, initInstanceProps5 = _ref3.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref3.shouldResetStyleCacheOnItemSizeChange, validateProps5 = _ref3.validateProps;
  return _class = /* @__PURE__ */ function(_PureComponent) {
    _inheritsLoose(List, _PureComponent);
    function List(props) {
      var _this;
      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps5(_this.props, _assertThisInitialized(_this));
      _this._outerRef = void 0;
      _this._resetIsScrollingTimeoutId = null;
      _this.state = {
        instance: _assertThisInitialized(_this),
        isScrolling: false,
        scrollDirection: "forward",
        scrollOffset: typeof _this.props.initialScrollOffset === "number" ? _this.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: false
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = memoizeOne(function(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
        return _this.props.onItemsRendered({
          overscanStartIndex,
          overscanStopIndex,
          visibleStartIndex,
          visibleStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = memoizeOne(function(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          scrollDirection,
          scrollOffset,
          scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;
      _this._getItemStyle = function(index) {
        var _this$props = _this.props, direction = _this$props.direction, itemSize = _this$props.itemSize, layout = _this$props.layout;
        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
        var style;
        if (itemStyleCache.hasOwnProperty(index)) {
          style = itemStyleCache[index];
        } else {
          var _offset = getItemOffset3(_this.props, index, _this._instanceProps);
          var size2 = getItemSize3(_this.props, index, _this._instanceProps);
          var isHorizontal = direction === "horizontal" || layout === "horizontal";
          var isRtl = direction === "rtl";
          var offsetHorizontal = isHorizontal ? _offset : 0;
          itemStyleCache[index] = style = {
            position: "absolute",
            left: isRtl ? void 0 : offsetHorizontal,
            right: isRtl ? offsetHorizontal : void 0,
            top: !isHorizontal ? _offset : 0,
            height: !isHorizontal ? size2 : "100%",
            width: isHorizontal ? size2 : "100%"
          };
        }
        return style;
      };
      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = memoizeOne(function(_, __, ___) {
        return {};
      });
      _this._onScrollHorizontal = function(event) {
        var _event$currentTarget = event.currentTarget, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollWidth = _event$currentTarget.scrollWidth;
        _this.setState(function(prevState) {
          if (prevState.scrollOffset === scrollLeft) {
            return null;
          }
          var direction = _this.props.direction;
          var scrollOffset = scrollLeft;
          if (direction === "rtl") {
            switch (getRTLOffsetType()) {
              case "negative":
                scrollOffset = -scrollLeft;
                break;
              case "positive-descending":
                scrollOffset = scrollWidth - clientWidth - scrollLeft;
                break;
            }
          }
          scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollLeft ? "forward" : "backward",
            scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };
      _this._onScrollVertical = function(event) {
        var _event$currentTarget2 = event.currentTarget, clientHeight = _event$currentTarget2.clientHeight, scrollHeight = _event$currentTarget2.scrollHeight, scrollTop = _event$currentTarget2.scrollTop;
        _this.setState(function(prevState) {
          if (prevState.scrollOffset === scrollTop) {
            return null;
          }
          var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
            scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };
      _this._outerRefSetter = function(ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;
        if (typeof outerRef === "function") {
          outerRef(ref);
        } else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) {
          outerRef.current = ref;
        }
      };
      _this._resetIsScrollingDebounced = function() {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }
        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL$1);
      };
      _this._resetIsScrolling = function() {
        _this._resetIsScrollingTimeoutId = null;
        _this.setState({
          isScrolling: false
        }, function() {
          _this._getItemStyleCache(-1, null);
        });
      };
      return _this;
    }
    List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps$1(nextProps, prevState);
      validateProps5(nextProps);
      return null;
    };
    var _proto = List.prototype;
    _proto.scrollTo = function scrollTo2(scrollOffset) {
      scrollOffset = Math.max(0, scrollOffset);
      this.setState(function(prevState) {
        if (prevState.scrollOffset === scrollOffset) {
          return null;
        }
        return {
          scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
          scrollOffset,
          scrollUpdateWasRequested: true
        };
      }, this._resetIsScrollingDebounced);
    };
    _proto.scrollToItem = function scrollToItem(index, align) {
      if (align === void 0) {
        align = "auto";
      }
      var itemCount = this.props.itemCount;
      var scrollOffset = this.state.scrollOffset;
      index = Math.max(0, Math.min(index, itemCount - 1));
      this.scrollTo(getOffsetForIndexAndAlignment5(this.props, index, align, scrollOffset, this._instanceProps));
    };
    _proto.componentDidMount = function componentDidMount() {
      var _this$props2 = this.props, direction = _this$props2.direction, initialScrollOffset = _this$props2.initialScrollOffset, layout = _this$props2.layout;
      if (typeof initialScrollOffset === "number" && this._outerRef != null) {
        var outerRef = this._outerRef;
        if (direction === "horizontal" || layout === "horizontal") {
          outerRef.scrollLeft = initialScrollOffset;
        } else {
          outerRef.scrollTop = initialScrollOffset;
        }
      }
      this._callPropsCallbacks();
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
      var _this$props3 = this.props, direction = _this$props3.direction, layout = _this$props3.layout;
      var _this$state = this.state, scrollOffset = _this$state.scrollOffset, scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
      if (scrollUpdateWasRequested && this._outerRef != null) {
        var outerRef = this._outerRef;
        if (direction === "horizontal" || layout === "horizontal") {
          if (direction === "rtl") {
            switch (getRTLOffsetType()) {
              case "negative":
                outerRef.scrollLeft = -scrollOffset;
                break;
              case "positive-ascending":
                outerRef.scrollLeft = scrollOffset;
                break;
              default:
                var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                break;
            }
          } else {
            outerRef.scrollLeft = scrollOffset;
          }
        } else {
          outerRef.scrollTop = scrollOffset;
        }
      }
      this._callPropsCallbacks();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };
    _proto.render = function render() {
      var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemCount = _this$props4.itemCount, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? defaultItemKey$1 : _this$props4$itemKey, layout = _this$props4.layout, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
      var isScrolling = this.state.isScrolling;
      var isHorizontal = direction === "horizontal" || layout === "horizontal";
      var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
      var _this$_getRangeToRend = this._getRangeToRender(), startIndex = _this$_getRangeToRend[0], stopIndex = _this$_getRangeToRend[1];
      var items = [];
      if (itemCount > 0) {
        for (var _index = startIndex; _index <= stopIndex; _index++) {
          items.push(createElement(children, {
            data: itemData,
            key: itemKey(_index, itemData),
            index: _index,
            isScrolling: useIsScrolling ? isScrolling : void 0,
            style: this._getItemStyle(_index)
          }));
        }
      }
      var estimatedTotalSize = getEstimatedTotalSize4(this.props, this._instanceProps);
      return createElement(outerElementType || outerTagName || "div", {
        className,
        onScroll,
        ref: this._outerRefSetter,
        style: _extends({
          position: "relative",
          height,
          width,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction
        }, style)
      }, createElement(innerElementType || innerTagName || "div", {
        children: items,
        ref: innerRef,
        style: {
          height: isHorizontal ? "100%" : estimatedTotalSize,
          pointerEvents: isScrolling ? "none" : void 0,
          width: isHorizontal ? estimatedTotalSize : "100%"
        }
      }));
    };
    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      if (typeof this.props.onItemsRendered === "function") {
        var itemCount = this.props.itemCount;
        if (itemCount > 0) {
          var _this$_getRangeToRend2 = this._getRangeToRender(), _overscanStartIndex = _this$_getRangeToRend2[0], _overscanStopIndex = _this$_getRangeToRend2[1], _visibleStartIndex = _this$_getRangeToRend2[2], _visibleStopIndex = _this$_getRangeToRend2[3];
          this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
        }
      }
      if (typeof this.props.onScroll === "function") {
        var _this$state2 = this.state, _scrollDirection = _this$state2.scrollDirection, _scrollOffset = _this$state2.scrollOffset, _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
        this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
      }
    };
    _proto._getRangeToRender = function _getRangeToRender() {
      var _this$props5 = this.props, itemCount = _this$props5.itemCount, overscanCount = _this$props5.overscanCount;
      var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollDirection = _this$state3.scrollDirection, scrollOffset = _this$state3.scrollOffset;
      if (itemCount === 0) {
        return [0, 0, 0, 0];
      }
      var startIndex = getStartIndexForOffset3(this.props, scrollOffset, this._instanceProps);
      var stopIndex = getStopIndexForStartIndex3(this.props, startIndex, scrollOffset, this._instanceProps);
      var overscanBackward = !isScrolling || scrollDirection === "backward" ? Math.max(1, overscanCount) : 1;
      var overscanForward = !isScrolling || scrollDirection === "forward" ? Math.max(1, overscanCount) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };
    return List;
  }(PureComponent), _class.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    layout: "vertical",
    overscanCount: 2,
    useIsScrolling: false
  }, _class;
}
var validateSharedProps$1 = function validateSharedProps3(_ref22, _ref3) {
  _ref22.children;
  _ref22.direction;
  _ref22.height;
  _ref22.layout;
  _ref22.innerTagName;
  _ref22.outerTagName;
  _ref22.width;
  _ref3.instance;
};
var DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
var getItemMetadata$1 = function getItemMetadata3(props, index, instanceProps) {
  var _ref3 = props, itemSize = _ref3.itemSize;
  var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
  if (index > lastMeasuredIndex) {
    var offset = 0;
    if (lastMeasuredIndex >= 0) {
      var itemMetadata = itemMetadataMap[lastMeasuredIndex];
      offset = itemMetadata.offset + itemMetadata.size;
    }
    for (var i = lastMeasuredIndex + 1; i <= index; i++) {
      var size2 = itemSize(i);
      itemMetadataMap[i] = {
        offset,
        size: size2
      };
      offset += size2;
    }
    instanceProps.lastMeasuredIndex = index;
  }
  return itemMetadataMap[index];
};
var findNearestItem$1 = function findNearestItem3(props, instanceProps, offset) {
  var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
  var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
  if (lastMeasuredItemOffset >= offset) {
    return findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
  } else {
    return findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
  }
};
var findNearestItemBinarySearch$1 = function findNearestItemBinarySearch3(props, instanceProps, high, low, offset) {
  while (low <= high) {
    var middle = low + Math.floor((high - low) / 2);
    var currentOffset = getItemMetadata$1(props, middle, instanceProps).offset;
    if (currentOffset === offset) {
      return middle;
    } else if (currentOffset < offset) {
      low = middle + 1;
    } else if (currentOffset > offset) {
      high = middle - 1;
    }
  }
  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};
var findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch3(props, instanceProps, index, offset) {
  var itemCount = props.itemCount;
  var interval = 1;
  while (index < itemCount && getItemMetadata$1(props, index, instanceProps).offset < offset) {
    index += interval;
    interval *= 2;
  }
  return findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var getEstimatedTotalSize = function getEstimatedTotalSize2(_ref22, _ref3) {
  var itemCount = _ref22.itemCount;
  var itemMetadataMap = _ref3.itemMetadataMap, estimatedItemSize = _ref3.estimatedItemSize, lastMeasuredIndex = _ref3.lastMeasuredIndex;
  var totalSizeOfMeasuredItems = 0;
  if (lastMeasuredIndex >= itemCount) {
    lastMeasuredIndex = itemCount - 1;
  }
  if (lastMeasuredIndex >= 0) {
    var itemMetadata = itemMetadataMap[lastMeasuredIndex];
    totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
  }
  var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
  return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};
var VariableSizeList = /* @__PURE__ */ createListComponent({
  getItemOffset: function getItemOffset(props, index, instanceProps) {
    return getItemMetadata$1(props, index, instanceProps).offset;
  },
  getItemSize: function getItemSize(props, index, instanceProps) {
    return instanceProps.itemMetadataMap[index].size;
  },
  getEstimatedTotalSize,
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment3(props, index, align, scrollOffset, instanceProps) {
    var direction = props.direction, height = props.height, layout = props.layout, width = props.width;
    var isHorizontal = direction === "horizontal" || layout === "horizontal";
    var size2 = isHorizontal ? width : height;
    var itemMetadata = getItemMetadata$1(props, index, instanceProps);
    var estimatedTotalSize = getEstimatedTotalSize(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size2, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size2 + itemMetadata.size);
    if (align === "smart") {
      if (scrollOffset >= minOffset - size2 && scrollOffset <= maxOffset + size2) {
        align = "auto";
      } else {
        align = "center";
      }
    }
    switch (align) {
      case "start":
        return maxOffset;
      case "end":
        return minOffset;
      case "center":
        return Math.round(minOffset + (maxOffset - minOffset) / 2);
      case "auto":
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }
    }
  },
  getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
    return findNearestItem$1(props, instanceProps, offset);
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
    var direction = props.direction, height = props.height, itemCount = props.itemCount, layout = props.layout, width = props.width;
    var isHorizontal = direction === "horizontal" || layout === "horizontal";
    var size2 = isHorizontal ? width : height;
    var itemMetadata = getItemMetadata$1(props, startIndex, instanceProps);
    var maxOffset = scrollOffset + size2;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;
    while (stopIndex < itemCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata$1(props, stopIndex, instanceProps).size;
    }
    return stopIndex;
  },
  initInstanceProps: function initInstanceProps2(props, instance) {
    var _ref4 = props, estimatedItemSize = _ref4.estimatedItemSize;
    var instanceProps = {
      itemMetadataMap: {},
      estimatedItemSize: estimatedItemSize || DEFAULT_ESTIMATED_ITEM_SIZE$1,
      lastMeasuredIndex: -1
    };
    instance.resetAfterIndex = function(index, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }
      instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1);
      instance._getItemStyleCache(-1);
      if (shouldForceUpdate) {
        instance.forceUpdate();
      }
    };
    return instanceProps;
  },
  shouldResetStyleCacheOnItemSizeChange: false,
  validateProps: function validateProps2(_ref5) {
    _ref5.itemSize;
  }
});
var FixedSizeGrid = /* @__PURE__ */ createGridComponent({
  getColumnOffset: function getColumnOffset2(_ref3, index) {
    var columnWidth = _ref3.columnWidth;
    return index * columnWidth;
  },
  getColumnWidth: function getColumnWidth2(_ref22, index) {
    var columnWidth = _ref22.columnWidth;
    return columnWidth;
  },
  getRowOffset: function getRowOffset2(_ref3, index) {
    var rowHeight = _ref3.rowHeight;
    return index * rowHeight;
  },
  getRowHeight: function getRowHeight2(_ref4, index) {
    var rowHeight = _ref4.rowHeight;
    return rowHeight;
  },
  getEstimatedTotalHeight: function getEstimatedTotalHeight3(_ref5) {
    var rowCount = _ref5.rowCount, rowHeight = _ref5.rowHeight;
    return rowHeight * rowCount;
  },
  getEstimatedTotalWidth: function getEstimatedTotalWidth3(_ref6) {
    var columnCount = _ref6.columnCount, columnWidth = _ref6.columnWidth;
    return columnWidth * columnCount;
  },
  getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment2(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
    var columnCount = _ref7.columnCount, columnWidth = _ref7.columnWidth, width = _ref7.width;
    var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
    var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
    var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);
    if (align === "smart") {
      if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) {
        align = "auto";
      } else {
        align = "center";
      }
    }
    switch (align) {
      case "start":
        return maxOffset;
      case "end":
        return minOffset;
      case "center":
        var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
        if (middleOffset < Math.ceil(width / 2)) {
          return 0;
        } else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) {
          return lastColumnOffset;
        } else {
          return middleOffset;
        }
      case "auto":
      default:
        if (scrollLeft >= minOffset && scrollLeft <= maxOffset) {
          return scrollLeft;
        } else if (minOffset > maxOffset) {
          return minOffset;
        } else if (scrollLeft < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }
    }
  },
  getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment2(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
    var rowHeight = _ref8.rowHeight, height = _ref8.height, rowCount = _ref8.rowCount;
    var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
    var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
    var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);
    if (align === "smart") {
      if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) {
        align = "auto";
      } else {
        align = "center";
      }
    }
    switch (align) {
      case "start":
        return maxOffset;
      case "end":
        return minOffset;
      case "center":
        var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
        if (middleOffset < Math.ceil(height / 2)) {
          return 0;
        } else if (middleOffset > lastRowOffset + Math.floor(height / 2)) {
          return lastRowOffset;
        } else {
          return middleOffset;
        }
      case "auto":
      default:
        if (scrollTop >= minOffset && scrollTop <= maxOffset) {
          return scrollTop;
        } else if (minOffset > maxOffset) {
          return minOffset;
        } else if (scrollTop < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }
    }
  },
  getColumnStartIndexForOffset: function getColumnStartIndexForOffset2(_ref9, scrollLeft) {
    var columnWidth = _ref9.columnWidth, columnCount = _ref9.columnCount;
    return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
  },
  getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex2(_ref10, startIndex, scrollLeft) {
    var columnWidth = _ref10.columnWidth, columnCount = _ref10.columnCount, width = _ref10.width;
    var left = startIndex * columnWidth;
    var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
    return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1));
  },
  getRowStartIndexForOffset: function getRowStartIndexForOffset2(_ref11, scrollTop) {
    var rowHeight = _ref11.rowHeight, rowCount = _ref11.rowCount;
    return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
  },
  getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex2(_ref12, startIndex, scrollTop) {
    var rowHeight = _ref12.rowHeight, rowCount = _ref12.rowCount, height = _ref12.height;
    var top = startIndex * rowHeight;
    var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
    return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1));
  },
  initInstanceProps: function initInstanceProps3(props) {
  },
  shouldResetStyleCacheOnItemSizeChange: true,
  validateProps: function validateProps3(_ref13) {
    _ref13.columnWidth;
    _ref13.rowHeight;
  }
});
var FixedSizeList = /* @__PURE__ */ createListComponent({
  getItemOffset: function getItemOffset2(_ref3, index) {
    var itemSize = _ref3.itemSize;
    return index * itemSize;
  },
  getItemSize: function getItemSize2(_ref22, index) {
    var itemSize = _ref22.itemSize;
    return itemSize;
  },
  getEstimatedTotalSize: function getEstimatedTotalSize3(_ref3) {
    var itemCount = _ref3.itemCount, itemSize = _ref3.itemSize;
    return itemSize * itemCount;
  },
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment4(_ref4, index, align, scrollOffset) {
    var direction = _ref4.direction, height = _ref4.height, itemCount = _ref4.itemCount, itemSize = _ref4.itemSize, layout = _ref4.layout, width = _ref4.width;
    var isHorizontal = direction === "horizontal" || layout === "horizontal";
    var size2 = isHorizontal ? width : height;
    var lastItemOffset = Math.max(0, itemCount * itemSize - size2);
    var maxOffset = Math.min(lastItemOffset, index * itemSize);
    var minOffset = Math.max(0, index * itemSize - size2 + itemSize);
    if (align === "smart") {
      if (scrollOffset >= minOffset - size2 && scrollOffset <= maxOffset + size2) {
        align = "auto";
      } else {
        align = "center";
      }
    }
    switch (align) {
      case "start":
        return maxOffset;
      case "end":
        return minOffset;
      case "center": {
        var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
        if (middleOffset < Math.ceil(size2 / 2)) {
          return 0;
        } else if (middleOffset > lastItemOffset + Math.floor(size2 / 2)) {
          return lastItemOffset;
        } else {
          return middleOffset;
        }
      }
      case "auto":
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }
    }
  },
  getStartIndexForOffset: function getStartIndexForOffset2(_ref5, offset) {
    var itemCount = _ref5.itemCount, itemSize = _ref5.itemSize;
    return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex2(_ref6, startIndex, scrollOffset) {
    var direction = _ref6.direction, height = _ref6.height, itemCount = _ref6.itemCount, itemSize = _ref6.itemSize, layout = _ref6.layout, width = _ref6.width;
    var isHorizontal = direction === "horizontal" || layout === "horizontal";
    var offset = startIndex * itemSize;
    var size2 = isHorizontal ? width : height;
    var numVisibleItems = Math.ceil((size2 + scrollOffset - offset) / itemSize);
    return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1));
  },
  initInstanceProps: function initInstanceProps4(props) {
  },
  shouldResetStyleCacheOnItemSizeChange: true,
  validateProps: function validateProps4(_ref7) {
    _ref7.itemSize;
  }
});
function shallowDiffers(prev2, next2) {
  for (var attribute in prev2) {
    if (!(attribute in next2)) {
      return true;
    }
  }
  for (var _attribute in next2) {
    if (prev2[_attribute] !== next2[_attribute]) {
      return true;
    }
  }
  return false;
}
var _excluded$1 = ["style"], _excluded2 = ["style"];
function areEqual(prevProps, nextProps) {
  var prevStyle = prevProps.style, prevRest = _objectWithoutPropertiesLoose(prevProps, _excluded$1);
  var nextStyle = nextProps.style, nextRest = _objectWithoutPropertiesLoose(nextProps, _excluded2);
  return !shallowDiffers(prevStyle, nextStyle) && !shallowDiffers(prevRest, nextRest);
}
function shouldComponentUpdate(nextProps, nextState) {
  return !areEqual(this.props, nextProps) || shallowDiffers(this.state, nextState);
}
var index_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FixedSizeGrid,
  FixedSizeList,
  VariableSizeGrid,
  VariableSizeList,
  areEqual,
  shouldComponentUpdate
}, Symbol.toStringTag, { value: "Module" }));
var require$$2 = /* @__PURE__ */ getAugmentedNamespace(index_esm);
var main = function(e2) {
  var t2 = {};
  function n2(r2) {
    if (t2[r2])
      return t2[r2].exports;
    var o = t2[r2] = { i: r2, l: false, exports: {} };
    return e2[r2].call(o.exports, o, o.exports, n2), o.l = true, o.exports;
  }
  return n2.m = e2, n2.c = t2, n2.d = function(e3, t3, r2) {
    n2.o(e3, t3) || Object.defineProperty(e3, t3, { enumerable: true, get: r2 });
  }, n2.r = function(e3) {
    typeof Symbol != "undefined" && Symbol.toStringTag && Object.defineProperty(e3, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e3, "__esModule", { value: true });
  }, n2.t = function(e3, t3) {
    if (1 & t3 && (e3 = n2(e3)), 8 & t3)
      return e3;
    if (4 & t3 && typeof e3 == "object" && e3 && e3.__esModule)
      return e3;
    var r2 = /* @__PURE__ */ Object.create(null);
    if (n2.r(r2), Object.defineProperty(r2, "default", { enumerable: true, value: e3 }), 2 & t3 && typeof e3 != "string")
      for (var o in e3)
        n2.d(r2, o, function(t4) {
          return e3[t4];
        }.bind(null, o));
    return r2;
  }, n2.n = function(e3) {
    var t3 = e3 && e3.__esModule ? function() {
      return e3.default;
    } : function() {
      return e3;
    };
    return n2.d(t3, "a", t3), t3;
  }, n2.o = function(e3, t3) {
    return Object.prototype.hasOwnProperty.call(e3, t3);
  }, n2.p = "", n2(n2.s = 6);
}([function(e2, t2) {
  e2.exports = React__default;
}, function(e2, t2, n2) {
  n2.d(t2, "a", function() {
    return i;
  }), n2.d(t2, "c", function() {
    return u;
  }), n2.d(t2, "d", function() {
    return c2;
  }), n2.d(t2, "b", function() {
    return f2;
  });
  var r2 = n2(0), o = function(e3, t3) {
    for (var n3 = 0, r3 = t3.length, o2 = e3.length; n3 < r3; n3++, o2++)
      e3[o2] = t3[n3];
    return e3;
  };
  function i(e3) {
    return ((e3 = e3 || [])[0] || {}).options !== void 0 ? e3.reduce(function(e4, t3) {
      return e4 + t3.options.length;
    }, 0) : e3.length;
  }
  function u(e3) {
    return e3.reduce(function(e4, t3) {
      var n3 = t3.props.children, i2 = n3 === void 0 ? [] : n3;
      return o(o(o([], e4), [r2.cloneElement(t3, { type: "group" }, [])]), i2);
    }, []);
  }
  function a(e3) {
    return e3.props.isFocused === true;
  }
  function c2(e3) {
    return Math.max(e3.findIndex(a), 0);
  }
  function f2(e3) {
    var t3 = e3.groupHeadingStyles, n3 = e3.noOptionsMsgStyles, r3 = e3.optionStyles, o2 = e3.loadingMsgStyles;
    return function(e4) {
      var i2 = e4.props, u2 = i2.type, a2 = i2.children, c3 = i2.inputValue, f3 = i2.selectProps, s = f3.noOptionsMessage, l2 = f3.loadingMessage;
      if (u2 === "group") {
        var d2 = t3.height;
        return d2 === void 0 ? 25 : d2;
      }
      if (u2 === "option") {
        var p2 = r3.height;
        return p2 === void 0 ? 35 : p2;
      }
      if (typeof s == "function" && a2 === s({ inputValue: c3 })) {
        var g2 = n3.height;
        return g2 === void 0 ? 35 : g2;
      }
      if (typeof l2 == "function" && a2 === l2({ inputValue: c3 })) {
        var v2 = o2.height;
        return v2 === void 0 ? 35 : v2;
      }
      return 35;
    };
  }
}, function(e2, t2, n2) {
  var r2 = n2(1), o = n2(0), i = n2(5), u = function() {
    return (u = Object.assign || function(e3) {
      for (var t3, n3 = 1, r3 = arguments.length; n3 < r3; n3++)
        for (var o2 in t3 = arguments[n3])
          Object.prototype.hasOwnProperty.call(t3, o2) && (e3[o2] = t3[o2]);
      return e3;
    }).apply(this, arguments);
  }, a = function(e3, t3) {
    var n3 = {};
    for (var r3 in e3)
      Object.prototype.hasOwnProperty.call(e3, r3) && t3.indexOf(r3) < 0 && (n3[r3] = e3[r3]);
    if (e3 != null && typeof Object.getOwnPropertySymbols == "function") {
      var o2 = 0;
      for (r3 = Object.getOwnPropertySymbols(e3); o2 < r3.length; o2++)
        t3.indexOf(r3[o2]) < 0 && Object.prototype.propertyIsEnumerable.call(e3, r3[o2]) && (n3[r3[o2]] = e3[r3[o2]]);
    }
    return n3;
  };
  function c2(e3) {
    var t3 = e3.data, n3 = e3.index, r3 = e3.setMeasuredHeight, i2 = o.useRef(null);
    return o.useLayoutEffect(function() {
      if (i2.current) {
        var e4 = i2.current.getBoundingClientRect().height;
        r3({ index: n3, measuredHeight: e4 });
      }
    }, [i2.current]), o.createElement("div", { key: "option-" + n3, ref: i2 }, t3);
  }
  t2.a = function(e3) {
    var t3 = o.useMemo(function() {
      var t4 = o.Children.toArray(e3.children), n4 = t4[0] || {};
      if (o.isValidElement(n4)) {
        var i2 = n4.props, u2 = (i2 === void 0 ? {} : i2).data, a2 = (u2 === void 0 ? {} : u2).options, c3 = (a2 === void 0 ? [] : a2).length > 0, f3 = c3 && Object(r2.c)(t4);
        return c3 ? f3 : t4;
      }
      return [];
    }, [e3.children]), n3 = e3.getStyles, f2 = n3("groupHeading", e3), s = n3("loadingMessage", e3), l2 = n3("noOptionsMessage", e3), d2 = n3("option", e3), p2 = Object(r2.b)({ groupHeadingStyles: f2, noOptionsMsgStyles: l2, optionStyles: d2, loadingMsgStyles: s }), g2 = o.useMemo(function() {
      return t3.map(p2);
    }, [t3]), v2 = o.useMemo(function() {
      return Object(r2.d)(t3);
    }, [t3]), y2 = t3.length, h2 = o.useState({}), m2 = h2[0], O = h2[1], b2 = n3("menuList", e3), x2 = b2.maxHeight, M = b2.paddingBottom, j = M === void 0 ? 0 : M, S = b2.paddingTop, w2 = S === void 0 ? 0 : S, P = a(b2, ["maxHeight", "paddingBottom", "paddingTop"]), E = o.useMemo(function() {
      return g2.reduce(function(e4, t4, n4) {
        return m2[n4] ? e4 + m2[n4] : e4 + t4;
      }, 0);
    }, [g2, m2]), _ = E + j + w2, H = Math.min(x2, _), T = Math.floor(E / y2), R = e3.innerRef, I = e3.selectProps || {}, L = I.classNamePrefix, V = I.isMulti, q2 = o.useRef(null);
    o.useEffect(function() {
      O({});
    }, [e3.children]);
    var z2 = function(e4) {
      var t4 = e4.index, n4 = e4.measuredHeight;
      m2[t4] !== void 0 && m2[t4] === n4 || (O(function(e5) {
        var r3;
        return u(u({}, e5), ((r3 = {})[t4] = n4, r3));
      }), q2.current && q2.current.resetAfterIndex(t4));
    };
    return o.useEffect(function() {
      v2 >= 0 && q2.current !== null && q2.current.scrollToItem(v2);
    }, [v2, t3, q2]), o.createElement(i.VariableSizeList, { className: L ? L + "__menu-list" + (V ? " " + L + "__menu-list--is-multi" : "") : "", style: P, ref: q2, outerRef: R, estimatedItemSize: T, innerElementType: o.forwardRef(function(e4, t4) {
      var n4 = e4.style, r3 = a(e4, ["style"]);
      return o.createElement("div", u({ ref: t4, style: u(u({}, n4), { height: parseFloat(n4.height) + j + w2 + "px" }) }, r3));
    }), height: H, width: "100%", itemCount: y2, itemData: t3, itemSize: function(e4) {
      return m2[e4] || g2[e4];
    } }, function(e4) {
      var t4 = e4.data, n4 = e4.index, r3 = e4.style;
      return o.createElement("div", { style: u(u({}, r3), { top: parseFloat(r3.top.toString()) + w2 + "px" }) }, o.createElement(c2, { data: t4[n4], index: n4, setMeasuredHeight: z2 }));
    });
  };
}, function(e2, t2) {
  e2.exports = require$$1;
}, function(e2, t2, n2) {
  var r2 = n2(2), o = n2(0), i = n2(3), u = n2.n(i), a = n2(1), c2 = function() {
    return (c2 = Object.assign || function(e3) {
      for (var t3, n3 = 1, r3 = arguments.length; n3 < r3; n3++)
        for (var o2 in t3 = arguments[n3])
          Object.prototype.hasOwnProperty.call(t3, o2) && (e3[o2] = t3[o2]);
      return e3;
    }).apply(this, arguments);
  }, f2 = function(e3, t3) {
    var n3 = {};
    for (var r3 in e3)
      Object.prototype.hasOwnProperty.call(e3, r3) && t3.indexOf(r3) < 0 && (n3[r3] = e3[r3]);
    if (e3 != null && typeof Object.getOwnPropertySymbols == "function") {
      var o2 = 0;
      for (r3 = Object.getOwnPropertySymbols(e3); o2 < r3.length; o2++)
        t3.indexOf(r3[o2]) < 0 && Object.prototype.propertyIsEnumerable.call(e3, r3[o2]) && (n3[r3[o2]] = e3[r3[o2]]);
    }
    return n3;
  };
  t2.a = o.forwardRef(function(e3, t3) {
    var n3 = e3.windowThreshold, i2 = n3 === void 0 ? 100 : n3, s = f2(e3, ["windowThreshold"]), l2 = o.useMemo(function() {
      return Object(a.a)(s.options);
    }, [s.options]) >= i2;
    return o.createElement(u.a, c2({}, s, { components: c2(c2({}, s.components), l2 ? { MenuList: r2.a } : {}), ref: t3 }));
  });
}, function(e2, t2) {
  e2.exports = require$$2;
}, function(e2, t2, n2) {
  n2.r(t2);
  var r2 = n2(4), o = n2(3);
  for (var i in o)
    ["default", "WindowedMenuList"].indexOf(i) < 0 && function(e3) {
      n2.d(t2, e3, function() {
        return o[e3];
      });
    }(i);
  var u = n2(2);
  n2.d(t2, "WindowedMenuList", function() {
    return u.a;
  }), t2.default = r2.a;
}]);
var _excluded = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"];
var compareOption = function compareOption2() {
  var inputValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var option = arguments.length > 1 ? arguments[1] : void 0;
  var accessors = arguments.length > 2 ? arguments[2] : void 0;
  var candidate = String(inputValue).toLowerCase();
  var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
  var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
  return optionValue === candidate || optionLabel === candidate;
};
var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return 'Create "'.concat(inputValue, '"');
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
    return !(!inputValue || selectValue.some(function(option) {
      return compareOption(inputValue, option, accessors);
    }) || selectOptions.some(function(option) {
      return compareOption(inputValue, option, accessors);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};
function useCreatable(_ref3) {
  var _ref$allowCreateWhile = _ref3.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref3.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? "last" : _ref$createOptionPosi, _ref$formatCreateLabe = _ref3.formatCreateLabel, formatCreateLabel2 = _ref$formatCreateLabe === void 0 ? builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref3.isValidNewOption, isValidNewOption2 = _ref$isValidNewOption === void 0 ? builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref3.getNewOptionData, getNewOptionData2 = _ref$getNewOptionData === void 0 ? builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref3.onCreateOption, _ref$options = _ref3.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref3.onChange, restSelectProps = _objectWithoutProperties(_ref3, _excluded);
  var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1$1 = _restSelectProps$getO === void 0 ? getOptionValue$1 : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1$1 = _restSelectProps$getO2 === void 0 ? getOptionLabel$1 : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
  var newOption = useMemo(function() {
    return isValidNewOption2(inputValue, cleanValue(value), propsOptions, {
      getOptionValue: getOptionValue$1$1,
      getOptionLabel: getOptionLabel$1$1
    }) ? getNewOptionData2(inputValue, formatCreateLabel2(inputValue)) : void 0;
  }, [formatCreateLabel2, getNewOptionData2, getOptionLabel$1$1, getOptionValue$1$1, inputValue, isValidNewOption2, propsOptions, value]);
  var options2 = useMemo(function() {
    return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === "first" ? [newOption].concat(_toConsumableArray(propsOptions)) : [].concat(_toConsumableArray(propsOptions), [newOption]) : propsOptions;
  }, [allowCreateWhileLoading, createOptionPosition, isLoading, newOption, propsOptions]);
  var onChange2 = useCallback(function(newValue, actionMeta) {
    if (actionMeta.action !== "select-option") {
      return propsOnChange(newValue, actionMeta);
    }
    var valueArray = Array.isArray(newValue) ? newValue : [newValue];
    if (valueArray[valueArray.length - 1] === newOption) {
      if (onCreateOption)
        onCreateOption(inputValue);
      else {
        var newOptionData = getNewOptionData2(inputValue, inputValue);
        var newActionMeta = {
          action: "create-option",
          name,
          option: newOptionData
        };
        propsOnChange(valueTernary(isMulti, [].concat(_toConsumableArray(cleanValue(value)), [newOptionData]), newOptionData), newActionMeta);
      }
      return;
    }
    propsOnChange(newValue, actionMeta);
  }, [getNewOptionData2, inputValue, isMulti, name, newOption, onCreateOption, propsOnChange, value]);
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    options: options2,
    onChange: onChange2
  });
}
var CreatableSelect = /* @__PURE__ */ forwardRef(function(props, ref) {
  var creatableProps = useStateManager(props);
  var selectProps = useCreatable(creatableProps);
  return /* @__PURE__ */ React.createElement(Select, _extends({
    ref
  }, selectProps));
});
const LitTokenSelect = ({
  label,
  setSelectedToken,
  option,
  selectedToken,
  allowEthereum = false
}) => {
  const {
    tokenList,
    defaultTokens
  } = useContext(ShareModalContext);
  const Option3 = (_a) => {
    var _b = _a, {
      children,
      data: {
        label: label2,
        logo,
        symbol
      }
    } = _b, props = __objRest(_b, [
      "children",
      "data"
    ]);
    const _a2 = props.innerProps, {
      onMouseMove,
      onMouseOver
    } = _a2, rest = __objRest(_a2, [
      "onMouseMove",
      "onMouseOver"
    ]);
    const newProps = Object.assign(props, {
      innerProps: rest
    });
    return /* @__PURE__ */ jsxs(main.components.Option, __spreadProps(__spreadValues({}, newProps), {
      className: "lsm-option-select",
      children: [!!logo && /* @__PURE__ */ jsx$1("img", {
        src: logo,
        style: {
          height: "1em",
          marginRight: "0.5em"
        },
        className: "lsm-chain-selector-options-icons",
        alt: label2
      }), /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx$1("div", {
          className: "",
          children: label2
        }), /* @__PURE__ */ jsx$1("div", {
          className: "lsm-condition-prompt-text-no-margin",
          children: symbol
        })]
      })]
    }));
  };
  const tokenSelectRows = useMemo(() => {
    let formattedDefaultTokens = [];
    if (defaultTokens) {
      formattedDefaultTokens = defaultTokens.map((t2) => {
        return {
          label: t2.label,
          value: t2.value,
          standard: t2.standard,
          logo: t2.logo,
          symbol: t2.symbol
        };
      });
    }
    if (allowEthereum) {
      return [{
        label: "Ethereum",
        value: "ethereum",
        symbol: "ETH",
        logo: "https://upload.wikimedia.org/wikipedia/commons/0/05/Ethereum_logo_2014.svg"
      }, ...formattedDefaultTokens, ...tokenList.map((t2) => ({
        label: t2.name,
        value: t2.address,
        standard: t2.standard,
        logo: t2.logoURI,
        symbol: t2.symbol
      }))];
    } else {
      return [...formattedDefaultTokens, ...tokenList.map((t2) => ({
        label: t2.name,
        value: t2.address,
        standard: t2.standard,
        logo: t2.logoURI,
        symbol: t2.symbol
      }))];
    }
  }, [tokenList]);
  return /* @__PURE__ */ jsx$1(CreatableSelect, {
    className: "lsm-token-select",
    classNamePrefix: "lsm-ts",
    filterOption: main.createFilter({
      ignoreAccents: false
    }),
    components: {
      Option: Option3,
      MenuList: main.WindowedMenuList
    },
    isClearable: true,
    isSearchable: true,
    defaultValue: "",
    options: tokenSelectRows,
    styles: {
      menuPortal: (base) => __spreadProps(__spreadValues({}, base), {
        zIndex: 9999
      })
    },
    menuPortalTarget: document.body,
    onChange: setSelectedToken
  });
};
var bn = { exports: {} };
(function(module) {
  (function(module2, exports) {
    function assert(val, msg) {
      if (!val)
        throw new Error(msg || "Assertion failed");
    }
    function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function() {
      };
      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    }
    function BN2(number, base, endian) {
      if (BN2.isBN(number)) {
        return number;
      }
      this.negative = 0;
      this.words = null;
      this.length = 0;
      this.red = null;
      if (number !== null) {
        if (base === "le" || base === "be") {
          endian = base;
          base = 10;
        }
        this._init(number || 0, base || 10, endian || "be");
      }
    }
    if (typeof module2 === "object") {
      module2.exports = BN2;
    } else {
      exports.BN = BN2;
    }
    BN2.BN = BN2;
    BN2.wordSize = 26;
    var Buffer2;
    try {
      if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") {
        Buffer2 = window.Buffer;
      } else {
        Buffer2 = require("buffer").Buffer;
      }
    } catch (e2) {
    }
    BN2.isBN = function isBN(num) {
      if (num instanceof BN2) {
        return true;
      }
      return num !== null && typeof num === "object" && num.constructor.wordSize === BN2.wordSize && Array.isArray(num.words);
    };
    BN2.max = function max(left, right) {
      if (left.cmp(right) > 0)
        return left;
      return right;
    };
    BN2.min = function min(left, right) {
      if (left.cmp(right) < 0)
        return left;
      return right;
    };
    BN2.prototype._init = function init(number, base, endian) {
      if (typeof number === "number") {
        return this._initNumber(number, base, endian);
      }
      if (typeof number === "object") {
        return this._initArray(number, base, endian);
      }
      if (base === "hex") {
        base = 16;
      }
      assert(base === (base | 0) && base >= 2 && base <= 36);
      number = number.toString().replace(/\s+/g, "");
      var start = 0;
      if (number[0] === "-") {
        start++;
        this.negative = 1;
      }
      if (start < number.length) {
        if (base === 16) {
          this._parseHex(number, start, endian);
        } else {
          this._parseBase(number, base, start);
          if (endian === "le") {
            this._initArray(this.toArray(), base, endian);
          }
        }
      }
    };
    BN2.prototype._initNumber = function _initNumber(number, base, endian) {
      if (number < 0) {
        this.negative = 1;
        number = -number;
      }
      if (number < 67108864) {
        this.words = [number & 67108863];
        this.length = 1;
      } else if (number < 4503599627370496) {
        this.words = [
          number & 67108863,
          number / 67108864 & 67108863
        ];
        this.length = 2;
      } else {
        assert(number < 9007199254740992);
        this.words = [
          number & 67108863,
          number / 67108864 & 67108863,
          1
        ];
        this.length = 3;
      }
      if (endian !== "le")
        return;
      this._initArray(this.toArray(), base, endian);
    };
    BN2.prototype._initArray = function _initArray(number, base, endian) {
      assert(typeof number.length === "number");
      if (number.length <= 0) {
        this.words = [0];
        this.length = 1;
        return this;
      }
      this.length = Math.ceil(number.length / 3);
      this.words = new Array(this.length);
      for (var i = 0; i < this.length; i++) {
        this.words[i] = 0;
      }
      var j, w2;
      var off = 0;
      if (endian === "be") {
        for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
          w2 = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
          this.words[j] |= w2 << off & 67108863;
          this.words[j + 1] = w2 >>> 26 - off & 67108863;
          off += 24;
          if (off >= 26) {
            off -= 26;
            j++;
          }
        }
      } else if (endian === "le") {
        for (i = 0, j = 0; i < number.length; i += 3) {
          w2 = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
          this.words[j] |= w2 << off & 67108863;
          this.words[j + 1] = w2 >>> 26 - off & 67108863;
          off += 24;
          if (off >= 26) {
            off -= 26;
            j++;
          }
        }
      }
      return this._strip();
    };
    function parseHex4Bits(string, index) {
      var c2 = string.charCodeAt(index);
      if (c2 >= 48 && c2 <= 57) {
        return c2 - 48;
      } else if (c2 >= 65 && c2 <= 70) {
        return c2 - 55;
      } else if (c2 >= 97 && c2 <= 102) {
        return c2 - 87;
      } else {
        assert(false, "Invalid character in " + string);
      }
    }
    function parseHexByte(string, lowerBound, index) {
      var r2 = parseHex4Bits(string, index);
      if (index - 1 >= lowerBound) {
        r2 |= parseHex4Bits(string, index - 1) << 4;
      }
      return r2;
    }
    BN2.prototype._parseHex = function _parseHex(number, start, endian) {
      this.length = Math.ceil((number.length - start) / 6);
      this.words = new Array(this.length);
      for (var i = 0; i < this.length; i++) {
        this.words[i] = 0;
      }
      var off = 0;
      var j = 0;
      var w2;
      if (endian === "be") {
        for (i = number.length - 1; i >= start; i -= 2) {
          w2 = parseHexByte(number, start, i) << off;
          this.words[j] |= w2 & 67108863;
          if (off >= 18) {
            off -= 18;
            j += 1;
            this.words[j] |= w2 >>> 26;
          } else {
            off += 8;
          }
        }
      } else {
        var parseLength = number.length - start;
        for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
          w2 = parseHexByte(number, start, i) << off;
          this.words[j] |= w2 & 67108863;
          if (off >= 18) {
            off -= 18;
            j += 1;
            this.words[j] |= w2 >>> 26;
          } else {
            off += 8;
          }
        }
      }
      this._strip();
    };
    function parseBase(str, start, end, mul) {
      var r2 = 0;
      var b2 = 0;
      var len = Math.min(str.length, end);
      for (var i = start; i < len; i++) {
        var c2 = str.charCodeAt(i) - 48;
        r2 *= mul;
        if (c2 >= 49) {
          b2 = c2 - 49 + 10;
        } else if (c2 >= 17) {
          b2 = c2 - 17 + 10;
        } else {
          b2 = c2;
        }
        assert(c2 >= 0 && b2 < mul, "Invalid character");
        r2 += b2;
      }
      return r2;
    }
    BN2.prototype._parseBase = function _parseBase(number, base, start) {
      this.words = [0];
      this.length = 1;
      for (var limbLen = 0, limbPow = 1; limbPow <= 67108863; limbPow *= base) {
        limbLen++;
      }
      limbLen--;
      limbPow = limbPow / base | 0;
      var total = number.length - start;
      var mod = total % limbLen;
      var end = Math.min(total, total - mod) + start;
      var word = 0;
      for (var i = start; i < end; i += limbLen) {
        word = parseBase(number, i, i + limbLen, base);
        this.imuln(limbPow);
        if (this.words[0] + word < 67108864) {
          this.words[0] += word;
        } else {
          this._iaddn(word);
        }
      }
      if (mod !== 0) {
        var pow = 1;
        word = parseBase(number, i, number.length, base);
        for (i = 0; i < mod; i++) {
          pow *= base;
        }
        this.imuln(pow);
        if (this.words[0] + word < 67108864) {
          this.words[0] += word;
        } else {
          this._iaddn(word);
        }
      }
      this._strip();
    };
    BN2.prototype.copy = function copy2(dest) {
      dest.words = new Array(this.length);
      for (var i = 0; i < this.length; i++) {
        dest.words[i] = this.words[i];
      }
      dest.length = this.length;
      dest.negative = this.negative;
      dest.red = this.red;
    };
    function move(dest, src) {
      dest.words = src.words;
      dest.length = src.length;
      dest.negative = src.negative;
      dest.red = src.red;
    }
    BN2.prototype._move = function _move(dest) {
      move(dest, this);
    };
    BN2.prototype.clone = function clone() {
      var r2 = new BN2(null);
      this.copy(r2);
      return r2;
    };
    BN2.prototype._expand = function _expand(size2) {
      while (this.length < size2) {
        this.words[this.length++] = 0;
      }
      return this;
    };
    BN2.prototype._strip = function strip() {
      while (this.length > 1 && this.words[this.length - 1] === 0) {
        this.length--;
      }
      return this._normSign();
    };
    BN2.prototype._normSign = function _normSign() {
      if (this.length === 1 && this.words[0] === 0) {
        this.negative = 0;
      }
      return this;
    };
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") {
      try {
        BN2.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
      } catch (e2) {
        BN2.prototype.inspect = inspect;
      }
    } else {
      BN2.prototype.inspect = inspect;
    }
    function inspect() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var zeros2 = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ];
    var groupSizes = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ];
    var groupBases = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    BN2.prototype.toString = function toString(base, padding) {
      base = base || 10;
      padding = padding | 0 || 1;
      var out;
      if (base === 16 || base === "hex") {
        out = "";
        var off = 0;
        var carry = 0;
        for (var i = 0; i < this.length; i++) {
          var w2 = this.words[i];
          var word = ((w2 << off | carry) & 16777215).toString(16);
          carry = w2 >>> 24 - off & 16777215;
          off += 2;
          if (off >= 26) {
            off -= 26;
            i--;
          }
          if (carry !== 0 || i !== this.length - 1) {
            out = zeros2[6 - word.length] + word + out;
          } else {
            out = word + out;
          }
        }
        if (carry !== 0) {
          out = carry.toString(16) + out;
        }
        while (out.length % padding !== 0) {
          out = "0" + out;
        }
        if (this.negative !== 0) {
          out = "-" + out;
        }
        return out;
      }
      if (base === (base | 0) && base >= 2 && base <= 36) {
        var groupSize = groupSizes[base];
        var groupBase = groupBases[base];
        out = "";
        var c2 = this.clone();
        c2.negative = 0;
        while (!c2.isZero()) {
          var r2 = c2.modrn(groupBase).toString(base);
          c2 = c2.idivn(groupBase);
          if (!c2.isZero()) {
            out = zeros2[groupSize - r2.length] + r2 + out;
          } else {
            out = r2 + out;
          }
        }
        if (this.isZero()) {
          out = "0" + out;
        }
        while (out.length % padding !== 0) {
          out = "0" + out;
        }
        if (this.negative !== 0) {
          out = "-" + out;
        }
        return out;
      }
      assert(false, "Base should be between 2 and 36");
    };
    BN2.prototype.toNumber = function toNumber() {
      var ret = this.words[0];
      if (this.length === 2) {
        ret += this.words[1] * 67108864;
      } else if (this.length === 3 && this.words[2] === 1) {
        ret += 4503599627370496 + this.words[1] * 67108864;
      } else if (this.length > 2) {
        assert(false, "Number can only safely store up to 53 bits");
      }
      return this.negative !== 0 ? -ret : ret;
    };
    BN2.prototype.toJSON = function toJSON() {
      return this.toString(16, 2);
    };
    if (Buffer2) {
      BN2.prototype.toBuffer = function toBuffer(endian, length2) {
        return this.toArrayLike(Buffer2, endian, length2);
      };
    }
    BN2.prototype.toArray = function toArray(endian, length2) {
      return this.toArrayLike(Array, endian, length2);
    };
    var allocate = function allocate2(ArrayType, size2) {
      if (ArrayType.allocUnsafe) {
        return ArrayType.allocUnsafe(size2);
      }
      return new ArrayType(size2);
    };
    BN2.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length2) {
      this._strip();
      var byteLength = this.byteLength();
      var reqLength = length2 || Math.max(1, byteLength);
      assert(byteLength <= reqLength, "byte array longer than desired length");
      assert(reqLength > 0, "Requested array length <= 0");
      var res = allocate(ArrayType, reqLength);
      var postfix = endian === "le" ? "LE" : "BE";
      this["_toArrayLike" + postfix](res, byteLength);
      return res;
    };
    BN2.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
      var position2 = 0;
      var carry = 0;
      for (var i = 0, shift = 0; i < this.length; i++) {
        var word = this.words[i] << shift | carry;
        res[position2++] = word & 255;
        if (position2 < res.length) {
          res[position2++] = word >> 8 & 255;
        }
        if (position2 < res.length) {
          res[position2++] = word >> 16 & 255;
        }
        if (shift === 6) {
          if (position2 < res.length) {
            res[position2++] = word >> 24 & 255;
          }
          carry = 0;
          shift = 0;
        } else {
          carry = word >>> 24;
          shift += 2;
        }
      }
      if (position2 < res.length) {
        res[position2++] = carry;
        while (position2 < res.length) {
          res[position2++] = 0;
        }
      }
    };
    BN2.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
      var position2 = res.length - 1;
      var carry = 0;
      for (var i = 0, shift = 0; i < this.length; i++) {
        var word = this.words[i] << shift | carry;
        res[position2--] = word & 255;
        if (position2 >= 0) {
          res[position2--] = word >> 8 & 255;
        }
        if (position2 >= 0) {
          res[position2--] = word >> 16 & 255;
        }
        if (shift === 6) {
          if (position2 >= 0) {
            res[position2--] = word >> 24 & 255;
          }
          carry = 0;
          shift = 0;
        } else {
          carry = word >>> 24;
          shift += 2;
        }
      }
      if (position2 >= 0) {
        res[position2--] = carry;
        while (position2 >= 0) {
          res[position2--] = 0;
        }
      }
    };
    if (Math.clz32) {
      BN2.prototype._countBits = function _countBits(w2) {
        return 32 - Math.clz32(w2);
      };
    } else {
      BN2.prototype._countBits = function _countBits(w2) {
        var t2 = w2;
        var r2 = 0;
        if (t2 >= 4096) {
          r2 += 13;
          t2 >>>= 13;
        }
        if (t2 >= 64) {
          r2 += 7;
          t2 >>>= 7;
        }
        if (t2 >= 8) {
          r2 += 4;
          t2 >>>= 4;
        }
        if (t2 >= 2) {
          r2 += 2;
          t2 >>>= 2;
        }
        return r2 + t2;
      };
    }
    BN2.prototype._zeroBits = function _zeroBits(w2) {
      if (w2 === 0)
        return 26;
      var t2 = w2;
      var r2 = 0;
      if ((t2 & 8191) === 0) {
        r2 += 13;
        t2 >>>= 13;
      }
      if ((t2 & 127) === 0) {
        r2 += 7;
        t2 >>>= 7;
      }
      if ((t2 & 15) === 0) {
        r2 += 4;
        t2 >>>= 4;
      }
      if ((t2 & 3) === 0) {
        r2 += 2;
        t2 >>>= 2;
      }
      if ((t2 & 1) === 0) {
        r2++;
      }
      return r2;
    };
    BN2.prototype.bitLength = function bitLength() {
      var w2 = this.words[this.length - 1];
      var hi = this._countBits(w2);
      return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
      var w2 = new Array(num.bitLength());
      for (var bit = 0; bit < w2.length; bit++) {
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        w2[bit] = num.words[off] >>> wbit & 1;
      }
      return w2;
    }
    BN2.prototype.zeroBits = function zeroBits() {
      if (this.isZero())
        return 0;
      var r2 = 0;
      for (var i = 0; i < this.length; i++) {
        var b2 = this._zeroBits(this.words[i]);
        r2 += b2;
        if (b2 !== 26)
          break;
      }
      return r2;
    };
    BN2.prototype.byteLength = function byteLength() {
      return Math.ceil(this.bitLength() / 8);
    };
    BN2.prototype.toTwos = function toTwos(width) {
      if (this.negative !== 0) {
        return this.abs().inotn(width).iaddn(1);
      }
      return this.clone();
    };
    BN2.prototype.fromTwos = function fromTwos(width) {
      if (this.testn(width - 1)) {
        return this.notn(width).iaddn(1).ineg();
      }
      return this.clone();
    };
    BN2.prototype.isNeg = function isNeg() {
      return this.negative !== 0;
    };
    BN2.prototype.neg = function neg() {
      return this.clone().ineg();
    };
    BN2.prototype.ineg = function ineg() {
      if (!this.isZero()) {
        this.negative ^= 1;
      }
      return this;
    };
    BN2.prototype.iuor = function iuor(num) {
      while (this.length < num.length) {
        this.words[this.length++] = 0;
      }
      for (var i = 0; i < num.length; i++) {
        this.words[i] = this.words[i] | num.words[i];
      }
      return this._strip();
    };
    BN2.prototype.ior = function ior(num) {
      assert((this.negative | num.negative) === 0);
      return this.iuor(num);
    };
    BN2.prototype.or = function or(num) {
      if (this.length > num.length)
        return this.clone().ior(num);
      return num.clone().ior(this);
    };
    BN2.prototype.uor = function uor(num) {
      if (this.length > num.length)
        return this.clone().iuor(num);
      return num.clone().iuor(this);
    };
    BN2.prototype.iuand = function iuand(num) {
      var b2;
      if (this.length > num.length) {
        b2 = num;
      } else {
        b2 = this;
      }
      for (var i = 0; i < b2.length; i++) {
        this.words[i] = this.words[i] & num.words[i];
      }
      this.length = b2.length;
      return this._strip();
    };
    BN2.prototype.iand = function iand(num) {
      assert((this.negative | num.negative) === 0);
      return this.iuand(num);
    };
    BN2.prototype.and = function and(num) {
      if (this.length > num.length)
        return this.clone().iand(num);
      return num.clone().iand(this);
    };
    BN2.prototype.uand = function uand(num) {
      if (this.length > num.length)
        return this.clone().iuand(num);
      return num.clone().iuand(this);
    };
    BN2.prototype.iuxor = function iuxor(num) {
      var a;
      var b2;
      if (this.length > num.length) {
        a = this;
        b2 = num;
      } else {
        a = num;
        b2 = this;
      }
      for (var i = 0; i < b2.length; i++) {
        this.words[i] = a.words[i] ^ b2.words[i];
      }
      if (this !== a) {
        for (; i < a.length; i++) {
          this.words[i] = a.words[i];
        }
      }
      this.length = a.length;
      return this._strip();
    };
    BN2.prototype.ixor = function ixor(num) {
      assert((this.negative | num.negative) === 0);
      return this.iuxor(num);
    };
    BN2.prototype.xor = function xor(num) {
      if (this.length > num.length)
        return this.clone().ixor(num);
      return num.clone().ixor(this);
    };
    BN2.prototype.uxor = function uxor(num) {
      if (this.length > num.length)
        return this.clone().iuxor(num);
      return num.clone().iuxor(this);
    };
    BN2.prototype.inotn = function inotn(width) {
      assert(typeof width === "number" && width >= 0);
      var bytesNeeded = Math.ceil(width / 26) | 0;
      var bitsLeft = width % 26;
      this._expand(bytesNeeded);
      if (bitsLeft > 0) {
        bytesNeeded--;
      }
      for (var i = 0; i < bytesNeeded; i++) {
        this.words[i] = ~this.words[i] & 67108863;
      }
      if (bitsLeft > 0) {
        this.words[i] = ~this.words[i] & 67108863 >> 26 - bitsLeft;
      }
      return this._strip();
    };
    BN2.prototype.notn = function notn(width) {
      return this.clone().inotn(width);
    };
    BN2.prototype.setn = function setn(bit, val) {
      assert(typeof bit === "number" && bit >= 0);
      var off = bit / 26 | 0;
      var wbit = bit % 26;
      this._expand(off + 1);
      if (val) {
        this.words[off] = this.words[off] | 1 << wbit;
      } else {
        this.words[off] = this.words[off] & ~(1 << wbit);
      }
      return this._strip();
    };
    BN2.prototype.iadd = function iadd(num) {
      var r2;
      if (this.negative !== 0 && num.negative === 0) {
        this.negative = 0;
        r2 = this.isub(num);
        this.negative ^= 1;
        return this._normSign();
      } else if (this.negative === 0 && num.negative !== 0) {
        num.negative = 0;
        r2 = this.isub(num);
        num.negative = 1;
        return r2._normSign();
      }
      var a, b2;
      if (this.length > num.length) {
        a = this;
        b2 = num;
      } else {
        a = num;
        b2 = this;
      }
      var carry = 0;
      for (var i = 0; i < b2.length; i++) {
        r2 = (a.words[i] | 0) + (b2.words[i] | 0) + carry;
        this.words[i] = r2 & 67108863;
        carry = r2 >>> 26;
      }
      for (; carry !== 0 && i < a.length; i++) {
        r2 = (a.words[i] | 0) + carry;
        this.words[i] = r2 & 67108863;
        carry = r2 >>> 26;
      }
      this.length = a.length;
      if (carry !== 0) {
        this.words[this.length] = carry;
        this.length++;
      } else if (a !== this) {
        for (; i < a.length; i++) {
          this.words[i] = a.words[i];
        }
      }
      return this;
    };
    BN2.prototype.add = function add(num) {
      var res;
      if (num.negative !== 0 && this.negative === 0) {
        num.negative = 0;
        res = this.sub(num);
        num.negative ^= 1;
        return res;
      } else if (num.negative === 0 && this.negative !== 0) {
        this.negative = 0;
        res = num.sub(this);
        this.negative = 1;
        return res;
      }
      if (this.length > num.length)
        return this.clone().iadd(num);
      return num.clone().iadd(this);
    };
    BN2.prototype.isub = function isub(num) {
      if (num.negative !== 0) {
        num.negative = 0;
        var r2 = this.iadd(num);
        num.negative = 1;
        return r2._normSign();
      } else if (this.negative !== 0) {
        this.negative = 0;
        this.iadd(num);
        this.negative = 1;
        return this._normSign();
      }
      var cmp = this.cmp(num);
      if (cmp === 0) {
        this.negative = 0;
        this.length = 1;
        this.words[0] = 0;
        return this;
      }
      var a, b2;
      if (cmp > 0) {
        a = this;
        b2 = num;
      } else {
        a = num;
        b2 = this;
      }
      var carry = 0;
      for (var i = 0; i < b2.length; i++) {
        r2 = (a.words[i] | 0) - (b2.words[i] | 0) + carry;
        carry = r2 >> 26;
        this.words[i] = r2 & 67108863;
      }
      for (; carry !== 0 && i < a.length; i++) {
        r2 = (a.words[i] | 0) + carry;
        carry = r2 >> 26;
        this.words[i] = r2 & 67108863;
      }
      if (carry === 0 && i < a.length && a !== this) {
        for (; i < a.length; i++) {
          this.words[i] = a.words[i];
        }
      }
      this.length = Math.max(this.length, i);
      if (a !== this) {
        this.negative = 1;
      }
      return this._strip();
    };
    BN2.prototype.sub = function sub(num) {
      return this.clone().isub(num);
    };
    function smallMulTo(self2, num, out) {
      out.negative = num.negative ^ self2.negative;
      var len = self2.length + num.length | 0;
      out.length = len;
      len = len - 1 | 0;
      var a = self2.words[0] | 0;
      var b2 = num.words[0] | 0;
      var r2 = a * b2;
      var lo = r2 & 67108863;
      var carry = r2 / 67108864 | 0;
      out.words[0] = lo;
      for (var k2 = 1; k2 < len; k2++) {
        var ncarry = carry >>> 26;
        var rword = carry & 67108863;
        var maxJ = Math.min(k2, num.length - 1);
        for (var j = Math.max(0, k2 - self2.length + 1); j <= maxJ; j++) {
          var i = k2 - j | 0;
          a = self2.words[i] | 0;
          b2 = num.words[j] | 0;
          r2 = a * b2 + rword;
          ncarry += r2 / 67108864 | 0;
          rword = r2 & 67108863;
        }
        out.words[k2] = rword | 0;
        carry = ncarry | 0;
      }
      if (carry !== 0) {
        out.words[k2] = carry | 0;
      } else {
        out.length--;
      }
      return out._strip();
    }
    var comb10MulTo = function comb10MulTo2(self2, num, out) {
      var a = self2.words;
      var b2 = num.words;
      var o = out.words;
      var c2 = 0;
      var lo;
      var mid;
      var hi;
      var a0 = a[0] | 0;
      var al0 = a0 & 8191;
      var ah0 = a0 >>> 13;
      var a1 = a[1] | 0;
      var al1 = a1 & 8191;
      var ah1 = a1 >>> 13;
      var a2 = a[2] | 0;
      var al2 = a2 & 8191;
      var ah2 = a2 >>> 13;
      var a3 = a[3] | 0;
      var al3 = a3 & 8191;
      var ah3 = a3 >>> 13;
      var a4 = a[4] | 0;
      var al4 = a4 & 8191;
      var ah4 = a4 >>> 13;
      var a5 = a[5] | 0;
      var al5 = a5 & 8191;
      var ah5 = a5 >>> 13;
      var a6 = a[6] | 0;
      var al6 = a6 & 8191;
      var ah6 = a6 >>> 13;
      var a7 = a[7] | 0;
      var al7 = a7 & 8191;
      var ah7 = a7 >>> 13;
      var a8 = a[8] | 0;
      var al8 = a8 & 8191;
      var ah8 = a8 >>> 13;
      var a9 = a[9] | 0;
      var al9 = a9 & 8191;
      var ah9 = a9 >>> 13;
      var b0 = b2[0] | 0;
      var bl0 = b0 & 8191;
      var bh0 = b0 >>> 13;
      var b1 = b2[1] | 0;
      var bl1 = b1 & 8191;
      var bh1 = b1 >>> 13;
      var b22 = b2[2] | 0;
      var bl2 = b22 & 8191;
      var bh2 = b22 >>> 13;
      var b3 = b2[3] | 0;
      var bl3 = b3 & 8191;
      var bh3 = b3 >>> 13;
      var b4 = b2[4] | 0;
      var bl4 = b4 & 8191;
      var bh4 = b4 >>> 13;
      var b5 = b2[5] | 0;
      var bl5 = b5 & 8191;
      var bh5 = b5 >>> 13;
      var b6 = b2[6] | 0;
      var bl6 = b6 & 8191;
      var bh6 = b6 >>> 13;
      var b7 = b2[7] | 0;
      var bl7 = b7 & 8191;
      var bh7 = b7 >>> 13;
      var b8 = b2[8] | 0;
      var bl8 = b8 & 8191;
      var bh8 = b8 >>> 13;
      var b9 = b2[9] | 0;
      var bl9 = b9 & 8191;
      var bh9 = b9 >>> 13;
      out.negative = self2.negative ^ num.negative;
      out.length = 19;
      lo = Math.imul(al0, bl0);
      mid = Math.imul(al0, bh0);
      mid = mid + Math.imul(ah0, bl0) | 0;
      hi = Math.imul(ah0, bh0);
      var w0 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
      w0 &= 67108863;
      lo = Math.imul(al1, bl0);
      mid = Math.imul(al1, bh0);
      mid = mid + Math.imul(ah1, bl0) | 0;
      hi = Math.imul(ah1, bh0);
      lo = lo + Math.imul(al0, bl1) | 0;
      mid = mid + Math.imul(al0, bh1) | 0;
      mid = mid + Math.imul(ah0, bl1) | 0;
      hi = hi + Math.imul(ah0, bh1) | 0;
      var w1 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
      w1 &= 67108863;
      lo = Math.imul(al2, bl0);
      mid = Math.imul(al2, bh0);
      mid = mid + Math.imul(ah2, bl0) | 0;
      hi = Math.imul(ah2, bh0);
      lo = lo + Math.imul(al1, bl1) | 0;
      mid = mid + Math.imul(al1, bh1) | 0;
      mid = mid + Math.imul(ah1, bl1) | 0;
      hi = hi + Math.imul(ah1, bh1) | 0;
      lo = lo + Math.imul(al0, bl2) | 0;
      mid = mid + Math.imul(al0, bh2) | 0;
      mid = mid + Math.imul(ah0, bl2) | 0;
      hi = hi + Math.imul(ah0, bh2) | 0;
      var w2 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
      w2 &= 67108863;
      lo = Math.imul(al3, bl0);
      mid = Math.imul(al3, bh0);
      mid = mid + Math.imul(ah3, bl0) | 0;
      hi = Math.imul(ah3, bh0);
      lo = lo + Math.imul(al2, bl1) | 0;
      mid = mid + Math.imul(al2, bh1) | 0;
      mid = mid + Math.imul(ah2, bl1) | 0;
      hi = hi + Math.imul(ah2, bh1) | 0;
      lo = lo + Math.imul(al1, bl2) | 0;
      mid = mid + Math.imul(al1, bh2) | 0;
      mid = mid + Math.imul(ah1, bl2) | 0;
      hi = hi + Math.imul(ah1, bh2) | 0;
      lo = lo + Math.imul(al0, bl3) | 0;
      mid = mid + Math.imul(al0, bh3) | 0;
      mid = mid + Math.imul(ah0, bl3) | 0;
      hi = hi + Math.imul(ah0, bh3) | 0;
      var w3 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
      w3 &= 67108863;
      lo = Math.imul(al4, bl0);
      mid = Math.imul(al4, bh0);
      mid = mid + Math.imul(ah4, bl0) | 0;
      hi = Math.imul(ah4, bh0);
      lo = lo + Math.imul(al3, bl1) | 0;
      mid = mid + Math.imul(al3, bh1) | 0;
      mid = mid + Math.imul(ah3, bl1) | 0;
      hi = hi + Math.imul(ah3, bh1) | 0;
      lo = lo + Math.imul(al2, bl2) | 0;
      mid = mid + Math.imul(al2, bh2) | 0;
      mid = mid + Math.imul(ah2, bl2) | 0;
      hi = hi + Math.imul(ah2, bh2) | 0;
      lo = lo + Math.imul(al1, bl3) | 0;
      mid = mid + Math.imul(al1, bh3) | 0;
      mid = mid + Math.imul(ah1, bl3) | 0;
      hi = hi + Math.imul(ah1, bh3) | 0;
      lo = lo + Math.imul(al0, bl4) | 0;
      mid = mid + Math.imul(al0, bh4) | 0;
      mid = mid + Math.imul(ah0, bl4) | 0;
      hi = hi + Math.imul(ah0, bh4) | 0;
      var w4 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
      w4 &= 67108863;
      lo = Math.imul(al5, bl0);
      mid = Math.imul(al5, bh0);
      mid = mid + Math.imul(ah5, bl0) | 0;
      hi = Math.imul(ah5, bh0);
      lo = lo + Math.imul(al4, bl1) | 0;
      mid = mid + Math.imul(al4, bh1) | 0;
      mid = mid + Math.imul(ah4, bl1) | 0;
      hi = hi + Math.imul(ah4, bh1) | 0;
      lo = lo + Math.imul(al3, bl2) | 0;
      mid = mid + Math.imul(al3, bh2) | 0;
      mid = mid + Math.imul(ah3, bl2) | 0;
      hi = hi + Math.imul(ah3, bh2) | 0;
      lo = lo + Math.imul(al2, bl3) | 0;
      mid = mid + Math.imul(al2, bh3) | 0;
      mid = mid + Math.imul(ah2, bl3) | 0;
      hi = hi + Math.imul(ah2, bh3) | 0;
      lo = lo + Math.imul(al1, bl4) | 0;
      mid = mid + Math.imul(al1, bh4) | 0;
      mid = mid + Math.imul(ah1, bl4) | 0;
      hi = hi + Math.imul(ah1, bh4) | 0;
      lo = lo + Math.imul(al0, bl5) | 0;
      mid = mid + Math.imul(al0, bh5) | 0;
      mid = mid + Math.imul(ah0, bl5) | 0;
      hi = hi + Math.imul(ah0, bh5) | 0;
      var w5 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
      w5 &= 67108863;
      lo = Math.imul(al6, bl0);
      mid = Math.imul(al6, bh0);
      mid = mid + Math.imul(ah6, bl0) | 0;
      hi = Math.imul(ah6, bh0);
      lo = lo + Math.imul(al5, bl1) | 0;
      mid = mid + Math.imul(al5, bh1) | 0;
      mid = mid + Math.imul(ah5, bl1) | 0;
      hi = hi + Math.imul(ah5, bh1) | 0;
      lo = lo + Math.imul(al4, bl2) | 0;
      mid = mid + Math.imul(al4, bh2) | 0;
      mid = mid + Math.imul(ah4, bl2) | 0;
      hi = hi + Math.imul(ah4, bh2) | 0;
      lo = lo + Math.imul(al3, bl3) | 0;
      mid = mid + Math.imul(al3, bh3) | 0;
      mid = mid + Math.imul(ah3, bl3) | 0;
      hi = hi + Math.imul(ah3, bh3) | 0;
      lo = lo + Math.imul(al2, bl4) | 0;
      mid = mid + Math.imul(al2, bh4) | 0;
      mid = mid + Math.imul(ah2, bl4) | 0;
      hi = hi + Math.imul(ah2, bh4) | 0;
      lo = lo + Math.imul(al1, bl5) | 0;
      mid = mid + Math.imul(al1, bh5) | 0;
      mid = mid + Math.imul(ah1, bl5) | 0;
      hi = hi + Math.imul(ah1, bh5) | 0;
      lo = lo + Math.imul(al0, bl6) | 0;
      mid = mid + Math.imul(al0, bh6) | 0;
      mid = mid + Math.imul(ah0, bl6) | 0;
      hi = hi + Math.imul(ah0, bh6) | 0;
      var w6 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
      w6 &= 67108863;
      lo = Math.imul(al7, bl0);
      mid = Math.imul(al7, bh0);
      mid = mid + Math.imul(ah7, bl0) | 0;
      hi = Math.imul(ah7, bh0);
      lo = lo + Math.imul(al6, bl1) | 0;
      mid = mid + Math.imul(al6, bh1) | 0;
      mid = mid + Math.imul(ah6, bl1) | 0;
      hi = hi + Math.imul(ah6, bh1) | 0;
      lo = lo + Math.imul(al5, bl2) | 0;
      mid = mid + Math.imul(al5, bh2) | 0;
      mid = mid + Math.imul(ah5, bl2) | 0;
      hi = hi + Math.imul(ah5, bh2) | 0;
      lo = lo + Math.imul(al4, bl3) | 0;
      mid = mid + Math.imul(al4, bh3) | 0;
      mid = mid + Math.imul(ah4, bl3) | 0;
      hi = hi + Math.imul(ah4, bh3) | 0;
      lo = lo + Math.imul(al3, bl4) | 0;
      mid = mid + Math.imul(al3, bh4) | 0;
      mid = mid + Math.imul(ah3, bl4) | 0;
      hi = hi + Math.imul(ah3, bh4) | 0;
      lo = lo + Math.imul(al2, bl5) | 0;
      mid = mid + Math.imul(al2, bh5) | 0;
      mid = mid + Math.imul(ah2, bl5) | 0;
      hi = hi + Math.imul(ah2, bh5) | 0;
      lo = lo + Math.imul(al1, bl6) | 0;
      mid = mid + Math.imul(al1, bh6) | 0;
      mid = mid + Math.imul(ah1, bl6) | 0;
      hi = hi + Math.imul(ah1, bh6) | 0;
      lo = lo + Math.imul(al0, bl7) | 0;
      mid = mid + Math.imul(al0, bh7) | 0;
      mid = mid + Math.imul(ah0, bl7) | 0;
      hi = hi + Math.imul(ah0, bh7) | 0;
      var w7 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
      w7 &= 67108863;
      lo = Math.imul(al8, bl0);
      mid = Math.imul(al8, bh0);
      mid = mid + Math.imul(ah8, bl0) | 0;
      hi = Math.imul(ah8, bh0);
      lo = lo + Math.imul(al7, bl1) | 0;
      mid = mid + Math.imul(al7, bh1) | 0;
      mid = mid + Math.imul(ah7, bl1) | 0;
      hi = hi + Math.imul(ah7, bh1) | 0;
      lo = lo + Math.imul(al6, bl2) | 0;
      mid = mid + Math.imul(al6, bh2) | 0;
      mid = mid + Math.imul(ah6, bl2) | 0;
      hi = hi + Math.imul(ah6, bh2) | 0;
      lo = lo + Math.imul(al5, bl3) | 0;
      mid = mid + Math.imul(al5, bh3) | 0;
      mid = mid + Math.imul(ah5, bl3) | 0;
      hi = hi + Math.imul(ah5, bh3) | 0;
      lo = lo + Math.imul(al4, bl4) | 0;
      mid = mid + Math.imul(al4, bh4) | 0;
      mid = mid + Math.imul(ah4, bl4) | 0;
      hi = hi + Math.imul(ah4, bh4) | 0;
      lo = lo + Math.imul(al3, bl5) | 0;
      mid = mid + Math.imul(al3, bh5) | 0;
      mid = mid + Math.imul(ah3, bl5) | 0;
      hi = hi + Math.imul(ah3, bh5) | 0;
      lo = lo + Math.imul(al2, bl6) | 0;
      mid = mid + Math.imul(al2, bh6) | 0;
      mid = mid + Math.imul(ah2, bl6) | 0;
      hi = hi + Math.imul(ah2, bh6) | 0;
      lo = lo + Math.imul(al1, bl7) | 0;
      mid = mid + Math.imul(al1, bh7) | 0;
      mid = mid + Math.imul(ah1, bl7) | 0;
      hi = hi + Math.imul(ah1, bh7) | 0;
      lo = lo + Math.imul(al0, bl8) | 0;
      mid = mid + Math.imul(al0, bh8) | 0;
      mid = mid + Math.imul(ah0, bl8) | 0;
      hi = hi + Math.imul(ah0, bh8) | 0;
      var w8 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
      w8 &= 67108863;
      lo = Math.imul(al9, bl0);
      mid = Math.imul(al9, bh0);
      mid = mid + Math.imul(ah9, bl0) | 0;
      hi = Math.imul(ah9, bh0);
      lo = lo + Math.imul(al8, bl1) | 0;
      mid = mid + Math.imul(al8, bh1) | 0;
      mid = mid + Math.imul(ah8, bl1) | 0;
      hi = hi + Math.imul(ah8, bh1) | 0;
      lo = lo + Math.imul(al7, bl2) | 0;
      mid = mid + Math.imul(al7, bh2) | 0;
      mid = mid + Math.imul(ah7, bl2) | 0;
      hi = hi + Math.imul(ah7, bh2) | 0;
      lo = lo + Math.imul(al6, bl3) | 0;
      mid = mid + Math.imul(al6, bh3) | 0;
      mid = mid + Math.imul(ah6, bl3) | 0;
      hi = hi + Math.imul(ah6, bh3) | 0;
      lo = lo + Math.imul(al5, bl4) | 0;
      mid = mid + Math.imul(al5, bh4) | 0;
      mid = mid + Math.imul(ah5, bl4) | 0;
      hi = hi + Math.imul(ah5, bh4) | 0;
      lo = lo + Math.imul(al4, bl5) | 0;
      mid = mid + Math.imul(al4, bh5) | 0;
      mid = mid + Math.imul(ah4, bl5) | 0;
      hi = hi + Math.imul(ah4, bh5) | 0;
      lo = lo + Math.imul(al3, bl6) | 0;
      mid = mid + Math.imul(al3, bh6) | 0;
      mid = mid + Math.imul(ah3, bl6) | 0;
      hi = hi + Math.imul(ah3, bh6) | 0;
      lo = lo + Math.imul(al2, bl7) | 0;
      mid = mid + Math.imul(al2, bh7) | 0;
      mid = mid + Math.imul(ah2, bl7) | 0;
      hi = hi + Math.imul(ah2, bh7) | 0;
      lo = lo + Math.imul(al1, bl8) | 0;
      mid = mid + Math.imul(al1, bh8) | 0;
      mid = mid + Math.imul(ah1, bl8) | 0;
      hi = hi + Math.imul(ah1, bh8) | 0;
      lo = lo + Math.imul(al0, bl9) | 0;
      mid = mid + Math.imul(al0, bh9) | 0;
      mid = mid + Math.imul(ah0, bl9) | 0;
      hi = hi + Math.imul(ah0, bh9) | 0;
      var w9 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
      w9 &= 67108863;
      lo = Math.imul(al9, bl1);
      mid = Math.imul(al9, bh1);
      mid = mid + Math.imul(ah9, bl1) | 0;
      hi = Math.imul(ah9, bh1);
      lo = lo + Math.imul(al8, bl2) | 0;
      mid = mid + Math.imul(al8, bh2) | 0;
      mid = mid + Math.imul(ah8, bl2) | 0;
      hi = hi + Math.imul(ah8, bh2) | 0;
      lo = lo + Math.imul(al7, bl3) | 0;
      mid = mid + Math.imul(al7, bh3) | 0;
      mid = mid + Math.imul(ah7, bl3) | 0;
      hi = hi + Math.imul(ah7, bh3) | 0;
      lo = lo + Math.imul(al6, bl4) | 0;
      mid = mid + Math.imul(al6, bh4) | 0;
      mid = mid + Math.imul(ah6, bl4) | 0;
      hi = hi + Math.imul(ah6, bh4) | 0;
      lo = lo + Math.imul(al5, bl5) | 0;
      mid = mid + Math.imul(al5, bh5) | 0;
      mid = mid + Math.imul(ah5, bl5) | 0;
      hi = hi + Math.imul(ah5, bh5) | 0;
      lo = lo + Math.imul(al4, bl6) | 0;
      mid = mid + Math.imul(al4, bh6) | 0;
      mid = mid + Math.imul(ah4, bl6) | 0;
      hi = hi + Math.imul(ah4, bh6) | 0;
      lo = lo + Math.imul(al3, bl7) | 0;
      mid = mid + Math.imul(al3, bh7) | 0;
      mid = mid + Math.imul(ah3, bl7) | 0;
      hi = hi + Math.imul(ah3, bh7) | 0;
      lo = lo + Math.imul(al2, bl8) | 0;
      mid = mid + Math.imul(al2, bh8) | 0;
      mid = mid + Math.imul(ah2, bl8) | 0;
      hi = hi + Math.imul(ah2, bh8) | 0;
      lo = lo + Math.imul(al1, bl9) | 0;
      mid = mid + Math.imul(al1, bh9) | 0;
      mid = mid + Math.imul(ah1, bl9) | 0;
      hi = hi + Math.imul(ah1, bh9) | 0;
      var w10 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
      w10 &= 67108863;
      lo = Math.imul(al9, bl2);
      mid = Math.imul(al9, bh2);
      mid = mid + Math.imul(ah9, bl2) | 0;
      hi = Math.imul(ah9, bh2);
      lo = lo + Math.imul(al8, bl3) | 0;
      mid = mid + Math.imul(al8, bh3) | 0;
      mid = mid + Math.imul(ah8, bl3) | 0;
      hi = hi + Math.imul(ah8, bh3) | 0;
      lo = lo + Math.imul(al7, bl4) | 0;
      mid = mid + Math.imul(al7, bh4) | 0;
      mid = mid + Math.imul(ah7, bl4) | 0;
      hi = hi + Math.imul(ah7, bh4) | 0;
      lo = lo + Math.imul(al6, bl5) | 0;
      mid = mid + Math.imul(al6, bh5) | 0;
      mid = mid + Math.imul(ah6, bl5) | 0;
      hi = hi + Math.imul(ah6, bh5) | 0;
      lo = lo + Math.imul(al5, bl6) | 0;
      mid = mid + Math.imul(al5, bh6) | 0;
      mid = mid + Math.imul(ah5, bl6) | 0;
      hi = hi + Math.imul(ah5, bh6) | 0;
      lo = lo + Math.imul(al4, bl7) | 0;
      mid = mid + Math.imul(al4, bh7) | 0;
      mid = mid + Math.imul(ah4, bl7) | 0;
      hi = hi + Math.imul(ah4, bh7) | 0;
      lo = lo + Math.imul(al3, bl8) | 0;
      mid = mid + Math.imul(al3, bh8) | 0;
      mid = mid + Math.imul(ah3, bl8) | 0;
      hi = hi + Math.imul(ah3, bh8) | 0;
      lo = lo + Math.imul(al2, bl9) | 0;
      mid = mid + Math.imul(al2, bh9) | 0;
      mid = mid + Math.imul(ah2, bl9) | 0;
      hi = hi + Math.imul(ah2, bh9) | 0;
      var w11 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
      w11 &= 67108863;
      lo = Math.imul(al9, bl3);
      mid = Math.imul(al9, bh3);
      mid = mid + Math.imul(ah9, bl3) | 0;
      hi = Math.imul(ah9, bh3);
      lo = lo + Math.imul(al8, bl4) | 0;
      mid = mid + Math.imul(al8, bh4) | 0;
      mid = mid + Math.imul(ah8, bl4) | 0;
      hi = hi + Math.imul(ah8, bh4) | 0;
      lo = lo + Math.imul(al7, bl5) | 0;
      mid = mid + Math.imul(al7, bh5) | 0;
      mid = mid + Math.imul(ah7, bl5) | 0;
      hi = hi + Math.imul(ah7, bh5) | 0;
      lo = lo + Math.imul(al6, bl6) | 0;
      mid = mid + Math.imul(al6, bh6) | 0;
      mid = mid + Math.imul(ah6, bl6) | 0;
      hi = hi + Math.imul(ah6, bh6) | 0;
      lo = lo + Math.imul(al5, bl7) | 0;
      mid = mid + Math.imul(al5, bh7) | 0;
      mid = mid + Math.imul(ah5, bl7) | 0;
      hi = hi + Math.imul(ah5, bh7) | 0;
      lo = lo + Math.imul(al4, bl8) | 0;
      mid = mid + Math.imul(al4, bh8) | 0;
      mid = mid + Math.imul(ah4, bl8) | 0;
      hi = hi + Math.imul(ah4, bh8) | 0;
      lo = lo + Math.imul(al3, bl9) | 0;
      mid = mid + Math.imul(al3, bh9) | 0;
      mid = mid + Math.imul(ah3, bl9) | 0;
      hi = hi + Math.imul(ah3, bh9) | 0;
      var w12 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
      w12 &= 67108863;
      lo = Math.imul(al9, bl4);
      mid = Math.imul(al9, bh4);
      mid = mid + Math.imul(ah9, bl4) | 0;
      hi = Math.imul(ah9, bh4);
      lo = lo + Math.imul(al8, bl5) | 0;
      mid = mid + Math.imul(al8, bh5) | 0;
      mid = mid + Math.imul(ah8, bl5) | 0;
      hi = hi + Math.imul(ah8, bh5) | 0;
      lo = lo + Math.imul(al7, bl6) | 0;
      mid = mid + Math.imul(al7, bh6) | 0;
      mid = mid + Math.imul(ah7, bl6) | 0;
      hi = hi + Math.imul(ah7, bh6) | 0;
      lo = lo + Math.imul(al6, bl7) | 0;
      mid = mid + Math.imul(al6, bh7) | 0;
      mid = mid + Math.imul(ah6, bl7) | 0;
      hi = hi + Math.imul(ah6, bh7) | 0;
      lo = lo + Math.imul(al5, bl8) | 0;
      mid = mid + Math.imul(al5, bh8) | 0;
      mid = mid + Math.imul(ah5, bl8) | 0;
      hi = hi + Math.imul(ah5, bh8) | 0;
      lo = lo + Math.imul(al4, bl9) | 0;
      mid = mid + Math.imul(al4, bh9) | 0;
      mid = mid + Math.imul(ah4, bl9) | 0;
      hi = hi + Math.imul(ah4, bh9) | 0;
      var w13 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
      w13 &= 67108863;
      lo = Math.imul(al9, bl5);
      mid = Math.imul(al9, bh5);
      mid = mid + Math.imul(ah9, bl5) | 0;
      hi = Math.imul(ah9, bh5);
      lo = lo + Math.imul(al8, bl6) | 0;
      mid = mid + Math.imul(al8, bh6) | 0;
      mid = mid + Math.imul(ah8, bl6) | 0;
      hi = hi + Math.imul(ah8, bh6) | 0;
      lo = lo + Math.imul(al7, bl7) | 0;
      mid = mid + Math.imul(al7, bh7) | 0;
      mid = mid + Math.imul(ah7, bl7) | 0;
      hi = hi + Math.imul(ah7, bh7) | 0;
      lo = lo + Math.imul(al6, bl8) | 0;
      mid = mid + Math.imul(al6, bh8) | 0;
      mid = mid + Math.imul(ah6, bl8) | 0;
      hi = hi + Math.imul(ah6, bh8) | 0;
      lo = lo + Math.imul(al5, bl9) | 0;
      mid = mid + Math.imul(al5, bh9) | 0;
      mid = mid + Math.imul(ah5, bl9) | 0;
      hi = hi + Math.imul(ah5, bh9) | 0;
      var w14 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
      w14 &= 67108863;
      lo = Math.imul(al9, bl6);
      mid = Math.imul(al9, bh6);
      mid = mid + Math.imul(ah9, bl6) | 0;
      hi = Math.imul(ah9, bh6);
      lo = lo + Math.imul(al8, bl7) | 0;
      mid = mid + Math.imul(al8, bh7) | 0;
      mid = mid + Math.imul(ah8, bl7) | 0;
      hi = hi + Math.imul(ah8, bh7) | 0;
      lo = lo + Math.imul(al7, bl8) | 0;
      mid = mid + Math.imul(al7, bh8) | 0;
      mid = mid + Math.imul(ah7, bl8) | 0;
      hi = hi + Math.imul(ah7, bh8) | 0;
      lo = lo + Math.imul(al6, bl9) | 0;
      mid = mid + Math.imul(al6, bh9) | 0;
      mid = mid + Math.imul(ah6, bl9) | 0;
      hi = hi + Math.imul(ah6, bh9) | 0;
      var w15 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
      w15 &= 67108863;
      lo = Math.imul(al9, bl7);
      mid = Math.imul(al9, bh7);
      mid = mid + Math.imul(ah9, bl7) | 0;
      hi = Math.imul(ah9, bh7);
      lo = lo + Math.imul(al8, bl8) | 0;
      mid = mid + Math.imul(al8, bh8) | 0;
      mid = mid + Math.imul(ah8, bl8) | 0;
      hi = hi + Math.imul(ah8, bh8) | 0;
      lo = lo + Math.imul(al7, bl9) | 0;
      mid = mid + Math.imul(al7, bh9) | 0;
      mid = mid + Math.imul(ah7, bl9) | 0;
      hi = hi + Math.imul(ah7, bh9) | 0;
      var w16 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
      w16 &= 67108863;
      lo = Math.imul(al9, bl8);
      mid = Math.imul(al9, bh8);
      mid = mid + Math.imul(ah9, bl8) | 0;
      hi = Math.imul(ah9, bh8);
      lo = lo + Math.imul(al8, bl9) | 0;
      mid = mid + Math.imul(al8, bh9) | 0;
      mid = mid + Math.imul(ah8, bl9) | 0;
      hi = hi + Math.imul(ah8, bh9) | 0;
      var w17 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
      w17 &= 67108863;
      lo = Math.imul(al9, bl9);
      mid = Math.imul(al9, bh9);
      mid = mid + Math.imul(ah9, bl9) | 0;
      hi = Math.imul(ah9, bh9);
      var w18 = (c2 + lo | 0) + ((mid & 8191) << 13) | 0;
      c2 = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
      w18 &= 67108863;
      o[0] = w0;
      o[1] = w1;
      o[2] = w2;
      o[3] = w3;
      o[4] = w4;
      o[5] = w5;
      o[6] = w6;
      o[7] = w7;
      o[8] = w8;
      o[9] = w9;
      o[10] = w10;
      o[11] = w11;
      o[12] = w12;
      o[13] = w13;
      o[14] = w14;
      o[15] = w15;
      o[16] = w16;
      o[17] = w17;
      o[18] = w18;
      if (c2 !== 0) {
        o[19] = c2;
        out.length++;
      }
      return out;
    };
    if (!Math.imul) {
      comb10MulTo = smallMulTo;
    }
    function bigMulTo(self2, num, out) {
      out.negative = num.negative ^ self2.negative;
      out.length = self2.length + num.length;
      var carry = 0;
      var hncarry = 0;
      for (var k2 = 0; k2 < out.length - 1; k2++) {
        var ncarry = hncarry;
        hncarry = 0;
        var rword = carry & 67108863;
        var maxJ = Math.min(k2, num.length - 1);
        for (var j = Math.max(0, k2 - self2.length + 1); j <= maxJ; j++) {
          var i = k2 - j;
          var a = self2.words[i] | 0;
          var b2 = num.words[j] | 0;
          var r2 = a * b2;
          var lo = r2 & 67108863;
          ncarry = ncarry + (r2 / 67108864 | 0) | 0;
          lo = lo + rword | 0;
          rword = lo & 67108863;
          ncarry = ncarry + (lo >>> 26) | 0;
          hncarry += ncarry >>> 26;
          ncarry &= 67108863;
        }
        out.words[k2] = rword;
        carry = ncarry;
        ncarry = hncarry;
      }
      if (carry !== 0) {
        out.words[k2] = carry;
      } else {
        out.length--;
      }
      return out._strip();
    }
    function jumboMulTo(self2, num, out) {
      return bigMulTo(self2, num, out);
    }
    BN2.prototype.mulTo = function mulTo(num, out) {
      var res;
      var len = this.length + num.length;
      if (this.length === 10 && num.length === 10) {
        res = comb10MulTo(this, num, out);
      } else if (len < 63) {
        res = smallMulTo(this, num, out);
      } else if (len < 1024) {
        res = bigMulTo(this, num, out);
      } else {
        res = jumboMulTo(this, num, out);
      }
      return res;
    };
    BN2.prototype.mul = function mul(num) {
      var out = new BN2(null);
      out.words = new Array(this.length + num.length);
      return this.mulTo(num, out);
    };
    BN2.prototype.mulf = function mulf(num) {
      var out = new BN2(null);
      out.words = new Array(this.length + num.length);
      return jumboMulTo(this, num, out);
    };
    BN2.prototype.imul = function imul(num) {
      return this.clone().mulTo(num, this);
    };
    BN2.prototype.imuln = function imuln(num) {
      var isNegNum = num < 0;
      if (isNegNum)
        num = -num;
      assert(typeof num === "number");
      assert(num < 67108864);
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w2 = (this.words[i] | 0) * num;
        var lo = (w2 & 67108863) + (carry & 67108863);
        carry >>= 26;
        carry += w2 / 67108864 | 0;
        carry += lo >>> 26;
        this.words[i] = lo & 67108863;
      }
      if (carry !== 0) {
        this.words[i] = carry;
        this.length++;
      }
      return isNegNum ? this.ineg() : this;
    };
    BN2.prototype.muln = function muln(num) {
      return this.clone().imuln(num);
    };
    BN2.prototype.sqr = function sqr() {
      return this.mul(this);
    };
    BN2.prototype.isqr = function isqr() {
      return this.imul(this.clone());
    };
    BN2.prototype.pow = function pow(num) {
      var w2 = toBitArray(num);
      if (w2.length === 0)
        return new BN2(1);
      var res = this;
      for (var i = 0; i < w2.length; i++, res = res.sqr()) {
        if (w2[i] !== 0)
          break;
      }
      if (++i < w2.length) {
        for (var q2 = res.sqr(); i < w2.length; i++, q2 = q2.sqr()) {
          if (w2[i] === 0)
            continue;
          res = res.mul(q2);
        }
      }
      return res;
    };
    BN2.prototype.iushln = function iushln(bits) {
      assert(typeof bits === "number" && bits >= 0);
      var r2 = bits % 26;
      var s = (bits - r2) / 26;
      var carryMask = 67108863 >>> 26 - r2 << 26 - r2;
      var i;
      if (r2 !== 0) {
        var carry = 0;
        for (i = 0; i < this.length; i++) {
          var newCarry = this.words[i] & carryMask;
          var c2 = (this.words[i] | 0) - newCarry << r2;
          this.words[i] = c2 | carry;
          carry = newCarry >>> 26 - r2;
        }
        if (carry) {
          this.words[i] = carry;
          this.length++;
        }
      }
      if (s !== 0) {
        for (i = this.length - 1; i >= 0; i--) {
          this.words[i + s] = this.words[i];
        }
        for (i = 0; i < s; i++) {
          this.words[i] = 0;
        }
        this.length += s;
      }
      return this._strip();
    };
    BN2.prototype.ishln = function ishln(bits) {
      assert(this.negative === 0);
      return this.iushln(bits);
    };
    BN2.prototype.iushrn = function iushrn(bits, hint, extended) {
      assert(typeof bits === "number" && bits >= 0);
      var h2;
      if (hint) {
        h2 = (hint - hint % 26) / 26;
      } else {
        h2 = 0;
      }
      var r2 = bits % 26;
      var s = Math.min((bits - r2) / 26, this.length);
      var mask = 67108863 ^ 67108863 >>> r2 << r2;
      var maskedWords = extended;
      h2 -= s;
      h2 = Math.max(0, h2);
      if (maskedWords) {
        for (var i = 0; i < s; i++) {
          maskedWords.words[i] = this.words[i];
        }
        maskedWords.length = s;
      }
      if (s === 0)
        ;
      else if (this.length > s) {
        this.length -= s;
        for (i = 0; i < this.length; i++) {
          this.words[i] = this.words[i + s];
        }
      } else {
        this.words[0] = 0;
        this.length = 1;
      }
      var carry = 0;
      for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h2); i--) {
        var word = this.words[i] | 0;
        this.words[i] = carry << 26 - r2 | word >>> r2;
        carry = word & mask;
      }
      if (maskedWords && carry !== 0) {
        maskedWords.words[maskedWords.length++] = carry;
      }
      if (this.length === 0) {
        this.words[0] = 0;
        this.length = 1;
      }
      return this._strip();
    };
    BN2.prototype.ishrn = function ishrn(bits, hint, extended) {
      assert(this.negative === 0);
      return this.iushrn(bits, hint, extended);
    };
    BN2.prototype.shln = function shln(bits) {
      return this.clone().ishln(bits);
    };
    BN2.prototype.ushln = function ushln(bits) {
      return this.clone().iushln(bits);
    };
    BN2.prototype.shrn = function shrn(bits) {
      return this.clone().ishrn(bits);
    };
    BN2.prototype.ushrn = function ushrn(bits) {
      return this.clone().iushrn(bits);
    };
    BN2.prototype.testn = function testn(bit) {
      assert(typeof bit === "number" && bit >= 0);
      var r2 = bit % 26;
      var s = (bit - r2) / 26;
      var q2 = 1 << r2;
      if (this.length <= s)
        return false;
      var w2 = this.words[s];
      return !!(w2 & q2);
    };
    BN2.prototype.imaskn = function imaskn(bits) {
      assert(typeof bits === "number" && bits >= 0);
      var r2 = bits % 26;
      var s = (bits - r2) / 26;
      assert(this.negative === 0, "imaskn works only with positive numbers");
      if (this.length <= s) {
        return this;
      }
      if (r2 !== 0) {
        s++;
      }
      this.length = Math.min(s, this.length);
      if (r2 !== 0) {
        var mask = 67108863 ^ 67108863 >>> r2 << r2;
        this.words[this.length - 1] &= mask;
      }
      return this._strip();
    };
    BN2.prototype.maskn = function maskn(bits) {
      return this.clone().imaskn(bits);
    };
    BN2.prototype.iaddn = function iaddn(num) {
      assert(typeof num === "number");
      assert(num < 67108864);
      if (num < 0)
        return this.isubn(-num);
      if (this.negative !== 0) {
        if (this.length === 1 && (this.words[0] | 0) <= num) {
          this.words[0] = num - (this.words[0] | 0);
          this.negative = 0;
          return this;
        }
        this.negative = 0;
        this.isubn(num);
        this.negative = 1;
        return this;
      }
      return this._iaddn(num);
    };
    BN2.prototype._iaddn = function _iaddn(num) {
      this.words[0] += num;
      for (var i = 0; i < this.length && this.words[i] >= 67108864; i++) {
        this.words[i] -= 67108864;
        if (i === this.length - 1) {
          this.words[i + 1] = 1;
        } else {
          this.words[i + 1]++;
        }
      }
      this.length = Math.max(this.length, i + 1);
      return this;
    };
    BN2.prototype.isubn = function isubn(num) {
      assert(typeof num === "number");
      assert(num < 67108864);
      if (num < 0)
        return this.iaddn(-num);
      if (this.negative !== 0) {
        this.negative = 0;
        this.iaddn(num);
        this.negative = 1;
        return this;
      }
      this.words[0] -= num;
      if (this.length === 1 && this.words[0] < 0) {
        this.words[0] = -this.words[0];
        this.negative = 1;
      } else {
        for (var i = 0; i < this.length && this.words[i] < 0; i++) {
          this.words[i] += 67108864;
          this.words[i + 1] -= 1;
        }
      }
      return this._strip();
    };
    BN2.prototype.addn = function addn(num) {
      return this.clone().iaddn(num);
    };
    BN2.prototype.subn = function subn(num) {
      return this.clone().isubn(num);
    };
    BN2.prototype.iabs = function iabs() {
      this.negative = 0;
      return this;
    };
    BN2.prototype.abs = function abs2() {
      return this.clone().iabs();
    };
    BN2.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
      var len = num.length + shift;
      var i;
      this._expand(len);
      var w2;
      var carry = 0;
      for (i = 0; i < num.length; i++) {
        w2 = (this.words[i + shift] | 0) + carry;
        var right = (num.words[i] | 0) * mul;
        w2 -= right & 67108863;
        carry = (w2 >> 26) - (right / 67108864 | 0);
        this.words[i + shift] = w2 & 67108863;
      }
      for (; i < this.length - shift; i++) {
        w2 = (this.words[i + shift] | 0) + carry;
        carry = w2 >> 26;
        this.words[i + shift] = w2 & 67108863;
      }
      if (carry === 0)
        return this._strip();
      assert(carry === -1);
      carry = 0;
      for (i = 0; i < this.length; i++) {
        w2 = -(this.words[i] | 0) + carry;
        carry = w2 >> 26;
        this.words[i] = w2 & 67108863;
      }
      this.negative = 1;
      return this._strip();
    };
    BN2.prototype._wordDiv = function _wordDiv(num, mode) {
      var shift = this.length - num.length;
      var a = this.clone();
      var b2 = num;
      var bhi = b2.words[b2.length - 1] | 0;
      var bhiBits = this._countBits(bhi);
      shift = 26 - bhiBits;
      if (shift !== 0) {
        b2 = b2.ushln(shift);
        a.iushln(shift);
        bhi = b2.words[b2.length - 1] | 0;
      }
      var m2 = a.length - b2.length;
      var q2;
      if (mode !== "mod") {
        q2 = new BN2(null);
        q2.length = m2 + 1;
        q2.words = new Array(q2.length);
        for (var i = 0; i < q2.length; i++) {
          q2.words[i] = 0;
        }
      }
      var diff = a.clone()._ishlnsubmul(b2, 1, m2);
      if (diff.negative === 0) {
        a = diff;
        if (q2) {
          q2.words[m2] = 1;
        }
      }
      for (var j = m2 - 1; j >= 0; j--) {
        var qj = (a.words[b2.length + j] | 0) * 67108864 + (a.words[b2.length + j - 1] | 0);
        qj = Math.min(qj / bhi | 0, 67108863);
        a._ishlnsubmul(b2, qj, j);
        while (a.negative !== 0) {
          qj--;
          a.negative = 0;
          a._ishlnsubmul(b2, 1, j);
          if (!a.isZero()) {
            a.negative ^= 1;
          }
        }
        if (q2) {
          q2.words[j] = qj;
        }
      }
      if (q2) {
        q2._strip();
      }
      a._strip();
      if (mode !== "div" && shift !== 0) {
        a.iushrn(shift);
      }
      return {
        div: q2 || null,
        mod: a
      };
    };
    BN2.prototype.divmod = function divmod(num, mode, positive) {
      assert(!num.isZero());
      if (this.isZero()) {
        return {
          div: new BN2(0),
          mod: new BN2(0)
        };
      }
      var div, mod, res;
      if (this.negative !== 0 && num.negative === 0) {
        res = this.neg().divmod(num, mode);
        if (mode !== "mod") {
          div = res.div.neg();
        }
        if (mode !== "div") {
          mod = res.mod.neg();
          if (positive && mod.negative !== 0) {
            mod.iadd(num);
          }
        }
        return {
          div,
          mod
        };
      }
      if (this.negative === 0 && num.negative !== 0) {
        res = this.divmod(num.neg(), mode);
        if (mode !== "mod") {
          div = res.div.neg();
        }
        return {
          div,
          mod: res.mod
        };
      }
      if ((this.negative & num.negative) !== 0) {
        res = this.neg().divmod(num.neg(), mode);
        if (mode !== "div") {
          mod = res.mod.neg();
          if (positive && mod.negative !== 0) {
            mod.isub(num);
          }
        }
        return {
          div: res.div,
          mod
        };
      }
      if (num.length > this.length || this.cmp(num) < 0) {
        return {
          div: new BN2(0),
          mod: this
        };
      }
      if (num.length === 1) {
        if (mode === "div") {
          return {
            div: this.divn(num.words[0]),
            mod: null
          };
        }
        if (mode === "mod") {
          return {
            div: null,
            mod: new BN2(this.modrn(num.words[0]))
          };
        }
        return {
          div: this.divn(num.words[0]),
          mod: new BN2(this.modrn(num.words[0]))
        };
      }
      return this._wordDiv(num, mode);
    };
    BN2.prototype.div = function div(num) {
      return this.divmod(num, "div", false).div;
    };
    BN2.prototype.mod = function mod(num) {
      return this.divmod(num, "mod", false).mod;
    };
    BN2.prototype.umod = function umod(num) {
      return this.divmod(num, "mod", true).mod;
    };
    BN2.prototype.divRound = function divRound(num) {
      var dm = this.divmod(num);
      if (dm.mod.isZero())
        return dm.div;
      var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
      var half = num.ushrn(1);
      var r2 = num.andln(1);
      var cmp = mod.cmp(half);
      if (cmp < 0 || r2 === 1 && cmp === 0)
        return dm.div;
      return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN2.prototype.modrn = function modrn(num) {
      var isNegNum = num < 0;
      if (isNegNum)
        num = -num;
      assert(num <= 67108863);
      var p2 = (1 << 26) % num;
      var acc = 0;
      for (var i = this.length - 1; i >= 0; i--) {
        acc = (p2 * acc + (this.words[i] | 0)) % num;
      }
      return isNegNum ? -acc : acc;
    };
    BN2.prototype.modn = function modn(num) {
      return this.modrn(num);
    };
    BN2.prototype.idivn = function idivn(num) {
      var isNegNum = num < 0;
      if (isNegNum)
        num = -num;
      assert(num <= 67108863);
      var carry = 0;
      for (var i = this.length - 1; i >= 0; i--) {
        var w2 = (this.words[i] | 0) + carry * 67108864;
        this.words[i] = w2 / num | 0;
        carry = w2 % num;
      }
      this._strip();
      return isNegNum ? this.ineg() : this;
    };
    BN2.prototype.divn = function divn(num) {
      return this.clone().idivn(num);
    };
    BN2.prototype.egcd = function egcd(p2) {
      assert(p2.negative === 0);
      assert(!p2.isZero());
      var x2 = this;
      var y2 = p2.clone();
      if (x2.negative !== 0) {
        x2 = x2.umod(p2);
      } else {
        x2 = x2.clone();
      }
      var A2 = new BN2(1);
      var B = new BN2(0);
      var C = new BN2(0);
      var D = new BN2(1);
      var g2 = 0;
      while (x2.isEven() && y2.isEven()) {
        x2.iushrn(1);
        y2.iushrn(1);
        ++g2;
      }
      var yp = y2.clone();
      var xp = x2.clone();
      while (!x2.isZero()) {
        for (var i = 0, im = 1; (x2.words[0] & im) === 0 && i < 26; ++i, im <<= 1)
          ;
        if (i > 0) {
          x2.iushrn(i);
          while (i-- > 0) {
            if (A2.isOdd() || B.isOdd()) {
              A2.iadd(yp);
              B.isub(xp);
            }
            A2.iushrn(1);
            B.iushrn(1);
          }
        }
        for (var j = 0, jm = 1; (y2.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1)
          ;
        if (j > 0) {
          y2.iushrn(j);
          while (j-- > 0) {
            if (C.isOdd() || D.isOdd()) {
              C.iadd(yp);
              D.isub(xp);
            }
            C.iushrn(1);
            D.iushrn(1);
          }
        }
        if (x2.cmp(y2) >= 0) {
          x2.isub(y2);
          A2.isub(C);
          B.isub(D);
        } else {
          y2.isub(x2);
          C.isub(A2);
          D.isub(B);
        }
      }
      return {
        a: C,
        b: D,
        gcd: y2.iushln(g2)
      };
    };
    BN2.prototype._invmp = function _invmp(p2) {
      assert(p2.negative === 0);
      assert(!p2.isZero());
      var a = this;
      var b2 = p2.clone();
      if (a.negative !== 0) {
        a = a.umod(p2);
      } else {
        a = a.clone();
      }
      var x1 = new BN2(1);
      var x2 = new BN2(0);
      var delta = b2.clone();
      while (a.cmpn(1) > 0 && b2.cmpn(1) > 0) {
        for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1)
          ;
        if (i > 0) {
          a.iushrn(i);
          while (i-- > 0) {
            if (x1.isOdd()) {
              x1.iadd(delta);
            }
            x1.iushrn(1);
          }
        }
        for (var j = 0, jm = 1; (b2.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1)
          ;
        if (j > 0) {
          b2.iushrn(j);
          while (j-- > 0) {
            if (x2.isOdd()) {
              x2.iadd(delta);
            }
            x2.iushrn(1);
          }
        }
        if (a.cmp(b2) >= 0) {
          a.isub(b2);
          x1.isub(x2);
        } else {
          b2.isub(a);
          x2.isub(x1);
        }
      }
      var res;
      if (a.cmpn(1) === 0) {
        res = x1;
      } else {
        res = x2;
      }
      if (res.cmpn(0) < 0) {
        res.iadd(p2);
      }
      return res;
    };
    BN2.prototype.gcd = function gcd(num) {
      if (this.isZero())
        return num.abs();
      if (num.isZero())
        return this.abs();
      var a = this.clone();
      var b2 = num.clone();
      a.negative = 0;
      b2.negative = 0;
      for (var shift = 0; a.isEven() && b2.isEven(); shift++) {
        a.iushrn(1);
        b2.iushrn(1);
      }
      do {
        while (a.isEven()) {
          a.iushrn(1);
        }
        while (b2.isEven()) {
          b2.iushrn(1);
        }
        var r2 = a.cmp(b2);
        if (r2 < 0) {
          var t2 = a;
          a = b2;
          b2 = t2;
        } else if (r2 === 0 || b2.cmpn(1) === 0) {
          break;
        }
        a.isub(b2);
      } while (true);
      return b2.iushln(shift);
    };
    BN2.prototype.invm = function invm(num) {
      return this.egcd(num).a.umod(num);
    };
    BN2.prototype.isEven = function isEven() {
      return (this.words[0] & 1) === 0;
    };
    BN2.prototype.isOdd = function isOdd() {
      return (this.words[0] & 1) === 1;
    };
    BN2.prototype.andln = function andln(num) {
      return this.words[0] & num;
    };
    BN2.prototype.bincn = function bincn(bit) {
      assert(typeof bit === "number");
      var r2 = bit % 26;
      var s = (bit - r2) / 26;
      var q2 = 1 << r2;
      if (this.length <= s) {
        this._expand(s + 1);
        this.words[s] |= q2;
        return this;
      }
      var carry = q2;
      for (var i = s; carry !== 0 && i < this.length; i++) {
        var w2 = this.words[i] | 0;
        w2 += carry;
        carry = w2 >>> 26;
        w2 &= 67108863;
        this.words[i] = w2;
      }
      if (carry !== 0) {
        this.words[i] = carry;
        this.length++;
      }
      return this;
    };
    BN2.prototype.isZero = function isZero() {
      return this.length === 1 && this.words[0] === 0;
    };
    BN2.prototype.cmpn = function cmpn(num) {
      var negative = num < 0;
      if (this.negative !== 0 && !negative)
        return -1;
      if (this.negative === 0 && negative)
        return 1;
      this._strip();
      var res;
      if (this.length > 1) {
        res = 1;
      } else {
        if (negative) {
          num = -num;
        }
        assert(num <= 67108863, "Number is too big");
        var w2 = this.words[0] | 0;
        res = w2 === num ? 0 : w2 < num ? -1 : 1;
      }
      if (this.negative !== 0)
        return -res | 0;
      return res;
    };
    BN2.prototype.cmp = function cmp(num) {
      if (this.negative !== 0 && num.negative === 0)
        return -1;
      if (this.negative === 0 && num.negative !== 0)
        return 1;
      var res = this.ucmp(num);
      if (this.negative !== 0)
        return -res | 0;
      return res;
    };
    BN2.prototype.ucmp = function ucmp(num) {
      if (this.length > num.length)
        return 1;
      if (this.length < num.length)
        return -1;
      var res = 0;
      for (var i = this.length - 1; i >= 0; i--) {
        var a = this.words[i] | 0;
        var b2 = num.words[i] | 0;
        if (a === b2)
          continue;
        if (a < b2) {
          res = -1;
        } else if (a > b2) {
          res = 1;
        }
        break;
      }
      return res;
    };
    BN2.prototype.gtn = function gtn(num) {
      return this.cmpn(num) === 1;
    };
    BN2.prototype.gt = function gt(num) {
      return this.cmp(num) === 1;
    };
    BN2.prototype.gten = function gten(num) {
      return this.cmpn(num) >= 0;
    };
    BN2.prototype.gte = function gte(num) {
      return this.cmp(num) >= 0;
    };
    BN2.prototype.ltn = function ltn(num) {
      return this.cmpn(num) === -1;
    };
    BN2.prototype.lt = function lt(num) {
      return this.cmp(num) === -1;
    };
    BN2.prototype.lten = function lten(num) {
      return this.cmpn(num) <= 0;
    };
    BN2.prototype.lte = function lte(num) {
      return this.cmp(num) <= 0;
    };
    BN2.prototype.eqn = function eqn(num) {
      return this.cmpn(num) === 0;
    };
    BN2.prototype.eq = function eq(num) {
      return this.cmp(num) === 0;
    };
    BN2.red = function red(num) {
      return new Red(num);
    };
    BN2.prototype.toRed = function toRed(ctx) {
      assert(!this.red, "Already a number in reduction context");
      assert(this.negative === 0, "red works only with positives");
      return ctx.convertTo(this)._forceRed(ctx);
    };
    BN2.prototype.fromRed = function fromRed() {
      assert(this.red, "fromRed works only with numbers in reduction context");
      return this.red.convertFrom(this);
    };
    BN2.prototype._forceRed = function _forceRed(ctx) {
      this.red = ctx;
      return this;
    };
    BN2.prototype.forceRed = function forceRed(ctx) {
      assert(!this.red, "Already a number in reduction context");
      return this._forceRed(ctx);
    };
    BN2.prototype.redAdd = function redAdd(num) {
      assert(this.red, "redAdd works only with red numbers");
      return this.red.add(this, num);
    };
    BN2.prototype.redIAdd = function redIAdd(num) {
      assert(this.red, "redIAdd works only with red numbers");
      return this.red.iadd(this, num);
    };
    BN2.prototype.redSub = function redSub(num) {
      assert(this.red, "redSub works only with red numbers");
      return this.red.sub(this, num);
    };
    BN2.prototype.redISub = function redISub(num) {
      assert(this.red, "redISub works only with red numbers");
      return this.red.isub(this, num);
    };
    BN2.prototype.redShl = function redShl(num) {
      assert(this.red, "redShl works only with red numbers");
      return this.red.shl(this, num);
    };
    BN2.prototype.redMul = function redMul(num) {
      assert(this.red, "redMul works only with red numbers");
      this.red._verify2(this, num);
      return this.red.mul(this, num);
    };
    BN2.prototype.redIMul = function redIMul(num) {
      assert(this.red, "redMul works only with red numbers");
      this.red._verify2(this, num);
      return this.red.imul(this, num);
    };
    BN2.prototype.redSqr = function redSqr() {
      assert(this.red, "redSqr works only with red numbers");
      this.red._verify1(this);
      return this.red.sqr(this);
    };
    BN2.prototype.redISqr = function redISqr() {
      assert(this.red, "redISqr works only with red numbers");
      this.red._verify1(this);
      return this.red.isqr(this);
    };
    BN2.prototype.redSqrt = function redSqrt() {
      assert(this.red, "redSqrt works only with red numbers");
      this.red._verify1(this);
      return this.red.sqrt(this);
    };
    BN2.prototype.redInvm = function redInvm() {
      assert(this.red, "redInvm works only with red numbers");
      this.red._verify1(this);
      return this.red.invm(this);
    };
    BN2.prototype.redNeg = function redNeg() {
      assert(this.red, "redNeg works only with red numbers");
      this.red._verify1(this);
      return this.red.neg(this);
    };
    BN2.prototype.redPow = function redPow(num) {
      assert(this.red && !num.red, "redPow(normalNum)");
      this.red._verify1(this);
      return this.red.pow(this, num);
    };
    var primes = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function MPrime(name, p2) {
      this.name = name;
      this.p = new BN2(p2, 16);
      this.n = this.p.bitLength();
      this.k = new BN2(1).iushln(this.n).isub(this.p);
      this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
      var tmp = new BN2(null);
      tmp.words = new Array(Math.ceil(this.n / 13));
      return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
      var r2 = num;
      var rlen;
      do {
        this.split(r2, this.tmp);
        r2 = this.imulK(r2);
        r2 = r2.iadd(this.tmp);
        rlen = r2.bitLength();
      } while (rlen > this.n);
      var cmp = rlen < this.n ? -1 : r2.ucmp(this.p);
      if (cmp === 0) {
        r2.words[0] = 0;
        r2.length = 1;
      } else if (cmp > 0) {
        r2.isub(this.p);
      } else {
        if (r2.strip !== void 0) {
          r2.strip();
        } else {
          r2._strip();
        }
      }
      return r2;
    };
    MPrime.prototype.split = function split(input, out) {
      input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
      return num.imul(this.k);
    };
    function K256() {
      MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
      var mask = 4194303;
      var outLen = Math.min(input.length, 9);
      for (var i = 0; i < outLen; i++) {
        output.words[i] = input.words[i];
      }
      output.length = outLen;
      if (input.length <= 9) {
        input.words[0] = 0;
        input.length = 1;
        return;
      }
      var prev2 = input.words[9];
      output.words[output.length++] = prev2 & mask;
      for (i = 10; i < input.length; i++) {
        var next2 = input.words[i] | 0;
        input.words[i - 10] = (next2 & mask) << 4 | prev2 >>> 22;
        prev2 = next2;
      }
      prev2 >>>= 22;
      input.words[i - 10] = prev2;
      if (prev2 === 0 && input.length > 10) {
        input.length -= 10;
      } else {
        input.length -= 9;
      }
    };
    K256.prototype.imulK = function imulK(num) {
      num.words[num.length] = 0;
      num.words[num.length + 1] = 0;
      num.length += 2;
      var lo = 0;
      for (var i = 0; i < num.length; i++) {
        var w2 = num.words[i] | 0;
        lo += w2 * 977;
        num.words[i] = lo & 67108863;
        lo = w2 * 64 + (lo / 67108864 | 0);
      }
      if (num.words[num.length - 1] === 0) {
        num.length--;
        if (num.words[num.length - 1] === 0) {
          num.length--;
        }
      }
      return num;
    };
    function P224() {
      MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
      MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
      MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
      var carry = 0;
      for (var i = 0; i < num.length; i++) {
        var hi = (num.words[i] | 0) * 19 + carry;
        var lo = hi & 67108863;
        hi >>>= 26;
        num.words[i] = lo;
        carry = hi;
      }
      if (carry !== 0) {
        num.words[num.length++] = carry;
      }
      return num;
    };
    BN2._prime = function prime(name) {
      if (primes[name])
        return primes[name];
      var prime2;
      if (name === "k256") {
        prime2 = new K256();
      } else if (name === "p224") {
        prime2 = new P224();
      } else if (name === "p192") {
        prime2 = new P192();
      } else if (name === "p25519") {
        prime2 = new P25519();
      } else {
        throw new Error("Unknown prime " + name);
      }
      primes[name] = prime2;
      return prime2;
    };
    function Red(m2) {
      if (typeof m2 === "string") {
        var prime = BN2._prime(m2);
        this.m = prime.p;
        this.prime = prime;
      } else {
        assert(m2.gtn(1), "modulus must be greater than 1");
        this.m = m2;
        this.prime = null;
      }
    }
    Red.prototype._verify1 = function _verify1(a) {
      assert(a.negative === 0, "red works only with positives");
      assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b2) {
      assert((a.negative | b2.negative) === 0, "red works only with positives");
      assert(a.red && a.red === b2.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
      if (this.prime)
        return this.prime.ireduce(a)._forceRed(this);
      move(a, a.umod(this.m)._forceRed(this));
      return a;
    };
    Red.prototype.neg = function neg(a) {
      if (a.isZero()) {
        return a.clone();
      }
      return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b2) {
      this._verify2(a, b2);
      var res = a.add(b2);
      if (res.cmp(this.m) >= 0) {
        res.isub(this.m);
      }
      return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b2) {
      this._verify2(a, b2);
      var res = a.iadd(b2);
      if (res.cmp(this.m) >= 0) {
        res.isub(this.m);
      }
      return res;
    };
    Red.prototype.sub = function sub(a, b2) {
      this._verify2(a, b2);
      var res = a.sub(b2);
      if (res.cmpn(0) < 0) {
        res.iadd(this.m);
      }
      return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b2) {
      this._verify2(a, b2);
      var res = a.isub(b2);
      if (res.cmpn(0) < 0) {
        res.iadd(this.m);
      }
      return res;
    };
    Red.prototype.shl = function shl(a, num) {
      this._verify1(a);
      return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b2) {
      this._verify2(a, b2);
      return this.imod(a.imul(b2));
    };
    Red.prototype.mul = function mul(a, b2) {
      this._verify2(a, b2);
      return this.imod(a.mul(b2));
    };
    Red.prototype.isqr = function isqr(a) {
      return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
      return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
      if (a.isZero())
        return a.clone();
      var mod3 = this.m.andln(3);
      assert(mod3 % 2 === 1);
      if (mod3 === 3) {
        var pow = this.m.add(new BN2(1)).iushrn(2);
        return this.pow(a, pow);
      }
      var q2 = this.m.subn(1);
      var s = 0;
      while (!q2.isZero() && q2.andln(1) === 0) {
        s++;
        q2.iushrn(1);
      }
      assert(!q2.isZero());
      var one = new BN2(1).toRed(this);
      var nOne = one.redNeg();
      var lpow = this.m.subn(1).iushrn(1);
      var z2 = this.m.bitLength();
      z2 = new BN2(2 * z2 * z2).toRed(this);
      while (this.pow(z2, lpow).cmp(nOne) !== 0) {
        z2.redIAdd(nOne);
      }
      var c2 = this.pow(z2, q2);
      var r2 = this.pow(a, q2.addn(1).iushrn(1));
      var t2 = this.pow(a, q2);
      var m2 = s;
      while (t2.cmp(one) !== 0) {
        var tmp = t2;
        for (var i = 0; tmp.cmp(one) !== 0; i++) {
          tmp = tmp.redSqr();
        }
        assert(i < m2);
        var b2 = this.pow(c2, new BN2(1).iushln(m2 - i - 1));
        r2 = r2.redMul(b2);
        c2 = b2.redSqr();
        t2 = t2.redMul(c2);
        m2 = i;
      }
      return r2;
    };
    Red.prototype.invm = function invm(a) {
      var inv = a._invmp(this.m);
      if (inv.negative !== 0) {
        inv.negative = 0;
        return this.imod(inv).redNeg();
      } else {
        return this.imod(inv);
      }
    };
    Red.prototype.pow = function pow(a, num) {
      if (num.isZero())
        return new BN2(1).toRed(this);
      if (num.cmpn(1) === 0)
        return a.clone();
      var windowSize = 4;
      var wnd = new Array(1 << windowSize);
      wnd[0] = new BN2(1).toRed(this);
      wnd[1] = a;
      for (var i = 2; i < wnd.length; i++) {
        wnd[i] = this.mul(wnd[i - 1], a);
      }
      var res = wnd[0];
      var current = 0;
      var currentLen = 0;
      var start = num.bitLength() % 26;
      if (start === 0) {
        start = 26;
      }
      for (i = num.length - 1; i >= 0; i--) {
        var word = num.words[i];
        for (var j = start - 1; j >= 0; j--) {
          var bit = word >> j & 1;
          if (res !== wnd[0]) {
            res = this.sqr(res);
          }
          if (bit === 0 && current === 0) {
            currentLen = 0;
            continue;
          }
          current <<= 1;
          current |= bit;
          currentLen++;
          if (currentLen !== windowSize && (i !== 0 || j !== 0))
            continue;
          res = this.mul(res, wnd[current]);
          currentLen = 0;
          current = 0;
        }
        start = 26;
      }
      return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
      var r2 = num.umod(this.m);
      return r2 === num ? r2.clone() : r2;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
      var res = num.clone();
      res.red = null;
      return res;
    };
    BN2.mont = function mont(num) {
      return new Mont(num);
    };
    function Mont(m2) {
      Red.call(this, m2);
      this.shift = this.m.bitLength();
      if (this.shift % 26 !== 0) {
        this.shift += 26 - this.shift % 26;
      }
      this.r = new BN2(1).iushln(this.shift);
      this.r2 = this.imod(this.r.sqr());
      this.rinv = this.r._invmp(this.m);
      this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
      this.minv = this.minv.umod(this.r);
      this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
      return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
      var r2 = this.imod(num.mul(this.rinv));
      r2.red = null;
      return r2;
    };
    Mont.prototype.imul = function imul(a, b2) {
      if (a.isZero() || b2.isZero()) {
        a.words[0] = 0;
        a.length = 1;
        return a;
      }
      var t2 = a.imul(b2);
      var c2 = t2.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
      var u = t2.isub(c2).iushrn(this.shift);
      var res = u;
      if (u.cmp(this.m) >= 0) {
        res = u.isub(this.m);
      } else if (u.cmpn(0) < 0) {
        res = u.iadd(this.m);
      }
      return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b2) {
      if (a.isZero() || b2.isZero())
        return new BN2(0)._forceRed(this);
      var t2 = a.mul(b2);
      var c2 = t2.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
      var u = t2.isub(c2).iushrn(this.shift);
      var res = u;
      if (u.cmp(this.m) >= 0) {
        res = u.isub(this.m);
      } else if (u.cmpn(0) < 0) {
        res = u.iadd(this.m);
      }
      return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
      var res = this.imod(a._invmp(this.m).mul(this.r2));
      return res._forceRed(this);
    };
  })(module, commonjsGlobal);
})(bn);
var BN$1 = bn.exports;
const version$4 = "logger/5.6.0";
let _permanentCensorErrors = false;
let _censorErrors = false;
const LogLevels = { debug: 1, "default": 2, info: 2, warning: 3, error: 4, off: 5 };
let _logLevel = LogLevels["default"];
let _globalLogger = null;
function _checkNormalize() {
  try {
    const missing = [];
    ["NFD", "NFC", "NFKD", "NFKC"].forEach((form) => {
      try {
        if ("test".normalize(form) !== "test") {
          throw new Error("bad normalize");
        }
        ;
      } catch (error) {
        missing.push(form);
      }
    });
    if (missing.length) {
      throw new Error("missing " + missing.join(", "));
    }
    if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769)) {
      throw new Error("broken implementation");
    }
  } catch (error) {
    return error.message;
  }
  return null;
}
const _normalizeError = _checkNormalize();
var LogLevel;
(function(LogLevel2) {
  LogLevel2["DEBUG"] = "DEBUG";
  LogLevel2["INFO"] = "INFO";
  LogLevel2["WARNING"] = "WARNING";
  LogLevel2["ERROR"] = "ERROR";
  LogLevel2["OFF"] = "OFF";
})(LogLevel || (LogLevel = {}));
var ErrorCode;
(function(ErrorCode2) {
  ErrorCode2["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
  ErrorCode2["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
  ErrorCode2["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
  ErrorCode2["NETWORK_ERROR"] = "NETWORK_ERROR";
  ErrorCode2["SERVER_ERROR"] = "SERVER_ERROR";
  ErrorCode2["TIMEOUT"] = "TIMEOUT";
  ErrorCode2["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
  ErrorCode2["NUMERIC_FAULT"] = "NUMERIC_FAULT";
  ErrorCode2["MISSING_NEW"] = "MISSING_NEW";
  ErrorCode2["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
  ErrorCode2["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
  ErrorCode2["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
  ErrorCode2["CALL_EXCEPTION"] = "CALL_EXCEPTION";
  ErrorCode2["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
  ErrorCode2["NONCE_EXPIRED"] = "NONCE_EXPIRED";
  ErrorCode2["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
  ErrorCode2["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
  ErrorCode2["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
})(ErrorCode || (ErrorCode = {}));
const HEX = "0123456789abcdef";
class Logger {
  constructor(version2) {
    Object.defineProperty(this, "version", {
      enumerable: true,
      value: version2,
      writable: false
    });
  }
  _log(logLevel, args) {
    const level = logLevel.toLowerCase();
    if (LogLevels[level] == null) {
      this.throwArgumentError("invalid log level name", "logLevel", logLevel);
    }
    if (_logLevel > LogLevels[level]) {
      return;
    }
    console.log.apply(console, args);
  }
  debug(...args) {
    this._log(Logger.levels.DEBUG, args);
  }
  info(...args) {
    this._log(Logger.levels.INFO, args);
  }
  warn(...args) {
    this._log(Logger.levels.WARNING, args);
  }
  makeError(message, code, params) {
    if (_censorErrors) {
      return this.makeError("censored error", code, {});
    }
    if (!code) {
      code = Logger.errors.UNKNOWN_ERROR;
    }
    if (!params) {
      params = {};
    }
    const messageDetails = [];
    Object.keys(params).forEach((key) => {
      const value = params[key];
      try {
        if (value instanceof Uint8Array) {
          let hex = "";
          for (let i = 0; i < value.length; i++) {
            hex += HEX[value[i] >> 4];
            hex += HEX[value[i] & 15];
          }
          messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
        } else {
          messageDetails.push(key + "=" + JSON.stringify(value));
        }
      } catch (error2) {
        messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
      }
    });
    messageDetails.push(`code=${code}`);
    messageDetails.push(`version=${this.version}`);
    const reason = message;
    let url = "";
    switch (code) {
      case ErrorCode.NUMERIC_FAULT: {
        url = "NUMERIC_FAULT";
        const fault = message;
        switch (fault) {
          case "overflow":
          case "underflow":
          case "division-by-zero":
            url += "-" + fault;
            break;
          case "negative-power":
          case "negative-width":
            url += "-unsupported";
            break;
          case "unbound-bitwise-result":
            url += "-unbound-result";
            break;
        }
        break;
      }
      case ErrorCode.CALL_EXCEPTION:
      case ErrorCode.INSUFFICIENT_FUNDS:
      case ErrorCode.MISSING_NEW:
      case ErrorCode.NONCE_EXPIRED:
      case ErrorCode.REPLACEMENT_UNDERPRICED:
      case ErrorCode.TRANSACTION_REPLACED:
      case ErrorCode.UNPREDICTABLE_GAS_LIMIT:
        url = code;
        break;
    }
    if (url) {
      message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
    }
    if (messageDetails.length) {
      message += " (" + messageDetails.join(", ") + ")";
    }
    const error = new Error(message);
    error.reason = reason;
    error.code = code;
    Object.keys(params).forEach(function(key) {
      error[key] = params[key];
    });
    return error;
  }
  throwError(message, code, params) {
    throw this.makeError(message, code, params);
  }
  throwArgumentError(message, name, value) {
    return this.throwError(message, Logger.errors.INVALID_ARGUMENT, {
      argument: name,
      value
    });
  }
  assert(condition, message, code, params) {
    if (!!condition) {
      return;
    }
    this.throwError(message, code, params);
  }
  assertArgument(condition, message, name, value) {
    if (!!condition) {
      return;
    }
    this.throwArgumentError(message, name, value);
  }
  checkNormalize(message) {
    if (_normalizeError) {
      this.throwError("platform missing String.prototype.normalize", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "String.prototype.normalize",
        form: _normalizeError
      });
    }
  }
  checkSafeUint53(value, message) {
    if (typeof value !== "number") {
      return;
    }
    if (message == null) {
      message = "value not safe";
    }
    if (value < 0 || value >= 9007199254740991) {
      this.throwError(message, Logger.errors.NUMERIC_FAULT, {
        operation: "checkSafeInteger",
        fault: "out-of-safe-range",
        value
      });
    }
    if (value % 1) {
      this.throwError(message, Logger.errors.NUMERIC_FAULT, {
        operation: "checkSafeInteger",
        fault: "non-integer",
        value
      });
    }
  }
  checkArgumentCount(count, expectedCount, message) {
    if (message) {
      message = ": " + message;
    } else {
      message = "";
    }
    if (count < expectedCount) {
      this.throwError("missing argument" + message, Logger.errors.MISSING_ARGUMENT, {
        count,
        expectedCount
      });
    }
    if (count > expectedCount) {
      this.throwError("too many arguments" + message, Logger.errors.UNEXPECTED_ARGUMENT, {
        count,
        expectedCount
      });
    }
  }
  checkNew(target, kind) {
    if (target === Object || target == null) {
      this.throwError("missing new", Logger.errors.MISSING_NEW, { name: kind.name });
    }
  }
  checkAbstract(target, kind) {
    if (target === kind) {
      this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", Logger.errors.UNSUPPORTED_OPERATION, { name: target.name, operation: "new" });
    } else if (target === Object || target == null) {
      this.throwError("missing new", Logger.errors.MISSING_NEW, { name: kind.name });
    }
  }
  static globalLogger() {
    if (!_globalLogger) {
      _globalLogger = new Logger(version$4);
    }
    return _globalLogger;
  }
  static setCensorship(censorship, permanent) {
    if (!censorship && permanent) {
      this.globalLogger().throwError("cannot permanently disable censorship", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    if (_permanentCensorErrors) {
      if (!censorship) {
        return;
      }
      this.globalLogger().throwError("error censorship permanent", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    _censorErrors = !!censorship;
    _permanentCensorErrors = !!permanent;
  }
  static setLogLevel(logLevel) {
    const level = LogLevels[logLevel.toLowerCase()];
    if (level == null) {
      Logger.globalLogger().warn("invalid log level - " + logLevel);
      return;
    }
    _logLevel = level;
  }
  static from(version2) {
    return new Logger(version2);
  }
}
Logger.errors = ErrorCode;
Logger.levels = LogLevel;
const version$3 = "bytes/5.6.1";
const logger$4 = new Logger(version$3);
function isHexable(value) {
  return !!value.toHexString;
}
function addSlice(array) {
  if (array.slice) {
    return array;
  }
  array.slice = function() {
    const args = Array.prototype.slice.call(arguments);
    return addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
  };
  return array;
}
function isInteger(value) {
  return typeof value === "number" && value == value && value % 1 === 0;
}
function isBytes(value) {
  if (value == null) {
    return false;
  }
  if (value.constructor === Uint8Array) {
    return true;
  }
  if (typeof value === "string") {
    return false;
  }
  if (!isInteger(value.length) || value.length < 0) {
    return false;
  }
  for (let i = 0; i < value.length; i++) {
    const v2 = value[i];
    if (!isInteger(v2) || v2 < 0 || v2 >= 256) {
      return false;
    }
  }
  return true;
}
function arrayify(value, options2) {
  if (!options2) {
    options2 = {};
  }
  if (typeof value === "number") {
    logger$4.checkSafeUint53(value, "invalid arrayify value");
    const result = [];
    while (value) {
      result.unshift(value & 255);
      value = parseInt(String(value / 256));
    }
    if (result.length === 0) {
      result.push(0);
    }
    return addSlice(new Uint8Array(result));
  }
  if (options2.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") {
    value = "0x" + value;
  }
  if (isHexable(value)) {
    value = value.toHexString();
  }
  if (isHexString(value)) {
    let hex = value.substring(2);
    if (hex.length % 2) {
      if (options2.hexPad === "left") {
        hex = "0" + hex;
      } else if (options2.hexPad === "right") {
        hex += "0";
      } else {
        logger$4.throwArgumentError("hex data is odd-length", "value", value);
      }
    }
    const result = [];
    for (let i = 0; i < hex.length; i += 2) {
      result.push(parseInt(hex.substring(i, i + 2), 16));
    }
    return addSlice(new Uint8Array(result));
  }
  if (isBytes(value)) {
    return addSlice(new Uint8Array(value));
  }
  return logger$4.throwArgumentError("invalid arrayify value", "value", value);
}
function isHexString(value, length2) {
  if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) {
    return false;
  }
  if (length2 && value.length !== 2 + 2 * length2) {
    return false;
  }
  return true;
}
const HexCharacters = "0123456789abcdef";
function hexlify(value, options2) {
  if (!options2) {
    options2 = {};
  }
  if (typeof value === "number") {
    logger$4.checkSafeUint53(value, "invalid hexlify value");
    let hex = "";
    while (value) {
      hex = HexCharacters[value & 15] + hex;
      value = Math.floor(value / 16);
    }
    if (hex.length) {
      if (hex.length % 2) {
        hex = "0" + hex;
      }
      return "0x" + hex;
    }
    return "0x00";
  }
  if (typeof value === "bigint") {
    value = value.toString(16);
    if (value.length % 2) {
      return "0x0" + value;
    }
    return "0x" + value;
  }
  if (options2.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") {
    value = "0x" + value;
  }
  if (isHexable(value)) {
    return value.toHexString();
  }
  if (isHexString(value)) {
    if (value.length % 2) {
      if (options2.hexPad === "left") {
        value = "0x0" + value.substring(2);
      } else if (options2.hexPad === "right") {
        value += "0";
      } else {
        logger$4.throwArgumentError("hex data is odd-length", "value", value);
      }
    }
    return value.toLowerCase();
  }
  if (isBytes(value)) {
    let result = "0x";
    for (let i = 0; i < value.length; i++) {
      let v2 = value[i];
      result += HexCharacters[(v2 & 240) >> 4] + HexCharacters[v2 & 15];
    }
    return result;
  }
  return logger$4.throwArgumentError("invalid hexlify value", "value", value);
}
function hexZeroPad(value, length2) {
  if (typeof value !== "string") {
    value = hexlify(value);
  } else if (!isHexString(value)) {
    logger$4.throwArgumentError("invalid hex string", "value", value);
  }
  if (value.length > 2 * length2 + 2) {
    logger$4.throwArgumentError("value out of range", "value", arguments[1]);
  }
  while (value.length < 2 * length2 + 2) {
    value = "0x0" + value.substring(2);
  }
  return value;
}
const version$2 = "bignumber/5.6.2";
var BN = BN$1.BN;
const logger$3 = new Logger(version$2);
const _constructorGuard$1 = {};
const MAX_SAFE = 9007199254740991;
function isBigNumberish(value) {
  return value != null && (BigNumber.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || isHexString(value) || typeof value === "bigint" || isBytes(value));
}
let _warnedToStringRadix = false;
class BigNumber {
  constructor(constructorGuard, hex) {
    if (constructorGuard !== _constructorGuard$1) {
      logger$3.throwError("cannot call constructor directly; use BigNumber.from", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "new (BigNumber)"
      });
    }
    this._hex = hex;
    this._isBigNumber = true;
    Object.freeze(this);
  }
  fromTwos(value) {
    return toBigNumber(toBN(this).fromTwos(value));
  }
  toTwos(value) {
    return toBigNumber(toBN(this).toTwos(value));
  }
  abs() {
    if (this._hex[0] === "-") {
      return BigNumber.from(this._hex.substring(1));
    }
    return this;
  }
  add(other) {
    return toBigNumber(toBN(this).add(toBN(other)));
  }
  sub(other) {
    return toBigNumber(toBN(this).sub(toBN(other)));
  }
  div(other) {
    const o = BigNumber.from(other);
    if (o.isZero()) {
      throwFault$1("division-by-zero", "div");
    }
    return toBigNumber(toBN(this).div(toBN(other)));
  }
  mul(other) {
    return toBigNumber(toBN(this).mul(toBN(other)));
  }
  mod(other) {
    const value = toBN(other);
    if (value.isNeg()) {
      throwFault$1("division-by-zero", "mod");
    }
    return toBigNumber(toBN(this).umod(value));
  }
  pow(other) {
    const value = toBN(other);
    if (value.isNeg()) {
      throwFault$1("negative-power", "pow");
    }
    return toBigNumber(toBN(this).pow(value));
  }
  and(other) {
    const value = toBN(other);
    if (this.isNegative() || value.isNeg()) {
      throwFault$1("unbound-bitwise-result", "and");
    }
    return toBigNumber(toBN(this).and(value));
  }
  or(other) {
    const value = toBN(other);
    if (this.isNegative() || value.isNeg()) {
      throwFault$1("unbound-bitwise-result", "or");
    }
    return toBigNumber(toBN(this).or(value));
  }
  xor(other) {
    const value = toBN(other);
    if (this.isNegative() || value.isNeg()) {
      throwFault$1("unbound-bitwise-result", "xor");
    }
    return toBigNumber(toBN(this).xor(value));
  }
  mask(value) {
    if (this.isNegative() || value < 0) {
      throwFault$1("negative-width", "mask");
    }
    return toBigNumber(toBN(this).maskn(value));
  }
  shl(value) {
    if (this.isNegative() || value < 0) {
      throwFault$1("negative-width", "shl");
    }
    return toBigNumber(toBN(this).shln(value));
  }
  shr(value) {
    if (this.isNegative() || value < 0) {
      throwFault$1("negative-width", "shr");
    }
    return toBigNumber(toBN(this).shrn(value));
  }
  eq(other) {
    return toBN(this).eq(toBN(other));
  }
  lt(other) {
    return toBN(this).lt(toBN(other));
  }
  lte(other) {
    return toBN(this).lte(toBN(other));
  }
  gt(other) {
    return toBN(this).gt(toBN(other));
  }
  gte(other) {
    return toBN(this).gte(toBN(other));
  }
  isNegative() {
    return this._hex[0] === "-";
  }
  isZero() {
    return toBN(this).isZero();
  }
  toNumber() {
    try {
      return toBN(this).toNumber();
    } catch (error) {
      throwFault$1("overflow", "toNumber", this.toString());
    }
    return null;
  }
  toBigInt() {
    try {
      return BigInt(this.toString());
    } catch (e2) {
    }
    return logger$3.throwError("this platform does not support BigInt", Logger.errors.UNSUPPORTED_OPERATION, {
      value: this.toString()
    });
  }
  toString() {
    if (arguments.length > 0) {
      if (arguments[0] === 10) {
        if (!_warnedToStringRadix) {
          _warnedToStringRadix = true;
          logger$3.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
        }
      } else if (arguments[0] === 16) {
        logger$3.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", Logger.errors.UNEXPECTED_ARGUMENT, {});
      } else {
        logger$3.throwError("BigNumber.toString does not accept parameters", Logger.errors.UNEXPECTED_ARGUMENT, {});
      }
    }
    return toBN(this).toString(10);
  }
  toHexString() {
    return this._hex;
  }
  toJSON(key) {
    return { type: "BigNumber", hex: this.toHexString() };
  }
  static from(value) {
    if (value instanceof BigNumber) {
      return value;
    }
    if (typeof value === "string") {
      if (value.match(/^-?0x[0-9a-f]+$/i)) {
        return new BigNumber(_constructorGuard$1, toHex(value));
      }
      if (value.match(/^-?[0-9]+$/)) {
        return new BigNumber(_constructorGuard$1, toHex(new BN(value)));
      }
      return logger$3.throwArgumentError("invalid BigNumber string", "value", value);
    }
    if (typeof value === "number") {
      if (value % 1) {
        throwFault$1("underflow", "BigNumber.from", value);
      }
      if (value >= MAX_SAFE || value <= -MAX_SAFE) {
        throwFault$1("overflow", "BigNumber.from", value);
      }
      return BigNumber.from(String(value));
    }
    const anyValue = value;
    if (typeof anyValue === "bigint") {
      return BigNumber.from(anyValue.toString());
    }
    if (isBytes(anyValue)) {
      return BigNumber.from(hexlify(anyValue));
    }
    if (anyValue) {
      if (anyValue.toHexString) {
        const hex = anyValue.toHexString();
        if (typeof hex === "string") {
          return BigNumber.from(hex);
        }
      } else {
        let hex = anyValue._hex;
        if (hex == null && anyValue.type === "BigNumber") {
          hex = anyValue.hex;
        }
        if (typeof hex === "string") {
          if (isHexString(hex) || hex[0] === "-" && isHexString(hex.substring(1))) {
            return BigNumber.from(hex);
          }
        }
      }
    }
    return logger$3.throwArgumentError("invalid BigNumber value", "value", value);
  }
  static isBigNumber(value) {
    return !!(value && value._isBigNumber);
  }
}
function toHex(value) {
  if (typeof value !== "string") {
    return toHex(value.toString(16));
  }
  if (value[0] === "-") {
    value = value.substring(1);
    if (value[0] === "-") {
      logger$3.throwArgumentError("invalid hex", "value", value);
    }
    value = toHex(value);
    if (value === "0x00") {
      return value;
    }
    return "-" + value;
  }
  if (value.substring(0, 2) !== "0x") {
    value = "0x" + value;
  }
  if (value === "0x") {
    return "0x00";
  }
  if (value.length % 2) {
    value = "0x0" + value.substring(2);
  }
  while (value.length > 4 && value.substring(0, 4) === "0x00") {
    value = "0x" + value.substring(4);
  }
  return value;
}
function toBigNumber(value) {
  return BigNumber.from(toHex(value));
}
function toBN(value) {
  const hex = BigNumber.from(value).toHexString();
  if (hex[0] === "-") {
    return new BN("-" + hex.substring(3), 16);
  }
  return new BN(hex.substring(2), 16);
}
function throwFault$1(fault, operation, value) {
  const params = { fault, operation };
  if (value != null) {
    params.value = value;
  }
  return logger$3.throwError(fault, Logger.errors.NUMERIC_FAULT, params);
}
function _base36To16(value) {
  return new BN(value, 36).toString(16);
}
const logger$2 = new Logger(version$2);
const _constructorGuard = {};
const Zero = BigNumber.from(0);
const NegativeOne = BigNumber.from(-1);
function throwFault(message, fault, operation, value) {
  const params = { fault, operation };
  if (value !== void 0) {
    params.value = value;
  }
  return logger$2.throwError(message, Logger.errors.NUMERIC_FAULT, params);
}
let zeros = "0";
while (zeros.length < 256) {
  zeros += zeros;
}
function getMultiplier(decimals) {
  if (typeof decimals !== "number") {
    try {
      decimals = BigNumber.from(decimals).toNumber();
    } catch (e2) {
    }
  }
  if (typeof decimals === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) {
    return "1" + zeros.substring(0, decimals);
  }
  return logger$2.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function formatFixed(value, decimals) {
  if (decimals == null) {
    decimals = 0;
  }
  const multiplier = getMultiplier(decimals);
  value = BigNumber.from(value);
  const negative = value.lt(Zero);
  if (negative) {
    value = value.mul(NegativeOne);
  }
  let fraction = value.mod(multiplier).toString();
  while (fraction.length < multiplier.length - 1) {
    fraction = "0" + fraction;
  }
  fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
  const whole = value.div(multiplier).toString();
  if (multiplier.length === 1) {
    value = whole;
  } else {
    value = whole + "." + fraction;
  }
  if (negative) {
    value = "-" + value;
  }
  return value;
}
function parseFixed(value, decimals) {
  if (decimals == null) {
    decimals = 0;
  }
  const multiplier = getMultiplier(decimals);
  if (typeof value !== "string" || !value.match(/^-?[0-9.]+$/)) {
    logger$2.throwArgumentError("invalid decimal value", "value", value);
  }
  const negative = value.substring(0, 1) === "-";
  if (negative) {
    value = value.substring(1);
  }
  if (value === ".") {
    logger$2.throwArgumentError("missing value", "value", value);
  }
  const comps = value.split(".");
  if (comps.length > 2) {
    logger$2.throwArgumentError("too many decimal points", "value", value);
  }
  let whole = comps[0], fraction = comps[1];
  if (!whole) {
    whole = "0";
  }
  if (!fraction) {
    fraction = "0";
  }
  while (fraction[fraction.length - 1] === "0") {
    fraction = fraction.substring(0, fraction.length - 1);
  }
  if (fraction.length > multiplier.length - 1) {
    throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
  }
  if (fraction === "") {
    fraction = "0";
  }
  while (fraction.length < multiplier.length - 1) {
    fraction += "0";
  }
  const wholeValue = BigNumber.from(whole);
  const fractionValue = BigNumber.from(fraction);
  let wei = wholeValue.mul(multiplier).add(fractionValue);
  if (negative) {
    wei = wei.mul(NegativeOne);
  }
  return wei;
}
class FixedFormat {
  constructor(constructorGuard, signed, width, decimals) {
    if (constructorGuard !== _constructorGuard) {
      logger$2.throwError("cannot use FixedFormat constructor; use FixedFormat.from", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "new FixedFormat"
      });
    }
    this.signed = signed;
    this.width = width;
    this.decimals = decimals;
    this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
    this._multiplier = getMultiplier(decimals);
    Object.freeze(this);
  }
  static from(value) {
    if (value instanceof FixedFormat) {
      return value;
    }
    if (typeof value === "number") {
      value = `fixed128x${value}`;
    }
    let signed = true;
    let width = 128;
    let decimals = 18;
    if (typeof value === "string") {
      if (value === "fixed")
        ;
      else if (value === "ufixed") {
        signed = false;
      } else {
        const match2 = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
        if (!match2) {
          logger$2.throwArgumentError("invalid fixed format", "format", value);
        }
        signed = match2[1] !== "u";
        width = parseInt(match2[2]);
        decimals = parseInt(match2[3]);
      }
    } else if (value) {
      const check = (key, type, defaultValue) => {
        if (value[key] == null) {
          return defaultValue;
        }
        if (typeof value[key] !== type) {
          logger$2.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
        }
        return value[key];
      };
      signed = check("signed", "boolean", signed);
      width = check("width", "number", width);
      decimals = check("decimals", "number", decimals);
    }
    if (width % 8) {
      logger$2.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
    }
    if (decimals > 80) {
      logger$2.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
    }
    return new FixedFormat(_constructorGuard, signed, width, decimals);
  }
}
class FixedNumber {
  constructor(constructorGuard, hex, value, format) {
    if (constructorGuard !== _constructorGuard) {
      logger$2.throwError("cannot use FixedNumber constructor; use FixedNumber.from", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "new FixedFormat"
      });
    }
    this.format = format;
    this._hex = hex;
    this._value = value;
    this._isFixedNumber = true;
    Object.freeze(this);
  }
  _checkFormat(other) {
    if (this.format.name !== other.format.name) {
      logger$2.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
    }
  }
  addUnsafe(other) {
    this._checkFormat(other);
    const a = parseFixed(this._value, this.format.decimals);
    const b2 = parseFixed(other._value, other.format.decimals);
    return FixedNumber.fromValue(a.add(b2), this.format.decimals, this.format);
  }
  subUnsafe(other) {
    this._checkFormat(other);
    const a = parseFixed(this._value, this.format.decimals);
    const b2 = parseFixed(other._value, other.format.decimals);
    return FixedNumber.fromValue(a.sub(b2), this.format.decimals, this.format);
  }
  mulUnsafe(other) {
    this._checkFormat(other);
    const a = parseFixed(this._value, this.format.decimals);
    const b2 = parseFixed(other._value, other.format.decimals);
    return FixedNumber.fromValue(a.mul(b2).div(this.format._multiplier), this.format.decimals, this.format);
  }
  divUnsafe(other) {
    this._checkFormat(other);
    const a = parseFixed(this._value, this.format.decimals);
    const b2 = parseFixed(other._value, other.format.decimals);
    return FixedNumber.fromValue(a.mul(this.format._multiplier).div(b2), this.format.decimals, this.format);
  }
  floor() {
    const comps = this.toString().split(".");
    if (comps.length === 1) {
      comps.push("0");
    }
    let result = FixedNumber.from(comps[0], this.format);
    const hasFraction = !comps[1].match(/^(0*)$/);
    if (this.isNegative() && hasFraction) {
      result = result.subUnsafe(ONE.toFormat(result.format));
    }
    return result;
  }
  ceiling() {
    const comps = this.toString().split(".");
    if (comps.length === 1) {
      comps.push("0");
    }
    let result = FixedNumber.from(comps[0], this.format);
    const hasFraction = !comps[1].match(/^(0*)$/);
    if (!this.isNegative() && hasFraction) {
      result = result.addUnsafe(ONE.toFormat(result.format));
    }
    return result;
  }
  round(decimals) {
    if (decimals == null) {
      decimals = 0;
    }
    const comps = this.toString().split(".");
    if (comps.length === 1) {
      comps.push("0");
    }
    if (decimals < 0 || decimals > 80 || decimals % 1) {
      logger$2.throwArgumentError("invalid decimal count", "decimals", decimals);
    }
    if (comps[1].length <= decimals) {
      return this;
    }
    const factor = FixedNumber.from("1" + zeros.substring(0, decimals), this.format);
    const bump = BUMP.toFormat(this.format);
    return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
  }
  isZero() {
    return this._value === "0.0" || this._value === "0";
  }
  isNegative() {
    return this._value[0] === "-";
  }
  toString() {
    return this._value;
  }
  toHexString(width) {
    if (width == null) {
      return this._hex;
    }
    if (width % 8) {
      logger$2.throwArgumentError("invalid byte width", "width", width);
    }
    const hex = BigNumber.from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
    return hexZeroPad(hex, width / 8);
  }
  toUnsafeFloat() {
    return parseFloat(this.toString());
  }
  toFormat(format) {
    return FixedNumber.fromString(this._value, format);
  }
  static fromValue(value, decimals, format) {
    if (format == null && decimals != null && !isBigNumberish(decimals)) {
      format = decimals;
      decimals = null;
    }
    if (decimals == null) {
      decimals = 0;
    }
    if (format == null) {
      format = "fixed";
    }
    return FixedNumber.fromString(formatFixed(value, decimals), FixedFormat.from(format));
  }
  static fromString(value, format) {
    if (format == null) {
      format = "fixed";
    }
    const fixedFormat = FixedFormat.from(format);
    const numeric = parseFixed(value, fixedFormat.decimals);
    if (!fixedFormat.signed && numeric.lt(Zero)) {
      throwFault("unsigned value cannot be negative", "overflow", "value", value);
    }
    let hex = null;
    if (fixedFormat.signed) {
      hex = numeric.toTwos(fixedFormat.width).toHexString();
    } else {
      hex = numeric.toHexString();
      hex = hexZeroPad(hex, fixedFormat.width / 8);
    }
    const decimal = formatFixed(numeric, fixedFormat.decimals);
    return new FixedNumber(_constructorGuard, hex, decimal, fixedFormat);
  }
  static fromBytes(value, format) {
    if (format == null) {
      format = "fixed";
    }
    const fixedFormat = FixedFormat.from(format);
    if (arrayify(value).length > fixedFormat.width / 8) {
      throw new Error("overflow");
    }
    let numeric = BigNumber.from(value);
    if (fixedFormat.signed) {
      numeric = numeric.fromTwos(fixedFormat.width);
    }
    const hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
    const decimal = formatFixed(numeric, fixedFormat.decimals);
    return new FixedNumber(_constructorGuard, hex, decimal, fixedFormat);
  }
  static from(value, format) {
    if (typeof value === "string") {
      return FixedNumber.fromString(value, format);
    }
    if (isBytes(value)) {
      return FixedNumber.fromBytes(value, format);
    }
    try {
      return FixedNumber.fromValue(value, 0, format);
    } catch (error) {
      if (error.code !== Logger.errors.INVALID_ARGUMENT) {
        throw error;
      }
    }
    return logger$2.throwArgumentError("invalid FixedNumber value", "value", value);
  }
  static isFixedNumber(value) {
    return !!(value && value._isFixedNumber);
  }
}
const ONE = FixedNumber.from(1);
const BUMP = FixedNumber.from("0.5");
var sha3$1 = { exports: {} };
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */
(function(module) {
  (function() {
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) {
      WINDOW = false;
    }
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof process === "object" && process.versions && process.versions.node;
    if (NODE_JS) {
      root = {};
    } else if (WEB_WORKER) {
      root = self;
    }
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [31, 7936, 2031616, 520093696];
    var CSHAKE_PADDING = [4, 1024, 262144, 67108864];
    var KECCAK_PADDING = [1, 256, 65536, 16777216];
    var PADDING = [6, 1536, 393216, 100663296];
    var SHIFT = [0, 8, 16, 24];
    var RC = [
      1,
      0,
      32898,
      0,
      32906,
      2147483648,
      2147516416,
      2147483648,
      32907,
      0,
      2147483649,
      0,
      2147516545,
      2147483648,
      32777,
      2147483648,
      138,
      0,
      136,
      0,
      2147516425,
      0,
      2147483658,
      0,
      2147516555,
      0,
      139,
      2147483648,
      32905,
      2147483648,
      32771,
      2147483648,
      32770,
      2147483648,
      128,
      2147483648,
      32778,
      0,
      2147483658,
      2147483648,
      2147516545,
      2147483648,
      32896,
      2147483648,
      2147483649,
      0,
      2147516424,
      2147483648
    ];
    var BITS = [224, 256, 384, 512];
    var SHAKE_BITS = [128, 256];
    var OUTPUT_TYPES = ["hex", "buffer", "arrayBuffer", "array", "digest"];
    var CSHAKE_BYTEPAD = {
      "128": 168,
      "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) {
      Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
      };
    }
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
      ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
      };
    }
    var createOutputMethod = function(bits2, padding, outputType) {
      return function(message) {
        return new Keccak(bits2, padding, bits2).update(message)[outputType]();
      };
    };
    var createShakeOutputMethod = function(bits2, padding, outputType) {
      return function(message, outputBits) {
        return new Keccak(bits2, padding, outputBits).update(message)[outputType]();
      };
    };
    var createCshakeOutputMethod = function(bits2, padding, outputType) {
      return function(message, outputBits, n2, s) {
        return methods["cshake" + bits2].update(message, outputBits, n2, s)[outputType]();
      };
    };
    var createKmacOutputMethod = function(bits2, padding, outputType) {
      return function(key, message, outputBits, s) {
        return methods["kmac" + bits2].update(key, message, outputBits, s)[outputType]();
      };
    };
    var createOutputMethods = function(method, createMethod2, bits2, padding) {
      for (var i2 = 0; i2 < OUTPUT_TYPES.length; ++i2) {
        var type = OUTPUT_TYPES[i2];
        method[type] = createMethod2(bits2, padding, type);
      }
      return method;
    };
    var createMethod = function(bits2, padding) {
      var method = createOutputMethod(bits2, padding, "hex");
      method.create = function() {
        return new Keccak(bits2, padding, bits2);
      };
      method.update = function(message) {
        return method.create().update(message);
      };
      return createOutputMethods(method, createOutputMethod, bits2, padding);
    };
    var createShakeMethod = function(bits2, padding) {
      var method = createShakeOutputMethod(bits2, padding, "hex");
      method.create = function(outputBits) {
        return new Keccak(bits2, padding, outputBits);
      };
      method.update = function(message, outputBits) {
        return method.create(outputBits).update(message);
      };
      return createOutputMethods(method, createShakeOutputMethod, bits2, padding);
    };
    var createCshakeMethod = function(bits2, padding) {
      var w2 = CSHAKE_BYTEPAD[bits2];
      var method = createCshakeOutputMethod(bits2, padding, "hex");
      method.create = function(outputBits, n2, s) {
        if (!n2 && !s) {
          return methods["shake" + bits2].create(outputBits);
        } else {
          return new Keccak(bits2, padding, outputBits).bytepad([n2, s], w2);
        }
      };
      method.update = function(message, outputBits, n2, s) {
        return method.create(outputBits, n2, s).update(message);
      };
      return createOutputMethods(method, createCshakeOutputMethod, bits2, padding);
    };
    var createKmacMethod = function(bits2, padding) {
      var w2 = CSHAKE_BYTEPAD[bits2];
      var method = createKmacOutputMethod(bits2, padding, "hex");
      method.create = function(key, outputBits, s) {
        return new Kmac(bits2, padding, outputBits).bytepad(["KMAC", s], w2).bytepad([key], w2);
      };
      method.update = function(key, message, outputBits, s) {
        return method.create(key, outputBits, s).update(message);
      };
      return createOutputMethods(method, createKmacOutputMethod, bits2, padding);
    };
    var algorithms = [
      { name: "keccak", padding: KECCAK_PADDING, bits: BITS, createMethod },
      { name: "sha3", padding: PADDING, bits: BITS, createMethod },
      { name: "shake", padding: SHAKE_PADDING, bits: SHAKE_BITS, createMethod: createShakeMethod },
      { name: "cshake", padding: CSHAKE_PADDING, bits: SHAKE_BITS, createMethod: createCshakeMethod },
      { name: "kmac", padding: CSHAKE_PADDING, bits: SHAKE_BITS, createMethod: createKmacMethod }
    ];
    var methods = {}, methodNames = [];
    for (var i = 0; i < algorithms.length; ++i) {
      var algorithm = algorithms[i];
      var bits = algorithm.bits;
      for (var j = 0; j < bits.length; ++j) {
        var methodName = algorithm.name + "_" + bits[j];
        methodNames.push(methodName);
        methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
        if (algorithm.name !== "sha3") {
          var newMethodName = algorithm.name + bits[j];
          methodNames.push(newMethodName);
          methods[newMethodName] = methods[methodName];
        }
      }
    }
    function Keccak(bits2, padding, outputBits) {
      this.blocks = [];
      this.s = [];
      this.padding = padding;
      this.outputBits = outputBits;
      this.reset = true;
      this.finalized = false;
      this.block = 0;
      this.start = 0;
      this.blockCount = 1600 - (bits2 << 1) >> 5;
      this.byteCount = this.blockCount << 2;
      this.outputBlocks = outputBits >> 5;
      this.extraBytes = (outputBits & 31) >> 3;
      for (var i2 = 0; i2 < 50; ++i2) {
        this.s[i2] = 0;
      }
    }
    Keccak.prototype.update = function(message) {
      if (this.finalized) {
        throw new Error(FINALIZE_ERROR);
      }
      var notString, type = typeof message;
      if (type !== "string") {
        if (type === "object") {
          if (message === null) {
            throw new Error(INPUT_ERROR);
          } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
            message = new Uint8Array(message);
          } else if (!Array.isArray(message)) {
            if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
              throw new Error(INPUT_ERROR);
            }
          }
        } else {
          throw new Error(INPUT_ERROR);
        }
        notString = true;
      }
      var blocks = this.blocks, byteCount = this.byteCount, length2 = message.length, blockCount = this.blockCount, index = 0, s = this.s, i2, code;
      while (index < length2) {
        if (this.reset) {
          this.reset = false;
          blocks[0] = this.block;
          for (i2 = 1; i2 < blockCount + 1; ++i2) {
            blocks[i2] = 0;
          }
        }
        if (notString) {
          for (i2 = this.start; index < length2 && i2 < byteCount; ++index) {
            blocks[i2 >> 2] |= message[index] << SHIFT[i2++ & 3];
          }
        } else {
          for (i2 = this.start; index < length2 && i2 < byteCount; ++index) {
            code = message.charCodeAt(index);
            if (code < 128) {
              blocks[i2 >> 2] |= code << SHIFT[i2++ & 3];
            } else if (code < 2048) {
              blocks[i2 >> 2] |= (192 | code >> 6) << SHIFT[i2++ & 3];
              blocks[i2 >> 2] |= (128 | code & 63) << SHIFT[i2++ & 3];
            } else if (code < 55296 || code >= 57344) {
              blocks[i2 >> 2] |= (224 | code >> 12) << SHIFT[i2++ & 3];
              blocks[i2 >> 2] |= (128 | code >> 6 & 63) << SHIFT[i2++ & 3];
              blocks[i2 >> 2] |= (128 | code & 63) << SHIFT[i2++ & 3];
            } else {
              code = 65536 + ((code & 1023) << 10 | message.charCodeAt(++index) & 1023);
              blocks[i2 >> 2] |= (240 | code >> 18) << SHIFT[i2++ & 3];
              blocks[i2 >> 2] |= (128 | code >> 12 & 63) << SHIFT[i2++ & 3];
              blocks[i2 >> 2] |= (128 | code >> 6 & 63) << SHIFT[i2++ & 3];
              blocks[i2 >> 2] |= (128 | code & 63) << SHIFT[i2++ & 3];
            }
          }
        }
        this.lastByteIndex = i2;
        if (i2 >= byteCount) {
          this.start = i2 - byteCount;
          this.block = blocks[blockCount];
          for (i2 = 0; i2 < blockCount; ++i2) {
            s[i2] ^= blocks[i2];
          }
          f2(s);
          this.reset = true;
        } else {
          this.start = i2;
        }
      }
      return this;
    };
    Keccak.prototype.encode = function(x2, right) {
      var o = x2 & 255, n2 = 1;
      var bytes = [o];
      x2 = x2 >> 8;
      o = x2 & 255;
      while (o > 0) {
        bytes.unshift(o);
        x2 = x2 >> 8;
        o = x2 & 255;
        ++n2;
      }
      if (right) {
        bytes.push(n2);
      } else {
        bytes.unshift(n2);
      }
      this.update(bytes);
      return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
      var notString, type = typeof str;
      if (type !== "string") {
        if (type === "object") {
          if (str === null) {
            throw new Error(INPUT_ERROR);
          } else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) {
            str = new Uint8Array(str);
          } else if (!Array.isArray(str)) {
            if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) {
              throw new Error(INPUT_ERROR);
            }
          }
        } else {
          throw new Error(INPUT_ERROR);
        }
        notString = true;
      }
      var bytes = 0, length2 = str.length;
      if (notString) {
        bytes = length2;
      } else {
        for (var i2 = 0; i2 < str.length; ++i2) {
          var code = str.charCodeAt(i2);
          if (code < 128) {
            bytes += 1;
          } else if (code < 2048) {
            bytes += 2;
          } else if (code < 55296 || code >= 57344) {
            bytes += 3;
          } else {
            code = 65536 + ((code & 1023) << 10 | str.charCodeAt(++i2) & 1023);
            bytes += 4;
          }
        }
      }
      bytes += this.encode(bytes * 8);
      this.update(str);
      return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w2) {
      var bytes = this.encode(w2);
      for (var i2 = 0; i2 < strs.length; ++i2) {
        bytes += this.encodeString(strs[i2]);
      }
      var paddingBytes = w2 - bytes % w2;
      var zeros2 = [];
      zeros2.length = paddingBytes;
      this.update(zeros2);
      return this;
    };
    Keccak.prototype.finalize = function() {
      if (this.finalized) {
        return;
      }
      this.finalized = true;
      var blocks = this.blocks, i2 = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
      blocks[i2 >> 2] |= this.padding[i2 & 3];
      if (this.lastByteIndex === this.byteCount) {
        blocks[0] = blocks[blockCount];
        for (i2 = 1; i2 < blockCount + 1; ++i2) {
          blocks[i2] = 0;
        }
      }
      blocks[blockCount - 1] |= 2147483648;
      for (i2 = 0; i2 < blockCount; ++i2) {
        s[i2] ^= blocks[i2];
      }
      f2(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
      this.finalize();
      var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i2 = 0, j2 = 0;
      var hex = "", block;
      while (j2 < outputBlocks) {
        for (i2 = 0; i2 < blockCount && j2 < outputBlocks; ++i2, ++j2) {
          block = s[i2];
          hex += HEX_CHARS[block >> 4 & 15] + HEX_CHARS[block & 15] + HEX_CHARS[block >> 12 & 15] + HEX_CHARS[block >> 8 & 15] + HEX_CHARS[block >> 20 & 15] + HEX_CHARS[block >> 16 & 15] + HEX_CHARS[block >> 28 & 15] + HEX_CHARS[block >> 24 & 15];
        }
        if (j2 % blockCount === 0) {
          f2(s);
          i2 = 0;
        }
      }
      if (extraBytes) {
        block = s[i2];
        hex += HEX_CHARS[block >> 4 & 15] + HEX_CHARS[block & 15];
        if (extraBytes > 1) {
          hex += HEX_CHARS[block >> 12 & 15] + HEX_CHARS[block >> 8 & 15];
        }
        if (extraBytes > 2) {
          hex += HEX_CHARS[block >> 20 & 15] + HEX_CHARS[block >> 16 & 15];
        }
      }
      return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
      this.finalize();
      var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i2 = 0, j2 = 0;
      var bytes = this.outputBits >> 3;
      var buffer;
      if (extraBytes) {
        buffer = new ArrayBuffer(outputBlocks + 1 << 2);
      } else {
        buffer = new ArrayBuffer(bytes);
      }
      var array = new Uint32Array(buffer);
      while (j2 < outputBlocks) {
        for (i2 = 0; i2 < blockCount && j2 < outputBlocks; ++i2, ++j2) {
          array[j2] = s[i2];
        }
        if (j2 % blockCount === 0) {
          f2(s);
        }
      }
      if (extraBytes) {
        array[i2] = s[i2];
        buffer = buffer.slice(0, bytes);
      }
      return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
      this.finalize();
      var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i2 = 0, j2 = 0;
      var array = [], offset, block;
      while (j2 < outputBlocks) {
        for (i2 = 0; i2 < blockCount && j2 < outputBlocks; ++i2, ++j2) {
          offset = j2 << 2;
          block = s[i2];
          array[offset] = block & 255;
          array[offset + 1] = block >> 8 & 255;
          array[offset + 2] = block >> 16 & 255;
          array[offset + 3] = block >> 24 & 255;
        }
        if (j2 % blockCount === 0) {
          f2(s);
        }
      }
      if (extraBytes) {
        offset = j2 << 2;
        block = s[i2];
        array[offset] = block & 255;
        if (extraBytes > 1) {
          array[offset + 1] = block >> 8 & 255;
        }
        if (extraBytes > 2) {
          array[offset + 2] = block >> 16 & 255;
        }
      }
      return array;
    };
    function Kmac(bits2, padding, outputBits) {
      Keccak.call(this, bits2, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
      this.encode(this.outputBits, true);
      return Keccak.prototype.finalize.call(this);
    };
    var f2 = function(s) {
      var h2, l2, n2, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
      for (n2 = 0; n2 < 48; n2 += 2) {
        c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
        c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
        c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
        c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
        c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
        c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
        c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
        c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
        c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
        c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
        h2 = c8 ^ (c2 << 1 | c3 >>> 31);
        l2 = c9 ^ (c3 << 1 | c2 >>> 31);
        s[0] ^= h2;
        s[1] ^= l2;
        s[10] ^= h2;
        s[11] ^= l2;
        s[20] ^= h2;
        s[21] ^= l2;
        s[30] ^= h2;
        s[31] ^= l2;
        s[40] ^= h2;
        s[41] ^= l2;
        h2 = c0 ^ (c4 << 1 | c5 >>> 31);
        l2 = c1 ^ (c5 << 1 | c4 >>> 31);
        s[2] ^= h2;
        s[3] ^= l2;
        s[12] ^= h2;
        s[13] ^= l2;
        s[22] ^= h2;
        s[23] ^= l2;
        s[32] ^= h2;
        s[33] ^= l2;
        s[42] ^= h2;
        s[43] ^= l2;
        h2 = c2 ^ (c6 << 1 | c7 >>> 31);
        l2 = c3 ^ (c7 << 1 | c6 >>> 31);
        s[4] ^= h2;
        s[5] ^= l2;
        s[14] ^= h2;
        s[15] ^= l2;
        s[24] ^= h2;
        s[25] ^= l2;
        s[34] ^= h2;
        s[35] ^= l2;
        s[44] ^= h2;
        s[45] ^= l2;
        h2 = c4 ^ (c8 << 1 | c9 >>> 31);
        l2 = c5 ^ (c9 << 1 | c8 >>> 31);
        s[6] ^= h2;
        s[7] ^= l2;
        s[16] ^= h2;
        s[17] ^= l2;
        s[26] ^= h2;
        s[27] ^= l2;
        s[36] ^= h2;
        s[37] ^= l2;
        s[46] ^= h2;
        s[47] ^= l2;
        h2 = c6 ^ (c0 << 1 | c1 >>> 31);
        l2 = c7 ^ (c1 << 1 | c0 >>> 31);
        s[8] ^= h2;
        s[9] ^= l2;
        s[18] ^= h2;
        s[19] ^= l2;
        s[28] ^= h2;
        s[29] ^= l2;
        s[38] ^= h2;
        s[39] ^= l2;
        s[48] ^= h2;
        s[49] ^= l2;
        b0 = s[0];
        b1 = s[1];
        b32 = s[11] << 4 | s[10] >>> 28;
        b33 = s[10] << 4 | s[11] >>> 28;
        b14 = s[20] << 3 | s[21] >>> 29;
        b15 = s[21] << 3 | s[20] >>> 29;
        b46 = s[31] << 9 | s[30] >>> 23;
        b47 = s[30] << 9 | s[31] >>> 23;
        b28 = s[40] << 18 | s[41] >>> 14;
        b29 = s[41] << 18 | s[40] >>> 14;
        b20 = s[2] << 1 | s[3] >>> 31;
        b21 = s[3] << 1 | s[2] >>> 31;
        b2 = s[13] << 12 | s[12] >>> 20;
        b3 = s[12] << 12 | s[13] >>> 20;
        b34 = s[22] << 10 | s[23] >>> 22;
        b35 = s[23] << 10 | s[22] >>> 22;
        b16 = s[33] << 13 | s[32] >>> 19;
        b17 = s[32] << 13 | s[33] >>> 19;
        b48 = s[42] << 2 | s[43] >>> 30;
        b49 = s[43] << 2 | s[42] >>> 30;
        b40 = s[5] << 30 | s[4] >>> 2;
        b41 = s[4] << 30 | s[5] >>> 2;
        b22 = s[14] << 6 | s[15] >>> 26;
        b23 = s[15] << 6 | s[14] >>> 26;
        b4 = s[25] << 11 | s[24] >>> 21;
        b5 = s[24] << 11 | s[25] >>> 21;
        b36 = s[34] << 15 | s[35] >>> 17;
        b37 = s[35] << 15 | s[34] >>> 17;
        b18 = s[45] << 29 | s[44] >>> 3;
        b19 = s[44] << 29 | s[45] >>> 3;
        b10 = s[6] << 28 | s[7] >>> 4;
        b11 = s[7] << 28 | s[6] >>> 4;
        b42 = s[17] << 23 | s[16] >>> 9;
        b43 = s[16] << 23 | s[17] >>> 9;
        b24 = s[26] << 25 | s[27] >>> 7;
        b25 = s[27] << 25 | s[26] >>> 7;
        b6 = s[36] << 21 | s[37] >>> 11;
        b7 = s[37] << 21 | s[36] >>> 11;
        b38 = s[47] << 24 | s[46] >>> 8;
        b39 = s[46] << 24 | s[47] >>> 8;
        b30 = s[8] << 27 | s[9] >>> 5;
        b31 = s[9] << 27 | s[8] >>> 5;
        b12 = s[18] << 20 | s[19] >>> 12;
        b13 = s[19] << 20 | s[18] >>> 12;
        b44 = s[29] << 7 | s[28] >>> 25;
        b45 = s[28] << 7 | s[29] >>> 25;
        b26 = s[38] << 8 | s[39] >>> 24;
        b27 = s[39] << 8 | s[38] >>> 24;
        b8 = s[48] << 14 | s[49] >>> 18;
        b9 = s[49] << 14 | s[48] >>> 18;
        s[0] = b0 ^ ~b2 & b4;
        s[1] = b1 ^ ~b3 & b5;
        s[10] = b10 ^ ~b12 & b14;
        s[11] = b11 ^ ~b13 & b15;
        s[20] = b20 ^ ~b22 & b24;
        s[21] = b21 ^ ~b23 & b25;
        s[30] = b30 ^ ~b32 & b34;
        s[31] = b31 ^ ~b33 & b35;
        s[40] = b40 ^ ~b42 & b44;
        s[41] = b41 ^ ~b43 & b45;
        s[2] = b2 ^ ~b4 & b6;
        s[3] = b3 ^ ~b5 & b7;
        s[12] = b12 ^ ~b14 & b16;
        s[13] = b13 ^ ~b15 & b17;
        s[22] = b22 ^ ~b24 & b26;
        s[23] = b23 ^ ~b25 & b27;
        s[32] = b32 ^ ~b34 & b36;
        s[33] = b33 ^ ~b35 & b37;
        s[42] = b42 ^ ~b44 & b46;
        s[43] = b43 ^ ~b45 & b47;
        s[4] = b4 ^ ~b6 & b8;
        s[5] = b5 ^ ~b7 & b9;
        s[14] = b14 ^ ~b16 & b18;
        s[15] = b15 ^ ~b17 & b19;
        s[24] = b24 ^ ~b26 & b28;
        s[25] = b25 ^ ~b27 & b29;
        s[34] = b34 ^ ~b36 & b38;
        s[35] = b35 ^ ~b37 & b39;
        s[44] = b44 ^ ~b46 & b48;
        s[45] = b45 ^ ~b47 & b49;
        s[6] = b6 ^ ~b8 & b0;
        s[7] = b7 ^ ~b9 & b1;
        s[16] = b16 ^ ~b18 & b10;
        s[17] = b17 ^ ~b19 & b11;
        s[26] = b26 ^ ~b28 & b20;
        s[27] = b27 ^ ~b29 & b21;
        s[36] = b36 ^ ~b38 & b30;
        s[37] = b37 ^ ~b39 & b31;
        s[46] = b46 ^ ~b48 & b40;
        s[47] = b47 ^ ~b49 & b41;
        s[8] = b8 ^ ~b0 & b2;
        s[9] = b9 ^ ~b1 & b3;
        s[18] = b18 ^ ~b10 & b12;
        s[19] = b19 ^ ~b11 & b13;
        s[28] = b28 ^ ~b20 & b22;
        s[29] = b29 ^ ~b21 & b23;
        s[38] = b38 ^ ~b30 & b32;
        s[39] = b39 ^ ~b31 & b33;
        s[48] = b48 ^ ~b40 & b42;
        s[49] = b49 ^ ~b41 & b43;
        s[0] ^= RC[n2];
        s[1] ^= RC[n2 + 1];
      }
    };
    if (COMMON_JS) {
      module.exports = methods;
    } else {
      for (i = 0; i < methodNames.length; ++i) {
        root[methodNames[i]] = methods[methodNames[i]];
      }
    }
  })();
})(sha3$1);
var sha3 = sha3$1.exports;
function keccak256(data) {
  return "0x" + sha3.keccak_256(arrayify(data));
}
const version$1 = "address/5.6.1";
const logger$1 = new Logger(version$1);
function getChecksumAddress(address) {
  if (!isHexString(address, 20)) {
    logger$1.throwArgumentError("invalid address", "address", address);
  }
  address = address.toLowerCase();
  const chars = address.substring(2).split("");
  const expanded = new Uint8Array(40);
  for (let i = 0; i < 40; i++) {
    expanded[i] = chars[i].charCodeAt(0);
  }
  const hashed = arrayify(keccak256(expanded));
  for (let i = 0; i < 40; i += 2) {
    if (hashed[i >> 1] >> 4 >= 8) {
      chars[i] = chars[i].toUpperCase();
    }
    if ((hashed[i >> 1] & 15) >= 8) {
      chars[i + 1] = chars[i + 1].toUpperCase();
    }
  }
  return "0x" + chars.join("");
}
const MAX_SAFE_INTEGER = 9007199254740991;
function log10(x2) {
  if (Math.log10) {
    return Math.log10(x2);
  }
  return Math.log(x2) / Math.LN10;
}
const ibanLookup = {};
for (let i = 0; i < 10; i++) {
  ibanLookup[String(i)] = String(i);
}
for (let i = 0; i < 26; i++) {
  ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
}
const safeDigits = Math.floor(log10(MAX_SAFE_INTEGER));
function ibanChecksum(address) {
  address = address.toUpperCase();
  address = address.substring(4) + address.substring(0, 2) + "00";
  let expanded = address.split("").map((c2) => {
    return ibanLookup[c2];
  }).join("");
  while (expanded.length >= safeDigits) {
    let block = expanded.substring(0, safeDigits);
    expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
  }
  let checksum = String(98 - parseInt(expanded, 10) % 97);
  while (checksum.length < 2) {
    checksum = "0" + checksum;
  }
  return checksum;
}
function getAddress(address) {
  let result = null;
  if (typeof address !== "string") {
    logger$1.throwArgumentError("invalid address", "address", address);
  }
  if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
    if (address.substring(0, 2) !== "0x") {
      address = "0x" + address;
    }
    result = getChecksumAddress(address);
    if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) {
      logger$1.throwArgumentError("bad address checksum", "address", address);
    }
  } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
    if (address.substring(2, 4) !== ibanChecksum(address)) {
      logger$1.throwArgumentError("bad icap checksum", "address", address);
    }
    result = _base36To16(address.substring(4));
    while (result.length < 40) {
      result = "0" + result;
    }
    result = getChecksumAddress("0x" + result);
  } else {
    logger$1.throwArgumentError("invalid address", "address", address);
  }
  return result;
}
function isAddress(address) {
  try {
    getAddress(address);
    return true;
  } catch (error) {
  }
  return false;
}
const version = "units/5.6.1";
const logger = new Logger(version);
const names = [
  "wei",
  "kwei",
  "mwei",
  "gwei",
  "szabo",
  "finney",
  "ether"
];
function parseUnits(value, unitName) {
  if (typeof value !== "string") {
    logger.throwArgumentError("value must be a string", "value", value);
  }
  if (typeof unitName === "string") {
    const index = names.indexOf(unitName);
    if (index !== -1) {
      unitName = 3 * index;
    }
  }
  return parseFixed(value, unitName != null ? unitName : 18);
}
function parseEther(ether) {
  return parseUnits(ether, 18);
}
const EthereumSelectNFT = ({
  updateUnifiedAccessControlConditions,
  submitDisabled,
  chain,
  initialState = null
}) => {
  const [tokenId, setTokenId] = useState("");
  const [selectedToken, setSelectedToken] = useState({});
  const [contractAddress, setContractAddress] = useState("");
  const [addressIsValid, setAddressIsValid] = useState(false);
  const {
    wipeInitialProps
  } = useContext(ShareModalContext);
  useEffect(() => {
    if (initialState) {
      if (initialState["NFTAddress"]) {
        setContractAddress(initialState["NFTAddress"]);
        handleSubmit(initialState["NFTAddress"]);
      }
      if (initialState["NFTTokenId"]) {
        setTokenId(initialState["NFTTokenId"]);
      }
    }
    wipeInitialProps();
  }, []);
  useEffect(() => {
    if (!!contractAddress) {
      handleSubmit(contractAddress);
    }
  }, [chain, tokenId, contractAddress]);
  useEffect(() => {
    if (selectedToken === null) {
      setContractAddress("");
    }
    if ((selectedToken == null ? void 0 : selectedToken["value"]) === "ethereum") {
      setContractAddress("");
    }
    if ((selectedToken == null ? void 0 : selectedToken["value"]) && isAddress(selectedToken == null ? void 0 : selectedToken["value"])) {
      setContractAddress(selectedToken["value"]);
    }
  }, [selectedToken]);
  const handleSubmit = (address) => {
    const isValid = chain.addressValidator(address);
    setAddressIsValid(isValid);
    submitDisabled(!address || !address.length || !tokenId.length || !isValid);
    const unifiedAccessControlConditions = [{
      conditionType: "evmBasic",
      contractAddress: address,
      standardContractType: "ERC721",
      chain: chain["value"],
      method: "ownerOf",
      parameters: [tokenId],
      returnValueTest: {
        comparator: "=",
        value: ":userAddress"
      }
    }];
    updateUnifiedAccessControlConditions(unifiedAccessControlConditions);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-condition-container",
    children: [/* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "Which NFT's should be able to access this asset?"
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "Select token or enter contract address"
    }), /* @__PURE__ */ jsx$1(LitTokenSelect, {
      option: selectedToken,
      label: !selectedToken || !selectedToken["label"] ? "Search for a token/NFT" : selectedToken.label,
      selectedToken,
      setSelectedToken
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "Contract Address"
    }), /* @__PURE__ */ jsx$1(LitInput, {
      value: contractAddress,
      disabled: selectedToken == null ? void 0 : selectedToken["value"],
      setValue: setContractAddress,
      errorMessage: addressIsValid ? null : "Address is invalid",
      placeholder: "ERC721 Address"
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "Add Token ID"
    }), /* @__PURE__ */ jsx$1(LitInput, {
      value: tokenId,
      setValue: setTokenId
    })]
  });
};
let devModeIsAllowed = false;
const setDevModeIsAllowed = (allow) => {
  devModeIsAllowed = allow;
};
const logDevError = (message) => {
  if (devModeIsAllowed) {
    console.log(`Error in Lit Share Modal - ${message}`);
  }
};
const checkPropTypes = (props) => {
  if (props["chainsAllowed"] && !Array.isArray(props["chainsAllowed"])) {
    logDevError("'chainsAllowed' prop must be an array.");
  }
  if (props["defaultChain"] && typeof props["defaultChain"] !== "string") {
    logDevError("'defaultChain' prop must be a string.");
  }
  if (props["injectCSS"] && typeof props["injectCSS"] !== "boolean") {
    logDevError("'injectCSS' prop must be a boolean.");
  }
  if (props["allowChainSelector"] && typeof props["allowChainSelector"] !== "boolean") {
    logDevError("'allowChainSelector' prop must be a boolean.");
  }
  if (props["allowMultipleConditions"] && typeof props["allowMultipleConditions"] !== "boolean") {
    logDevError("'allowMultipleConditions' prop must be a boolean.");
  }
  if (props["permanentDefault"] && typeof props["permanentDefault"] !== "boolean") {
    logDevError("'permanentDefault' prop must be a boolean.");
  }
  if (props["isModal"] && typeof props["isModal"] !== "boolean") {
    logDevError("'isModal' prop must be a boolean.");
  }
  if (props["allowDevMode"] && typeof props["allowDevMode"] !== "boolean") {
    setDevModeIsAllowed(true);
    logDevError("'allowDevMode' prop must be a boolean.");
    setDevModeIsAllowed(false);
  }
  if (props["injectInitialState"] && typeof props["injectInitialState"] !== "boolean") {
    logDevError("'injectInitialState' prop must be a boolean.");
  }
  if (props["initialFlow"] && (props["initialFlow"] !== "singleCondition" || props["initialFlow"] !== "multipleConditions")) {
    logDevError("'initialFlow' prop must be either `singleCondition` or `multipleConditions`.");
  }
  if (props["initialState"] && typeof props["initialState"] !== "string") {
    logDevError("'initialState' prop must be a string.");
  }
};
const getAllowedConditionTypes = (chainData, conditionsAllowed = null) => {
  if (!conditionsAllowed) {
    return chainData;
  } else {
    const chainDataHolder = chainData;
    const chainConditionsAllowed = {};
    conditionsAllowed.forEach((c2) => {
      if (!!chainData.types.conditionTypes[c2]) {
        chainConditionsAllowed[c2] = chainData.types.conditionTypes[c2];
      } else {
        logDevError(`condition '${c2}' not found or not supported for this chain.`);
      }
    });
    chainDataHolder.types.conditionTypes = chainConditionsAllowed;
    return chainDataHolder;
  }
};
const getAllowedConditions = (chainsAllowed, conditionsAllowed, defaultAllowedChainsObj) => {
  const currentlyAllowedChains = [];
  chainsAllowed.forEach((c2) => {
    if (!!defaultAllowedChainsObj[c2]) {
      let chainData = defaultAllowedChainsObj[c2];
      chainData = getAllowedConditionTypes(chainData, conditionsAllowed[c2]);
      currentlyAllowedChains.push(chainData);
    } else {
      logDevError(`chain '${c2}' not found. Check the spelling.`);
    }
  });
  return currentlyAllowedChains;
};
const stripNestedArray = (unifiedAccessControlConditions) => {
  if (unifiedAccessControlConditions.length === 1 && Array.isArray(unifiedAccessControlConditions[0])) {
    return stripNestedArray(unifiedAccessControlConditions[0]);
  } else {
    return unifiedAccessControlConditions;
  }
};
const EthereumSelectGroup = ({
  updateUnifiedAccessControlConditions,
  submitDisabled,
  chain,
  initialState = null
}) => {
  const [amount, setAmount] = useState("");
  const [selectedToken, setSelectedToken] = useState({});
  const [contractAddress, setContractAddress] = useState("");
  const [contractType, setContractType] = useState("");
  const [erc1155TokenId, setErc1155TokenId] = useState("");
  const [addressIsValid, setAddressIsValid] = useState(false);
  const {
    wipeInitialProps
  } = useContext(ShareModalContext);
  useEffect(() => {
    if (initialState) {
      if (initialState["groupAddress"]) {
        setContractAddress(initialState["groupAddress"]);
      }
      if (initialState["groupContractType"]) {
        handleChangeContractType(initialState["groupContractType"].toUpperCase());
      }
      if (initialState["groupAmount"]) {
        setAmount(initialState["groupAmount"]);
      }
      if (initialState["groupErc1155TokenId"]) {
        setErc1155TokenId(initialState["groupErc1155TokenId"]);
      }
    }
    wipeInitialProps();
  }, []);
  useEffect(() => {
    if (selectedToken === null) {
      setContractAddress("");
      setContractType("");
    }
    if ((selectedToken == null ? void 0 : selectedToken["value"]) === "ethereum") {
      setContractAddress("");
    }
    if ((selectedToken == null ? void 0 : selectedToken["value"]) && isAddress(selectedToken == null ? void 0 : selectedToken["value"])) {
      setContractAddress(selectedToken["value"]);
    }
    if (selectedToken == null ? void 0 : selectedToken["standard"]) {
      setContractType(selectedToken["standard"].toUpperCase());
    }
  }, [selectedToken]);
  useEffect(() => {
    if (contractAddress.length && !!selectedToken && contractAddress !== selectedToken["value"]) {
      setSelectedToken({});
    }
    const contractIsValid = chain.addressValidator(contractAddress);
    setAddressIsValid(contractIsValid);
  }, [contractAddress]);
  useEffect(() => {
    const itIsValid = isValid();
    handleSubmit();
    submitDisabled(itIsValid);
  }, [amount, addressIsValid, contractAddress, chain, selectedToken, contractType, erc1155TokenId]);
  const isValid = () => {
    if ((selectedToken == null ? void 0 : selectedToken["value"]) === "ethereum") {
      return !amount;
    }
    return !amount || !addressIsValid || !contractAddress.length || !contractType.length || contractType === "ERC1155" && !erc1155TokenId.length;
  };
  const checkEthereum = () => {
    const amountInWei = parseEther(amount);
    const unifiedAccessControlConditions = [{
      conditionType: "evmBasic",
      contractAddress: "",
      standardContractType: "",
      chain: chain["value"],
      method: "eth_getBalance",
      parameters: [":userAddress", "latest"],
      returnValueTest: {
        comparator: ">=",
        value: amountInWei.toString()
      }
    }];
    saveCondition(unifiedAccessControlConditions);
  };
  const checkERC1155 = () => {
    const unifiedAccessControlConditions = [{
      conditionType: "evmBasic",
      contractAddress,
      standardContractType: contractType,
      chain: chain["value"],
      method: "balanceOf",
      parameters: [":userAddress", erc1155TokenId],
      returnValueTest: {
        comparator: ">=",
        value: amount.toString()
      }
    }];
    saveCondition(unifiedAccessControlConditions);
  };
  const checkERC721 = () => {
    const unifiedAccessControlConditions = [{
      conditionType: "evmBasic",
      contractAddress,
      standardContractType: contractType,
      chain: chain["value"],
      method: "balanceOf",
      parameters: [":userAddress"],
      returnValueTest: {
        comparator: ">=",
        value: amount.toString()
      }
    }];
    saveCondition(unifiedAccessControlConditions);
  };
  const checkERC20 = async () => {
    let decimals = 0;
    let unifiedAccessControlConditions;
    try {
      decimals = await LitJsSdk.decimalPlaces({
        chain: chain["value"],
        contractAddress
      });
    } catch (e2) {
      logDevError(e2);
    }
    let amountInBaseUnit;
    try {
      amountInBaseUnit = parseUnits(amount, decimals);
    } catch (err) {
      logDevError(err);
    }
    try {
      unifiedAccessControlConditions = [{
        conditionType: "evmBasic",
        contractAddress,
        standardContractType: contractType,
        chain: chain["value"],
        method: "balanceOf",
        parameters: [":userAddress"],
        returnValueTest: {
          comparator: ">=",
          value: amountInBaseUnit.toString()
        }
      }];
    } catch (err) {
      logDevError(err);
      return;
    }
    saveCondition(unifiedAccessControlConditions);
  };
  const saveCondition = (uacc) => {
    updateUnifiedAccessControlConditions(uacc);
  };
  const handleSubmit = async () => {
    if (isValid()) {
      return;
    }
    if (selectedToken && selectedToken.value === "ethereum") {
      checkEthereum();
    } else if (contractType === "ERC1155") {
      checkERC1155();
    } else if (contractType === "ERC721") {
      checkERC721();
    } else if (contractType === "ERC20") {
      await checkERC20();
    }
  };
  const handleChangeContractType = (value) => {
    setContractType(value);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-condition-container",
    children: [/* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "Which group should be able to access this asset?"
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "Select token/NFT or enter contract address:"
    }), /* @__PURE__ */ jsx$1(LitTokenSelect, {
      option: selectedToken,
      label: !selectedToken || !selectedToken["label"] ? "Search for a token/NFT" : selectedToken.label,
      selectedToken,
      setSelectedToken,
      allowEthereum: true
    }), (selectedToken == null ? void 0 : selectedToken["value"]) !== "ethereum" && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx$1("h3", {
        className: "lsm-condition-prompt-text",
        children: "Contract Address"
      }), /* @__PURE__ */ jsx$1(LitInput, {
        value: contractAddress,
        disabled: selectedToken == null ? void 0 : selectedToken["value"],
        setValue: setContractAddress,
        errorMessage: addressIsValid ? null : "Address is invalid",
        placeholder: "ERC20 or ERC721 or ERC1155 address"
      }), !!contractAddress.length && addressIsValid && /* @__PURE__ */ jsxs("div", {
        className: "",
        children: [/* @__PURE__ */ jsx$1("h3", {
          className: "lsm-condition-prompt-text",
          children: "Token Contract Type:"
        }), /* @__PURE__ */ jsxs("span", {
          onChange: (e2) => handleChangeContractType(e2.target.value),
          className: "lsm-radio-container",
          children: [/* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsx$1("input", {
              disabled: (selectedToken == null ? void 0 : selectedToken["standard"]) && (selectedToken == null ? void 0 : selectedToken.standard) === contractType,
              readOnly: true,
              checked: contractType === "ERC20",
              type: "radio",
              id: "erc20",
              name: "addressType",
              value: "ERC20"
            }), /* @__PURE__ */ jsx$1("label", {
              className: "lsm-radio-label",
              htmlFor: "erc20",
              children: "ERC20"
            })]
          }), /* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsx$1("input", {
              disabled: (selectedToken == null ? void 0 : selectedToken["standard"]) && (selectedToken == null ? void 0 : selectedToken.standard) === contractType,
              readOnly: true,
              checked: contractType === "ERC721",
              type: "radio",
              id: "erc721",
              name: "addressType",
              value: "ERC721"
            }), /* @__PURE__ */ jsx$1("label", {
              className: "lsm-radio-label",
              htmlFor: "erc721",
              children: "ERC721"
            })]
          }), /* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsx$1("input", {
              disabled: (selectedToken == null ? void 0 : selectedToken["standard"]) && (selectedToken == null ? void 0 : selectedToken.standard) === contractType,
              readOnly: true,
              checked: contractType === "ERC1155",
              type: "radio",
              id: "erc1155",
              name: "addressType",
              value: "ERC1155"
            }), /* @__PURE__ */ jsx$1("label", {
              className: "lsm-radio-label",
              htmlFor: "erc1155",
              children: "ERC1155"
            })]
          })]
        })]
      }), !!contractAddress.length && contractType === "ERC1155" && /* @__PURE__ */ jsx$1(LitInput, {
        value: erc1155TokenId,
        setValue: setErc1155TokenId,
        placeholder: "ERC1155 Token Id"
      })]
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "How many tokens does the wallet need to own?"
    }), /* @__PURE__ */ jsx$1(LitInput, {
      value: amount,
      setValue: (e2) => setAmount(e2),
      errorMessage: isNaN(parseFloat(amount)) ? "Must be a number" : null,
      placeholder: "##"
    })]
  });
};
const EthereumSelectDAO = ({
  updateUnifiedAccessControlConditions,
  submitDisabled,
  chain,
  initialState = null
}) => {
  const [DAOAddress, setDAOAddress] = useState("");
  const [DAOName, setDAOName] = useState(null);
  const {
    wipeInitialProps
  } = useContext(ShareModalContext);
  useEffect(() => {
    if (initialState) {
      if (initialState["DAOAddress"] && initialState["DAOAddress"].length) {
        setDAOAddress(initialState["DAOAddress"]);
      }
      if (initialState["DAOName"] && initialState["DAOName"].length) {
        console.log(initialState["DAOName"]);
        setDAOName(initialState["DAOName"]);
      }
    }
    wipeInitialProps();
  }, []);
  useEffect(() => {
    if (DAOAddress.length) {
      handleSubmit();
    }
    submitDisabled(!DAOAddress.length);
  }, [DAOAddress, chain]);
  const handleSubmit = () => {
    const unifiedAccessControlConditions = [{
      conditionType: "evmBasic",
      contractAddress: DAOAddress,
      standardContractType: "MolochDAOv2.1",
      chain: chain.value,
      method: "members",
      parameters: [":userAddress"],
      returnValueTest: {
        comparator: "=",
        value: "true"
      }
    }];
    updateUnifiedAccessControlConditions(unifiedAccessControlConditions);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-condition-container",
    children: [/* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "Which DAO's members should be able to access this asset?"
    }), DAOName && (initialState == null ? void 0 : initialState["DAOAddress"]) && DAOAddress === initialState["DAOAddress"] && /* @__PURE__ */ jsxs("h3", {
      className: "lsm-condition-prompt-text",
      children: ["DAO Name: ", /* @__PURE__ */ jsx$1("strong", {
        children: DAOName
      })]
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "Add DAO contract address:"
    }), /* @__PURE__ */ jsx$1(LitInput, {
      value: DAOAddress,
      setValue: setDAOAddress
    }), /* @__PURE__ */ jsx$1("p", {
      className: "lsm-condition-prompt-text",
      children: "Lit Gateway currently supports DAOs using the MolochDAOv2.1 contract (includes DAOhaus)"
    })]
  });
};
const typesOfPoapGate = [{
  label: "By POAP ID",
  id: "eventId",
  value: "="
}, {
  label: "By POAP Name",
  id: "tokenURI",
  value: "="
}];
const matchConditionOptions = [{
  label: "Contains POAP Name",
  id: "contains",
  value: "contains"
}, {
  label: "Equals POAP Name exactly",
  id: "equals",
  value: "="
}];
const EthereumSelectPOAP = ({
  updateUnifiedAccessControlConditions,
  submitDisabled,
  initialState = null
}) => {
  const [poapGateType, setPoapGateType] = useState(typesOfPoapGate[0]);
  const [poapId, setPoapId] = useState("");
  const [poapName, setPoapName] = useState("");
  const [nameMatchCondition, setNameMatchCondition] = useState(matchConditionOptions[0]);
  const [render, setRender] = useState(false);
  const {
    wipeInitialProps
  } = useContext(ShareModalContext);
  useEffect(() => {
    if (initialState) {
      if (initialState["poapName"]) {
        setPoapGateType(typesOfPoapGate[1]);
        setPoapName(initialState["poapName"]);
        if (initialState["poapMatchCondition"] === "contains") {
          setNameMatchCondition(matchConditionOptions[0]);
        } else if (initialState["poapMatchCondition"] === "equals") {
          setNameMatchCondition(matchConditionOptions[1]);
        }
      } else if (initialState["poapId"]) {
        setPoapGateType(typesOfPoapGate[0]);
        setPoapId(initialState["poapId"]);
        setNameMatchCondition(matchConditionOptions[1]);
      }
    }
    setRender(true);
    wipeInitialProps();
  }, []);
  useEffect(() => {
    if (!poapId.length || !poapName.length || !nameMatchCondition) {
      handleSubmit();
    }
    submitDisabled(poapGateType.id === "eventId" ? !poapId.length : !poapName.length || !nameMatchCondition);
  }, [poapGateType, poapId, poapName, nameMatchCondition]);
  const getComparator = (type) => {
    if (type === "eventId") {
      return "=";
    } else {
      return nameMatchCondition.value;
    }
  };
  const handleSubmit = () => {
    const unifiedAccessControlConditions = [[{
      conditionType: "evmBasic",
      contractAddress: "0x22C1f6050E56d2876009903609a2cC3fEf83B415",
      standardContractType: "POAP",
      chain: "xdai",
      method: poapGateType.id,
      parameters: [],
      returnValueTest: {
        comparator: getComparator(poapGateType.id),
        value: poapGateType.id === "eventId" ? poapId : poapName
      }
    }, {
      operator: "or"
    }, {
      conditionType: "evmBasic",
      contractAddress: "0x22C1f6050E56d2876009903609a2cC3fEf83B415",
      standardContractType: "POAP",
      chain: "ethereum",
      method: poapGateType.id,
      parameters: [],
      returnValueTest: {
        comparator: getComparator(poapGateType.id),
        value: poapGateType.id === "eventId" ? poapId : poapName
      }
    }]];
    updateUnifiedAccessControlConditions(unifiedAccessControlConditions);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-condition-container",
    children: [/* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "Which POAP should be able to access this asset?"
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "How would you like to reference this POAP?"
    }), /* @__PURE__ */ jsx$1(StateManagedSelect, {
      className: "lsm-reusable-select",
      classNamePrefix: "lsm",
      options: typesOfPoapGate,
      defaultValue: typesOfPoapGate[0],
      isSeachable: false,
      onChange: (c2) => setPoapGateType(c2)
    }), poapGateType.id === "eventId" && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx$1("h3", {
        className: "lsm-condition-prompt-text",
        children: "POAP ID:"
      }), /* @__PURE__ */ jsx$1("input", {
        type: "number",
        value: poapId,
        onChange: (e2) => setPoapId(e2.target.value),
        className: "lsm-input"
      })]
    }), poapGateType.id === "tokenURI" && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx$1("h3", {
        className: "lsm-condition-prompt-text",
        children: "POAP Name:"
      }), /* @__PURE__ */ jsx$1("input", {
        value: poapName,
        onChange: (e2) => setPoapName(e2.target.value),
        className: "lsm-border-brand-4 lsm-input"
      }), /* @__PURE__ */ jsx$1("h3", {
        className: "lsm-condition-prompt-text",
        children: "Match conditions:"
      }), /* @__PURE__ */ jsx$1(StateManagedSelect, {
        className: "lsm-reusable-select",
        classNamePrefix: "lsm",
        options: matchConditionOptions,
        defaultValue: nameMatchCondition,
        isSeachable: false,
        onChange: (c2) => setNameMatchCondition(c2)
      })]
    })]
  });
};
const caskContractMap = {
  polygon: "0x4A6f232552E0fd76787006Bb688bFBCB931cc3d0",
  avalanche: "0x4A6f232552E0fd76787006Bb688bFBCB931cc3d0",
  fuji: "0x921ec72BEf414D75F0C6fFee37975BB3ae80d41C",
  mumbai: "0xaC7331DF9CB75beC251b75647AEccdeA8d336e33",
  fantom: "0x7DaF9a1744Df00d0473A9A920B6A4Ea33B665360",
  aurora: "0xD054F8866fc45c4387d56D2340dCA08d83E14A5e",
  xdai: "0xD054F8866fc45c4387d56D2340dCA08d83E14A5e"
};
const EthereumSelectCask = ({
  updateUnifiedAccessControlConditions,
  submitDisabled,
  chain,
  initialState = null
}) => {
  const [providerAddress, setProviderAddress] = useState("");
  const [addressIsValid, setAddressIsValid] = useState(false);
  const [providerPlan, setProviderPlan] = useState("");
  const [planIsValid, setPlanIsValid] = useState(false);
  const {
    wipeInitialProps
  } = useContext(ShareModalContext);
  useEffect(() => {
    if (initialState) {
      if (initialState["CaskProviderAddress"]) {
        setProviderAddress(initialState["CaskProviderAddress"]);
      }
      if (initialState["CaskPlanId"]) {
        setProviderPlan(initialState["CaskPlanId"]);
      }
      handleSubmit(initialState["CaskProviderAddress"], initialState["CaskPlanId"]);
    }
    wipeInitialProps();
  }, []);
  useEffect(() => {
    handleSubmit(providerAddress, providerPlan);
  }, [chain, providerAddress, providerPlan]);
  const handleSubmit = (address, plan) => {
    const checkIfAddressIsValid = isAddress(address);
    setAddressIsValid(checkIfAddressIsValid);
    const checkIfPlanIsValid = !isNaN(plan);
    setPlanIsValid(checkIfPlanIsValid);
    submitDisabled(!checkIfAddressIsValid || !checkIfPlanIsValid);
    const unifiedAccessControlConditions = [{
      conditionType: "evmBasic",
      contractAddress: caskContractMap[chain["value"]],
      standardContractType: "CASK",
      method: "getActiveSubscriptionCount",
      parameters: [":userAddress", address, plan],
      chain: chain["value"],
      returnValueTest: {
        comparator: ">=",
        value: "1"
      }
    }];
    updateUnifiedAccessControlConditions(unifiedAccessControlConditions);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-condition-container",
    children: [/* @__PURE__ */ jsxs("h3", {
      className: "lsm-condition-prompt-text",
      children: ["This access control allows you to gate access to users who have an active subscription, contribution or other money flow. It is powered by the decentralized ", /* @__PURE__ */ jsx$1("a", {
        href: "https://www.cask.fi",
        target: "_blank",
        children: "Cask Protocol"
      }), ". \xA0", /* @__PURE__ */ jsx$1("a", {
        href: "https://docs.cask.fi",
        target: "_blank",
        children: "Learn more"
      }), "."]
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "Cask Provider Address"
    }), /* @__PURE__ */ jsx$1(LitInput, {
      value: providerAddress,
      setValue: setProviderAddress,
      errorMessage: addressIsValid ? null : "Address is invalid",
      placeholder: "Cask Provider Address"
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "Cask Plan ID"
    }), /* @__PURE__ */ jsx$1(LitInput, {
      value: providerPlan,
      setValue: setProviderPlan,
      errorMessage: planIsValid ? null : "Invalid plan ID - must be a numeric Cask plan ID",
      placeholder: "Cask Plan ID"
    })]
  });
};
var POAP = "data:image/svg+xml;base64,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";
var CASK = "data:image/svg+xml;base64,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";
const ethereumTypesConfig = {
  conditionTypeID: "evmBasic",
  conditionTypes: {
    "wallet": EthereumSelectWallet,
    "nft": EthereumSelectNFT,
    "group": EthereumSelectGroup,
    "dao": EthereumSelectDAO,
    "poap": EthereumSelectPOAP,
    "cask": EthereumSelectCask
  },
  conditionTypeData: {
    wallet: { label: "An Individual Wallet", img: null, requiresMultipleConditions: false },
    nft: { label: "An Individual NFT", img: null, requiresMultipleConditions: false },
    group: { label: "A Group of Token or NFT Holders", img: null, requiresMultipleConditions: false },
    dao: { label: "DAO Members", img: null, requiresMultipleConditions: false },
    poap: {
      label: "POAP Collectors",
      img: POAP,
      requiresMultipleConditions: true,
      supportedChains: ["ethereum", "xdai"]
    },
    cask: {
      label: "Active Subscriber (Powered by Cask)",
      img: CASK,
      requiresMultipleConditions: false,
      supportedChains: ["ethereum", "polygon", "avalanche", "mumbai", "fuji", "fantom", "aurora", "xdai"]
    }
  },
  disallowNesting: ["poap"]
};
const SolanaSelectWallet = ({
  updateUnifiedAccessControlConditions,
  submitDisabled,
  initialState = null
}) => {
  const [walletAddress, setWalletAddress] = useState("");
  const {
    wipeInitialProps
  } = useContext(ShareModalContext);
  useEffect(() => {
    if (initialState) {
      if (initialState["solWalletAddress"]) {
        setWalletAddress(initialState["solWalletAddress"]);
      }
    }
    wipeInitialProps();
  }, []);
  useEffect(() => {
    handleSubmit();
    submitDisabled(!walletAddress.length);
  }, [walletAddress]);
  const handleSubmit = async () => {
    let resolvedAddress = walletAddress;
    const solRpcConditions = [{
      conditionType: "solRpc",
      method: "",
      params: [":userAddress"],
      chain: "solana",
      pdaParams: [],
      pdaInterface: {
        offset: 0,
        fields: {}
      },
      pdaKey: "",
      returnValueTest: {
        key: "",
        comparator: "=",
        value: resolvedAddress
      }
    }];
    updateUnifiedAccessControlConditions(solRpcConditions);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-condition-container",
    children: [/* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "Which wallet should be able to access this asset?"
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "Add Wallet Address here:"
    }), /* @__PURE__ */ jsx$1(LitInput, {
      value: walletAddress,
      setValue: setWalletAddress
    })]
  });
};
const SolanaSelectNFT = ({
  updateUnifiedAccessControlConditions,
  submitDisabled,
  initialState = null
}) => {
  const [contractAddress, setContractAddress] = useState("");
  const {
    wipeInitialProps
  } = useContext(ShareModalContext);
  useEffect(() => {
    if (initialState) {
      if (initialState["solNFTAddress"]) {
        setContractAddress(initialState["solNFTAddress"]);
      }
    }
    wipeInitialProps();
  }, []);
  useEffect(() => {
    if (contractAddress.length) {
      handleSubmit();
    }
    submitDisabled(!contractAddress.length);
  }, [contractAddress]);
  const handleSubmit = () => {
    const unifiedAccessControlConditions = [{
      conditionType: "solRpc",
      method: "balanceOfToken",
      params: [contractAddress],
      chain: "solana",
      pdaParams: [],
      pdaInterface: {
        offset: 0,
        fields: {}
      },
      pdaKey: "",
      returnValueTest: {
        key: "$.amount",
        comparator: ">",
        value: "0"
      }
    }];
    updateUnifiedAccessControlConditions(unifiedAccessControlConditions);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-condition-container",
    children: [/* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "Which wallet should be able to access this asset?"
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "Enter the token address"
    }), /* @__PURE__ */ jsx$1(LitInput, {
      value: contractAddress,
      setValue: setContractAddress
    })]
  });
};
const SolanaMetaplexCollection = ({
  updateUnifiedAccessControlConditions,
  submitDisabled,
  initialState = null
}) => {
  useContext(ShareModalContext);
  const [amount, setAmount] = useState("");
  const [contractAddress, setContractAddress] = useState("");
  const {
    wipeInitialProps
  } = useContext(ShareModalContext);
  useEffect(() => {
    if (initialState) {
      if (initialState["solMetaplexAddress"]) {
        setContractAddress(initialState["solMetaplexAddress"]);
      }
    }
    wipeInitialProps();
  }, []);
  useEffect(() => {
    submitDisabled(!amount || !contractAddress.length);
    handleSubmit();
  }, [amount, contractAddress]);
  const handleSubmit = async () => {
    if (contractAddress && contractAddress.length) {
      const unifiedAccessControlConditions = [{
        conditionType: "solRpc",
        method: "balanceOfMetaplexCollection",
        params: [contractAddress],
        chain: "solana",
        pdaParams: [],
        pdaInterface: {
          offset: 0,
          fields: {}
        },
        pdaKey: "",
        returnValueTest: {
          key: "",
          comparator: ">=",
          value: amount
        }
      }];
      updateUnifiedAccessControlConditions(unifiedAccessControlConditions);
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-condition-container",
    children: [/* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "Which group should be able to access this asset?"
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "Enter Metaplex collection address:"
    }), /* @__PURE__ */ jsx$1(LitInput, {
      value: contractAddress,
      setValue: setContractAddress,
      placeholder: "NFT or group address"
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: "How many tokens does the wallet need to own?"
    }), /* @__PURE__ */ jsx$1("input", {
      value: amount,
      onChange: (e2) => setAmount(e2.target.value),
      placeholder: "##",
      className: "lsm-border-brand-4 lsm-input"
    }), /* @__PURE__ */ jsx$1("h3", {
      className: "lsm-condition-prompt-text",
      children: /* @__PURE__ */ jsx$1("a", {
        href: "https://support.opensea.io/hc/en-us/articles/5661749143571-Getting-my-Solana-collection-on-OpenSea-Understanding-the-Metaplex-Certified-Collection-standard",
        target: "_blank",
        children: "More information on Metaplex collections."
      })
    })]
  });
};
const solanaTypesConfig = {
  conditionTypeID: "solRpc",
  conditionTypes: {
    "wallet": SolanaSelectWallet,
    "nft": SolanaSelectNFT,
    "group": SolanaMetaplexCollection
  },
  conditionTypeData: {
    wallet: { label: "An Individual Wallet", img: null, requiresMultipleConditions: false },
    nft: { label: "An Individual NFT", img: null, requiresMultipleConditions: false },
    group: { label: "A Metaplex Collection", img: null, requiresMultipleConditions: false }
  },
  doNotAllowForNested: []
};
const chainConfig = {
  ethereum: {
    value: "ethereum",
    label: "Ethereum",
    logo: ethLogo,
    abbreviation: "eth",
    types: ethereumTypesConfig,
    addressValidator: (walletAddress) => isAddress(walletAddress)
  },
  polygon: {
    value: "polygon",
    label: "Polygon",
    logo: polygonLogo,
    abbreviation: "matic",
    types: ethereumTypesConfig,
    addressValidator: (walletAddress) => true
  },
  solana: {
    value: "solana",
    label: "Solana",
    logo: solanaLogo,
    abbreviation: "Sol",
    types: solanaTypesConfig,
    addressValidator: (walletAddress) => true
  },
  fantom: {
    value: "fantom",
    label: "Fantom",
    logo: ftmLogo,
    abbreviation: "ftm",
    types: ethereumTypesConfig,
    addressValidator: (walletAddress) => true
  },
  xdai: {
    value: "xdai",
    label: "xDai",
    logo: xdaiLogo,
    abbreviation: "stake",
    types: ethereumTypesConfig,
    addressValidator: (walletAddress) => true
  },
  bsc: {
    value: "bsc",
    label: "Binance Smart Chain",
    logo: bnbLogo,
    abbreviation: "bsc",
    types: ethereumTypesConfig,
    addressValidator: (walletAddress) => true
  },
  arbitrum: {
    value: "arbitrum",
    label: "Arbitrum",
    logo: arbitrumLogo,
    abbreviation: "arbitrum",
    types: ethereumTypesConfig,
    addressValidator: (walletAddress) => true
  },
  avalanche: {
    value: "avalanche",
    label: "Avalanche",
    logo: avalancheLogo,
    abbreviation: "avax",
    types: ethereumTypesConfig,
    addressValidator: (walletAddress) => true
  },
  optimism: {
    value: "optimism",
    label: "Optimism",
    logo: optimismLogo,
    abbreviation: "op",
    types: ethereumTypesConfig,
    addressValidator: (walletAddress) => true
  },
  celo: {
    value: "celo",
    label: "Celo",
    logo: celoLogo,
    abbreviation: "celo",
    types: ethereumTypesConfig,
    addressValidator: (walletAddress) => true
  },
  eluvio: {
    value: "eluvio",
    label: "Eluvio",
    logo: eluvioLogo,
    abbreviation: "elv",
    types: ethereumTypesConfig,
    addressValidator: (walletAddress) => true
  },
  fuji: {
    value: "fuji",
    label: "Avalanche FUJI Testnet",
    logo: avalancheLogo,
    abbreviation: "fuji",
    types: ethereumTypesConfig,
    addressValidator: (walletAddress) => true
  },
  harmony: {
    value: "harmony",
    label: "Harmony",
    logo: harmonyLogo,
    abbreviation: "one",
    types: ethereumTypesConfig,
    addressValidator: (walletAddress) => true
  },
  kovan: {
    value: "kovan",
    label: "Kovan",
    logo: kovanLogo,
    abbreviation: "kovan",
    types: ethereumTypesConfig,
    addressValidator: (walletAddress) => true
  },
  mumbai: {
    value: "mumbai",
    label: "Mumbai",
    logo: polygonLogo,
    abbreviation: "mumbai",
    types: ethereumTypesConfig,
    addressValidator: (walletAddress) => true
  },
  goerli: {
    value: "goerli",
    label: "Goerli",
    logo: goerliLogo,
    abbreviation: "goerli",
    types: ethereumTypesConfig,
    addressValidator: (walletAddress) => true
  },
  ropstein: {
    value: "ropstein",
    label: "Ropstein",
    logo: ethLogo,
    abbreviation: "ropstein",
    types: ethereumTypesConfig,
    addressValidator: (walletAddress) => true
  },
  rinkeby: {
    value: "rinkeby",
    label: "Rinkeby",
    logo: ethLogo,
    abbreviation: "rinkeby",
    types: ethereumTypesConfig,
    addressValidator: (walletAddress) => true
  },
  cronos: {
    value: "cronos",
    label: "Cronos",
    logo: cronosLogo,
    abbreviation: "cro",
    types: ethereumTypesConfig,
    addressValidator: (walletAddress) => true
  },
  aurora: {
    value: "aurora",
    label: "Aurora",
    logo: auroraLogo,
    abbreviation: "aoa",
    types: ethereumTypesConfig,
    addressValidator: (walletAddress) => true
  }
};
var link = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik02LjY0OTUzIDEwLjI4NjNMMTMuMzM3NSAzLjYwOTM4VjcuOTk5OTJIMTQuNjcwOVYxLjMzMzI1TDcuOTk5NjcgMS4zMzMyNVYyLjY2NjU5TDEyLjM5NDcgMi42NjY1OUw1LjcwNjcyIDkuMzQzNDZMNi42NDk1MyAxMC4yODYzWiIgZmlsbD0iIzgxNTlEOSIvPgogICAgPHBhdGggZD0iTTYuNjY2MzQgMy45OTk5MlY1LjMzMzI1SDIuNjY2MzRWMTMuMzMzM0gxMC42NjYzVjkuMzMzMjVIMTEuOTk5N1YxNC42NjY2SDEuMzMzMDFWMy45OTk5Mkg2LjY2NjM0WiIgZmlsbD0iIzgxNTlEOSIvPgo8L3N2Zz4K";
const LitCheckbox = ({
  value,
  setValue,
  label
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-checkbox-container",
    children: [/* @__PURE__ */ jsx$1("input", {
      className: "lsm-checkbox-input",
      type: "checkbox",
      id: "edit",
      name: "edit",
      checked: value,
      value,
      onChange: (e2) => setValue(e2.target.checked)
    }), /* @__PURE__ */ jsx$1("label", {
      className: "lsm-checkbox-label",
      htmlFor: "edit",
      children: label
    })]
  });
};
const ReviewConditions = ({
  humanizedUnifiedAccessControlConditions,
  unifiedAccessControlConditions
}) => {
  const {
    sendUnifiedAccessControlConditions,
    flow,
    resetModal,
    setDisplayedPage,
    permanentDefault
  } = useContext(ShareModalContext);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [conditionsArePermanent, setConditionsArePermanent] = useState(permanentDefault);
  const [conditionsSent, setConditionsSent] = useState(false);
  const navigateBack = () => {
    if (flow === "singleCondition") {
      setShowConfirmationModal(true);
    } else if (flow === "multipleConditions") {
      setDisplayedPage("multiple");
    }
  };
  const handleConfirmGoBack = (modalResponse) => {
    if (modalResponse === "yes") {
      resetModal();
    }
    setShowConfirmationModal(false);
  };
  const getOperatorAndCondition = (humanAccEntry, key) => {
    if (!humanAccEntry["operator"]) {
      return /* @__PURE__ */ jsxs("div", {
        className: "lsm-review-condition-humanized-text",
        children: [/* @__PURE__ */ jsx$1("span", {
          children: humanAccEntry.humanizedAcc
        }), /* @__PURE__ */ jsx$1("span", {
          children: /* @__PURE__ */ jsxs("i", {
            children: ["chain - ", humanAccEntry.chain, " | condition type - ", humanAccEntry.conditionType]
          })
        })]
      }, `${humanAccEntry[0]}-${humanAccEntry.conditionType[0]}-${key}`);
    } else if (humanAccEntry["operator"]) {
      return /* @__PURE__ */ jsx$1("span", {
        className: "lsm-review-condition-operator-text",
        children: humanAccEntry.operator === "and" ? "AND" : "OR"
      }, `n-${key}`);
    }
  };
  const recursiveRenderConditionsGroups = (humanAcc, depth = 0, index = 0) => {
    return /* @__PURE__ */ jsx$1("div", {
      className: "lsm-review-conditions-group ",
      style: {
        "backgroundColor": colorArray[Math.ceil(depth / 2)]
      },
      children: Array.isArray(humanAcc) ? humanAcc.map((h2, i) => {
        if (Array.isArray(h2)) {
          return recursiveRenderConditionsGroups(h2, depth, i);
        } else {
          return getOperatorAndCondition(h2, depth + i);
        }
      }) : getOperatorAndCondition(humanAcc, depth)
    }, `${depth}-${index}}`);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-review-conditions-container",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "lsm-review-conditions-group-container",
      children: [/* @__PURE__ */ jsx$1("h3", {
        className: "lsm-review-conditions-prompt",
        children: "Review your conditions and confirm at bottom"
      }), !!humanizedUnifiedAccessControlConditions && recursiveRenderConditionsGroups(humanizedUnifiedAccessControlConditions), /* @__PURE__ */ jsxs("footer", {
        className: "lsm-review-conditions-footer",
        children: [/* @__PURE__ */ jsx$1(LitCheckbox, {
          value: conditionsArePermanent,
          checked: conditionsArePermanent,
          setValue: setConditionsArePermanent,
          label: "Make condition(s) permanent; if selected, you cannot update them later"
        }), /* @__PURE__ */ jsx$1("div", {
          className: "lsm-review-conditions-link",
          children: /* @__PURE__ */ jsxs("a", {
            href: "https://developer.litprotocol.com/docs/AccessControlConditions/evmBasicExamples",
            target: "_blank",
            rel: "noreferrer",
            children: ["More information about conditions", /* @__PURE__ */ jsx$1("img", {
              alt: "clear input",
              className: "lsm-review-conditions-link-icon",
              src: link
            })]
          })
        })]
      })]
    }), /* @__PURE__ */ jsx$1(LitFooter, {
      backAction: () => navigateBack(),
      nextAction: () => {
        setConditionsSent(true);
        sendUnifiedAccessControlConditions(conditionsArePermanent);
      },
      disableNextButton: false,
      nextButtonLabel: "DONE"
    }), /* @__PURE__ */ jsx$1(LitConfirmationModal, {
      showConfirmationModal,
      onClick: handleConfirmGoBack
    })]
  });
};
const DevModeHeader = ({
  handleClose,
  isModal,
  showDevMode,
  setShowDevMode
}) => {
  return /* @__PURE__ */ jsxs("header", {
    className: "lsm-header-container",
    children: [/* @__PURE__ */ jsx$1("h3", {
      className: "lsm-header-text",
      children: "Dev Mode"
    }), /* @__PURE__ */ jsx$1("button", {
      className: "lsm-dev-mode-show-button",
      onClick: () => setShowDevMode(!showDevMode),
      children: showDevMode ? "Hide Dev" : "Show Dev"
    }), isModal && /* @__PURE__ */ jsx$1("button", {
      className: "lsm-header-close-button",
      onClick: handleClose,
      children: /* @__PURE__ */ jsx$1("svg", {
        className: "lsm-header-close-button-icon",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ jsx$1("path", {
          d: "M10 11.4142L17.7782 19.1924L19.1924 17.7782L11.4142 10L19.1924 2.22183L17.7782 0.807617L10 8.58579L2.22183 0.807617L0.807617 2.22183L8.58579 10L0.807619 17.7782L2.22183 19.1924L10 11.4142Z",
          fill: "rgba(0, 5, 51, 0.6)"
        })
      })
    })]
  });
};
var DevModeContent$1 = "";
const DevModeContent = ({
  unifiedAccessControlConditions
}) => {
  const [accTextArea, setAccTextArea] = useState("");
  useEffect(() => {
    if (unifiedAccessControlConditions) {
      const prettify = JSON.stringify(unifiedAccessControlConditions, void 0, 4);
      setAccTextArea(prettify);
    }
  }, [unifiedAccessControlConditions]);
  return /* @__PURE__ */ jsxs("div", {
    className: "lsm-dev-mode-container",
    children: [/* @__PURE__ */ jsx$1("label", {
      className: "lsm-dev-mode-container-label",
      children: "Raw Access Control Conditions"
    }), /* @__PURE__ */ jsx$1("textarea", {
      className: "lsm-dev-mode-textarea",
      rows: 35,
      value: accTextArea,
      onChange: (e2) => setAccTextArea(e2.target.value)
    })]
  });
};
var baseCss = ".lsm-light-theme{--lsm-primary-color: #333;--lsm-contrast-color: #fff;--lsm-secondary-color: #c4c4c4;--lsm-background-color: #fff;--lsm-modal-overlay-color: rgba(0, 0, 0, .4);--lsm-secondary-background-color: #fcfcfc;--lsm-accent-color: rgb(36,78,112);--lsm-accent-text: #fff;--lsm-error-color: rgba(168,0,0,.7);--lsm-disabled-color: #aaa;--lsm-menu-focused-color: #2684FF;--lsm-title-font: Segoe UI, sans-serif;--lsm-title-font-weight: 300;--lsm-primary-font: Segoe UI, sans-serif;--lsm-primary-font-weight: 300;--lsm-border-radius: .25em;margin:0;padding:0}.lsm-dark-theme{--lsm-primary-color: #efefef;--lsm-contrast-color: #333;--lsm-secondary-color: #777;--lsm-background-color: #222;--lsm-modal-overlay-color: rgba(0, 0, 0, .7);--lsm-secondary-background-color: #333;--lsm-accent-color: rgb(36,78,112);--lsm-accent-text: #fff;--lsm-error-color: rgba(255, 60, 60, .7);--lsm-disabled-color: #aaa;--lsm-menu-focused-color: #2684FF;--lsm-title-font: Segoe UI, sans-serif;--lsm-title-font-weight: 300;--lsm-primary-font: Segoe UI, sans-serif;--lsm-primary-font-weight: 300;--lsm-border-radius: .25em;margin:0;padding:0}\n";
var shareModalCss = ".lsm-share-modal-container{box-sizing:border-box;padding:0 .5em;background-color:var(--lsm-background-color);height:100%;width:100%;top:0;left:0;position:fixed;font-size:16px;overflow:hidden;display:flex;flex-direction:column}.lsm-condition-display{flex:1 1 auto;position:absolute;top:3.5em;bottom:0;left:0;right:0;overflow-y:scroll;text-align:left}.lsm-condition-container{display:flex;flex-direction:column;font-family:var(--lsm-primary-font);box-sizing:border-box;height:100%;padding:0 .5em;overflow-y:scroll}.lsm-condition-prompt-text{font-weight:var(--lsm-primary-font-weight);color:var(--lsm-primary-color);font-size:1em;margin:1em 0 .5em}.lsm-condition-prompt-text a{color:var(--lsm-menu-focused-color)}.lsm-condition-prompt-text:first-child{margin-top:.5em}.lsm-condition-prompt-text-no-margin{font-weight:var(--lsm-primary-font-weight);font-size:1em}.lsm-radio-container{display:flex;justify-content:space-between;align-items:center;width:97%;margin-bottom:.75em}.lsm-radio-label{font-weight:var(--lsm-primary-font-weight);margin-left:.25em;color:var(--lsm-primary-color)}@media (min-width: 768px){.lsm-share-modal-container{max-width:inherit;position:relative;border-radius:var(--lsm-border-radius);border:none;height:inherit}}\n";
var litSingleConditionSelectCss = ".lsm-single-condition-select-container{height:calc(100% - 4.5em);box-sizing:border-box;padding:0 .5em;display:flex;flex-direction:column;overflow-y:scroll;margin-bottom:4.5em}.lsm-single-select-condition-display{flex:1 1 auto;min-height:calc(100% - 4.5em);overflow-y:hidden;box-sizing:border-box}.lsm-single-condition-select-prompt{color:var(--lsm-primary-color);font-family:var(--lsm-primary-font);font-weight:var(--lsm-primary-font-weight);text-align:center;font-size:1.05em}.lsm-single-condition-select-prompt{margin:1em 0}.lsm-single-condition-multiple-button{width:100%;box-sizing:border-box;margin:2em auto;height:4em;padding:0 1em;position:absolute;bottom:0;left:0;text-decoration:underline;border:none;background-color:var(--lsm-background-color);color:var(--lsm-primary-color);display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:1em;font-weight:var(--lsm-primary-font-weight)}.lsm-single-condition-multiple-button p{margin-left:.25em}\n";
var litMultipleConditionSelectCss = ".lsm-multiple-conditions-container{height:100%;position:absolute;bottom:0;top:0;left:0;right:0;box-sizing:border-box;overflow:hidden}\n";
var litReviewConditionsCss = ".lsm-review-conditions-container{font-family:var(--lsm-primary-font);box-sizing:border-box;top:0;bottom:0;left:0;right:0;position:absolute}.lsm-review-conditions-group-container{display:flex;flex-direction:column;overflow-y:scroll;height:calc(100% - 4.5em);color:var(--lsm-primary-color);box-sizing:border-box;padding:.5em}.lsm-review-conditions-prompt{font-weight:var(--lsm-primary-font-weight);color:var(--lsm-primary-color);font-size:1.1em;margin:0}.lsm-review-conditions-group{box-sizing:border-box;padding:1em;overflow-wrap:break-word;font-weight:var(--lsm-primary-font-weight);border-radius:var(--lsm-border-radius);display:flex;flex-direction:column;margin:.75em 0;border:1px solid var(--lsm-secondary-color)}.lsm-review-conditions-group:first-child{margin:0 0 .75em}.lsm-review-conditions-footer{padding:0 1em}.lsm-review-condition-humanized-text{display:flex;flex-direction:column}.lsm-review-condition-operator-text{margin:.75em 0;font-size:.9em;font-weight:500}.lsm-review-conditions-link{font-weight:var(--lsm-primary-font-weight);margin:.75em auto;text-align:center}.lsm-review-conditions-link-icon{margin-left:.25em}\n";
var litChainSelectorCss = ".lsm-chain-selector-container{display:flex;width:100%;box-sizing:border-box;padding:0 .5em;justify-content:center;align-items:center;height:4em}.lsm-chain-selector{width:100%;font-family:var(--lsm-primary-font);cursor:pointer}.lsm-disabled-selector{border-radius:var(--lsm-border-radius);padding:.75em .5em;justify-content:space-between;position:relative;box-sizing:border-box;display:flex;flex-wrap:wrap;border-style:solid;border-width:1px;border-color:#b3b3b3;font-family:var(--lsm-primary-font);width:100%}.lsm__control{border-radius:var(--lsm-border-radius)!important;padding:.25em 0;cursor:pointer!important}.lsm__menu{border-radius:0!important}.lsm__menu-list{padding:0!important}.lsm__option{cursor:pointer!important;padding:.75em!important;background-color:var(--lsm-background-color)!important;color:var(--lsm-primary-color)!important}.lsm__option--is-focused{background-color:var(--lsm-menu-focused-color)!important;color:var(--lsm-contrast-color)!important}.lsm-chain-selector-control-icon{height:2em;width:2em;margin-right:.5em}.lsm-chain-selector-option-icons{height:1em;margin-right:.5em}\n";
var litHeaderCss = ".lsm-header-container{width:100%;padding-left:1em;padding-right:.5em;display:flex;justify-content:space-between;top:0;left:0;align-items:center;height:3.5em;box-sizing:border-box;z-index:1;background-color:var(--lsm-background-color)}.lsm-header-text{text-transform:uppercase;font-size:1.125em;line-height:26px;letter-spacing:.1em;color:var(--lsm-primary-color);font-family:var(--lsm-title-font);font-weight:var(--lsm-title-font-weight)}.lsm-header-close-button{background-color:transparent;border:none;cursor:pointer}.lsm-header-close-button-icon path{fill:var(--lsm-primary-color)}@media (min-width: 768px){.lsm-header-container{border-radius:var(--lsm-border-radius) var(--lsm-border-radius) 0 0;border:none;top:initial;left:initial;width:auto}}\n";
var litChooseAccessButtonCss = ".lsm-choose-access-button{width:calc(100% - 1em);box-sizing:border-box;margin:.5em auto;height:4.5em;border:var(--lsm-secondary-color) 1px solid;background-color:var(--lsm-secondary-background-color);border-radius:var(--lsm-border-radius);color:var(--lsm-primary-color);font-family:var(--lsm-primary-font);display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:.9em;font-weight:var(--lsm-primary-font-weight)}.lsm-choose-access-button-icon{height:2.5em;margin-right:1em}\n";
var litReusableSelectCss = ".lsm-reusable-select-container{display:flex;width:100%;box-sizing:border-box;justify-content:center;align-items:center}.lsm-reusable-select{width:100%;font-family:var(--lsm-primary-font)}.lsm__control{background-color:var(--lsm-background-color)!important;color:var(--lsm-primary-color)!important;border-radius:var(--lsm-border-radius)!important;padding:.25em 0;font-size:1em;cursor:pointer!important}.lsm__single-value{color:var(--lsm-primary-color)!important}.lsm__menu{border-radius:0!important}.lsm__menu-list{padding:0!important}.lsm__option{cursor:pointer!important;padding:.75em!important;background-color:var(--lsm-background-color)!important;color:var(--lsm-primary-color)!important}.lsm__option--is-focused{background-color:var(--lsm-menu-focused-color)!important;color:var(--lsm-contrast-color)!important}\n";
var litInputCss = ".lsm-input-container{box-sizing:border-box}.lsm-input{height:2.7em;width:100%;border-radius:var(--lsm-border-radius);background-color:var(--lsm-background-color);color:var(--lsm-primary-color);border:1px solid var(--lsm-secondary-color);padding-left:1em;padding-right:1em;box-sizing:border-box;font-size:1em}.lsm-input:disabled{color:#999}.lsm-input-error{margin:.25em 0 0;transition:.3s all;min-height:1.25em;color:var(--lsm-error-color)}.lsm-loading{margin:.25em 0 0;transition:.3s all;min-height:1.25em;color:var(--lsm-accent-color)}\n";
var litDevModeCss = ".lsm-dev-mode-container{margin-top:3.5em;overflow-y:scroll;height:calc(100% - 5em);font-family:var(--lsm-primary-font);text-align:center;display:flex;flex-direction:column;align-items:center}.lsm-dev-mode-container-label{margin:1em;font-weight:var(--lsm-primary-font-weight)}.lsm-dev-mode-textarea{width:95%;background-color:var(--lsm-background-color);color:var(--lsm-primary-color)}.lsm-dev-mode-show-button{background-color:var(--lsm-background-color);border:var(--lsm-secondary-color) 1px solid;border-radius:var(--lsm-border-radius);padding:.5em;color:var(--lsm-primary-color)}\n";
var litFooterCss = ".lsm-lit-footer{display:flex;position:absolute;justify-content:space-between;align-items:center;bottom:0;left:0;height:4.5em;padding:.5em 1rem 1em;width:100%;box-sizing:border-box;background-color:var(--lsm-background-color);z-index:1}@media (min-width: 768px){.lsm-lit-footer{border:none;border-bottom-right-radius:var(--lsm-border-radius);border-bottom-left-radius:var(--lsm-border-radius);transform:translate(0);bottom:0;left:0}}\n";
var litBackButtonCss = ".lsm-back-button{height:3em;padding:0 1.5em;border-radius:.25em;display:flex;align-items:center;border:var(--lsm-secondary-color) 1px solid;background-color:var(--lsm-background-color);color:var(--lsm-primary-color);cursor:pointer;transition-duration:.3s}.lsm-back-arrow{margin-right:.5em}.lsm-back-button:hover{background-color:#f4f4f4}\n";
var litNextButtonCss = ".lsm-next-button{height:3em;padding:0 1.5em;display:flex;align-items:center;border-radius:.25em;border:none;color:var(--lsm-accent-text);background-color:var(--lsm-accent-color);cursor:pointer;transition-duration:.3s}.lsm-next-label{color:var(--lsm-accent-text)}.lsm-next-button:disabled{background-color:var(--lsm-disabled-color);color:var(--lsm-secondary-color)}.lsm-next-button:hover{opacity:.9}.lsm-next-arrow{margin-left:.5em}\n";
var litConfirmationModalCss = ".lsm-confirmation-modal-container{width:100%;height:100%;position:fixed;top:0;left:0;z-index:10;background-color:var(--lsm-modal-overlay-color);border-radius:var(--lsm-border-radius)}.lsm-confirmation-modal{width:80%;height:auto;border-width:10px;border-radius:.25em;box-sizing:border-box;z-index:30;padding:1em 1.5em;position:fixed;background-color:var(--lsm-background-color);top:50%;left:50%;transform:translate(-50%,-50%)}.lsm-confirmation-modal-prompt{font-family:var(--lsm-primary-font);font-weight:var(--lsm-primary-font-weight);color:var(--lsm-primary-color);margin:0 0 1em;font-size:1.1em}.lsm-confirmation-modal-button-container{display:flex;justify-content:space-between;align-items:center;box-sizing:border-box;padding:0 .5em}.lsm-confirmation-modal-button-no{box-sizing:border-box;width:7em;height:3em;background-color:var(--lsm-background-color);color:var(--lsm-primary-color);border:var(--lsm-secondary-color) 1px solid;border-radius:var(--lsm-border-radius);cursor:pointer}.lsm-confirmation-modal-button-yes{box-sizing:border-box;width:7em;height:3em;color:#fff;background-color:var(--lsm-accent-color);border:var(--lsm-accent-color) 1px solid;border-radius:var(--lsm-border-radius);cursor:pointer}\n";
var litDeleteModalCss = ".lsm-delete-modal-container{width:100%;height:100%;position:fixed;top:0;left:0;z-index:10;background-color:var(--lsm-modal-overlay-color);border-radius:var(--lsm-border-radius)}.lsm-delete-modal{width:80%;height:auto;border-width:10px;border-radius:.25em;box-sizing:border-box;z-index:30;padding:1em 1.5em;position:fixed;background-color:var(--lsm-background-color);top:50%;left:50%;transform:translate(-50%,-50%)}.lsm-delete-modal-prompt{font-family:var(--lsm-primary-font);font-weight:var(--lsm-primary-font-weight);color:var(--lsm-primary-color);margin:0 0 1em;font-size:1em}.lsm-delete-modal-button-container{display:flex;justify-content:space-between;align-items:center;box-sizing:border-box;padding:0 .5em}.lsm-delete-modal-button-no{box-sizing:border-box;width:7em;height:3em;background-color:var(--lsm-background-color);color:var(--lsm-primary-color);border:var(--lsm-secondary-color) 1px solid;border-radius:var(--lsm-border-radius);cursor:pointer}.lsm-delete-modal-button-yes{box-sizing:border-box;width:7em;height:3em;color:#fff;background-color:var(--lsm-accent-color);border:var(--lsm-accent-color) 1px solid;border-radius:var(--lsm-border-radius);cursor:pointer}\n";
var litMultipleAddConditionCss = ".lsm-multiple-condition-add-container{overflow:hidden;height:calc(100% - 4.5em);box-sizing:border-box;width:100%}.lsm-multiple-condition-select-prompt{color:var(--lsm-primary-color);font-family:var(--lsm-primary-font);font-weight:var(--lsm-primary-font-weight);text-align:center;font-size:1.05em}.lsm-multiple-select-condition-display{flex:1 1 auto;height:calc(100% - 4.5em);width:100%;overflow-y:hidden;box-sizing:border-box}.lsm-multiple-condition-select-prompt{margin:1em 0}\n";
var litMultipleConditionEditorCss = ".lsm-multiple-condition-editor-container{font-family:var(--lsm-primary-font);box-sizing:border-box;padding:0 .5em;display:flex;align-items:center;flex-direction:column;height:calc(100% - 3.5em);overflow-y:scroll}.lsm-multiple-condition-prompt{font-weight:var(--lsm-primary-font-weight);font-size:1.1em;margin:1em 0 .5em}.lsm-multiple-condition-group{box-sizing:border-box;padding:1em;overflow-wrap:break-word;font-weight:var(--lsm-primary-font-weight);width:100%;border-radius:var(--lsm-border-radius);display:flex;flex-direction:column}.lsm-multiple-condition-initial-container{width:100%;display:flex;flex-direction:column;align-items:center;font-family:var(--lsm-primary-font)}.lsm-multiple-condition-humanized-container{width:100%;display:flex;justify-content:space-between;align-items:center}.lsm-multiple-condition-humanized-text{overflow-wrap:break-word;width:80%;margin-right:1em;font-size:1em;color:var(--lsm-primary-color);display:flex;flex-direction:column}.lsm-multiple-condition-humanized-delete{background-color:transparent;border:none;cursor:pointer}.lsm-multiple-condition-operator-container{width:100%;display:flex;justify-content:center;margin:1em auto}.lsm-multiple-condition-group-operator,.lsm-multiple-condition-group-operator-poap{color:var(--lsm-primary-color);width:6em;height:3em;margin:0 .5em;border-radius:var(--lsm-border-radius);background-color:var(--lsm-secondary-background-color);transition-duration:.25s;cursor:pointer}.lsm-multiple-condition-group-operator-poap{margin:1em 0 1em calc(50% - 1em)}.lsm-multiple-condition-define-first-group{box-sizing:border-box;padding:1em;overflow-wrap:break-word;font-weight:var(--lsm-primary-font-weight);width:100%;text-align:center;border-radius:var(--lsm-border-radius)}.lsm-multiple-condition-operator-selected{border:var(--lsm-primary-color) 1px solid}.lsm-multiple-condition-operator-not-selected{border:var(--lsm-contrast-color) 1px solid}.lsm-multiple-condition-define-first-arrow{margin-top:1em}.lsm-multiple-condition-define-first-arrow-path{stroke:var(--lsm-primary-color)}.lsm-multiple-condition-define-button{margin:1em auto 0;background-color:var(--lsm-secondary-background-color);border-radius:var(--lsm-border-radius);color:var(--lsm-primary-color);padding:1em;font-size:.9em;border:var(--lsm-secondary-color) 1px solid;cursor:pointer}.lsm-multiple-condition-define-first-button{margin:0 auto;background-color:var(--lsm-secondary-background-color);border-radius:var(--lsm-border-radius);color:var(--lsm-primary-color);padding:1em;font-size:.9em;border:var(--lsm-secondary-color) 1px solid;cursor:pointer}.lsm-multiple-condition-define-first-text{color:var(--lsm-primary-color);font-weight:var(--lsm-primary-font-weight);box-sizing:border-box;padding:0 .75em;font-size:1em;text-align:center}\n";
var litCheckboxCss = ".lsm-checkbox-container{display:flex;align-items:center;margin:.5em 0;cursor:pointer}.lsm-checkbox-input{height:1.1em;width:1.1em;margin-right:1em}.lsm-checkbox-label{cursor:pointer;color:var(--lsm-primary-color);max-width:calc(100% - 2em)}\n";
var litTokenSelectCss = ".lsm-ts__control{border-radius:var(--lsm-border-radius)!important;padding:.25em 0;font-size:1em;cursor:pointer!important;background-color:var(--lsm-background-color)!important}.lsm-ts__input-container,.lsm-ts__single-value{color:var(--lsm-primary-color)!important}.lsm-ts__menu{border-radius:0!important}.lsm-ts__menu-list{padding:0!important}.lsm-ts__option{padding:.75em!important;display:flex!important;align-items:center!important;background-color:var(--lsm-background-color)!important;color:var(--lsm-primary-color)!important;font-family:var(--lsm-primary-font)!important;cursor:pointer!important}.lsm-ts__option--is-focused,.lsm-ts__option:hover{background-color:var(--lsm-menu-focused-color)!important;color:var(--lsm-contrast-color)!important}.lsm-ts-chain-selector-options-icons{margin-right:.75em}\n";
const cssReference = {
  baseCss,
  shareModalCss,
  litSingleConditionSelectCss,
  litMultipleConditionSelectCss,
  litMultipleAddConditionCss,
  litMultipleConditionEditorCss,
  litReviewConditionsCss,
  litChainSelectorCss,
  litHeaderCss,
  litDevModeCss,
  litChooseAccessButtonCss,
  litReusableSelectCss,
  litInputCss,
  litFooterCss,
  litNextButtonCss,
  litBackButtonCss,
  litConfirmationModalCss,
  litDeleteModalCss,
  litCheckboxCss,
  litTokenSelectCss
};
const ShareModal = (props) => {
  const [displayedPage, setDisplayedPage] = useState("single");
  const [error, setError] = useState(null);
  const [unifiedAccessControlConditions, setUnifiedAccessControlConditions] = useState([]);
  const [humanizedUnifiedAccessControlConditions, setHumanizedUnifiedAccessControlConditions] = useState([]);
  const [flow, setFlow] = useState("singleCondition");
  const [tokenList, setTokenList] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [chain, setChain] = useState(null);
  const [cssLoaded, setCssLoaded] = useState(false);
  const [chainList, setChainList] = useState([]);
  const [showDevMode, setShowDevMode] = useState(false);
  const [storedInitialState, setStoredInitialState] = useState(null);
  const [storedInitialCondition, setStoredInitialCondition] = useState("chooseAccess");
  const {
    onClose = () => false,
    onUnifiedAccessControlConditionsSelected = (conditions) => console.log("conditions", conditions),
    injectInitialState = false,
    initialUnifiedAccessControlConditions = null,
    initialFlow = null,
    initialCondition = null,
    initialState = null,
    defaultTokens = TOP_LIST,
    defaultChain = "ethereum",
    allowChainSelector = true,
    allowMultipleConditions = true,
    permanentDefault = false,
    chainsAllowed = Object.keys(chainConfig),
    conditionsAllowed = {},
    isModal = true,
    injectCSS = true,
    darkMode = false,
    allowDevMode = false,
    cssSubstitution = {}
  } = props;
  useEffect(() => {
    checkPropTypes(props);
    setDevModeIsAllowed(allowDevMode);
    const chainsWithAllowedConditions = getAllowedConditions(chainsAllowed, conditionsAllowed, chainConfig);
    setChainList(chainsWithAllowedConditions);
    setInitialChain(chainsWithAllowedConditions);
    getTokens();
    if (injectInitialState) {
      if (Array.isArray(initialUnifiedAccessControlConditions)) {
        updateState(initialUnifiedAccessControlConditions);
        setFlow("multipleConditions");
        setDisplayedPage("multiple");
      }
      if (initialFlow) {
        setFlow(initialFlow);
        if (initialFlow === "multipleConditions") {
          setDisplayedPage("multiple");
        }
      }
      if (initialCondition) {
        setStoredInitialCondition(initialCondition);
        if (initialFlow === "multipleConditions") {
          setDisplayedPage("multiple-add");
        }
      }
      if (initialState) {
        setStoredInitialState(initialState);
      }
    }
    checkInjectCss();
  }, []);
  const wipeInitialProps = () => {
  };
  const checkInjectCss = () => {
    if (injectCSS) {
      let cssInjectArray = [];
      Object.keys(cssReference).forEach((s, i) => {
        if (i === Object.keys(cssReference).length && cssSubstitution[s]) {
          cssInjectArray.push(cssSubstitution[s]);
        } else if (i === Object.keys(cssReference).length) {
          cssInjectArray.push(cssReference[s]);
        } else if (cssSubstitution[s]) {
          cssInjectArray.push(cssSubstitution[s]);
        } else {
          cssInjectArray.push(cssReference[s]);
        }
      });
      const cssInjectString = cssInjectArray.join("\n");
      const style = document.createElement("style");
      style.innerHTML = cssInjectString;
      document.head.appendChild(style);
    }
    setTimeout(() => {
      setCssLoaded(true);
    }, 100);
  };
  const setInitialChain = async (chainsAllowed2) => {
    const initialChain = chainsAllowed2.find((c2) => c2.value === defaultChain);
    if (!initialChain) {
      logDevError("no default chain found.  Check defaultChain prop.");
      return;
    }
    await setChain(initialChain);
  };
  document.addEventListener("lit-ready", function(e2) {
  }, false);
  const getTokens = async () => {
    try {
      const tokens = await LitJsSdk.getTokenList();
      setTokenList(tokens);
    } catch (err) {
      setTokenList([]);
      console.log("Error retrieving token list:", err);
    }
  };
  const handleDeleteAccessControlCondition = async (localIndex, nestedIndex) => {
    const updatedAcc = unifiedAccessControlConditions;
    if (nestedIndex === null) {
      if (localIndex > 1 && localIndex === updatedAcc.length - 1) {
        updatedAcc.splice(-2);
      } else {
        updatedAcc.splice(updatedAcc[localIndex], 2);
      }
    } else {
      if (nestedIndex !== 0 && nestedIndex === updatedAcc[localIndex].length - 1) {
        updatedAcc[localIndex].splice(-2);
      } else {
        updatedAcc[localIndex].splice(updatedAcc[localIndex][nestedIndex], 2);
      }
    }
    await updateState(updatedAcc);
    if (updatedAcc.length === 0 && flow === "singleCondition") {
      setDisplayedPage("single");
    }
  };
  const checkForAddingOperatorToCondition = (acc, newAccessControlCondition) => {
    const updatedAcc = acc;
    if (!acc.length && newAccessControlCondition[0]) {
      updatedAcc.push(newAccessControlCondition[0]);
    } else {
      updatedAcc.push({
        operator: "and"
      });
      updatedAcc.push(newAccessControlCondition[0]);
    }
    return updatedAcc;
  };
  const handleUpdateUnifiedAccessControlConditions = async (newAccessControlCondition, isNested = false, index = null) => {
    let updatedAcc = [...unifiedAccessControlConditions];
    if (!newAccessControlCondition[0]) {
      return;
    }
    if (isNested) {
      if (Array.isArray(updatedAcc[index])) {
        updatedAcc[index] = checkForAddingOperatorToCondition(updatedAcc[index], newAccessControlCondition);
      } else {
        let nestedUpdatedAcc = checkForAddingOperatorToCondition([updatedAcc[index]], newAccessControlCondition);
        updatedAcc[index] = nestedUpdatedAcc;
      }
    } else {
      updatedAcc = checkForAddingOperatorToCondition(updatedAcc, newAccessControlCondition);
    }
    await updateState(updatedAcc);
  };
  const updateLogicOperator = async (value, localIndex, nestedIndex = null) => {
    let updatedAcc = [...unifiedAccessControlConditions];
    if (nestedIndex) {
      updatedAcc[localIndex][nestedIndex].operator = value;
    } else {
      updatedAcc[localIndex].operator = value;
    }
    await updateState(updatedAcc);
  };
  const updateState = async (acc) => {
    const cleanedAcc = cleanUnifiedAccessControlConditions(acc);
    let humanizedData;
    try {
      humanizedData = await humanizeNestedConditions([...cleanedAcc]);
      setHumanizedUnifiedAccessControlConditions([...humanizedData]);
    } catch (err) {
      logDevError(err);
    }
    setUnifiedAccessControlConditions([...cleanedAcc]);
  };
  const clearAllAccessControlConditions = () => {
    setUnifiedAccessControlConditions([]);
    setHumanizedUnifiedAccessControlConditions([]);
  };
  const handleClose = () => {
    if (unifiedAccessControlConditions.length) {
      setShowConfirmationModal(true);
    } else {
      resetModal();
      onClose();
    }
  };
  const resetModal = () => {
    setFlow("singleCondition");
    setDisplayedPage("single");
    clearAllAccessControlConditions();
    setError(null);
    setInitialChain(chainList).then(() => {
    });
  };
  const handleConfirmModalClose = (modalResponse) => {
    if (modalResponse === "yes") {
      resetModal();
      setShowConfirmationModal(false);
      onClose();
    } else {
      setShowConfirmationModal(false);
    }
  };
  const sendUnifiedAccessControlConditions = async (conditionsArePermanent) => {
    const cleanedAccessControlConditions = stripNestedArray(unifiedAccessControlConditions);
    const allConditionTypes = getAllNeededAuthSigs(unifiedAccessControlConditions);
    const authSigTypes = [...new Set(allConditionTypes)];
    const allChainTypes = getAllChains(unifiedAccessControlConditions);
    const chains = [...new Set(allChainTypes)];
    const keyParams = {
      unifiedAccessControlConditions: cleanedAccessControlConditions,
      permanent: conditionsArePermanent,
      chains,
      authSigTypes
    };
    await onUnifiedAccessControlConditionsSelected(keyParams);
    resetModal();
  };
  const getTheme = () => {
    if (darkMode) {
      return "lsm-dark-theme";
    } else {
      return "lsm-light-theme";
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: `lsm-share-modal-container ${getTheme()}`,
    children: [!error && cssLoaded && /* @__PURE__ */ jsxs(ShareModalContext.Provider, {
      value: {
        handleUpdateUnifiedAccessControlConditions,
        handleDeleteAccessControlCondition,
        clearAllAccessControlConditions,
        updateLogicOperator,
        handleClose,
        sendUnifiedAccessControlConditions,
        resetModal,
        wipeInitialProps,
        allowChainSelector,
        chain,
        chainList,
        setChain,
        setError,
        setDisplayedPage,
        setFlow,
        humanizedUnifiedAccessControlConditions,
        unifiedAccessControlConditions,
        displayedPage,
        tokenList,
        flow,
        defaultTokens,
        allowMultipleConditions,
        permanentDefault
      },
      children: [allowDevMode ? /* @__PURE__ */ jsx$1(DevModeHeader, {
        handleClose,
        isModal,
        showDevMode,
        setShowDevMode
      }) : /* @__PURE__ */ jsx$1(LitHeader, {
        handleClose,
        isModal
      }), allowDevMode && showDevMode ? /* @__PURE__ */ jsx$1(DevModeContent, {
        unifiedAccessControlConditions
      }) : /* @__PURE__ */ jsxs("div", {
        className: "lsm-condition-display",
        children: [flow === "singleCondition" && displayedPage !== "review" && /* @__PURE__ */ jsx$1(SingleConditionSelect, {
          stepAfterUpdate: "review",
          chain,
          initialState: storedInitialState,
          initialCondition: storedInitialCondition,
          humanizedUnifiedAccessControlConditions,
          unifiedAccessControlConditions
        }), flow === "multipleConditions" && displayedPage !== "review" && /* @__PURE__ */ jsx$1(MultipleConditionSelect, {
          chain,
          initialState: storedInitialState,
          initialCondition,
          humanizedUnifiedAccessControlConditions,
          unifiedAccessControlConditions
        }), displayedPage === "review" && /* @__PURE__ */ jsx$1(ReviewConditions, {
          chain,
          humanizedUnifiedAccessControlConditions,
          unifiedAccessControlConditions
        })]
      }), /* @__PURE__ */ jsx$1(LitConfirmationModal, {
        message: "Are you sure you want to close the modal?",
        showConfirmationModal,
        onClick: handleConfirmModalClose
      })]
    }), error && cssLoaded && /* @__PURE__ */ jsxs("span", {
      className: "lsm-error-display",
      children: [/* @__PURE__ */ jsx$1("p", {
        className: "lsm-font-segoe lsm-text-brand-5",
        children: "An error occurred with an external API:"
      }), /* @__PURE__ */ jsx$1("p", {
        className: "lsm-font-segoe",
        children: error.toString()
      }), /* @__PURE__ */ jsx$1("p", {
        className: "lsm-font-segoe lsm-text-brand-5",
        children: "Please close and reopen the modal to reconnect."
      }), /* @__PURE__ */ jsx$1("button", {
        className: "lsm-error-button lsm-bg-brand-4",
        onClick: onClose,
        children: "Close"
      })]
    })]
  });
};
export { ShareModal as default };
